(function () {


/* global BX:writable */ 

function $ee28a9d8791885a9$var$isNumber(subject) {
    return typeof subject === 'number';
}
function $ee28a9d8791885a9$var$isString(subject) {
    return typeof subject === 'string';
}
function $ee28a9d8791885a9$var$isBoolean(subject) {
    return typeof subject === 'boolean';
}
function $ee28a9d8791885a9$var$isObject(subject) {
    return Object.prototype.toString.call(subject) === '[object Object]';
}
function $ee28a9d8791885a9$var$mathAbs(n) {
    return Math.abs(n);
}
function $ee28a9d8791885a9$var$mathSign(n) {
    return Math.sign(n);
}
function $ee28a9d8791885a9$var$deltaAbs(valueB, valueA) {
    return $ee28a9d8791885a9$var$mathAbs(valueB - valueA);
}
function $ee28a9d8791885a9$var$factorAbs(valueB, valueA) {
    if (valueB === 0 || valueA === 0) return 0;
    if ($ee28a9d8791885a9$var$mathAbs(valueB) <= $ee28a9d8791885a9$var$mathAbs(valueA)) return 0;
    const diff = $ee28a9d8791885a9$var$deltaAbs($ee28a9d8791885a9$var$mathAbs(valueB), $ee28a9d8791885a9$var$mathAbs(valueA));
    return $ee28a9d8791885a9$var$mathAbs(diff / valueB);
}
function $ee28a9d8791885a9$var$roundToTwoDecimals(num) {
    return Math.round(num * 100) / 100;
}
function $ee28a9d8791885a9$var$arrayKeys(array) {
    return $ee28a9d8791885a9$var$objectKeys(array).map(Number);
}
function $ee28a9d8791885a9$var$arrayLast(array) {
    return array[$ee28a9d8791885a9$var$arrayLastIndex(array)];
}
function $ee28a9d8791885a9$var$arrayLastIndex(array) {
    return Math.max(0, array.length - 1);
}
function $ee28a9d8791885a9$var$arrayIsLastIndex(array, index) {
    return index === $ee28a9d8791885a9$var$arrayLastIndex(array);
}
function $ee28a9d8791885a9$var$arrayFromNumber(n, startAt = 0) {
    return Array.from(Array(n), (_, i)=>startAt + i);
}
function $ee28a9d8791885a9$var$objectKeys(object) {
    return Object.keys(object);
}
function $ee28a9d8791885a9$var$objectsMergeDeep(objectA, objectB) {
    return [
        objectA,
        objectB
    ].reduce((mergedObjects, currentObject)=>{
        $ee28a9d8791885a9$var$objectKeys(currentObject).forEach((key)=>{
            const valueA = mergedObjects[key];
            const valueB = currentObject[key];
            const areObjects = $ee28a9d8791885a9$var$isObject(valueA) && $ee28a9d8791885a9$var$isObject(valueB);
            mergedObjects[key] = areObjects ? $ee28a9d8791885a9$var$objectsMergeDeep(valueA, valueB) : valueB;
        });
        return mergedObjects;
    }, {});
}
function $ee28a9d8791885a9$var$isMouseEvent(evt, ownerWindow) {
    return typeof ownerWindow.MouseEvent !== 'undefined' && evt instanceof ownerWindow.MouseEvent;
}
function $ee28a9d8791885a9$var$Alignment(align, viewSize) {
    const predefined = {
        start: start,
        center: center,
        end: end
    };
    function start() {
        return 0;
    }
    function center(n) {
        return end(n) / 2;
    }
    function end(n) {
        return viewSize - n;
    }
    function measure(n, index) {
        if ($ee28a9d8791885a9$var$isString(align)) return predefined[align](n);
        return align(viewSize, n, index);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $ee28a9d8791885a9$var$EventStore() {
    let listeners = [];
    function add(node, type, handler, options = {
        passive: true
    }) {
        let removeListener;
        if ('addEventListener' in node) {
            node.addEventListener(type, handler, options);
            removeListener = ()=>node.removeEventListener(type, handler, options);
        } else {
            const legacyMediaQueryList = node;
            legacyMediaQueryList.addListener(handler);
            removeListener = ()=>legacyMediaQueryList.removeListener(handler);
        }
        listeners.push(removeListener);
        return self;
    }
    function clear() {
        listeners = listeners.filter((remove)=>remove());
    }
    const self = {
        add: add,
        clear: clear
    };
    return self;
}
function $ee28a9d8791885a9$var$Animations(ownerDocument, ownerWindow, update, render) {
    const documentVisibleHandler = $ee28a9d8791885a9$var$EventStore();
    const fixedTimeStep = 1000 / 60;
    let lastTimeStamp = null;
    let accumulatedTime = 0;
    let animationId = 0;
    function init() {
        documentVisibleHandler.add(ownerDocument, 'visibilitychange', ()=>{
            if (ownerDocument.hidden) reset();
        });
    }
    function destroy() {
        stop();
        documentVisibleHandler.clear();
    }
    function animate(timeStamp) {
        if (!animationId) return;
        if (!lastTimeStamp) {
            lastTimeStamp = timeStamp;
            update();
            update();
        }
        const timeElapsed = timeStamp - lastTimeStamp;
        lastTimeStamp = timeStamp;
        accumulatedTime += timeElapsed;
        while(accumulatedTime >= fixedTimeStep){
            update();
            accumulatedTime -= fixedTimeStep;
        }
        const alpha = accumulatedTime / fixedTimeStep;
        render(alpha);
        if (animationId) animationId = ownerWindow.requestAnimationFrame(animate);
    }
    function start() {
        if (animationId) return;
        animationId = ownerWindow.requestAnimationFrame(animate);
    }
    function stop() {
        ownerWindow.cancelAnimationFrame(animationId);
        lastTimeStamp = null;
        accumulatedTime = 0;
        animationId = 0;
    }
    function reset() {
        lastTimeStamp = null;
        accumulatedTime = 0;
    }
    const self = {
        init: init,
        destroy: destroy,
        start: start,
        stop: stop,
        update: update,
        render: render
    };
    return self;
}
function $ee28a9d8791885a9$var$Axis(axis, contentDirection) {
    const isRightToLeft = contentDirection === 'rtl';
    const isVertical = axis === 'y';
    const scroll = isVertical ? 'y' : 'x';
    const cross = isVertical ? 'x' : 'y';
    const sign = !isVertical && isRightToLeft ? -1 : 1;
    const startEdge = getStartEdge();
    const endEdge = getEndEdge();
    function measureSize(nodeRect) {
        const { height: height, width: width } = nodeRect;
        return isVertical ? height : width;
    }
    function getStartEdge() {
        if (isVertical) return 'top';
        return isRightToLeft ? 'right' : 'left';
    }
    function getEndEdge() {
        if (isVertical) return 'bottom';
        return isRightToLeft ? 'left' : 'right';
    }
    function direction(n) {
        return n * sign;
    }
    const self = {
        scroll: scroll,
        cross: cross,
        startEdge: startEdge,
        endEdge: endEdge,
        measureSize: measureSize,
        direction: direction
    };
    return self;
}
function $ee28a9d8791885a9$var$Limit(min = 0, max = 0) {
    const length = $ee28a9d8791885a9$var$mathAbs(min - max);
    function reachedMin(n) {
        return n < min;
    }
    function reachedMax(n) {
        return n > max;
    }
    function reachedAny(n) {
        return reachedMin(n) || reachedMax(n);
    }
    function constrain(n) {
        if (!reachedAny(n)) return n;
        return reachedMin(n) ? min : max;
    }
    function removeOffset(n) {
        if (!length) return n;
        return n - length * Math.ceil((n - max) / length);
    }
    const self = {
        length: length,
        max: max,
        min: min,
        constrain: constrain,
        reachedAny: reachedAny,
        reachedMax: reachedMax,
        reachedMin: reachedMin,
        removeOffset: removeOffset
    };
    return self;
}
function $ee28a9d8791885a9$var$Counter(max, start, loop) {
    const { constrain: constrain } = $ee28a9d8791885a9$var$Limit(0, max);
    const loopEnd = max + 1;
    let counter = withinLimit(start);
    function withinLimit(n) {
        return !loop ? constrain(n) : $ee28a9d8791885a9$var$mathAbs((loopEnd + n) % loopEnd);
    }
    function get() {
        return counter;
    }
    function set(n) {
        counter = withinLimit(n);
        return self;
    }
    function add(n) {
        return clone().set(get() + n);
    }
    function clone() {
        return $ee28a9d8791885a9$var$Counter(max, get(), loop);
    }
    const self = {
        get: get,
        set: set,
        add: add,
        clone: clone
    };
    return self;
}
function $ee28a9d8791885a9$var$DragHandler(axis, rootNode, ownerDocument, ownerWindow, target, dragTracker, location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, baseFriction, watchDrag) {
    const { cross: crossAxis, direction: direction } = axis;
    const focusNodes = [
        'INPUT',
        'SELECT',
        'TEXTAREA'
    ];
    const nonPassiveEvent = {
        passive: false
    };
    const initEvents = $ee28a9d8791885a9$var$EventStore();
    const dragEvents = $ee28a9d8791885a9$var$EventStore();
    const goToNextThreshold = $ee28a9d8791885a9$var$Limit(50, 225).constrain(percentOfView.measure(20));
    const snapForceBoost = {
        mouse: 300,
        touch: 400
    };
    const freeForceBoost = {
        mouse: 500,
        touch: 600
    };
    const baseSpeed = dragFree ? 43 : 25;
    let isMoving = false;
    let startScroll = 0;
    let startCross = 0;
    let pointerIsDown = false;
    let preventScroll = false;
    let preventClick = false;
    let isMouse = false;
    function init(emblaApi) {
        if (!watchDrag) return;
        function downIfAllowed(evt) {
            if ($ee28a9d8791885a9$var$isBoolean(watchDrag) || watchDrag(emblaApi, evt)) down(evt);
        }
        const node = rootNode;
        initEvents.add(node, 'dragstart', (evt)=>evt.preventDefault(), nonPassiveEvent).add(node, 'touchmove', ()=>undefined, nonPassiveEvent).add(node, 'touchend', ()=>undefined).add(node, 'touchstart', downIfAllowed).add(node, 'mousedown', downIfAllowed).add(node, 'touchcancel', up).add(node, 'contextmenu', up).add(node, 'click', click, true);
    }
    function destroy() {
        initEvents.clear();
        dragEvents.clear();
    }
    function addDragEvents() {
        const node = isMouse ? ownerDocument : rootNode;
        dragEvents.add(node, 'touchmove', move, nonPassiveEvent).add(node, 'touchend', up).add(node, 'mousemove', move, nonPassiveEvent).add(node, 'mouseup', up);
    }
    function isFocusNode(node) {
        const nodeName = node.nodeName || '';
        return focusNodes.includes(nodeName);
    }
    function forceBoost() {
        const boost = dragFree ? freeForceBoost : snapForceBoost;
        const type = isMouse ? 'mouse' : 'touch';
        return boost[type];
    }
    function allowedForce(force, targetChanged) {
        const next = index.add($ee28a9d8791885a9$var$mathSign(force) * -1);
        const baseForce = scrollTarget.byDistance(force, !dragFree).distance;
        if (dragFree || $ee28a9d8791885a9$var$mathAbs(force) < goToNextThreshold) return baseForce;
        if (skipSnaps && targetChanged) return baseForce * 0.5;
        return scrollTarget.byIndex(next.get(), 0).distance;
    }
    function down(evt) {
        const isMouseEvt = $ee28a9d8791885a9$var$isMouseEvent(evt, ownerWindow);
        isMouse = isMouseEvt;
        preventClick = dragFree && isMouseEvt && !evt.buttons && isMoving;
        isMoving = $ee28a9d8791885a9$var$deltaAbs(target.get(), location.get()) >= 2;
        if (isMouseEvt && evt.button !== 0) return;
        if (isFocusNode(evt.target)) return;
        pointerIsDown = true;
        dragTracker.pointerDown(evt);
        scrollBody.useFriction(0).useDuration(0);
        target.set(location);
        addDragEvents();
        startScroll = dragTracker.readPoint(evt);
        startCross = dragTracker.readPoint(evt, crossAxis);
        eventHandler.emit('pointerDown');
    }
    function move(evt) {
        const isTouchEvt = !$ee28a9d8791885a9$var$isMouseEvent(evt, ownerWindow);
        if (isTouchEvt && evt.touches.length >= 2) return up(evt);
        const lastScroll = dragTracker.readPoint(evt);
        const lastCross = dragTracker.readPoint(evt, crossAxis);
        const diffScroll = $ee28a9d8791885a9$var$deltaAbs(lastScroll, startScroll);
        const diffCross = $ee28a9d8791885a9$var$deltaAbs(lastCross, startCross);
        if (!preventScroll && !isMouse) {
            if (!evt.cancelable) return up(evt);
            preventScroll = diffScroll > diffCross;
            if (!preventScroll) return up(evt);
        }
        const diff = dragTracker.pointerMove(evt);
        if (diffScroll > dragThreshold) preventClick = true;
        scrollBody.useFriction(0.3).useDuration(0.75);
        animation.start();
        target.add(direction(diff));
        evt.preventDefault();
    }
    function up(evt) {
        const currentLocation = scrollTarget.byDistance(0, false);
        const targetChanged = currentLocation.index !== index.get();
        const rawForce = dragTracker.pointerUp(evt) * forceBoost();
        const force = allowedForce(direction(rawForce), targetChanged);
        const forceFactor = $ee28a9d8791885a9$var$factorAbs(rawForce, force);
        const speed = baseSpeed - 10 * forceFactor;
        const friction = baseFriction + forceFactor / 50;
        preventScroll = false;
        pointerIsDown = false;
        dragEvents.clear();
        scrollBody.useDuration(speed).useFriction(friction);
        scrollTo.distance(force, !dragFree);
        isMouse = false;
        eventHandler.emit('pointerUp');
    }
    function click(evt) {
        if (preventClick) {
            evt.stopPropagation();
            evt.preventDefault();
            preventClick = false;
        }
    }
    function pointerDown() {
        return pointerIsDown;
    }
    const self = {
        init: init,
        destroy: destroy,
        pointerDown: pointerDown
    };
    return self;
}
function $ee28a9d8791885a9$var$DragTracker(axis, ownerWindow) {
    const logInterval = 170;
    let startEvent;
    let lastEvent;
    function readTime(evt) {
        return evt.timeStamp;
    }
    function readPoint(evt, evtAxis) {
        const property = evtAxis || axis.scroll;
        const coord = `client${property === 'x' ? 'X' : 'Y'}`;
        return ($ee28a9d8791885a9$var$isMouseEvent(evt, ownerWindow) ? evt : evt.touches[0])[coord];
    }
    function pointerDown(evt) {
        startEvent = evt;
        lastEvent = evt;
        return readPoint(evt);
    }
    function pointerMove(evt) {
        const diff = readPoint(evt) - readPoint(lastEvent);
        const expired = readTime(evt) - readTime(startEvent) > logInterval;
        lastEvent = evt;
        if (expired) startEvent = evt;
        return diff;
    }
    function pointerUp(evt) {
        if (!startEvent || !lastEvent) return 0;
        const diffDrag = readPoint(lastEvent) - readPoint(startEvent);
        const diffTime = readTime(evt) - readTime(startEvent);
        const expired = readTime(evt) - readTime(lastEvent) > logInterval;
        const force = diffDrag / diffTime;
        const isFlick = diffTime && !expired && $ee28a9d8791885a9$var$mathAbs(force) > 0.1;
        return isFlick ? force : 0;
    }
    const self = {
        pointerDown: pointerDown,
        pointerMove: pointerMove,
        pointerUp: pointerUp,
        readPoint: readPoint
    };
    return self;
}
function $ee28a9d8791885a9$var$NodeRects() {
    function measure(node) {
        const { offsetTop: offsetTop, offsetLeft: offsetLeft, offsetWidth: offsetWidth, offsetHeight: offsetHeight } = node;
        const offset = {
            top: offsetTop,
            right: offsetLeft + offsetWidth,
            bottom: offsetTop + offsetHeight,
            left: offsetLeft,
            width: offsetWidth,
            height: offsetHeight
        };
        return offset;
    }
    const self = {
        measure: measure
    };
    return self;
}
function $ee28a9d8791885a9$var$PercentOfView(viewSize) {
    function measure(n) {
        return viewSize * (n / 100);
    }
    const self = {
        measure: measure
    };
    return self;
}
function $ee28a9d8791885a9$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects) {
    const observeNodes = [
        container
    ].concat(slides);
    let resizeObserver;
    let containerSize;
    let slideSizes = [];
    let destroyed = false;
    function readSize(node) {
        return axis.measureSize(nodeRects.measure(node));
    }
    function init(emblaApi) {
        if (!watchResize) return;
        containerSize = readSize(container);
        slideSizes = slides.map(readSize);
        function defaultCallback(entries) {
            for (const entry of entries){
                if (destroyed) return;
                const isContainer = entry.target === container;
                const slideIndex = slides.indexOf(entry.target);
                const lastSize = isContainer ? containerSize : slideSizes[slideIndex];
                const newSize = readSize(isContainer ? container : slides[slideIndex]);
                const diffSize = $ee28a9d8791885a9$var$mathAbs(newSize - lastSize);
                if (diffSize >= 0.5) {
                    emblaApi.reInit();
                    eventHandler.emit('resize');
                    break;
                }
            }
        }
        resizeObserver = new ResizeObserver((entries)=>{
            if ($ee28a9d8791885a9$var$isBoolean(watchResize) || watchResize(emblaApi, entries)) defaultCallback(entries);
        });
        ownerWindow.requestAnimationFrame(()=>{
            observeNodes.forEach((node)=>resizeObserver.observe(node));
        });
    }
    function destroy() {
        destroyed = true;
        if (resizeObserver) resizeObserver.disconnect();
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $ee28a9d8791885a9$var$ScrollBody(location, offsetLocation, previousLocation, target, baseDuration, baseFriction) {
    let scrollVelocity = 0;
    let scrollDirection = 0;
    let scrollDuration = baseDuration;
    let scrollFriction = baseFriction;
    let rawLocation = location.get();
    let rawLocationPrevious = 0;
    function seek() {
        const displacement = target.get() - location.get();
        const isInstant = !scrollDuration;
        let scrollDistance = 0;
        if (isInstant) {
            scrollVelocity = 0;
            previousLocation.set(target);
            location.set(target);
            scrollDistance = displacement;
        } else {
            previousLocation.set(location);
            scrollVelocity += displacement / scrollDuration;
            scrollVelocity *= scrollFriction;
            rawLocation += scrollVelocity;
            location.add(scrollVelocity);
            scrollDistance = rawLocation - rawLocationPrevious;
        }
        scrollDirection = $ee28a9d8791885a9$var$mathSign(scrollDistance);
        rawLocationPrevious = rawLocation;
        return self;
    }
    function settled() {
        const diff = target.get() - offsetLocation.get();
        return $ee28a9d8791885a9$var$mathAbs(diff) < 0.001;
    }
    function duration() {
        return scrollDuration;
    }
    function direction() {
        return scrollDirection;
    }
    function velocity() {
        return scrollVelocity;
    }
    function useBaseDuration() {
        return useDuration(baseDuration);
    }
    function useBaseFriction() {
        return useFriction(baseFriction);
    }
    function useDuration(n) {
        scrollDuration = n;
        return self;
    }
    function useFriction(n) {
        scrollFriction = n;
        return self;
    }
    const self = {
        direction: direction,
        duration: duration,
        velocity: velocity,
        seek: seek,
        settled: settled,
        useBaseFriction: useBaseFriction,
        useBaseDuration: useBaseDuration,
        useFriction: useFriction,
        useDuration: useDuration
    };
    return self;
}
function $ee28a9d8791885a9$var$ScrollBounds(limit, location, target, scrollBody, percentOfView) {
    const pullBackThreshold = percentOfView.measure(10);
    const edgeOffsetTolerance = percentOfView.measure(50);
    const frictionLimit = $ee28a9d8791885a9$var$Limit(0.1, 0.99);
    let disabled = false;
    function shouldConstrain() {
        if (disabled) return false;
        if (!limit.reachedAny(target.get())) return false;
        if (!limit.reachedAny(location.get())) return false;
        return true;
    }
    function constrain(pointerDown) {
        if (!shouldConstrain()) return;
        const edge = limit.reachedMin(location.get()) ? 'min' : 'max';
        const diffToEdge = $ee28a9d8791885a9$var$mathAbs(limit[edge] - location.get());
        const diffToTarget = target.get() - location.get();
        const friction = frictionLimit.constrain(diffToEdge / edgeOffsetTolerance);
        target.subtract(diffToTarget * friction);
        if (!pointerDown && $ee28a9d8791885a9$var$mathAbs(diffToTarget) < pullBackThreshold) {
            target.set(limit.constrain(target.get()));
            scrollBody.useDuration(25).useBaseFriction();
        }
    }
    function toggleActive(active) {
        disabled = !active;
    }
    const self = {
        shouldConstrain: shouldConstrain,
        constrain: constrain,
        toggleActive: toggleActive
    };
    return self;
}
function $ee28a9d8791885a9$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance) {
    const scrollBounds = $ee28a9d8791885a9$var$Limit(-contentSize + viewSize, 0);
    const snapsBounded = measureBounded();
    const scrollContainLimit = findScrollContainLimit();
    const snapsContained = measureContained();
    function usePixelTolerance(bound, snap) {
        return $ee28a9d8791885a9$var$deltaAbs(bound, snap) <= 1;
    }
    function findScrollContainLimit() {
        const startSnap = snapsBounded[0];
        const endSnap = $ee28a9d8791885a9$var$arrayLast(snapsBounded);
        const min = snapsBounded.lastIndexOf(startSnap);
        const max = snapsBounded.indexOf(endSnap) + 1;
        return $ee28a9d8791885a9$var$Limit(min, max);
    }
    function measureBounded() {
        return snapsAligned.map((snapAligned, index)=>{
            const { min: min, max: max } = scrollBounds;
            const snap = scrollBounds.constrain(snapAligned);
            const isFirst = !index;
            const isLast = $ee28a9d8791885a9$var$arrayIsLastIndex(snapsAligned, index);
            if (isFirst) return max;
            if (isLast) return min;
            if (usePixelTolerance(min, snap)) return min;
            if (usePixelTolerance(max, snap)) return max;
            return snap;
        }).map((scrollBound)=>parseFloat(scrollBound.toFixed(3)));
    }
    function measureContained() {
        if (contentSize <= viewSize + pixelTolerance) return [
            scrollBounds.max
        ];
        if (containScroll === 'keepSnaps') return snapsBounded;
        const { min: min, max: max } = scrollContainLimit;
        return snapsBounded.slice(min, max);
    }
    const self = {
        snapsContained: snapsContained,
        scrollContainLimit: scrollContainLimit
    };
    return self;
}
function $ee28a9d8791885a9$var$ScrollLimit(contentSize, scrollSnaps, loop) {
    const max = scrollSnaps[0];
    const min = loop ? max - contentSize : $ee28a9d8791885a9$var$arrayLast(scrollSnaps);
    const limit = $ee28a9d8791885a9$var$Limit(min, max);
    const self = {
        limit: limit
    };
    return self;
}
function $ee28a9d8791885a9$var$ScrollLooper(contentSize, limit, location, vectors) {
    const jointSafety = 0.1;
    const min = limit.min + jointSafety;
    const max = limit.max + jointSafety;
    const { reachedMin: reachedMin, reachedMax: reachedMax } = $ee28a9d8791885a9$var$Limit(min, max);
    function shouldLoop(direction) {
        if (direction === 1) return reachedMax(location.get());
        if (direction === -1) return reachedMin(location.get());
        return false;
    }
    function loop(direction) {
        if (!shouldLoop(direction)) return;
        const loopDistance = contentSize * (direction * -1);
        vectors.forEach((v)=>v.add(loopDistance));
    }
    const self = {
        loop: loop
    };
    return self;
}
function $ee28a9d8791885a9$var$ScrollProgress(limit) {
    const { max: max, length: length } = limit;
    function get(n) {
        const currentLocation = n - max;
        return length ? currentLocation / -length : 0;
    }
    const self = {
        get: get
    };
    return self;
}
function $ee28a9d8791885a9$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll) {
    const { startEdge: startEdge, endEdge: endEdge } = axis;
    const { groupSlides: groupSlides } = slidesToScroll;
    const alignments = measureSizes().map(alignment.measure);
    const snaps = measureUnaligned();
    const snapsAligned = measureAligned();
    function measureSizes() {
        return groupSlides(slideRects).map((rects)=>$ee28a9d8791885a9$var$arrayLast(rects)[endEdge] - rects[0][startEdge]).map($ee28a9d8791885a9$var$mathAbs);
    }
    function measureUnaligned() {
        return slideRects.map((rect)=>containerRect[startEdge] - rect[startEdge]).map((snap)=>-$ee28a9d8791885a9$var$mathAbs(snap));
    }
    function measureAligned() {
        return groupSlides(snaps).map((g)=>g[0]).map((snap, index)=>snap + alignments[index]);
    }
    const self = {
        snaps: snaps,
        snapsAligned: snapsAligned
    };
    return self;
}
function $ee28a9d8791885a9$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes) {
    const { groupSlides: groupSlides } = slidesToScroll;
    const { min: min, max: max } = scrollContainLimit;
    const slideRegistry = createSlideRegistry();
    function createSlideRegistry() {
        const groupedSlideIndexes = groupSlides(slideIndexes);
        const doNotContain = !containSnaps || containScroll === 'keepSnaps';
        if (scrollSnaps.length === 1) return [
            slideIndexes
        ];
        if (doNotContain) return groupedSlideIndexes;
        return groupedSlideIndexes.slice(min, max).map((group, index, groups)=>{
            const isFirst = !index;
            const isLast = $ee28a9d8791885a9$var$arrayIsLastIndex(groups, index);
            if (isFirst) {
                const range = $ee28a9d8791885a9$var$arrayLast(groups[0]) + 1;
                return $ee28a9d8791885a9$var$arrayFromNumber(range);
            }
            if (isLast) {
                const range = $ee28a9d8791885a9$var$arrayLastIndex(slideIndexes) - $ee28a9d8791885a9$var$arrayLast(groups)[0] + 1;
                return $ee28a9d8791885a9$var$arrayFromNumber(range, $ee28a9d8791885a9$var$arrayLast(groups)[0]);
            }
            return group;
        });
    }
    const self = {
        slideRegistry: slideRegistry
    };
    return self;
}
function $ee28a9d8791885a9$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, targetVector) {
    const { reachedAny: reachedAny, removeOffset: removeOffset, constrain: constrain } = limit;
    function minDistance(distances) {
        return distances.concat().sort((a, b)=>$ee28a9d8791885a9$var$mathAbs(a) - $ee28a9d8791885a9$var$mathAbs(b))[0];
    }
    function findTargetSnap(target) {
        const distance = loop ? removeOffset(target) : constrain(target);
        const ascDiffsToSnaps = scrollSnaps.map((snap, index)=>({
                diff: shortcut(snap - distance, 0),
                index: index
            })).sort((d1, d2)=>$ee28a9d8791885a9$var$mathAbs(d1.diff) - $ee28a9d8791885a9$var$mathAbs(d2.diff));
        const { index: index } = ascDiffsToSnaps[0];
        return {
            index: index,
            distance: distance
        };
    }
    function shortcut(target, direction) {
        const targets = [
            target,
            target + contentSize,
            target - contentSize
        ];
        if (!loop) return target;
        if (!direction) return minDistance(targets);
        const matchingTargets = targets.filter((t)=>$ee28a9d8791885a9$var$mathSign(t) === direction);
        if (matchingTargets.length) return minDistance(matchingTargets);
        return $ee28a9d8791885a9$var$arrayLast(targets) - contentSize;
    }
    function byIndex(index, direction) {
        const diffToSnap = scrollSnaps[index] - targetVector.get();
        const distance = shortcut(diffToSnap, direction);
        return {
            index: index,
            distance: distance
        };
    }
    function byDistance(distance, snap) {
        const target = targetVector.get() + distance;
        const { index: index, distance: targetSnapDistance } = findTargetSnap(target);
        const reachedBound = !loop && reachedAny(target);
        if (!snap || reachedBound) return {
            index: index,
            distance: distance
        };
        const diffToSnap = scrollSnaps[index] - targetSnapDistance;
        const snapDistance = distance + shortcut(diffToSnap, 0);
        return {
            index: index,
            distance: snapDistance
        };
    }
    const self = {
        byDistance: byDistance,
        byIndex: byIndex,
        shortcut: shortcut
    };
    return self;
}
function $ee28a9d8791885a9$var$ScrollTo(animation, indexCurrent, indexPrevious, scrollBody, scrollTarget, targetVector, eventHandler) {
    function scrollTo(target) {
        const distanceDiff = target.distance;
        const indexDiff = target.index !== indexCurrent.get();
        targetVector.add(distanceDiff);
        if (distanceDiff) {
            if (scrollBody.duration()) animation.start();
            else {
                animation.update();
                animation.render(1);
                animation.update();
            }
        }
        if (indexDiff) {
            indexPrevious.set(indexCurrent.get());
            indexCurrent.set(target.index);
            eventHandler.emit('select');
        }
    }
    function distance(n, snap) {
        const target = scrollTarget.byDistance(n, snap);
        scrollTo(target);
    }
    function index(n, direction) {
        const targetIndex = indexCurrent.clone().set(n);
        const target = scrollTarget.byIndex(targetIndex.get(), direction);
        scrollTo(target);
    }
    const self = {
        distance: distance,
        index: index
    };
    return self;
}
function $ee28a9d8791885a9$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus) {
    const focusListenerOptions = {
        passive: true,
        capture: true
    };
    let lastTabPressTime = 0;
    function init(emblaApi) {
        if (!watchFocus) return;
        function defaultCallback(index) {
            const nowTime = new Date().getTime();
            const diffTime = nowTime - lastTabPressTime;
            if (diffTime > 10) return;
            eventHandler.emit('slideFocusStart');
            root.scrollLeft = 0;
            const group = slideRegistry.findIndex((group)=>group.includes(index));
            if (!$ee28a9d8791885a9$var$isNumber(group)) return;
            scrollBody.useDuration(0);
            scrollTo.index(group, 0);
            eventHandler.emit('slideFocus');
        }
        eventStore.add(document, 'keydown', registerTabPress, false);
        slides.forEach((slide, slideIndex)=>{
            eventStore.add(slide, 'focus', (evt)=>{
                if ($ee28a9d8791885a9$var$isBoolean(watchFocus) || watchFocus(emblaApi, evt)) defaultCallback(slideIndex);
            }, focusListenerOptions);
        });
    }
    function registerTabPress(event) {
        if (event.code === 'Tab') lastTabPressTime = new Date().getTime();
    }
    const self = {
        init: init
    };
    return self;
}
function $ee28a9d8791885a9$var$Vector1D(initialValue) {
    let value = initialValue;
    function get() {
        return value;
    }
    function set(n) {
        value = normalizeInput(n);
    }
    function add(n) {
        value += normalizeInput(n);
    }
    function subtract(n) {
        value -= normalizeInput(n);
    }
    function normalizeInput(n) {
        return $ee28a9d8791885a9$var$isNumber(n) ? n : n.get();
    }
    const self = {
        get: get,
        set: set,
        add: add,
        subtract: subtract
    };
    return self;
}
function $ee28a9d8791885a9$var$Translate(axis, container) {
    const translate = axis.scroll === 'x' ? x : y;
    const containerStyle = container.style;
    let previousTarget = null;
    let disabled = false;
    function x(n) {
        return `translate3d(${n}px,0px,0px)`;
    }
    function y(n) {
        return `translate3d(0px,${n}px,0px)`;
    }
    function to(target) {
        if (disabled) return;
        const newTarget = $ee28a9d8791885a9$var$roundToTwoDecimals(axis.direction(target));
        if (newTarget === previousTarget) return;
        containerStyle.transform = translate(newTarget);
        previousTarget = newTarget;
    }
    function toggleActive(active) {
        disabled = !active;
    }
    function clear() {
        if (disabled) return;
        containerStyle.transform = '';
        if (!container.getAttribute('style')) container.removeAttribute('style');
    }
    const self = {
        clear: clear,
        to: to,
        toggleActive: toggleActive
    };
    return self;
}
function $ee28a9d8791885a9$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, location, slides) {
    const roundingSafety = 0.5;
    const ascItems = $ee28a9d8791885a9$var$arrayKeys(slideSizesWithGaps);
    const descItems = $ee28a9d8791885a9$var$arrayKeys(slideSizesWithGaps).reverse();
    const loopPoints = startPoints().concat(endPoints());
    function removeSlideSizes(indexes, from) {
        return indexes.reduce((a, i)=>{
            return a - slideSizesWithGaps[i];
        }, from);
    }
    function slidesInGap(indexes, gap) {
        return indexes.reduce((a, i)=>{
            const remainingGap = removeSlideSizes(a, gap);
            return remainingGap > 0 ? a.concat([
                i
            ]) : a;
        }, []);
    }
    function findSlideBounds(offset) {
        return snaps.map((snap, index)=>({
                start: snap - slideSizes[index] + roundingSafety + offset,
                end: snap + viewSize - roundingSafety + offset
            }));
    }
    function findLoopPoints(indexes, offset, isEndEdge) {
        const slideBounds = findSlideBounds(offset);
        return indexes.map((index)=>{
            const initial = isEndEdge ? 0 : -contentSize;
            const altered = isEndEdge ? contentSize : 0;
            const boundEdge = isEndEdge ? 'end' : 'start';
            const loopPoint = slideBounds[index][boundEdge];
            return {
                index: index,
                loopPoint: loopPoint,
                slideLocation: $ee28a9d8791885a9$var$Vector1D(-1),
                translate: $ee28a9d8791885a9$var$Translate(axis, slides[index]),
                target: ()=>location.get() > loopPoint ? initial : altered
            };
        });
    }
    function startPoints() {
        const gap = scrollSnaps[0];
        const indexes = slidesInGap(descItems, gap);
        return findLoopPoints(indexes, contentSize, false);
    }
    function endPoints() {
        const gap = viewSize - scrollSnaps[0] - 1;
        const indexes = slidesInGap(ascItems, gap);
        return findLoopPoints(indexes, -contentSize, true);
    }
    function canLoop() {
        return loopPoints.every(({ index: index })=>{
            const otherIndexes = ascItems.filter((i)=>i !== index);
            return removeSlideSizes(otherIndexes, viewSize) <= 0.1;
        });
    }
    function loop() {
        loopPoints.forEach((loopPoint)=>{
            const { target: target, translate: translate, slideLocation: slideLocation } = loopPoint;
            const shiftLocation = target();
            if (shiftLocation === slideLocation.get()) return;
            translate.to(shiftLocation);
            slideLocation.set(shiftLocation);
        });
    }
    function clear() {
        loopPoints.forEach((loopPoint)=>loopPoint.translate.clear());
    }
    const self = {
        canLoop: canLoop,
        clear: clear,
        loop: loop,
        loopPoints: loopPoints
    };
    return self;
}
function $ee28a9d8791885a9$var$SlidesHandler(container, eventHandler, watchSlides) {
    let mutationObserver;
    let destroyed = false;
    function init(emblaApi) {
        if (!watchSlides) return;
        function defaultCallback(mutations) {
            for (const mutation of mutations)if (mutation.type === 'childList') {
                emblaApi.reInit();
                eventHandler.emit('slidesChanged');
                break;
            }
        }
        mutationObserver = new MutationObserver((mutations)=>{
            if (destroyed) return;
            if ($ee28a9d8791885a9$var$isBoolean(watchSlides) || watchSlides(emblaApi, mutations)) defaultCallback(mutations);
        });
        mutationObserver.observe(container, {
            childList: true
        });
    }
    function destroy() {
        if (mutationObserver) mutationObserver.disconnect();
        destroyed = true;
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $ee28a9d8791885a9$var$SlidesInView(container, slides, eventHandler, threshold) {
    const intersectionEntryMap = {};
    let inViewCache = null;
    let notInViewCache = null;
    let intersectionObserver;
    let destroyed = false;
    function init() {
        intersectionObserver = new IntersectionObserver((entries)=>{
            if (destroyed) return;
            entries.forEach((entry)=>{
                const index = slides.indexOf(entry.target);
                intersectionEntryMap[index] = entry;
            });
            inViewCache = null;
            notInViewCache = null;
            eventHandler.emit('slidesInView');
        }, {
            root: container.parentElement,
            threshold: threshold
        });
        slides.forEach((slide)=>intersectionObserver.observe(slide));
    }
    function destroy() {
        if (intersectionObserver) intersectionObserver.disconnect();
        destroyed = true;
    }
    function createInViewList(inView) {
        return $ee28a9d8791885a9$var$objectKeys(intersectionEntryMap).reduce((list, slideIndex)=>{
            const index = parseInt(slideIndex);
            const { isIntersecting: isIntersecting } = intersectionEntryMap[index];
            const inViewMatch = inView && isIntersecting;
            const notInViewMatch = !inView && !isIntersecting;
            if (inViewMatch || notInViewMatch) list.push(index);
            return list;
        }, []);
    }
    function get(inView = true) {
        if (inView && inViewCache) return inViewCache;
        if (!inView && notInViewCache) return notInViewCache;
        const slideIndexes = createInViewList(inView);
        if (inView) inViewCache = slideIndexes;
        if (!inView) notInViewCache = slideIndexes;
        return slideIndexes;
    }
    const self = {
        init: init,
        destroy: destroy,
        get: get
    };
    return self;
}
function $ee28a9d8791885a9$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow) {
    const { measureSize: measureSize, startEdge: startEdge, endEdge: endEdge } = axis;
    const withEdgeGap = slideRects[0] && readEdgeGap;
    const startGap = measureStartGap();
    const endGap = measureEndGap();
    const slideSizes = slideRects.map(measureSize);
    const slideSizesWithGaps = measureWithGaps();
    function measureStartGap() {
        if (!withEdgeGap) return 0;
        const slideRect = slideRects[0];
        return $ee28a9d8791885a9$var$mathAbs(containerRect[startEdge] - slideRect[startEdge]);
    }
    function measureEndGap() {
        if (!withEdgeGap) return 0;
        const style = ownerWindow.getComputedStyle($ee28a9d8791885a9$var$arrayLast(slides));
        return parseFloat(style.getPropertyValue(`margin-${endEdge}`));
    }
    function measureWithGaps() {
        return slideRects.map((rect, index, rects)=>{
            const isFirst = !index;
            const isLast = $ee28a9d8791885a9$var$arrayIsLastIndex(rects, index);
            if (isFirst) return slideSizes[index] + startGap;
            if (isLast) return slideSizes[index] + endGap;
            return rects[index + 1][startEdge] - rect[startEdge];
        }).map($ee28a9d8791885a9$var$mathAbs);
    }
    const self = {
        slideSizes: slideSizes,
        slideSizesWithGaps: slideSizesWithGaps,
        startGap: startGap,
        endGap: endGap
    };
    return self;
}
function $ee28a9d8791885a9$var$SlidesToScroll(axis, viewSize, slidesToScroll, loop, containerRect, slideRects, startGap, endGap, pixelTolerance) {
    const { startEdge: startEdge, endEdge: endEdge, direction: direction } = axis;
    const groupByNumber = $ee28a9d8791885a9$var$isNumber(slidesToScroll);
    function byNumber(array, groupSize) {
        return $ee28a9d8791885a9$var$arrayKeys(array).filter((i)=>i % groupSize === 0).map((i)=>array.slice(i, i + groupSize));
    }
    function bySize(array) {
        if (!array.length) return [];
        return $ee28a9d8791885a9$var$arrayKeys(array).reduce((groups, rectB, index)=>{
            const rectA = $ee28a9d8791885a9$var$arrayLast(groups) || 0;
            const isFirst = rectA === 0;
            const isLast = rectB === $ee28a9d8791885a9$var$arrayLastIndex(array);
            const edgeA = containerRect[startEdge] - slideRects[rectA][startEdge];
            const edgeB = containerRect[startEdge] - slideRects[rectB][endEdge];
            const gapA = !loop && isFirst ? direction(startGap) : 0;
            const gapB = !loop && isLast ? direction(endGap) : 0;
            const chunkSize = $ee28a9d8791885a9$var$mathAbs(edgeB - gapB - (edgeA + gapA));
            if (index && chunkSize > viewSize + pixelTolerance) groups.push(rectB);
            if (isLast) groups.push(array.length);
            return groups;
        }, []).map((currentSize, index, groups)=>{
            const previousSize = Math.max(groups[index - 1] || 0);
            return array.slice(previousSize, currentSize);
        });
    }
    function groupSlides(array) {
        return groupByNumber ? byNumber(array, slidesToScroll) : bySize(array);
    }
    const self = {
        groupSlides: groupSlides
    };
    return self;
}
function $ee28a9d8791885a9$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler) {
    // Options
    const { align: align, axis: scrollAxis, direction: direction, startIndex: startIndex, loop: loop, duration: duration, dragFree: dragFree, dragThreshold: dragThreshold, inViewThreshold: inViewThreshold, slidesToScroll: groupSlides, skipSnaps: skipSnaps, containScroll: containScroll, watchResize: watchResize, watchSlides: watchSlides, watchDrag: watchDrag, watchFocus: watchFocus } = options;
    // Measurements
    const pixelTolerance = 2;
    const nodeRects = $ee28a9d8791885a9$var$NodeRects();
    const containerRect = nodeRects.measure(container);
    const slideRects = slides.map(nodeRects.measure);
    const axis = $ee28a9d8791885a9$var$Axis(scrollAxis, direction);
    const viewSize = axis.measureSize(containerRect);
    const percentOfView = $ee28a9d8791885a9$var$PercentOfView(viewSize);
    const alignment = $ee28a9d8791885a9$var$Alignment(align, viewSize);
    const containSnaps = !loop && !!containScroll;
    const readEdgeGap = loop || !!containScroll;
    const { slideSizes: slideSizes, slideSizesWithGaps: slideSizesWithGaps, startGap: startGap, endGap: endGap } = $ee28a9d8791885a9$var$SlideSizes(axis, containerRect, slideRects, slides, readEdgeGap, ownerWindow);
    const slidesToScroll = $ee28a9d8791885a9$var$SlidesToScroll(axis, viewSize, groupSlides, loop, containerRect, slideRects, startGap, endGap, pixelTolerance);
    const { snaps: snaps, snapsAligned: snapsAligned } = $ee28a9d8791885a9$var$ScrollSnaps(axis, alignment, containerRect, slideRects, slidesToScroll);
    const contentSize = -$ee28a9d8791885a9$var$arrayLast(snaps) + $ee28a9d8791885a9$var$arrayLast(slideSizesWithGaps);
    const { snapsContained: snapsContained, scrollContainLimit: scrollContainLimit } = $ee28a9d8791885a9$var$ScrollContain(viewSize, contentSize, snapsAligned, containScroll, pixelTolerance);
    const scrollSnaps = containSnaps ? snapsContained : snapsAligned;
    const { limit: limit } = $ee28a9d8791885a9$var$ScrollLimit(contentSize, scrollSnaps, loop);
    // Indexes
    const index = $ee28a9d8791885a9$var$Counter($ee28a9d8791885a9$var$arrayLastIndex(scrollSnaps), startIndex, loop);
    const indexPrevious = index.clone();
    const slideIndexes = $ee28a9d8791885a9$var$arrayKeys(slides);
    // Animation
    const update = ({ dragHandler: dragHandler, scrollBody: scrollBody, scrollBounds: scrollBounds, options: { loop: loop } })=>{
        if (!loop) scrollBounds.constrain(dragHandler.pointerDown());
        scrollBody.seek();
    };
    const render = ({ scrollBody: scrollBody, translate: translate, location: location, offsetLocation: offsetLocation, previousLocation: previousLocation, scrollLooper: scrollLooper, slideLooper: slideLooper, dragHandler: dragHandler, animation: animation, eventHandler: eventHandler, scrollBounds: scrollBounds, options: { loop: loop } }, alpha)=>{
        const shouldSettle = scrollBody.settled();
        const withinBounds = !scrollBounds.shouldConstrain();
        const hasSettled = loop ? shouldSettle : shouldSettle && withinBounds;
        const hasSettledAndIdle = hasSettled && !dragHandler.pointerDown();
        if (hasSettledAndIdle) animation.stop();
        const interpolatedLocation = location.get() * alpha + previousLocation.get() * (1 - alpha);
        offsetLocation.set(interpolatedLocation);
        if (loop) {
            scrollLooper.loop(scrollBody.direction());
            slideLooper.loop();
        }
        translate.to(offsetLocation.get());
        if (hasSettledAndIdle) eventHandler.emit('settle');
        if (!hasSettled) eventHandler.emit('scroll');
    };
    const animation = $ee28a9d8791885a9$var$Animations(ownerDocument, ownerWindow, ()=>update(engine), (alpha)=>render(engine, alpha));
    // Shared
    const friction = 0.68;
    const startLocation = scrollSnaps[index.get()];
    const location = $ee28a9d8791885a9$var$Vector1D(startLocation);
    const previousLocation = $ee28a9d8791885a9$var$Vector1D(startLocation);
    const offsetLocation = $ee28a9d8791885a9$var$Vector1D(startLocation);
    const target = $ee28a9d8791885a9$var$Vector1D(startLocation);
    const scrollBody = $ee28a9d8791885a9$var$ScrollBody(location, offsetLocation, previousLocation, target, duration, friction);
    const scrollTarget = $ee28a9d8791885a9$var$ScrollTarget(loop, scrollSnaps, contentSize, limit, target);
    const scrollTo = $ee28a9d8791885a9$var$ScrollTo(animation, index, indexPrevious, scrollBody, scrollTarget, target, eventHandler);
    const scrollProgress = $ee28a9d8791885a9$var$ScrollProgress(limit);
    const eventStore = $ee28a9d8791885a9$var$EventStore();
    const slidesInView = $ee28a9d8791885a9$var$SlidesInView(container, slides, eventHandler, inViewThreshold);
    const { slideRegistry: slideRegistry } = $ee28a9d8791885a9$var$SlideRegistry(containSnaps, containScroll, scrollSnaps, scrollContainLimit, slidesToScroll, slideIndexes);
    const slideFocus = $ee28a9d8791885a9$var$SlideFocus(root, slides, slideRegistry, scrollTo, scrollBody, eventStore, eventHandler, watchFocus);
    // Engine
    const engine = {
        ownerDocument: ownerDocument,
        ownerWindow: ownerWindow,
        eventHandler: eventHandler,
        containerRect: containerRect,
        slideRects: slideRects,
        animation: animation,
        axis: axis,
        dragHandler: $ee28a9d8791885a9$var$DragHandler(axis, root, ownerDocument, ownerWindow, target, $ee28a9d8791885a9$var$DragTracker(axis, ownerWindow), location, animation, scrollTo, scrollBody, scrollTarget, index, eventHandler, percentOfView, dragFree, dragThreshold, skipSnaps, friction, watchDrag),
        eventStore: eventStore,
        percentOfView: percentOfView,
        index: index,
        indexPrevious: indexPrevious,
        limit: limit,
        location: location,
        offsetLocation: offsetLocation,
        previousLocation: previousLocation,
        options: options,
        resizeHandler: $ee28a9d8791885a9$var$ResizeHandler(container, eventHandler, ownerWindow, slides, axis, watchResize, nodeRects),
        scrollBody: scrollBody,
        scrollBounds: $ee28a9d8791885a9$var$ScrollBounds(limit, offsetLocation, target, scrollBody, percentOfView),
        scrollLooper: $ee28a9d8791885a9$var$ScrollLooper(contentSize, limit, offsetLocation, [
            location,
            offsetLocation,
            previousLocation,
            target
        ]),
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnaps.map(scrollProgress.get),
        scrollSnaps: scrollSnaps,
        scrollTarget: scrollTarget,
        scrollTo: scrollTo,
        slideLooper: $ee28a9d8791885a9$var$SlideLooper(axis, viewSize, contentSize, slideSizes, slideSizesWithGaps, snaps, scrollSnaps, offsetLocation, slides),
        slideFocus: slideFocus,
        slidesHandler: $ee28a9d8791885a9$var$SlidesHandler(container, eventHandler, watchSlides),
        slidesInView: slidesInView,
        slideIndexes: slideIndexes,
        slideRegistry: slideRegistry,
        slidesToScroll: slidesToScroll,
        target: target,
        translate: $ee28a9d8791885a9$var$Translate(axis, container)
    };
    return engine;
}
function $ee28a9d8791885a9$var$EventHandler() {
    let listeners = {};
    let api;
    function init(emblaApi) {
        api = emblaApi;
    }
    function getListeners(evt) {
        return listeners[evt] || [];
    }
    function emit(evt) {
        getListeners(evt).forEach((e)=>e(api, evt));
        return self;
    }
    function on(evt, cb) {
        listeners[evt] = getListeners(evt).concat([
            cb
        ]);
        return self;
    }
    function off(evt, cb) {
        listeners[evt] = getListeners(evt).filter((e)=>e !== cb);
        return self;
    }
    function clear() {
        listeners = {};
    }
    const self = {
        init: init,
        emit: emit,
        off: off,
        on: on,
        clear: clear
    };
    return self;
}
const $ee28a9d8791885a9$var$defaultOptions = {
    align: 'center',
    axis: 'x',
    container: null,
    slides: null,
    containScroll: 'trimSnaps',
    direction: 'ltr',
    slidesToScroll: 1,
    inViewThreshold: 0,
    breakpoints: {},
    dragFree: false,
    dragThreshold: 10,
    loop: false,
    skipSnaps: false,
    duration: 25,
    startIndex: 0,
    active: true,
    watchDrag: true,
    watchResize: true,
    watchSlides: true,
    watchFocus: true
};
function $ee28a9d8791885a9$var$OptionsHandler(ownerWindow) {
    function mergeOptions(optionsA, optionsB) {
        return $ee28a9d8791885a9$var$objectsMergeDeep(optionsA, optionsB || {});
    }
    function optionsAtMedia(options) {
        const optionsAtMedia = options.breakpoints || {};
        const matchedMediaOptions = $ee28a9d8791885a9$var$objectKeys(optionsAtMedia).filter((media)=>ownerWindow.matchMedia(media).matches).map((media)=>optionsAtMedia[media]).reduce((a, mediaOption)=>mergeOptions(a, mediaOption), {});
        return mergeOptions(options, matchedMediaOptions);
    }
    function optionsMediaQueries(optionsList) {
        return optionsList.map((options)=>$ee28a9d8791885a9$var$objectKeys(options.breakpoints || {})).reduce((acc, mediaQueries)=>acc.concat(mediaQueries), []).map(ownerWindow.matchMedia);
    }
    const self = {
        mergeOptions: mergeOptions,
        optionsAtMedia: optionsAtMedia,
        optionsMediaQueries: optionsMediaQueries
    };
    return self;
}
function $ee28a9d8791885a9$var$PluginsHandler(optionsHandler) {
    let activePlugins = [];
    function init(emblaApi, plugins) {
        activePlugins = plugins.filter(({ options: options })=>optionsHandler.optionsAtMedia(options).active !== false);
        activePlugins.forEach((plugin)=>plugin.init(emblaApi, optionsHandler));
        return plugins.reduce((map, plugin)=>Object.assign(map, {
                [plugin.name]: plugin
            }), {});
    }
    function destroy() {
        activePlugins = activePlugins.filter((plugin)=>plugin.destroy());
    }
    const self = {
        init: init,
        destroy: destroy
    };
    return self;
}
function $ee28a9d8791885a9$export$2e2bcd8739ae039(root, userOptions, userPlugins) {
    const ownerDocument = root.ownerDocument;
    const ownerWindow = ownerDocument.defaultView;
    const optionsHandler = $ee28a9d8791885a9$var$OptionsHandler(ownerWindow);
    const pluginsHandler = $ee28a9d8791885a9$var$PluginsHandler(optionsHandler);
    const mediaHandlers = $ee28a9d8791885a9$var$EventStore();
    const eventHandler = $ee28a9d8791885a9$var$EventHandler();
    const { mergeOptions: mergeOptions, optionsAtMedia: optionsAtMedia, optionsMediaQueries: optionsMediaQueries } = optionsHandler;
    const { on: on, off: off, emit: emit } = eventHandler;
    const reInit = reActivate;
    let destroyed = false;
    let engine;
    let optionsBase = mergeOptions($ee28a9d8791885a9$var$defaultOptions, $ee28a9d8791885a9$export$2e2bcd8739ae039.globalOptions);
    let options = mergeOptions(optionsBase);
    let pluginList = [];
    let pluginApis;
    let container;
    let slides;
    function storeElements() {
        const { container: userContainer, slides: userSlides } = options;
        const customContainer = $ee28a9d8791885a9$var$isString(userContainer) ? root.querySelector(userContainer) : userContainer;
        container = customContainer || root.children[0];
        const customSlides = $ee28a9d8791885a9$var$isString(userSlides) ? container.querySelectorAll(userSlides) : userSlides;
        slides = [].slice.call(customSlides || container.children);
    }
    function createEngine(options) {
        const engine = $ee28a9d8791885a9$var$Engine(root, container, slides, ownerDocument, ownerWindow, options, eventHandler);
        if (options.loop && !engine.slideLooper.canLoop()) {
            const optionsWithoutLoop = Object.assign({}, options, {
                loop: false
            });
            return createEngine(optionsWithoutLoop);
        }
        return engine;
    }
    function activate(withOptions, withPlugins) {
        if (destroyed) return;
        optionsBase = mergeOptions(optionsBase, withOptions);
        options = optionsAtMedia(optionsBase);
        pluginList = withPlugins || pluginList;
        storeElements();
        engine = createEngine(options);
        optionsMediaQueries([
            optionsBase,
            ...pluginList.map(({ options: options })=>options)
        ]).forEach((query)=>mediaHandlers.add(query, 'change', reActivate));
        if (!options.active) return;
        engine.translate.to(engine.location.get());
        engine.animation.init();
        engine.slidesInView.init();
        engine.slideFocus.init(self);
        engine.eventHandler.init(self);
        engine.resizeHandler.init(self);
        engine.slidesHandler.init(self);
        if (engine.options.loop) engine.slideLooper.loop();
        if (container.offsetParent && slides.length) engine.dragHandler.init(self);
        pluginApis = pluginsHandler.init(self, pluginList);
    }
    function reActivate(withOptions, withPlugins) {
        const startIndex = selectedScrollSnap();
        deActivate();
        activate(mergeOptions({
            startIndex: startIndex
        }, withOptions), withPlugins);
        eventHandler.emit('reInit');
    }
    function deActivate() {
        engine.dragHandler.destroy();
        engine.eventStore.clear();
        engine.translate.clear();
        engine.slideLooper.clear();
        engine.resizeHandler.destroy();
        engine.slidesHandler.destroy();
        engine.slidesInView.destroy();
        engine.animation.destroy();
        pluginsHandler.destroy();
        mediaHandlers.clear();
    }
    function destroy() {
        if (destroyed) return;
        destroyed = true;
        mediaHandlers.clear();
        deActivate();
        eventHandler.emit('destroy');
        eventHandler.clear();
    }
    function scrollTo(index, jump, direction) {
        if (!options.active || destroyed) return;
        engine.scrollBody.useBaseFriction().useDuration(jump === true ? 0 : options.duration);
        engine.scrollTo.index(index, direction || 0);
    }
    function scrollNext(jump) {
        const next = engine.index.add(1).get();
        scrollTo(next, jump, -1);
    }
    function scrollPrev(jump) {
        const prev = engine.index.add(-1).get();
        scrollTo(prev, jump, 1);
    }
    function canScrollNext() {
        const next = engine.index.add(1).get();
        return next !== selectedScrollSnap();
    }
    function canScrollPrev() {
        const prev = engine.index.add(-1).get();
        return prev !== selectedScrollSnap();
    }
    function scrollSnapList() {
        return engine.scrollSnapList;
    }
    function scrollProgress() {
        return engine.scrollProgress.get(engine.offsetLocation.get());
    }
    function selectedScrollSnap() {
        return engine.index.get();
    }
    function previousScrollSnap() {
        return engine.indexPrevious.get();
    }
    function slidesInView() {
        return engine.slidesInView.get();
    }
    function slidesNotInView() {
        return engine.slidesInView.get(false);
    }
    function plugins() {
        return pluginApis;
    }
    function internalEngine() {
        return engine;
    }
    function rootNode() {
        return root;
    }
    function containerNode() {
        return container;
    }
    function slideNodes() {
        return slides;
    }
    const self = {
        canScrollNext: canScrollNext,
        canScrollPrev: canScrollPrev,
        containerNode: containerNode,
        internalEngine: internalEngine,
        destroy: destroy,
        off: off,
        on: on,
        emit: emit,
        plugins: plugins,
        previousScrollSnap: previousScrollSnap,
        reInit: reInit,
        rootNode: rootNode,
        scrollNext: scrollNext,
        scrollPrev: scrollPrev,
        scrollProgress: scrollProgress,
        scrollSnapList: scrollSnapList,
        scrollTo: scrollTo,
        selectedScrollSnap: selectedScrollSnap,
        slideNodes: slideNodes,
        slidesInView: slidesInView,
        slidesNotInView: slidesNotInView
    };
    activate(userOptions, userPlugins);
    setTimeout(()=>eventHandler.emit('init'), 0);
    return self;
}
$ee28a9d8791885a9$export$2e2bcd8739ae039.globalOptions = undefined;


const $9b5e29c72f357202$var$OPTIONS = {
    containScroll: 'trimSnaps',
    dragFree: true
};
const $9b5e29c72f357202$var$sliderElements = document.querySelectorAll('.embla');
if ($9b5e29c72f357202$var$sliderElements.length > 0) $9b5e29c72f357202$var$sliderElements.forEach((item)=>{
    const viewportElement = item.querySelector('.embla__viewport');
    if (viewportElement) (0, $ee28a9d8791885a9$export$2e2bcd8739ae039)(viewportElement, $9b5e29c72f357202$var$OPTIONS);
});


const $2f41d3e32458586b$var$MAX_AGE = 31536000;
const $2f41d3e32458586b$var$buttonElement = document.querySelector('.cookie-accept-btn');
const $2f41d3e32458586b$var$setCookie = ()=>{
    document.cookie = `cookiesAccept=accept; path=/; max-age=${$2f41d3e32458586b$var$MAX_AGE}`;
};
if ($2f41d3e32458586b$var$buttonElement) $2f41d3e32458586b$var$buttonElement.addEventListener('click', $2f41d3e32458586b$var$setCookie);


/* global CATALOG_MENU_ITEMS */ /* global BX:writable */ const $43829a6f0e34d097$export$5ebc6cb2748e1881 = ()=>{
    const userId = BX.message('USER_ID');
    return userId.length > 0 ? parseInt(userId, 10) : 0;
};
const $43829a6f0e34d097$export$1cf7a143bd720192 = ()=>{
    document.documentElement.classList.add('scroll-lock');
};
const $43829a6f0e34d097$export$2b9a380dc68c7d45 = ()=>{
    document.documentElement.classList.remove('scroll-lock');
};
const $43829a6f0e34d097$export$a62ef81e9740ca3e = {
    CLOSE: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    NEXT: "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439",
    PREV: "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439",
    MODAL: "\u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u0437\u0430\u043A\u0440\u044B\u0442\u044C \u044D\u0442\u043E \u043C\u043E\u0434\u0430\u043B\u044C\u043D\u043E\u0435 \u043E\u043A\u043D\u043E \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u043A\u043B\u0430\u0432\u0438\u0448\u0438 ESC",
    ERROR: "\u041E\u0448\u0438\u0431\u043A\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u043F\u043E\u0437\u0436\u0435",
    IMAGE_ERROR: "\u0418\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    ELEMENT_NOT_FOUND: "HTML \u044D\u043B\u0435\u043C\u0435\u043D\u0442 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D",
    AJAX_NOT_FOUND: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 AJAX: \u041D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E",
    AJAX_FORBIDDEN: "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 AJAX: \u0417\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043E",
    IFRAME_ERROR: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0444\u0440\u0435\u0439\u043C\u0430",
    TOGGLEZOOM: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
    TOGGLE1TO1: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
    ITERATEZOOM: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
    TOGGLE_ZOOM: "\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435",
    TOGGLE_THUMBS: "\u041C\u0438\u043D\u0438\u0430\u0442\u044E\u0440\u044B",
    TOGGLE_SLIDESHOW: "\u0421\u043B\u0430\u0439\u0434\u0448\u043E\u0443",
    TOGGLE_FULLSCREEN: "\u041F\u043E\u043B\u043D\u043E\u044D\u043A\u0440\u0430\u043D\u043D\u044B\u0439 \u0440\u0435\u0436\u0438\u043C",
    DOWNLOAD: "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C"
};


const $01a0247214ce9984$var$LINK_CLASS_NAME = 'catalog-nav__link';
const $01a0247214ce9984$var$OPENED_CLASS_NAME = 'catalog-nav__link--open';
const $01a0247214ce9984$var$HAVE_PARENT_CLASS_NAME = 'catalog-nav__link--parent';
const $01a0247214ce9984$var$COLUMN_CLASS_NAME = 'catalog-nav__column';
const $01a0247214ce9984$var$HIDDEN_COLUMN_CLASS_NAME = 'catalog-nav__column--hidden';
const $01a0247214ce9984$var$LOADER_CLASS_NAME = 'catalog-nav__loader';
const $01a0247214ce9984$var$HIDDEN_LOADER_CLASS_NAME = 'catalog-nav__loader--hidden';
const $01a0247214ce9984$var$openerElement = document.querySelector('.catalog-trigger');
const $01a0247214ce9984$var$catalogNavElement = document.querySelector('.catalog-nav');
const $01a0247214ce9984$var$removeOpenClassByParent = (parent)=>{
    const openedElements = parent.querySelectorAll(`.${$01a0247214ce9984$var$OPENED_CLASS_NAME}`);
    openedElements.forEach((item)=>{
        item.classList.remove($01a0247214ce9984$var$OPENED_CLASS_NAME);
    });
};
const $01a0247214ce9984$var$openNextItemsColumn = (currentItem)=>{
    const columnElement = currentItem.closest(`.${$01a0247214ce9984$var$COLUMN_CLASS_NAME}`);
    const nextColumnElement = columnElement.nextElementSibling;
    if (!nextColumnElement) return false;
    const listElement = nextColumnElement.querySelector('.catalog-nav__list');
    if (listElement) listElement.remove();
    const loaderElement = nextColumnElement.querySelector('.catalog-nav__loader');
    if (loaderElement) loaderElement.classList.remove($01a0247214ce9984$var$HIDDEN_LOADER_CLASS_NAME);
    nextColumnElement.classList.remove($01a0247214ce9984$var$HIDDEN_COLUMN_CLASS_NAME);
    return nextColumnElement;
};
const $01a0247214ce9984$var$closeNextItemsColumns = (currentItem)=>{
    const columnElement = currentItem.closest(`.${$01a0247214ce9984$var$COLUMN_CLASS_NAME}`);
    const nextColumnElement = columnElement.nextElementSibling;
    if (!nextColumnElement) return;
    nextColumnElement.classList.add($01a0247214ce9984$var$HIDDEN_COLUMN_CLASS_NAME);
    $01a0247214ce9984$var$closeNextItemsColumns(nextColumnElement);
    $01a0247214ce9984$var$removeOpenClassByParent(columnElement);
};
const $01a0247214ce9984$var$hideLoaderInColumn = (columnElement)=>{
    const loaderElement = columnElement.querySelector(`.${$01a0247214ce9984$var$LOADER_CLASS_NAME}`);
    if (loaderElement) loaderElement.classList.add($01a0247214ce9984$var$HIDDEN_LOADER_CLASS_NAME);
};
const $01a0247214ce9984$var$renderItems = (columnElement, data)=>{
    $01a0247214ce9984$var$hideLoaderInColumn(columnElement);
    if (data.length <= 0) return;
    let listItems = '';
    data.forEach((item)=>{
        listItems += `
            <li class="catalog-nav__item">
                <a class="catalog-nav__link${item.isParent ? ' catalog-nav__link--parent' : ''}" href="${item.url}" data-section-id="${item.id}">${item.name}</a>
            </li>
        `;
    });
    columnElement.insertAdjacentHTML('afterbegin', `<ul class="catalog-nav__list">${listItems}</ul>`);
    $01a0247214ce9984$var$navItemHoverInit(columnElement);
};
let $01a0247214ce9984$var$isPending = false;
let $01a0247214ce9984$var$timerId = 0;
const $01a0247214ce9984$var$navItemHoverHandler = ({ target: target }, parent)=>{
    clearTimeout($01a0247214ce9984$var$timerId);
    $01a0247214ce9984$var$timerId = setTimeout(()=>{
        const sectionId = parseInt(target.dataset.sectionId, 10);
        if (target.classList.contains($01a0247214ce9984$var$OPENED_CLASS_NAME) || $01a0247214ce9984$var$isPending || sectionId <= 0) return;
        $01a0247214ce9984$var$closeNextItemsColumns(target);
        if (!target.classList.contains($01a0247214ce9984$var$HAVE_PARENT_CLASS_NAME)) return;
        $01a0247214ce9984$var$removeOpenClassByParent(parent);
        target.classList.add($01a0247214ce9984$var$OPENED_CLASS_NAME);
        const nextColumnElement = $01a0247214ce9984$var$openNextItemsColumn(target);
        const section = CATALOG_MENU_ITEMS.find((item)=>{
            const itemId = parseInt(item.id, 10);
            return itemId === sectionId;
        });
        const subsections = CATALOG_MENU_ITEMS.filter((item)=>{
            return section.subsections.includes(item.id);
        });
        $01a0247214ce9984$var$renderItems(nextColumnElement, subsections);
    });
};
function $01a0247214ce9984$var$navItemHoverInit(targetElement) {
    const navItemElements = targetElement.querySelectorAll(`.${$01a0247214ce9984$var$LINK_CLASS_NAME}:not(.${$01a0247214ce9984$var$OPENED_CLASS_NAME})`);
    if (navItemElements.length > 0) navItemElements.forEach((item)=>{
        item.addEventListener('mouseenter', (evt)=>{
            $01a0247214ce9984$var$navItemHoverHandler(evt, targetElement);
        });
    });
}
const $01a0247214ce9984$var$navItemHoverDestroy = (targetElement)=>{
    const navItemElements = targetElement.querySelectorAll(`.${$01a0247214ce9984$var$LINK_CLASS_NAME}`);
    if (navItemElements.length > 0) navItemElements.forEach((item)=>{
        item.removeEventListener('mouseenter', $01a0247214ce9984$var$navItemHoverHandler);
    });
};
const $01a0247214ce9984$var$resetCatalog = ()=>{
    const openedLinks = $01a0247214ce9984$var$catalogNavElement.querySelectorAll(`.${$01a0247214ce9984$var$OPENED_CLASS_NAME}`);
    openedLinks.forEach((link)=>link.classList.remove($01a0247214ce9984$var$OPENED_CLASS_NAME));
    const columns = $01a0247214ce9984$var$catalogNavElement.querySelectorAll(`.${$01a0247214ce9984$var$COLUMN_CLASS_NAME}`);
    columns.forEach((column, index)=>{
        if (index === 0) {
            const loader = column.querySelector(`.${$01a0247214ce9984$var$LOADER_CLASS_NAME}`);
            if (loader) loader.classList.add($01a0247214ce9984$var$HIDDEN_LOADER_CLASS_NAME);
        } else {
            column.classList.add($01a0247214ce9984$var$HIDDEN_COLUMN_CLASS_NAME);
            const list = column.querySelector('.catalog-nav__list');
            if (list) list.remove();
        }
    });
};
const $01a0247214ce9984$var$openerClickHandler = (e)=>{
    e.preventDefault();
    const isHidden = getComputedStyle($01a0247214ce9984$var$catalogNavElement).display === 'none';
    $01a0247214ce9984$var$catalogNavElement.style.display = isHidden ? 'block' : 'none';
    $01a0247214ce9984$var$openerElement.classList.toggle('header__catalog-button--active');
    if (isHidden) {
        (0, $43829a6f0e34d097$export$1cf7a143bd720192)();
        $01a0247214ce9984$var$navItemHoverInit($01a0247214ce9984$var$catalogNavElement);
    } else {
        (0, $43829a6f0e34d097$export$2b9a380dc68c7d45)();
        $01a0247214ce9984$var$navItemHoverDestroy($01a0247214ce9984$var$catalogNavElement);
        $01a0247214ce9984$var$resetCatalog();
    }
};
if ($01a0247214ce9984$var$openerElement && window.innerWidth >= 1024) {
    const closeCatalog = ()=>{
        $01a0247214ce9984$var$catalogNavElement.style.display = 'none';
        $01a0247214ce9984$var$openerElement.classList.remove('header__catalog-button--active');
        (0, $43829a6f0e34d097$export$2b9a380dc68c7d45)();
        $01a0247214ce9984$var$navItemHoverDestroy($01a0247214ce9984$var$catalogNavElement);
        $01a0247214ce9984$var$resetCatalog();
    };
    const documentClickHandler = (e)=>{
        if ($01a0247214ce9984$var$catalogNavElement.style.display === 'block' && !$01a0247214ce9984$var$catalogNavElement.contains(e.target) && !$01a0247214ce9984$var$openerElement.contains(e.target)) closeCatalog();
    };
    document.addEventListener('click', documentClickHandler);
    $01a0247214ce9984$var$openerElement.addEventListener('click', $01a0247214ce9984$var$openerClickHandler);
}


/* eslint no-global-assign: "error" */ /* global ymaps:writable */ ymaps = window.ymaps;
if (ymaps) ymaps.ready(()=>{
    const zoomControl = new ymaps.control.ZoomControl({
        options: {
            float: 'none',
            position: {
                bottom: '50px',
                right: '30px'
            }
        }
    });
    const map = new ymaps.Map('company-map', {
        center: [
            48.49837,
            135.038769
        ],
        zoom: 16,
        controls: [
            zoomControl
        ]
    });
    map.behaviors.disable('scrollZoom');
    const HintLayout = ymaps.templateLayoutFactory.createClass("<div class='map-hint'>\u0443\u043B.\u0422\u0438\u0445\u043E\u043E\u043A\u0435\u0430\u043D\u0441\u043A\u0430\u044F, 73, \u043B\u0438\u0442 \u04111</div>", {
        getShape () {
            const el = this.getElement();
            let result = null;
            if (el) {
                const { firstChild: firstChild } = el;
                result = new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                    [
                        0,
                        0
                    ],
                    [
                        firstChild.offsetWidth,
                        firstChild.offsetHeight
                    ]
                ]));
            }
            return result;
        }
    });
    const placemark = new ymaps.Placemark([
        48.49837,
        135.038769
    ], {
        address: "\u0443\u043B.\u0422\u0438\u0445\u043E\u043E\u043A\u0435\u0430\u043D\u0441\u043A\u0430\u044F, 73, \u043B\u0438\u0442 \u04111"
    }, {
        hintLayout: HintLayout,
        iconLayout: 'default#image',
        iconImageHref: '/local/templates/supplier/assets/src/images/contacts/map-pin.svg',
        iconImageSize: [
            62,
            79
        ],
        iconImageOffset: [
            -31,
            -79
        ]
    });
    map.geoObjects.add(placemark);
});


const $55a7cb8e02d189d6$var$switchFieldVisibility = (idList, isHide)=>{
    if (idList.length <= 0) return;
    idList.forEach((item)=>{
        const fieldWrap = document.querySelector(`#${item}`);
        if (fieldWrap) {
            const formElements = fieldWrap.querySelectorAll('[name]');
            formElements.forEach((item)=>{
                const errorClassName = `${item.classList[0]}--error`;
                item.classList.remove(errorClassName);
                item.disabled = isHide;
                item.required = !isHide;
                item.tabIndex = isHide ? '-1' : '0';
            });
            fieldWrap.classList.toggle('visually-hidden', isHide);
        }
    });
};
const $55a7cb8e02d189d6$var$switchFieldInit = ()=>{
    const triggerElements = document.querySelectorAll('.switch-field-trigger');
    if (triggerElements.length > 0) triggerElements.forEach((item)=>{
        item.addEventListener('change', (evt)=>{
            const displayedFields = evt.target.dataset.displayedFields ? evt.target.dataset.displayedFields.split(' ') : [];
            const hiddenFields = evt.target.dataset.hiddenFields ? evt.target.dataset.hiddenFields.split(' ') : [];
            if (displayedFields.length > 0) $55a7cb8e02d189d6$var$switchFieldVisibility(displayedFields, false);
            if (hiddenFields.length > 0) $55a7cb8e02d189d6$var$switchFieldVisibility(hiddenFields, true);
        });
    });
};
document.addEventListener('DOMContentLoaded', ()=>{
    $55a7cb8e02d189d6$var$switchFieldInit();
});


const $ba47b2d160b5b9fb$var$clickListTriggerHandler = (evt)=>{
    const listElement = evt.currentTarget.nextElementSibling;
    if (listElement) {
        const listElementTrigger = listElement.parentElement.querySelector('.two-level-list__sub-list-trigger');
        listElementTrigger.classList.toggle('two-level-list__sub-list-trigger--active');
        listElement.classList.toggle('two-level-list__sub-list--open');
    }
};
document.addEventListener('DOMContentLoaded', ()=>{
    if (window.innerWidth < 1024) {
        const listTriggerElements = document.querySelectorAll('.two-level-list__sub-list-trigger');
        if (listTriggerElements.length > 0) listTriggerElements.forEach((item)=>{
            item.addEventListener('click', $ba47b2d160b5b9fb$var$clickListTriggerHandler);
        });
    }
});


const $9a4bfff5dffba651$export$4c67a568b2e7f1af = ()=>{
    const alertElements = document.querySelectorAll('.alert-wrap:not(.alert-wrap--static)');
    if (alertElements.length) alertElements.forEach((item)=>{
        item.remove();
    });
};
const $9a4bfff5dffba651$export$de026b00723010c1 = (insertPlace, position, message, type)=>{
    $9a4bfff5dffba651$export$4c67a568b2e7f1af();
    const data = `<div class="alert-wrap"><div class="alert alert--${type}">${message}</div></div>`;
    insertPlace.insertAdjacentHTML(position, data);
};


const $f2d2d5ccac893b6a$export$46cfff9ec9272f81 = (dialogElement, isHidden = false, isClearForm = false)=>{
    const form = dialogElement.querySelector('form[name]');
    if (form) {
        isClearForm && form.reset();
        form.classList.toggle('hidden', isHidden);
    }
};
const $f2d2d5ccac893b6a$var$backDropClickHandler = ({ currentTarget: currentTarget, target: target }, dialogElement)=>{
    const isClickedOnBackDrop = target === currentTarget;
    if (isClickedOnBackDrop) dialogElement.close();
};
const $f2d2d5ccac893b6a$var$dialogAddEventHandler = (dialogElement)=>{
    dialogElement.addEventListener('close', ()=>{
        dialogElement.removeEventListener('click', $f2d2d5ccac893b6a$var$backDropClickHandler);
        (0, $9a4bfff5dffba651$export$4c67a568b2e7f1af)();
        $f2d2d5ccac893b6a$export$46cfff9ec9272f81(dialogElement);
    }, {
        once: true
    });
};
const $f2d2d5ccac893b6a$export$32562b6fed4c6551 = (evt, dialogElement, callback = null)=>{
    dialogElement.showModal();
    setTimeout(()=>{
        $f2d2d5ccac893b6a$var$dialogAddEventHandler(dialogElement);
    }, 100);
    if (callback) callback(evt);
};
const $f2d2d5ccac893b6a$export$59a5ddcbc0f77a29 = (currentDialog)=>{
    const dialogModals = document.querySelectorAll('dialog');
    dialogModals.forEach((dialog)=>{
        if (!currentDialog || dialog.id !== currentDialog) dialog.close();
    });
};


/** Checks if value is string */ function $93906f2a377dc74e$export$844ec244b1367d54(str) {
    return typeof str === 'string' || str instanceof String;
}
/** Checks if value is object */ function $93906f2a377dc74e$export$a6cdc56e425d0d0a(obj) {
    var _obj$constructor;
    return typeof obj === 'object' && obj != null && (obj == null || (_obj$constructor = obj.constructor) == null ? void 0 : _obj$constructor.name) === 'Object';
}
function $93906f2a377dc74e$export$357523c63a2253b9(obj, keys) {
    if (Array.isArray(keys)) return $93906f2a377dc74e$export$357523c63a2253b9(obj, (_, k)=>keys.includes(k));
    return Object.entries(obj).reduce((acc, _ref)=>{
        let [k, v] = _ref;
        if (keys(v, k)) acc[k] = v;
        return acc;
    }, {});
}
/** Direction */ const $93906f2a377dc74e$export$9106728c49045482 = {
    NONE: 'NONE',
    LEFT: 'LEFT',
    FORCE_LEFT: 'FORCE_LEFT',
    RIGHT: 'RIGHT',
    FORCE_RIGHT: 'FORCE_RIGHT'
};
/** Direction */ function $93906f2a377dc74e$export$32af4dafed14c8ce(direction) {
    switch(direction){
        case $93906f2a377dc74e$export$9106728c49045482.LEFT:
            return $93906f2a377dc74e$export$9106728c49045482.FORCE_LEFT;
        case $93906f2a377dc74e$export$9106728c49045482.RIGHT:
            return $93906f2a377dc74e$export$9106728c49045482.FORCE_RIGHT;
        default:
            return direction;
    }
}
/** Escapes regular expression control chars */ function $93906f2a377dc74e$export$7c57da42ce8e346f(str) {
    return str.replace(/([.*+?^=!:${}()|[\]/\\])/g, '\\$1');
}
// cloned from https://github.com/epoberezkin/fast-deep-equal with small changes
function $93906f2a377dc74e$export$7aeb68f71172641d(b, a) {
    if (a === b) return true;
    const arrA = Array.isArray(a), arrB = Array.isArray(b);
    let i;
    if (arrA && arrB) {
        if (a.length != b.length) return false;
        for(i = 0; i < a.length; i++)if (!$93906f2a377dc74e$export$7aeb68f71172641d(a[i], b[i])) return false;
        return true;
    }
    if (arrA != arrB) return false;
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        const dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA && dateB) return a.getTime() == b.getTime();
        if (dateA != dateB) return false;
        const regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA && regexpB) return a.toString() == b.toString();
        if (regexpA != regexpB) return false;
        const keys = Object.keys(a);
        // if (keys.length !== Object.keys(b).length) return false;
        for(i = 0; i < keys.length; i++)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = 0; i < keys.length; i++)if (!$93906f2a377dc74e$export$7aeb68f71172641d(b[keys[i]], a[keys[i]])) return false;
        return true;
    } else if (a && b && typeof a === 'function' && typeof b === 'function') return a.toString() === b.toString();
    return false;
}



/** Provides details of changing input */ class $61d1aadea9846d62$export$2e2bcd8739ae039 {
    /** Current input value */ /** Current cursor position */ /** Old input value */ /** Old selection */ constructor(opts){
        Object.assign(this, opts);
        // double check if left part was changed (autofilling, other non-standard input triggers)
        while(this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos))--this.oldSelection.start;
        if (this.insertedCount) {
            // double check right part
            while(this.value.slice(this.cursorPos) !== this.oldValue.slice(this.oldSelection.end))if (this.value.length - this.cursorPos < this.oldValue.length - this.oldSelection.end) ++this.oldSelection.end;
            else ++this.cursorPos;
        }
    }
    /** Start changing position */ get startChangePos() {
        return Math.min(this.cursorPos, this.oldSelection.start);
    }
    /** Inserted symbols count */ get insertedCount() {
        return this.cursorPos - this.startChangePos;
    }
    /** Inserted symbols */ get inserted() {
        return this.value.substr(this.startChangePos, this.insertedCount);
    }
    /** Removed symbols count */ get removedCount() {
        // Math.max for opposite operation
        return Math.max(this.oldSelection.end - this.startChangePos || // for Delete
        this.oldValue.length - this.value.length, 0);
    }
    /** Removed symbols */ get removed() {
        return this.oldValue.substr(this.startChangePos, this.removedCount);
    }
    /** Unchanged head symbols */ get head() {
        return this.value.substring(0, this.startChangePos);
    }
    /** Unchanged tail symbols */ get tail() {
        return this.value.substring(this.startChangePos + this.insertedCount);
    }
    /** Remove direction */ get removeDirection() {
        if (!this.removedCount || this.insertedCount) return (0, $93906f2a377dc74e$export$9106728c49045482).NONE;
        // align right if delete at right
        return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) && // if not range removed (event with backspace)
        this.oldSelection.end === this.oldSelection.start ? (0, $93906f2a377dc74e$export$9106728c49045482).RIGHT : (0, $93906f2a377dc74e$export$9106728c49045482).LEFT;
    }
}



/** Applies mask on element */ function $9f3c06206bc5b9fe$export$2e2bcd8739ae039(el, opts) {
    // currently available only for input-like elements
    return new $9f3c06206bc5b9fe$export$2e2bcd8739ae039.InputMask(el, opts);
}


// TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754
// export function maskedClass(mask: string): typeof MaskedPattern;
// export function maskedClass(mask: DateConstructor): typeof MaskedDate;
// export function maskedClass(mask: NumberConstructor): typeof MaskedNumber;
// export function maskedClass(mask: Array<any> | ArrayConstructor): typeof MaskedDynamic;
// export function maskedClass(mask: MaskedDate): typeof MaskedDate;
// export function maskedClass(mask: MaskedNumber): typeof MaskedNumber;
// export function maskedClass(mask: MaskedEnum): typeof MaskedEnum;
// export function maskedClass(mask: MaskedRange): typeof MaskedRange;
// export function maskedClass(mask: MaskedRegExp): typeof MaskedRegExp;
// export function maskedClass(mask: MaskedFunction): typeof MaskedFunction;
// export function maskedClass(mask: MaskedPattern): typeof MaskedPattern;
// export function maskedClass(mask: MaskedDynamic): typeof MaskedDynamic;
// export function maskedClass(mask: Masked): typeof Masked;
// export function maskedClass(mask: typeof Masked): typeof Masked;
// export function maskedClass(mask: typeof MaskedDate): typeof MaskedDate;
// export function maskedClass(mask: typeof MaskedNumber): typeof MaskedNumber;
// export function maskedClass(mask: typeof MaskedEnum): typeof MaskedEnum;
// export function maskedClass(mask: typeof MaskedRange): typeof MaskedRange;
// export function maskedClass(mask: typeof MaskedRegExp): typeof MaskedRegExp;
// export function maskedClass(mask: typeof MaskedFunction): typeof MaskedFunction;
// export function maskedClass(mask: typeof MaskedPattern): typeof MaskedPattern;
// export function maskedClass(mask: typeof MaskedDynamic): typeof MaskedDynamic;
// export function maskedClass<Mask extends typeof Masked> (mask: Mask): Mask;
// export function maskedClass(mask: RegExp): typeof MaskedRegExp;
// export function maskedClass(mask: (value: string, ...args: any[]) => boolean): typeof MaskedFunction;
/** Get Masked class by mask type */ function $14fa5ae7a370b810$export$81ad4b1539a22420(mask) /* TODO */ {
    if (mask == null) throw new Error('mask property should be defined');
    if (mask instanceof RegExp) return (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedRegExp;
    if ((0, $93906f2a377dc74e$export$844ec244b1367d54)(mask)) return (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedPattern;
    if (mask === Date) return (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedDate;
    if (mask === Number) return (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedNumber;
    if (Array.isArray(mask) || mask === Array) return (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedDynamic;
    if ((0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked && mask.prototype instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked) return mask;
    if ((0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked && mask instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked) return mask.constructor;
    if (mask instanceof Function) return (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedFunction;
    console.warn('Mask not found for mask', mask); // eslint-disable-line no-console
    return (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked;
}
function $14fa5ae7a370b810$export$a213ae1c699d7230(opts) {
    if (!opts) throw new Error('Options in not defined');
    if ((0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked) {
        if (opts.prototype instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked) return {
            mask: opts
        };
        /*
      handle cases like:
      1) opts = Masked
      2) opts = { mask: Masked, ...instanceOpts }
    */ const { mask: mask, ...instanceOpts } = opts instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked ? {
            mask: opts
        } : (0, $93906f2a377dc74e$export$a6cdc56e425d0d0a)(opts) && opts.mask instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked ? opts : {};
        if (mask) {
            const _mask = mask.mask;
            return {
                ...(0, $93906f2a377dc74e$export$357523c63a2253b9)(mask, (_, k)=>!k.startsWith('_')),
                mask: mask.constructor,
                _mask: _mask,
                ...instanceOpts
            };
        }
    }
    if (!(0, $93906f2a377dc74e$export$a6cdc56e425d0d0a)(opts)) return {
        mask: opts
    };
    return {
        ...opts
    };
}
// TODO can't use overloads here because of https://github.com/microsoft/TypeScript/issues/50754
// From masked
// export default function createMask<Opts extends Masked, ReturnMasked=Opts> (opts: Opts): ReturnMasked;
// // From masked class
// export default function createMask<Opts extends MaskedOptions<typeof Masked>, ReturnMasked extends Masked=InstanceType<Opts['mask']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedDate>, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedNumber>, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedEnum>, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedRange>, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedRegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedFunction>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedPattern>, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<typeof MaskedDynamic>, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
// // From mask opts
// export default function createMask<Opts extends MaskedOptions<Masked>, ReturnMasked=Opts extends MaskedOptions<infer M> ? M : never> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedNumberOptions, ReturnMasked extends MaskedNumber=MaskedNumber<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedDateFactoryOptions, ReturnMasked extends MaskedDate=MaskedDate<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedEnumOptions, ReturnMasked extends MaskedEnum=MaskedEnum<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedRangeOptions, ReturnMasked extends MaskedRange=MaskedRange<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedPatternOptions, ReturnMasked extends MaskedPattern=MaskedPattern<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedDynamicOptions, ReturnMasked extends MaskedDynamic=MaskedDynamic<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<RegExp>, ReturnMasked extends MaskedRegExp=MaskedRegExp<Opts['parent']>> (opts: Opts): ReturnMasked;
// export default function createMask<Opts extends MaskedOptions<Function>, ReturnMasked extends MaskedFunction=MaskedFunction<Opts['parent']>> (opts: Opts): ReturnMasked;
/** Creates new {@link Masked} depending on mask type */ function $14fa5ae7a370b810$export$2e2bcd8739ae039(opts) {
    if ((0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked && opts instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked) return opts;
    const nOpts = $14fa5ae7a370b810$export$a213ae1c699d7230(opts);
    const MaskedClass = $14fa5ae7a370b810$export$81ad4b1539a22420(nOpts.mask);
    if (!MaskedClass) throw new Error("Masked class is not found for provided mask " + nOpts.mask + ", appropriate module needs to be imported manually before creating mask.");
    if (nOpts.mask === MaskedClass) delete nOpts.mask;
    if (nOpts._mask) {
        nOpts.mask = nOpts._mask;
        delete nOpts._mask;
    }
    return new MaskedClass(nOpts);
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).createMask = $14fa5ae7a370b810$export$2e2bcd8739ae039;



/**  Generic element API to use with mask */ class $e44dc73cca9b04dc$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** Safely returns selection start */ get selectionStart() {
        let start;
        try {
            start = this._unsafeSelectionStart;
        } catch  {}
        return start != null ? start : this.value.length;
    }
    /** Safely returns selection end */ get selectionEnd() {
        let end;
        try {
            end = this._unsafeSelectionEnd;
        } catch  {}
        return end != null ? end : this.value.length;
    }
    /** Safely sets element selection */ select(start, end) {
        if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd) return;
        try {
            this._unsafeSelect(start, end);
        } catch  {}
    }
    /** */ get isActive() {
        return false;
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskElement = $e44dc73cca9b04dc$export$2e2bcd8739ae039;




const $848bd4079eb9bf5d$var$KEY_Z = 90;
const $848bd4079eb9bf5d$var$KEY_Y = 89;
/** Bridge between HTMLElement and {@link Masked} */ class $848bd4079eb9bf5d$export$2e2bcd8739ae039 extends (0, $e44dc73cca9b04dc$export$2e2bcd8739ae039) {
    /** HTMLElement to use mask on */ constructor(input){
        super();
        this.input = input;
        this._onKeydown = this._onKeydown.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onBeforeinput = this._onBeforeinput.bind(this);
        this._onCompositionEnd = this._onCompositionEnd.bind(this);
    }
    get rootElement() {
        var _this$input$getRootNo, _this$input$getRootNo2, _this$input;
        return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) == null ? void 0 : _this$input$getRootNo2.call(_this$input)) != null ? _this$input$getRootNo : document;
    }
    /** Is element in focus */ get isActive() {
        return this.input === this.rootElement.activeElement;
    }
    /** Binds HTMLElement events to mask internal events */ bindEvents(handlers) {
        this.input.addEventListener('keydown', this._onKeydown);
        this.input.addEventListener('input', this._onInput);
        this.input.addEventListener('beforeinput', this._onBeforeinput);
        this.input.addEventListener('compositionend', this._onCompositionEnd);
        this.input.addEventListener('drop', handlers.drop);
        this.input.addEventListener('click', handlers.click);
        this.input.addEventListener('focus', handlers.focus);
        this.input.addEventListener('blur', handlers.commit);
        this._handlers = handlers;
    }
    _onKeydown(e) {
        if (this._handlers.redo && (e.keyCode === $848bd4079eb9bf5d$var$KEY_Z && e.shiftKey && (e.metaKey || e.ctrlKey) || e.keyCode === $848bd4079eb9bf5d$var$KEY_Y && e.ctrlKey)) {
            e.preventDefault();
            return this._handlers.redo(e);
        }
        if (this._handlers.undo && e.keyCode === $848bd4079eb9bf5d$var$KEY_Z && (e.metaKey || e.ctrlKey)) {
            e.preventDefault();
            return this._handlers.undo(e);
        }
        if (!e.isComposing) this._handlers.selectionChange(e);
    }
    _onBeforeinput(e) {
        if (e.inputType === 'historyUndo' && this._handlers.undo) {
            e.preventDefault();
            return this._handlers.undo(e);
        }
        if (e.inputType === 'historyRedo' && this._handlers.redo) {
            e.preventDefault();
            return this._handlers.redo(e);
        }
    }
    _onCompositionEnd(e) {
        this._handlers.input(e);
    }
    _onInput(e) {
        if (!e.isComposing) this._handlers.input(e);
    }
    /** Unbinds HTMLElement events to mask internal events */ unbindEvents() {
        this.input.removeEventListener('keydown', this._onKeydown);
        this.input.removeEventListener('input', this._onInput);
        this.input.removeEventListener('beforeinput', this._onBeforeinput);
        this.input.removeEventListener('compositionend', this._onCompositionEnd);
        this.input.removeEventListener('drop', this._handlers.drop);
        this.input.removeEventListener('click', this._handlers.click);
        this.input.removeEventListener('focus', this._handlers.focus);
        this.input.removeEventListener('blur', this._handlers.commit);
        this._handlers = {};
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).HTMLMaskElement = $848bd4079eb9bf5d$export$2e2bcd8739ae039;




/** Bridge between InputElement and {@link Masked} */ class $19dd1dae5da417e0$export$2e2bcd8739ae039 extends (0, $848bd4079eb9bf5d$export$2e2bcd8739ae039) {
    /** InputElement to use mask on */ constructor(input){
        super(input);
        this.input = input;
    }
    /** Returns InputElement selection start */ get _unsafeSelectionStart() {
        return this.input.selectionStart != null ? this.input.selectionStart : this.value.length;
    }
    /** Returns InputElement selection end */ get _unsafeSelectionEnd() {
        return this.input.selectionEnd;
    }
    /** Sets InputElement selection */ _unsafeSelect(start, end) {
        this.input.setSelectionRange(start, end);
    }
    get value() {
        return this.input.value;
    }
    set value(value) {
        this.input.value = value;
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).HTMLMaskElement = (0, $848bd4079eb9bf5d$export$2e2bcd8739ae039);





class $a9ad28f650e1e6f1$export$2e2bcd8739ae039 extends (0, $848bd4079eb9bf5d$export$2e2bcd8739ae039) {
    /** Returns HTMLElement selection start */ get _unsafeSelectionStart() {
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        const anchorOffset = selection && selection.anchorOffset;
        const focusOffset = selection && selection.focusOffset;
        if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) return anchorOffset;
        return focusOffset;
    }
    /** Returns HTMLElement selection end */ get _unsafeSelectionEnd() {
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        const anchorOffset = selection && selection.anchorOffset;
        const focusOffset = selection && selection.focusOffset;
        if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) return anchorOffset;
        return focusOffset;
    }
    /** Sets HTMLElement selection */ _unsafeSelect(start, end) {
        if (!this.rootElement.createRange) return;
        const range = this.rootElement.createRange();
        range.setStart(this.input.firstChild || this.input, start);
        range.setEnd(this.input.lastChild || this.input, end);
        const root = this.rootElement;
        const selection = root.getSelection && root.getSelection();
        if (selection) {
            selection.removeAllRanges();
            selection.addRange(range);
        }
    }
    /** HTMLElement value */ get value() {
        return this.input.textContent || '';
    }
    set value(value) {
        this.input.textContent = value;
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).HTMLContenteditableMaskElement = $a9ad28f650e1e6f1$export$2e2bcd8739ae039;



class $e1bccc8c26586292$export$2e2bcd8739ae039 {
    constructor(){
        this.states = [];
        this.currentIndex = 0;
    }
    get currentState() {
        return this.states[this.currentIndex];
    }
    get isEmpty() {
        return this.states.length === 0;
    }
    push(state) {
        // if current index points before the last element then remove the future
        if (this.currentIndex < this.states.length - 1) this.states.length = this.currentIndex + 1;
        this.states.push(state);
        if (this.states.length > $e1bccc8c26586292$export$2e2bcd8739ae039.MAX_LENGTH) this.states.shift();
        this.currentIndex = this.states.length - 1;
    }
    go(steps) {
        this.currentIndex = Math.min(Math.max(this.currentIndex + steps, 0), this.states.length - 1);
        return this.currentState;
    }
    undo() {
        return this.go(-1);
    }
    redo() {
        return this.go(1);
    }
    clear() {
        this.states.length = 0;
        this.currentIndex = 0;
    }
}
$e1bccc8c26586292$export$2e2bcd8739ae039.MAX_LENGTH = 100;



/** Listens to element events and controls changes between element and {@link Masked} */ class $426ce1bac78b56b7$export$2e2bcd8739ae039 {
    /**
    View element
  */ /** Internal {@link Masked} model */ constructor(el, opts){
        this.el = el instanceof (0, $e44dc73cca9b04dc$export$2e2bcd8739ae039) ? el : el.isContentEditable && el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA' ? new (0, $a9ad28f650e1e6f1$export$2e2bcd8739ae039)(el) : new (0, $19dd1dae5da417e0$export$2e2bcd8739ae039)(el);
        this.masked = (0, $14fa5ae7a370b810$export$2e2bcd8739ae039)(opts);
        this._listeners = {};
        this._value = '';
        this._unmaskedValue = '';
        this._rawInputValue = '';
        this.history = new (0, $e1bccc8c26586292$export$2e2bcd8739ae039)();
        this._saveSelection = this._saveSelection.bind(this);
        this._onInput = this._onInput.bind(this);
        this._onChange = this._onChange.bind(this);
        this._onDrop = this._onDrop.bind(this);
        this._onFocus = this._onFocus.bind(this);
        this._onClick = this._onClick.bind(this);
        this._onUndo = this._onUndo.bind(this);
        this._onRedo = this._onRedo.bind(this);
        this.alignCursor = this.alignCursor.bind(this);
        this.alignCursorFriendly = this.alignCursorFriendly.bind(this);
        this._bindEvents();
        // refresh
        this.updateValue();
        this._onChange();
    }
    maskEquals(mask) {
        var _this$masked;
        return mask == null || ((_this$masked = this.masked) == null ? void 0 : _this$masked.maskEquals(mask));
    }
    /** Masked */ get mask() {
        return this.masked.mask;
    }
    set mask(mask) {
        if (this.maskEquals(mask)) return;
        if (!(mask instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked) && this.masked.constructor === (0, $14fa5ae7a370b810$export$81ad4b1539a22420)(mask)) {
            // TODO "any" no idea
            this.masked.updateOptions({
                mask: mask
            });
            return;
        }
        const masked = mask instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked ? mask : (0, $14fa5ae7a370b810$export$2e2bcd8739ae039)({
            mask: mask
        });
        masked.unmaskedValue = this.masked.unmaskedValue;
        this.masked = masked;
    }
    /** Raw value */ get value() {
        return this._value;
    }
    set value(str) {
        if (this.value === str) return;
        this.masked.value = str;
        this.updateControl('auto');
    }
    /** Unmasked value */ get unmaskedValue() {
        return this._unmaskedValue;
    }
    set unmaskedValue(str) {
        if (this.unmaskedValue === str) return;
        this.masked.unmaskedValue = str;
        this.updateControl('auto');
    }
    /** Raw input value */ get rawInputValue() {
        return this._rawInputValue;
    }
    set rawInputValue(str) {
        if (this.rawInputValue === str) return;
        this.masked.rawInputValue = str;
        this.updateControl();
        this.alignCursor();
    }
    /** Typed unmasked value */ get typedValue() {
        return this.masked.typedValue;
    }
    set typedValue(val) {
        if (this.masked.typedValueEquals(val)) return;
        this.masked.typedValue = val;
        this.updateControl('auto');
    }
    /** Display value */ get displayValue() {
        return this.masked.displayValue;
    }
    /** Starts listening to element events */ _bindEvents() {
        this.el.bindEvents({
            selectionChange: this._saveSelection,
            input: this._onInput,
            drop: this._onDrop,
            click: this._onClick,
            focus: this._onFocus,
            commit: this._onChange,
            undo: this._onUndo,
            redo: this._onRedo
        });
    }
    /** Stops listening to element events */ _unbindEvents() {
        if (this.el) this.el.unbindEvents();
    }
    /** Fires custom event */ _fireEvent(ev, e) {
        const listeners = this._listeners[ev];
        if (!listeners) return;
        listeners.forEach((l)=>l(e));
    }
    /** Current selection start */ get selectionStart() {
        return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
    }
    /** Current cursor position */ get cursorPos() {
        return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
    }
    set cursorPos(pos) {
        if (!this.el || !this.el.isActive) return;
        this.el.select(pos, pos);
        this._saveSelection();
    }
    /** Stores current selection */ _saveSelection() {
        if (this.displayValue !== this.el.value) console.warn('Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.'); // eslint-disable-line no-console
        this._selection = {
            start: this.selectionStart,
            end: this.cursorPos
        };
    }
    /** Syncronizes model value from view */ updateValue() {
        this.masked.value = this.el.value;
        this._value = this.masked.value;
        this._unmaskedValue = this.masked.unmaskedValue;
        this._rawInputValue = this.masked.rawInputValue;
    }
    /** Syncronizes view from model value, fires change events */ updateControl(cursorPos) {
        const newUnmaskedValue = this.masked.unmaskedValue;
        const newValue = this.masked.value;
        const newRawInputValue = this.masked.rawInputValue;
        const newDisplayValue = this.displayValue;
        const isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue || this._rawInputValue !== newRawInputValue;
        this._unmaskedValue = newUnmaskedValue;
        this._value = newValue;
        this._rawInputValue = newRawInputValue;
        if (this.el.value !== newDisplayValue) this.el.value = newDisplayValue;
        if (cursorPos === 'auto') this.alignCursor();
        else if (cursorPos != null) this.cursorPos = cursorPos;
        if (isChanged) this._fireChangeEvents();
        if (!this._historyChanging && (isChanged || this.history.isEmpty)) this.history.push({
            unmaskedValue: newUnmaskedValue,
            selection: {
                start: this.selectionStart,
                end: this.cursorPos
            }
        });
    }
    /** Updates options with deep equal check, recreates {@link Masked} model if mask type changes */ updateOptions(opts) {
        const { mask: mask, ...restOpts } = opts; // TODO types, yes, mask is optional
        const updateMask = !this.maskEquals(mask);
        const updateOpts = this.masked.optionsIsChanged(restOpts);
        if (updateMask) this.mask = mask;
        if (updateOpts) this.masked.updateOptions(restOpts); // TODO
        if (updateMask || updateOpts) this.updateControl();
    }
    /** Updates cursor */ updateCursor(cursorPos) {
        if (cursorPos == null) return;
        this.cursorPos = cursorPos;
        // also queue change cursor for mobile browsers
        this._delayUpdateCursor(cursorPos);
    }
    /** Delays cursor update to support mobile browsers */ _delayUpdateCursor(cursorPos) {
        this._abortUpdateCursor();
        this._changingCursorPos = cursorPos;
        this._cursorChanging = setTimeout(()=>{
            if (!this.el) return; // if was destroyed
            this.cursorPos = this._changingCursorPos;
            this._abortUpdateCursor();
        }, 10);
    }
    /** Fires custom events */ _fireChangeEvents() {
        this._fireEvent('accept', this._inputEvent);
        if (this.masked.isComplete) this._fireEvent('complete', this._inputEvent);
    }
    /** Aborts delayed cursor update */ _abortUpdateCursor() {
        if (this._cursorChanging) {
            clearTimeout(this._cursorChanging);
            delete this._cursorChanging;
        }
    }
    /** Aligns cursor to nearest available position */ alignCursor() {
        this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, (0, $93906f2a377dc74e$export$9106728c49045482).LEFT));
    }
    /** Aligns cursor only if selection is empty */ alignCursorFriendly() {
        if (this.selectionStart !== this.cursorPos) return; // skip if range is selected
        this.alignCursor();
    }
    /** Adds listener on custom event */ on(ev, handler) {
        if (!this._listeners[ev]) this._listeners[ev] = [];
        this._listeners[ev].push(handler);
        return this;
    }
    /** Removes custom event listener */ off(ev, handler) {
        if (!this._listeners[ev]) return this;
        if (!handler) {
            delete this._listeners[ev];
            return this;
        }
        const hIndex = this._listeners[ev].indexOf(handler);
        if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
        return this;
    }
    /** Handles view input event */ _onInput(e) {
        this._inputEvent = e;
        this._abortUpdateCursor();
        const details = new (0, $61d1aadea9846d62$export$2e2bcd8739ae039)({
            // new state
            value: this.el.value,
            cursorPos: this.cursorPos,
            // old state
            oldValue: this.displayValue,
            oldSelection: this._selection
        });
        const oldRawValue = this.masked.rawInputValue;
        const offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection, {
            input: true,
            raw: true
        }).offset;
        // force align in remove direction only if no input chars were removed
        // otherwise we still need to align with NONE (to get out from fixed symbols for instance)
        const removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : (0, $93906f2a377dc74e$export$9106728c49045482).NONE;
        let cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
        if (removeDirection !== (0, $93906f2a377dc74e$export$9106728c49045482).NONE) cursorPos = this.masked.nearestInputPos(cursorPos, (0, $93906f2a377dc74e$export$9106728c49045482).NONE);
        this.updateControl(cursorPos);
        delete this._inputEvent;
    }
    /** Handles view change event and commits model value */ _onChange() {
        if (this.displayValue !== this.el.value) this.updateValue();
        this.masked.doCommit();
        this.updateControl();
        this._saveSelection();
    }
    /** Handles view drop event, prevents by default */ _onDrop(ev) {
        ev.preventDefault();
        ev.stopPropagation();
    }
    /** Restore last selection on focus */ _onFocus(ev) {
        this.alignCursorFriendly();
    }
    /** Restore last selection on focus */ _onClick(ev) {
        this.alignCursorFriendly();
    }
    _onUndo() {
        this._applyHistoryState(this.history.undo());
    }
    _onRedo() {
        this._applyHistoryState(this.history.redo());
    }
    _applyHistoryState(state) {
        if (!state) return;
        this._historyChanging = true;
        this.unmaskedValue = state.unmaskedValue;
        this.el.select(state.selection.start, state.selection.end);
        this._saveSelection();
        this._historyChanging = false;
    }
    /** Unbind view events and removes element reference */ destroy() {
        this._unbindEvents();
        this._listeners.length = 0;
        delete this.el;
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).InputMask = $426ce1bac78b56b7$export$2e2bcd8739ae039;








/** Provides details of changing model value */ class $ef0ad9fa705f5579$export$2e2bcd8739ae039 {
    /** Inserted symbols */ /** Additional offset if any changes occurred before tail */ /** Raw inserted is used by dynamic mask */ /** Can skip chars */ static normalize(prep) {
        return Array.isArray(prep) ? prep : [
            prep,
            new $ef0ad9fa705f5579$export$2e2bcd8739ae039()
        ];
    }
    constructor(details){
        Object.assign(this, {
            inserted: '',
            rawInserted: '',
            tailShift: 0,
            skip: false
        }, details);
    }
    /** Aggregate changes */ aggregate(details) {
        this.inserted += details.inserted;
        this.rawInserted += details.rawInserted;
        this.tailShift += details.tailShift;
        this.skip = this.skip || details.skip;
        return this;
    }
    /** Total offset considering all changes */ get offset() {
        return this.tailShift + this.inserted.length;
    }
    get consumed() {
        return Boolean(this.rawInserted) || this.skip;
    }
    equals(details) {
        return this.inserted === details.inserted && this.tailShift === details.tailShift && this.rawInserted === details.rawInserted && this.skip === details.skip;
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).ChangeDetails = $ef0ad9fa705f5579$export$2e2bcd8739ae039;




/** Provides details of continuous extracted tail */ class $c9d9fedd20e4a1e7$export$2e2bcd8739ae039 {
    /** Tail value as string */ /** Tail start position */ /** Start position */ constructor(value, from, stop){
        if (value === void 0) value = '';
        if (from === void 0) from = 0;
        this.value = value;
        this.from = from;
        this.stop = stop;
    }
    toString() {
        return this.value;
    }
    extend(tail) {
        this.value += String(tail);
    }
    appendTo(masked) {
        return masked.append(this.toString(), {
            tail: true
        }).aggregate(masked._appendPlaceholder());
    }
    get state() {
        return {
            value: this.value,
            from: this.from,
            stop: this.stop
        };
    }
    set state(state) {
        Object.assign(this, state);
    }
    unshift(beforePos) {
        if (!this.value.length || beforePos != null && this.from >= beforePos) return '';
        const shiftChar = this.value[0];
        this.value = this.value.slice(1);
        return shiftChar;
    }
    shift() {
        if (!this.value.length) return '';
        const shiftChar = this.value[this.value.length - 1];
        this.value = this.value.slice(0, -1);
        return shiftChar;
    }
}




/** Append flags */ /** Extract flags */ // see https://github.com/microsoft/TypeScript/issues/6223
/** Provides common masking stuff */ class $e23198c8dcc9cc5a$export$2e2bcd8739ae039 {
    /** */ /** */ /** Transforms value before mask processing */ /** Transforms each char before mask processing */ /** Validates if value is acceptable */ /** Does additional processing at the end of editing */ /** Format typed value to string */ /** Parse string to get typed value */ /** Enable characters overwriting */ /** */ /** */ /** */ /** */ constructor(opts){
        this._value = '';
        this._update({
            ...$e23198c8dcc9cc5a$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        });
        this._initialized = true;
    }
    /** Sets and applies new options */ updateOptions(opts) {
        if (!this.optionsIsChanged(opts)) return;
        this.withValueRefresh(this._update.bind(this, opts));
    }
    /** Sets new options */ _update(opts) {
        Object.assign(this, opts);
    }
    /** Mask state */ get state() {
        return {
            _value: this.value,
            _rawInputValue: this.rawInputValue
        };
    }
    set state(state) {
        this._value = state._value;
    }
    /** Resets value */ reset() {
        this._value = '';
    }
    get value() {
        return this._value;
    }
    set value(value) {
        this.resolve(value, {
            input: true
        });
    }
    /** Resolve new value */ resolve(value, flags) {
        if (flags === void 0) flags = {
            input: true
        };
        this.reset();
        this.append(value, flags, '');
        this.doCommit();
    }
    get unmaskedValue() {
        return this.value;
    }
    set unmaskedValue(value) {
        this.resolve(value, {});
    }
    get typedValue() {
        return this.parse ? this.parse(this.value, this) : this.unmaskedValue;
    }
    set typedValue(value) {
        if (this.format) this.value = this.format(value, this);
        else this.unmaskedValue = String(value);
    }
    /** Value that includes raw user input */ get rawInputValue() {
        return this.extractInput(0, this.displayValue.length, {
            raw: true
        });
    }
    set rawInputValue(value) {
        this.resolve(value, {
            raw: true
        });
    }
    get displayValue() {
        return this.value;
    }
    get isComplete() {
        return true;
    }
    get isFilled() {
        return this.isComplete;
    }
    /** Finds nearest input position in direction */ nearestInputPos(cursorPos, direction) {
        return cursorPos;
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        return Math.min(this.displayValue.length, toPos - fromPos);
    }
    /** Extracts value in range considering flags */ extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        return this.displayValue.slice(fromPos, toPos);
    }
    /** Extracts tail in range */ extractTail(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        return new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)(this.extractInput(fromPos, toPos), fromPos);
    }
    /** Appends tail */ appendTail(tail) {
        if ((0, $93906f2a377dc74e$export$844ec244b1367d54)(tail)) tail = new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)(String(tail));
        return tail.appendTo(this);
    }
    /** Appends char */ _appendCharRaw(ch, flags) {
        if (!ch) return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        this._value += ch;
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)({
            inserted: ch,
            rawInserted: ch
        });
    }
    /** Appends char */ _appendChar(ch, flags, checkTail) {
        if (flags === void 0) flags = {};
        const consistentState = this.state;
        let details;
        [ch, details] = this.doPrepareChar(ch, flags);
        if (ch) {
            details = details.aggregate(this._appendCharRaw(ch, flags));
            // TODO handle `skip`?
            // try `autofix` lookahead
            if (!details.rawInserted && this.autofix === 'pad') {
                const noFixState = this.state;
                this.state = consistentState;
                let fixDetails = this.pad(flags);
                const chDetails = this._appendCharRaw(ch, flags);
                fixDetails = fixDetails.aggregate(chDetails);
                // if fix was applied or
                // if details are equal use skip restoring state optimization
                if (chDetails.rawInserted || fixDetails.equals(details)) details = fixDetails;
                else this.state = noFixState;
            }
        }
        if (details.inserted) {
            let consistentTail;
            let appended = this.doValidate(flags) !== false;
            if (appended && checkTail != null) {
                // validation ok, check tail
                const beforeTailState = this.state;
                if (this.overwrite === true) {
                    consistentTail = checkTail.state;
                    for(let i = 0; i < details.rawInserted.length; ++i)checkTail.unshift(this.displayValue.length - details.tailShift);
                }
                let tailDetails = this.appendTail(checkTail);
                appended = tailDetails.rawInserted.length === checkTail.toString().length;
                // not ok, try shift
                if (!(appended && tailDetails.inserted) && this.overwrite === 'shift') {
                    this.state = beforeTailState;
                    consistentTail = checkTail.state;
                    for(let i = 0; i < details.rawInserted.length; ++i)checkTail.shift();
                    tailDetails = this.appendTail(checkTail);
                    appended = tailDetails.rawInserted.length === checkTail.toString().length;
                }
                // if ok, rollback state after tail
                if (appended && tailDetails.inserted) this.state = beforeTailState;
            }
            // revert all if something went wrong
            if (!appended) {
                details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
                this.state = consistentState;
                if (checkTail && consistentTail) checkTail.state = consistentTail;
            }
        }
        return details;
    }
    /** Appends optional placeholder at the end */ _appendPlaceholder() {
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
    /** Appends optional eager placeholder at the end */ _appendEager() {
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
    /** Appends symbols considering flags */ append(str, flags, tail) {
        if (!(0, $93906f2a377dc74e$export$844ec244b1367d54)(str)) throw new Error('value should be string');
        const checkTail = (0, $93906f2a377dc74e$export$844ec244b1367d54)(tail) ? new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)(String(tail)) : tail;
        if (flags != null && flags.tail) flags._beforeTailState = this.state;
        let details;
        [str, details] = this.doPrepare(str, flags);
        for(let ci = 0; ci < str.length; ++ci){
            const d = this._appendChar(str[ci], flags, checkTail);
            if (!d.rawInserted && !this.doSkipInvalid(str[ci], flags, checkTail)) break;
            details.aggregate(d);
        }
        if ((this.eager === true || this.eager === 'append') && flags != null && flags.input && str) details.aggregate(this._appendEager());
        // append tail but aggregate only tailShift
        if (checkTail != null) details.tailShift += this.appendTail(checkTail).tailShift;
        return details;
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        this._value = this.displayValue.slice(0, fromPos) + this.displayValue.slice(toPos);
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
    /** Calls function and reapplies current value */ withValueRefresh(fn) {
        if (this._refreshing || !this._initialized) return fn();
        this._refreshing = true;
        const rawInput = this.rawInputValue;
        const value = this.value;
        const ret = fn();
        this.rawInputValue = rawInput;
        // append lost trailing chars at the end
        if (this.value && this.value !== value && value.indexOf(this.value) === 0) {
            this.append(value.slice(this.displayValue.length), {}, '');
            this.doCommit();
        }
        delete this._refreshing;
        return ret;
    }
    runIsolated(fn) {
        if (this._isolated || !this._initialized) return fn(this);
        this._isolated = true;
        const state = this.state;
        const ret = fn(this);
        this.state = state;
        delete this._isolated;
        return ret;
    }
    doSkipInvalid(ch, flags, checkTail) {
        return Boolean(this.skipInvalid);
    }
    /** Prepares string before mask processing */ doPrepare(str, flags) {
        if (flags === void 0) flags = {};
        return (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039).normalize(this.prepare ? this.prepare(str, this, flags) : str);
    }
    /** Prepares each char before mask processing */ doPrepareChar(str, flags) {
        if (flags === void 0) flags = {};
        return (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039).normalize(this.prepareChar ? this.prepareChar(str, this, flags) : str);
    }
    /** Validates if value is acceptable */ doValidate(flags) {
        return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
    }
    /** Does additional processing at the end of editing */ doCommit() {
        if (this.commit) this.commit(this.value, this);
    }
    splice(start, deleteCount, inserted, removeDirection, flags) {
        if (inserted === void 0) inserted = '';
        if (removeDirection === void 0) removeDirection = (0, $93906f2a377dc74e$export$9106728c49045482).NONE;
        if (flags === void 0) flags = {
            input: true
        };
        const tailPos = start + deleteCount;
        const tail = this.extractTail(tailPos);
        const eagerRemove = this.eager === true || this.eager === 'remove';
        let oldRawValue;
        if (eagerRemove) {
            removeDirection = (0, $93906f2a377dc74e$export$32af4dafed14c8ce)(removeDirection);
            oldRawValue = this.extractInput(0, tailPos, {
                raw: true
            });
        }
        let startChangePos = start;
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        // if it is just deletion without insertion
        if (removeDirection !== (0, $93906f2a377dc74e$export$9106728c49045482).NONE) {
            startChangePos = this.nearestInputPos(start, deleteCount > 1 && start !== 0 && !eagerRemove ? (0, $93906f2a377dc74e$export$9106728c49045482).NONE : removeDirection);
            // adjust tailShift if start was aligned
            details.tailShift = startChangePos - start;
        }
        details.aggregate(this.remove(startChangePos));
        if (eagerRemove && removeDirection !== (0, $93906f2a377dc74e$export$9106728c49045482).NONE && oldRawValue === this.rawInputValue) {
            if (removeDirection === (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT) {
                let valLength;
                while(oldRawValue === this.rawInputValue && (valLength = this.displayValue.length))details.aggregate(new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)({
                    tailShift: -1
                })).aggregate(this.remove(valLength - 1));
            } else if (removeDirection === (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT) tail.unshift();
        }
        return details.aggregate(this.append(inserted, flags, tail));
    }
    maskEquals(mask) {
        return this.mask === mask;
    }
    optionsIsChanged(opts) {
        return !(0, $93906f2a377dc74e$export$7aeb68f71172641d)(this, opts);
    }
    typedValueEquals(value) {
        const tval = this.typedValue;
        return value === tval || $e23198c8dcc9cc5a$export$2e2bcd8739ae039.EMPTY_VALUES.includes(value) && $e23198c8dcc9cc5a$export$2e2bcd8739ae039.EMPTY_VALUES.includes(tval) || (this.format ? this.format(value, this) === this.format(this.typedValue, this) : false);
    }
    pad(flags) {
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
}
$e23198c8dcc9cc5a$export$2e2bcd8739ae039.DEFAULTS = {
    skipInvalid: true
};
$e23198c8dcc9cc5a$export$2e2bcd8739ae039.EMPTY_VALUES = [
    undefined,
    null,
    ''
];
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).Masked = $e23198c8dcc9cc5a$export$2e2bcd8739ae039;











class $28324efa3f559998$export$2e2bcd8739ae039 {
    /** */ constructor(chunks, from){
        if (chunks === void 0) chunks = [];
        if (from === void 0) from = 0;
        this.chunks = chunks;
        this.from = from;
    }
    toString() {
        return this.chunks.map(String).join('');
    }
    extend(tailChunk) {
        if (!String(tailChunk)) return;
        tailChunk = (0, $93906f2a377dc74e$export$844ec244b1367d54)(tailChunk) ? new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)(String(tailChunk)) : tailChunk;
        const lastChunk = this.chunks[this.chunks.length - 1];
        const extendLast = lastChunk && // if stops are same or tail has no stop
        (lastChunk.stop === tailChunk.stop || tailChunk.stop == null) && // if tail chunk goes just after last chunk
        tailChunk.from === lastChunk.from + lastChunk.toString().length;
        if (tailChunk instanceof (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)) {
            // check the ability to extend previous chunk
            if (extendLast) // extend previous chunk
            lastChunk.extend(tailChunk.toString());
            else // append new chunk
            this.chunks.push(tailChunk);
        } else if (tailChunk instanceof $28324efa3f559998$export$2e2bcd8739ae039) {
            if (tailChunk.stop == null) {
                // unwrap floating chunks to parent, keeping `from` pos
                let firstTailChunk;
                while(tailChunk.chunks.length && tailChunk.chunks[0].stop == null){
                    firstTailChunk = tailChunk.chunks.shift(); // not possible to be `undefined` because length was checked above
                    firstTailChunk.from += tailChunk.from;
                    this.extend(firstTailChunk);
                }
            }
            // if tail chunk still has value
            if (tailChunk.toString()) {
                // if chunks contains stops, then popup stop to container
                tailChunk.stop = tailChunk.blockIndex;
                this.chunks.push(tailChunk);
            }
        }
    }
    appendTo(masked) {
        if (!(masked instanceof (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedPattern)) {
            const tail = new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)(this.toString());
            return tail.appendTo(masked);
        }
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        for(let ci = 0; ci < this.chunks.length; ++ci){
            const chunk = this.chunks[ci];
            const lastBlockIter = masked._mapPosToBlock(masked.displayValue.length);
            const stop = chunk.stop;
            let chunkBlock;
            if (stop != null && // if block not found or stop is behind lastBlock
            (!lastBlockIter || lastBlockIter.index <= stop)) {
                if (chunk instanceof $28324efa3f559998$export$2e2bcd8739ae039 || // for continuous block also check if stop is exist
                masked._stops.indexOf(stop) >= 0) details.aggregate(masked._appendPlaceholder(stop));
                chunkBlock = chunk instanceof $28324efa3f559998$export$2e2bcd8739ae039 && masked._blocks[stop];
            }
            if (chunkBlock) {
                const tailDetails = chunkBlock.appendTail(chunk);
                details.aggregate(tailDetails);
                // get not inserted chars
                const remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
                if (remainChars) details.aggregate(masked.append(remainChars, {
                    tail: true
                }));
            } else details.aggregate(masked.append(chunk.toString(), {
                tail: true
            }));
        }
        return details;
    }
    get state() {
        return {
            chunks: this.chunks.map((c)=>c.state),
            from: this.from,
            stop: this.stop,
            blockIndex: this.blockIndex
        };
    }
    set state(state) {
        const { chunks: chunks, ...props } = state;
        Object.assign(this, props);
        this.chunks = chunks.map((cstate)=>{
            const chunk = "chunks" in cstate ? new $28324efa3f559998$export$2e2bcd8739ae039() : new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)();
            chunk.state = cstate;
            return chunk;
        });
    }
    unshift(beforePos) {
        if (!this.chunks.length || beforePos != null && this.from >= beforePos) return '';
        const chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
        let ci = 0;
        while(ci < this.chunks.length){
            const chunk = this.chunks[ci];
            const shiftChar = chunk.unshift(chunkShiftPos);
            if (chunk.toString()) {
                // chunk still contains value
                // but not shifted - means no more available chars to shift
                if (!shiftChar) break;
                ++ci;
            } else // clean if chunk has no value
            this.chunks.splice(ci, 1);
            if (shiftChar) return shiftChar;
        }
        return '';
    }
    shift() {
        if (!this.chunks.length) return '';
        let ci = this.chunks.length - 1;
        while(0 <= ci){
            const chunk = this.chunks[ci];
            const shiftChar = chunk.shift();
            if (chunk.toString()) {
                // chunk still contains value
                // but not shifted - means no more available chars to shift
                if (!shiftChar) break;
                --ci;
            } else // clean if chunk has no value
            this.chunks.splice(ci, 1);
            if (shiftChar) return shiftChar;
        }
        return '';
    }
}



class $50f71afd352b9d43$export$2e2bcd8739ae039 {
    constructor(masked, pos){
        this.masked = masked;
        this._log = [];
        const { offset: offset, index: index } = masked._mapPosToBlock(pos) || (pos < 0 ? // first
        {
            index: 0,
            offset: 0
        } : // last
        {
            index: this.masked._blocks.length,
            offset: 0
        });
        this.offset = offset;
        this.index = index;
        this.ok = false;
    }
    get block() {
        return this.masked._blocks[this.index];
    }
    get pos() {
        return this.masked._blockStartPos(this.index) + this.offset;
    }
    get state() {
        return {
            index: this.index,
            offset: this.offset,
            ok: this.ok
        };
    }
    set state(s) {
        Object.assign(this, s);
    }
    pushState() {
        this._log.push(this.state);
    }
    popState() {
        const s = this._log.pop();
        if (s) this.state = s;
        return s;
    }
    bindBlock() {
        if (this.block) return;
        if (this.index < 0) {
            this.index = 0;
            this.offset = 0;
        }
        if (this.index >= this.masked._blocks.length) {
            this.index = this.masked._blocks.length - 1;
            this.offset = this.block.displayValue.length; // TODO this is stupid type error, `block` depends on index that was changed above
        }
    }
    _pushLeft(fn) {
        this.pushState();
        for(this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((_this$block = this.block) == null ? void 0 : _this$block.displayValue.length) || 0){
            var _this$block;
            if (fn()) return this.ok = true;
        }
        return this.ok = false;
    }
    _pushRight(fn) {
        this.pushState();
        for(this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0){
            if (fn()) return this.ok = true;
        }
        return this.ok = false;
    }
    pushLeftBeforeFilled() {
        return this._pushLeft(()=>{
            if (this.block.isFixed || !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT);
            if (this.offset !== 0) return true;
        });
    }
    pushLeftBeforeInput() {
        // cases:
        // filled input: 00|
        // optional empty input: 00[]|
        // nested block: XX<[]>|
        return this._pushLeft(()=>{
            if (this.block.isFixed) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $93906f2a377dc74e$export$9106728c49045482).LEFT);
            return true;
        });
    }
    pushLeftBeforeRequired() {
        return this._pushLeft(()=>{
            if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $93906f2a377dc74e$export$9106728c49045482).LEFT);
            return true;
        });
    }
    pushRightBeforeFilled() {
        return this._pushRight(()=>{
            if (this.block.isFixed || !this.block.value) return;
            this.offset = this.block.nearestInputPos(this.offset, (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT);
            if (this.offset !== this.block.value.length) return true;
        });
    }
    pushRightBeforeInput() {
        return this._pushRight(()=>{
            if (this.block.isFixed) return;
            // const o = this.offset;
            this.offset = this.block.nearestInputPos(this.offset, (0, $93906f2a377dc74e$export$9106728c49045482).NONE);
            // HACK cases like (STILL DOES NOT WORK FOR NESTED)
            // aa|X
            // aa<X|[]>X_    - this will not work
            // if (o && o === this.offset && this.block instanceof PatternInputDefinition) continue;
            return true;
        });
    }
    pushRightBeforeRequired() {
        return this._pushRight(()=>{
            if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
            // TODO check |[*]XX_
            this.offset = this.block.nearestInputPos(this.offset, (0, $93906f2a377dc74e$export$9106728c49045482).NONE);
            return true;
        });
    }
}






class $29e919e8e196db5e$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** */ /** */ /** */ constructor(opts){
        Object.assign(this, opts);
        this._value = '';
        this.isFixed = true;
    }
    get value() {
        return this._value;
    }
    get unmaskedValue() {
        return this.isUnmasking ? this.value : '';
    }
    get rawInputValue() {
        return this._isRawInput ? this.value : '';
    }
    get displayValue() {
        return this.value;
    }
    reset() {
        this._isRawInput = false;
        this._value = '';
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this._value.length;
        this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
        if (!this._value) this._isRawInput = false;
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
    nearestInputPos(cursorPos, direction) {
        if (direction === void 0) direction = (0, $93906f2a377dc74e$export$9106728c49045482).NONE;
        const minPos = 0;
        const maxPos = this._value.length;
        switch(direction){
            case (0, $93906f2a377dc74e$export$9106728c49045482).LEFT:
            case (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT:
                return minPos;
            case (0, $93906f2a377dc74e$export$9106728c49045482).NONE:
            case (0, $93906f2a377dc74e$export$9106728c49045482).RIGHT:
            case (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT:
            default:
                return maxPos;
        }
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this._value.length;
        return this._isRawInput ? toPos - fromPos : 0;
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this._value.length;
        if (flags === void 0) flags = {};
        return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || '';
    }
    get isComplete() {
        return true;
    }
    get isFilled() {
        return Boolean(this._value);
    }
    _appendChar(ch, flags) {
        if (flags === void 0) flags = {};
        if (this.isFilled) return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        const appendEager = this.eager === true || this.eager === 'append';
        const appended = this.char === ch;
        const isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && (!flags.raw || !appendEager) && !flags.tail;
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)({
            inserted: this.char,
            rawInserted: isResolved ? this.char : ''
        });
        this._value = this.char;
        this._isRawInput = isResolved && (flags.raw || flags.input);
        return details;
    }
    _appendEager() {
        return this._appendChar(this.char, {
            tail: true
        });
    }
    _appendPlaceholder() {
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        if (this.isFilled) return details;
        this._value = details.inserted = this.char;
        return details;
    }
    extractTail() {
        return new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)('');
    }
    appendTail(tail) {
        if ((0, $93906f2a377dc74e$export$844ec244b1367d54)(tail)) tail = new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)(String(tail));
        return tail.appendTo(this);
    }
    append(str, flags, tail) {
        const details = this._appendChar(str[0], flags);
        if (tail != null) details.tailShift += this.appendTail(tail).tailShift;
        return details;
    }
    doCommit() {}
    get state() {
        return {
            _value: this._value,
            _rawInputValue: this.rawInputValue
        };
    }
    set state(state) {
        this._value = state._value;
        this._isRawInput = Boolean(state._rawInputValue);
    }
    pad(flags) {
        return this._appendPlaceholder();
    }
}






class $4829a4cac6c619fb$export$2e2bcd8739ae039 {
    /** */ /** */ /** */ /** */ /** */ /** */ /** */ /** */ constructor(opts){
        const { parent: parent, isOptional: isOptional, placeholderChar: placeholderChar, displayChar: displayChar, lazy: lazy, eager: eager, ...maskOpts } = opts;
        this.masked = (0, $14fa5ae7a370b810$export$2e2bcd8739ae039)(maskOpts);
        Object.assign(this, {
            parent: parent,
            isOptional: isOptional,
            placeholderChar: placeholderChar,
            displayChar: displayChar,
            lazy: lazy,
            eager: eager
        });
    }
    reset() {
        this.isFilled = false;
        this.masked.reset();
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.value.length;
        if (fromPos === 0 && toPos >= 1) {
            this.isFilled = false;
            return this.masked.remove(fromPos, toPos);
        }
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
    get value() {
        return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : '');
    }
    get unmaskedValue() {
        return this.masked.unmaskedValue;
    }
    get rawInputValue() {
        return this.masked.rawInputValue;
    }
    get displayValue() {
        return this.masked.value && this.displayChar || this.value;
    }
    get isComplete() {
        return Boolean(this.masked.value) || this.isOptional;
    }
    _appendChar(ch, flags) {
        if (flags === void 0) flags = {};
        if (this.isFilled) return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        const state = this.masked.state;
        // simulate input
        let details = this.masked._appendChar(ch, this.currentMaskFlags(flags));
        if (details.inserted && this.doValidate(flags) === false) {
            details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
            this.masked.state = state;
        }
        if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) details.inserted = this.placeholderChar;
        details.skip = !details.inserted && !this.isOptional;
        this.isFilled = Boolean(details.inserted);
        return details;
    }
    append(str, flags, tail) {
        // TODO probably should be done via _appendChar
        return this.masked.append(str, this.currentMaskFlags(flags), tail);
    }
    _appendPlaceholder() {
        if (this.isFilled || this.isOptional) return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        this.isFilled = true;
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)({
            inserted: this.placeholderChar
        });
    }
    _appendEager() {
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
    extractTail(fromPos, toPos) {
        return this.masked.extractTail(fromPos, toPos);
    }
    appendTail(tail) {
        return this.masked.appendTail(tail);
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.value.length;
        return this.masked.extractInput(fromPos, toPos, flags);
    }
    nearestInputPos(cursorPos, direction) {
        if (direction === void 0) direction = (0, $93906f2a377dc74e$export$9106728c49045482).NONE;
        const minPos = 0;
        const maxPos = this.value.length;
        const boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);
        switch(direction){
            case (0, $93906f2a377dc74e$export$9106728c49045482).LEFT:
            case (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT:
                return this.isComplete ? boundPos : minPos;
            case (0, $93906f2a377dc74e$export$9106728c49045482).RIGHT:
            case (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT:
                return this.isComplete ? boundPos : maxPos;
            case (0, $93906f2a377dc74e$export$9106728c49045482).NONE:
            default:
                return boundPos;
        }
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.value.length;
        return this.value.slice(fromPos, toPos).length;
    }
    doValidate(flags) {
        return this.masked.doValidate(this.currentMaskFlags(flags)) && (!this.parent || this.parent.doValidate(this.currentMaskFlags(flags)));
    }
    doCommit() {
        this.masked.doCommit();
    }
    get state() {
        return {
            _value: this.value,
            _rawInputValue: this.rawInputValue,
            masked: this.masked.state,
            isFilled: this.isFilled
        };
    }
    set state(state) {
        this.masked.state = state.masked;
        this.isFilled = state.isFilled;
    }
    currentMaskFlags(flags) {
        var _flags$_beforeTailSta;
        return {
            ...flags,
            _beforeTailState: (flags == null || (_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.masked) || (flags == null ? void 0 : flags._beforeTailState)
        };
    }
    pad(flags) {
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
    }
}
$4829a4cac6c619fb$export$2e2bcd8739ae039.DEFAULT_DEFINITIONS = {
    '0': /\d/,
    'a': /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
    // http://stackoverflow.com/a/22075070
    '*': /./
};







/** Masking by RegExp */ class $d997fae97fd92d7a$export$2e2bcd8739ae039 extends (0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039) {
    /** */ /** Enable characters overwriting */ /** */ /** */ /** */ updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const mask = opts.mask;
        if (mask) opts.validate = (value)=>value.search(mask) >= 0;
        super._update(opts);
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedRegExp = $d997fae97fd92d7a$export$2e2bcd8739ae039;



/** Pattern mask */ class $836f3f1cf9656cb9$export$2e2bcd8739ae039 extends (0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039) {
    /** */ /** */ /** Single char for empty input */ /** Single char for filled input */ /** Show placeholder only when needed */ /** Enable characters overwriting */ /** */ /** */ /** */ constructor(opts){
        super({
            ...$836f3f1cf9656cb9$export$2e2bcd8739ae039.DEFAULTS,
            ...opts,
            definitions: Object.assign({}, (0, $4829a4cac6c619fb$export$2e2bcd8739ae039).DEFAULT_DEFINITIONS, opts == null ? void 0 : opts.definitions)
        });
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        opts.definitions = Object.assign({}, this.definitions, opts.definitions);
        super._update(opts);
        this._rebuildMask();
    }
    _rebuildMask() {
        const defs = this.definitions;
        this._blocks = [];
        this.exposeBlock = undefined;
        this._stops = [];
        this._maskedBlocks = {};
        const pattern = this.mask;
        if (!pattern || !defs) return;
        let unmaskingBlock = false;
        let optionalBlock = false;
        for(let i = 0; i < pattern.length; ++i){
            if (this.blocks) {
                const p = pattern.slice(i);
                const bNames = Object.keys(this.blocks).filter((bName)=>p.indexOf(bName) === 0);
                // order by key length
                bNames.sort((a, b)=>b.length - a.length);
                // use block name with max length
                const bName = bNames[0];
                if (bName) {
                    const { expose: expose, repeat: repeat, ...bOpts } = (0, $14fa5ae7a370b810$export$a213ae1c699d7230)(this.blocks[bName]); // TODO type Opts<Arg & Extra>
                    const blockOpts = {
                        lazy: this.lazy,
                        eager: this.eager,
                        placeholderChar: this.placeholderChar,
                        displayChar: this.displayChar,
                        overwrite: this.overwrite,
                        autofix: this.autofix,
                        ...bOpts,
                        repeat: repeat,
                        parent: this
                    };
                    const maskedBlock = repeat != null ? new (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).RepeatBlock(blockOpts /* TODO */ ) : (0, $14fa5ae7a370b810$export$2e2bcd8739ae039)(blockOpts);
                    if (maskedBlock) {
                        this._blocks.push(maskedBlock);
                        if (expose) this.exposeBlock = maskedBlock;
                        // store block index
                        if (!this._maskedBlocks[bName]) this._maskedBlocks[bName] = [];
                        this._maskedBlocks[bName].push(this._blocks.length - 1);
                    }
                    i += bName.length - 1;
                    continue;
                }
            }
            let char = pattern[i];
            let isInput = char in defs;
            if (char === $836f3f1cf9656cb9$export$2e2bcd8739ae039.STOP_CHAR) {
                this._stops.push(this._blocks.length);
                continue;
            }
            if (char === '{' || char === '}') {
                unmaskingBlock = !unmaskingBlock;
                continue;
            }
            if (char === '[' || char === ']') {
                optionalBlock = !optionalBlock;
                continue;
            }
            if (char === $836f3f1cf9656cb9$export$2e2bcd8739ae039.ESCAPE_CHAR) {
                ++i;
                char = pattern[i];
                if (!char) break;
                isInput = false;
            }
            const def = isInput ? new (0, $4829a4cac6c619fb$export$2e2bcd8739ae039)({
                isOptional: optionalBlock,
                lazy: this.lazy,
                eager: this.eager,
                placeholderChar: this.placeholderChar,
                displayChar: this.displayChar,
                ...(0, $14fa5ae7a370b810$export$a213ae1c699d7230)(defs[char]),
                parent: this
            }) : new (0, $29e919e8e196db5e$export$2e2bcd8739ae039)({
                char: char,
                eager: this.eager,
                isUnmasking: unmaskingBlock
            });
            this._blocks.push(def);
        }
    }
    get state() {
        return {
            ...super.state,
            _blocks: this._blocks.map((b)=>b.state)
        };
    }
    set state(state) {
        if (!state) {
            this.reset();
            return;
        }
        const { _blocks: _blocks, ...maskedState } = state;
        this._blocks.forEach((b, bi)=>b.state = _blocks[bi]);
        super.state = maskedState;
    }
    reset() {
        super.reset();
        this._blocks.forEach((b)=>b.reset());
    }
    get isComplete() {
        return this.exposeBlock ? this.exposeBlock.isComplete : this._blocks.every((b)=>b.isComplete);
    }
    get isFilled() {
        return this._blocks.every((b)=>b.isFilled);
    }
    get isFixed() {
        return this._blocks.every((b)=>b.isFixed);
    }
    get isOptional() {
        return this._blocks.every((b)=>b.isOptional);
    }
    doCommit() {
        this._blocks.forEach((b)=>b.doCommit());
        super.doCommit();
    }
    get unmaskedValue() {
        return this.exposeBlock ? this.exposeBlock.unmaskedValue : this._blocks.reduce((str, b)=>str += b.unmaskedValue, '');
    }
    set unmaskedValue(unmaskedValue) {
        if (this.exposeBlock) {
            const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
            this.exposeBlock.unmaskedValue = unmaskedValue;
            this.appendTail(tail);
            this.doCommit();
        } else super.unmaskedValue = unmaskedValue;
    }
    get value() {
        return this.exposeBlock ? this.exposeBlock.value : // TODO return _value when not in change?
        this._blocks.reduce((str, b)=>str += b.value, '');
    }
    set value(value) {
        if (this.exposeBlock) {
            const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
            this.exposeBlock.value = value;
            this.appendTail(tail);
            this.doCommit();
        } else super.value = value;
    }
    get typedValue() {
        return this.exposeBlock ? this.exposeBlock.typedValue : super.typedValue;
    }
    set typedValue(value) {
        if (this.exposeBlock) {
            const tail = this.extractTail(this._blockStartPos(this._blocks.indexOf(this.exposeBlock)) + this.exposeBlock.displayValue.length);
            this.exposeBlock.typedValue = value;
            this.appendTail(tail);
            this.doCommit();
        } else super.typedValue = value;
    }
    get displayValue() {
        return this._blocks.reduce((str, b)=>str += b.displayValue, '');
    }
    appendTail(tail) {
        return super.appendTail(tail).aggregate(this._appendPlaceholder());
    }
    _appendEager() {
        var _this$_mapPosToBlock;
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        let startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index;
        if (startBlockIndex == null) return details;
        // TODO test if it works for nested pattern masks
        if (this._blocks[startBlockIndex].isFilled) ++startBlockIndex;
        for(let bi = startBlockIndex; bi < this._blocks.length; ++bi){
            const d = this._blocks[bi]._appendEager();
            if (!d.inserted) break;
            details.aggregate(d);
        }
        return details;
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const blockIter = this._mapPosToBlock(this.displayValue.length);
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        if (!blockIter) return details;
        for(let bi = blockIter.index, block; block = this._blocks[bi]; ++bi){
            var _flags$_beforeTailSta;
            const blockDetails = block._appendChar(ch, {
                ...flags,
                _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
            });
            details.aggregate(blockDetails);
            if (blockDetails.consumed) break; // go next char
        }
        return details;
    }
    extractTail(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        const chunkTail = new (0, $28324efa3f559998$export$2e2bcd8739ae039)();
        if (fromPos === toPos) return chunkTail;
        this._forEachBlocksInRange(fromPos, toPos, (b, bi, bFromPos, bToPos)=>{
            const blockChunk = b.extractTail(bFromPos, bToPos);
            blockChunk.stop = this._findStopBefore(bi);
            blockChunk.from = this._blockStartPos(bi);
            if (blockChunk instanceof (0, $28324efa3f559998$export$2e2bcd8739ae039)) blockChunk.blockIndex = bi;
            chunkTail.extend(blockChunk);
        });
        return chunkTail;
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        if (flags === void 0) flags = {};
        if (fromPos === toPos) return '';
        let input = '';
        this._forEachBlocksInRange(fromPos, toPos, (b, _, fromPos, toPos)=>{
            input += b.extractInput(fromPos, toPos, flags);
        });
        return input;
    }
    _findStopBefore(blockIndex) {
        let stopBefore;
        for(let si = 0; si < this._stops.length; ++si){
            const stop = this._stops[si];
            if (stop <= blockIndex) stopBefore = stop;
            else break;
        }
        return stopBefore;
    }
    /** Appends placeholder depending on laziness */ _appendPlaceholder(toBlockIndex) {
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        if (this.lazy && toBlockIndex == null) return details;
        const startBlockIter = this._mapPosToBlock(this.displayValue.length);
        if (!startBlockIter) return details;
        const startBlockIndex = startBlockIter.index;
        const endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
        this._blocks.slice(startBlockIndex, endBlockIndex).forEach((b)=>{
            if (!b.lazy || toBlockIndex != null) {
                var _blocks2;
                details.aggregate(b._appendPlaceholder((_blocks2 = b._blocks) == null ? void 0 : _blocks2.length));
            }
        });
        return details;
    }
    /** Finds block in pos */ _mapPosToBlock(pos) {
        let accVal = '';
        for(let bi = 0; bi < this._blocks.length; ++bi){
            const block = this._blocks[bi];
            const blockStartPos = accVal.length;
            accVal += block.displayValue;
            if (pos <= accVal.length) return {
                index: bi,
                offset: pos - blockStartPos
            };
        }
    }
    _blockStartPos(blockIndex) {
        return this._blocks.slice(0, blockIndex).reduce((pos, b)=>pos += b.displayValue.length, 0);
    }
    _forEachBlocksInRange(fromPos, toPos, fn) {
        if (toPos === void 0) toPos = this.displayValue.length;
        const fromBlockIter = this._mapPosToBlock(fromPos);
        if (fromBlockIter) {
            const toBlockIter = this._mapPosToBlock(toPos);
            // process first block
            const isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
            const fromBlockStartPos = fromBlockIter.offset;
            const fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].displayValue.length;
            fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
            if (toBlockIter && !isSameBlock) {
                // process intermediate blocks
                for(let bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi)fn(this._blocks[bi], bi, 0, this._blocks[bi].displayValue.length);
                // process last block
                fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
            }
        }
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        const removeDetails = super.remove(fromPos, toPos);
        this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos)=>{
            removeDetails.aggregate(b.remove(bFromPos, bToPos));
        });
        return removeDetails;
    }
    nearestInputPos(cursorPos, direction) {
        if (direction === void 0) direction = (0, $93906f2a377dc74e$export$9106728c49045482).NONE;
        if (!this._blocks.length) return 0;
        const cursor = new (0, $50f71afd352b9d43$export$2e2bcd8739ae039)(this, cursorPos);
        if (direction === (0, $93906f2a377dc74e$export$9106728c49045482).NONE) {
            // -------------------------------------------------
            // NONE should only go out from fixed to the right!
            // -------------------------------------------------
            if (cursor.pushRightBeforeInput()) return cursor.pos;
            cursor.popState();
            if (cursor.pushLeftBeforeInput()) return cursor.pos;
            return this.displayValue.length;
        }
        // FORCE is only about a|* otherwise is 0
        if (direction === (0, $93906f2a377dc74e$export$9106728c49045482).LEFT || direction === (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT) {
            // try to break fast when *|a
            if (direction === (0, $93906f2a377dc74e$export$9106728c49045482).LEFT) {
                cursor.pushRightBeforeFilled();
                if (cursor.ok && cursor.pos === cursorPos) return cursorPos;
                cursor.popState();
            }
            // forward flow
            cursor.pushLeftBeforeInput();
            cursor.pushLeftBeforeRequired();
            cursor.pushLeftBeforeFilled();
            // backward flow
            if (direction === (0, $93906f2a377dc74e$export$9106728c49045482).LEFT) {
                cursor.pushRightBeforeInput();
                cursor.pushRightBeforeRequired();
                if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                cursor.popState();
                if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
                cursor.popState();
            }
            if (cursor.ok) return cursor.pos;
            if (direction === (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT) return 0;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            return 0;
        }
        if (direction === (0, $93906f2a377dc74e$export$9106728c49045482).RIGHT || direction === (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT) {
            // forward flow
            cursor.pushRightBeforeInput();
            cursor.pushRightBeforeRequired();
            if (cursor.pushRightBeforeFilled()) return cursor.pos;
            if (direction === (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT) return this.displayValue.length;
            // backward flow
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            cursor.popState();
            if (cursor.ok) return cursor.pos;
            return this.nearestInputPos(cursorPos, (0, $93906f2a377dc74e$export$9106728c49045482).LEFT);
        }
        return cursorPos;
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        let total = 0;
        this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos)=>{
            total += b.totalInputPositions(bFromPos, bToPos);
        });
        return total;
    }
    /** Get block by name */ maskedBlock(name) {
        return this.maskedBlocks(name)[0];
    }
    /** Get all blocks by name */ maskedBlocks(name) {
        const indices = this._maskedBlocks[name];
        if (!indices) return [];
        return indices.map((gi)=>this._blocks[gi]);
    }
    pad(flags) {
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        this._forEachBlocksInRange(0, this.displayValue.length, (b)=>details.aggregate(b.pad(flags)));
        return details;
    }
}
$836f3f1cf9656cb9$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039).DEFAULTS,
    lazy: true,
    placeholderChar: '_'
};
$836f3f1cf9656cb9$export$2e2bcd8739ae039.STOP_CHAR = '`';
$836f3f1cf9656cb9$export$2e2bcd8739ae039.ESCAPE_CHAR = '\\';
$836f3f1cf9656cb9$export$2e2bcd8739ae039.InputDefinition = (0, $4829a4cac6c619fb$export$2e2bcd8739ae039);
$836f3f1cf9656cb9$export$2e2bcd8739ae039.FixedDefinition = (0, $29e919e8e196db5e$export$2e2bcd8739ae039);
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedPattern = $836f3f1cf9656cb9$export$2e2bcd8739ae039;














/** Pattern which accepts ranges */ class $64d8260964bbd131$export$2e2bcd8739ae039 extends (0, $836f3f1cf9656cb9$export$2e2bcd8739ae039) {
    /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */ /** Min bound */ /** Max bound */ get _matchFrom() {
        return this.maxLength - String(this.from).length;
    }
    constructor(opts){
        super(opts); // mask will be created in _update
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const { to: to = this.to || 0, from: from = this.from || 0, maxLength: maxLength = this.maxLength || 0, autofix: autofix = this.autofix, ...patternOpts } = opts;
        this.to = to;
        this.from = from;
        this.maxLength = Math.max(String(to).length, maxLength);
        this.autofix = autofix;
        const fromStr = String(this.from).padStart(this.maxLength, '0');
        const toStr = String(this.to).padStart(this.maxLength, '0');
        let sameCharsCount = 0;
        while(sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount])++sameCharsCount;
        patternOpts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, '\\0') + '0'.repeat(this.maxLength - sameCharsCount);
        super._update(patternOpts);
    }
    get isComplete() {
        return super.isComplete && Boolean(this.value);
    }
    boundaries(str) {
        let minstr = '';
        let maxstr = '';
        const [, placeholder, num] = str.match(/^(\D*)(\d*)(\D*)/) || [];
        if (num) {
            minstr = '0'.repeat(placeholder.length) + num;
            maxstr = '9'.repeat(placeholder.length) + num;
        }
        minstr = minstr.padEnd(this.maxLength, '0');
        maxstr = maxstr.padEnd(this.maxLength, '9');
        return [
            minstr,
            maxstr
        ];
    }
    doPrepareChar(ch, flags) {
        if (flags === void 0) flags = {};
        let details;
        [ch, details] = super.doPrepareChar(ch.replace(/\D/g, ''), flags);
        if (!ch) details.skip = !this.isComplete;
        return [
            ch,
            details
        ];
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        if (!this.autofix || this.value.length + 1 > this.maxLength) return super._appendCharRaw(ch, flags);
        const fromStr = String(this.from).padStart(this.maxLength, '0');
        const toStr = String(this.to).padStart(this.maxLength, '0');
        const [minstr, maxstr] = this.boundaries(this.value + ch);
        if (Number(maxstr) < this.from) return super._appendCharRaw(fromStr[this.value.length], flags);
        if (Number(minstr) > this.to) {
            if (!flags.tail && this.autofix === 'pad' && this.value.length + 1 < this.maxLength) return super._appendCharRaw(fromStr[this.value.length], flags).aggregate(this._appendCharRaw(ch, flags));
            return super._appendCharRaw(toStr[this.value.length], flags);
        }
        return super._appendCharRaw(ch, flags);
    }
    doValidate(flags) {
        const str = this.value;
        const firstNonZero = str.search(/[^0]/);
        if (firstNonZero === -1 && str.length <= this._matchFrom) return true;
        const [minstr, maxstr] = this.boundaries(str);
        return this.from <= Number(maxstr) && Number(minstr) <= this.to && super.doValidate(flags);
    }
    pad(flags) {
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        if (this.value.length === this.maxLength) return details;
        const value = this.value;
        const padLength = this.maxLength - this.value.length;
        if (padLength) {
            this.reset();
            for(let i = 0; i < padLength; ++i)details.aggregate(super._appendCharRaw('0', flags));
            // append tail
            value.split('').forEach((ch)=>this._appendCharRaw(ch));
        }
        return details;
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedRange = $64d8260964bbd131$export$2e2bcd8739ae039;













const $bf0c0fae3831ac7d$var$DefaultPattern = 'd{.}`m{.}`Y';
// Make format and parse required when pattern is provided
/** Date mask */ class $bf0c0fae3831ac7d$export$2e2bcd8739ae039 extends (0, $836f3f1cf9656cb9$export$2e2bcd8739ae039) {
    static extractPatternOptions(opts) {
        const { mask: mask, pattern: pattern, ...patternOpts } = opts;
        return {
            ...patternOpts,
            mask: (0, $93906f2a377dc74e$export$844ec244b1367d54)(mask) ? mask : pattern
        };
    }
    /** Pattern mask for date according to {@link MaskedDate#format} */ /** Start date */ /** End date */ /** Format typed value to string */ /** Parse string to get typed value */ constructor(opts){
        super($bf0c0fae3831ac7d$export$2e2bcd8739ae039.extractPatternOptions({
            ...$bf0c0fae3831ac7d$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        }));
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const { mask: mask, pattern: pattern, blocks: blocks, ...patternOpts } = {
            ...$bf0c0fae3831ac7d$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        };
        const patternBlocks = Object.assign({}, $bf0c0fae3831ac7d$export$2e2bcd8739ae039.GET_DEFAULT_BLOCKS());
        // adjust year block
        if (opts.min) patternBlocks.Y.from = opts.min.getFullYear();
        if (opts.max) patternBlocks.Y.to = opts.max.getFullYear();
        if (opts.min && opts.max && patternBlocks.Y.from === patternBlocks.Y.to) {
            patternBlocks.m.from = opts.min.getMonth() + 1;
            patternBlocks.m.to = opts.max.getMonth() + 1;
            if (patternBlocks.m.from === patternBlocks.m.to) {
                patternBlocks.d.from = opts.min.getDate();
                patternBlocks.d.to = opts.max.getDate();
            }
        }
        Object.assign(patternBlocks, this.blocks, blocks);
        super._update({
            ...patternOpts,
            mask: (0, $93906f2a377dc74e$export$844ec244b1367d54)(mask) ? mask : pattern,
            blocks: patternBlocks
        });
    }
    doValidate(flags) {
        const date = this.date;
        return super.doValidate(flags) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
    }
    /** Checks if date is exists */ isDateExist(str) {
        return this.format(this.parse(str, this), this).indexOf(str) >= 0;
    }
    /** Parsed Date */ get date() {
        return this.typedValue;
    }
    set date(date) {
        this.typedValue = date;
    }
    get typedValue() {
        return this.isComplete ? super.typedValue : null;
    }
    set typedValue(value) {
        super.typedValue = value;
    }
    maskEquals(mask) {
        return mask === Date || super.maskEquals(mask);
    }
    optionsIsChanged(opts) {
        return super.optionsIsChanged($bf0c0fae3831ac7d$export$2e2bcd8739ae039.extractPatternOptions(opts));
    }
}
$bf0c0fae3831ac7d$export$2e2bcd8739ae039.GET_DEFAULT_BLOCKS = ()=>({
        d: {
            mask: (0, $64d8260964bbd131$export$2e2bcd8739ae039),
            from: 1,
            to: 31,
            maxLength: 2
        },
        m: {
            mask: (0, $64d8260964bbd131$export$2e2bcd8739ae039),
            from: 1,
            to: 12,
            maxLength: 2
        },
        Y: {
            mask: (0, $64d8260964bbd131$export$2e2bcd8739ae039),
            from: 1900,
            to: 9999
        }
    });
$bf0c0fae3831ac7d$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $836f3f1cf9656cb9$export$2e2bcd8739ae039).DEFAULTS,
    mask: Date,
    pattern: $bf0c0fae3831ac7d$var$DefaultPattern,
    format: (date, masked)=>{
        if (!date) return '';
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return [
            day,
            month,
            year
        ].join('.');
    },
    parse: (str, masked)=>{
        const [day, month, year] = str.split('.').map(Number);
        return new Date(year, month - 1, day);
    }
};
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedDate = $bf0c0fae3831ac7d$export$2e2bcd8739ae039;








/** Dynamic mask for choosing appropriate mask in run-time */ class $e5831edf0b46fed9$export$2e2bcd8739ae039 extends (0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039) {
    constructor(opts){
        super({
            ...$e5831edf0b46fed9$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        });
        this.currentMask = undefined;
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        super._update(opts);
        if ('mask' in opts) {
            this.exposeMask = undefined;
            // mask could be totally dynamic with only `dispatch` option
            this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map((m)=>{
                const { expose: expose, ...maskOpts } = (0, $14fa5ae7a370b810$export$a213ae1c699d7230)(m);
                const masked = (0, $14fa5ae7a370b810$export$2e2bcd8739ae039)({
                    overwrite: this._overwrite,
                    eager: this._eager,
                    skipInvalid: this._skipInvalid,
                    ...maskOpts
                });
                if (expose) this.exposeMask = masked;
                return masked;
            }) : [];
        // this.currentMask = this.doDispatch(''); // probably not needed but lets see
        }
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const details = this._applyDispatch(ch, flags);
        if (this.currentMask) details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags)));
        return details;
    }
    _applyDispatch(appended, flags, tail) {
        if (appended === void 0) appended = '';
        if (flags === void 0) flags = {};
        if (tail === void 0) tail = '';
        const prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
        const inputValue = this.rawInputValue;
        const insertValue = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._rawInputValue : inputValue;
        const tailValue = inputValue.slice(insertValue.length);
        const prevMask = this.currentMask;
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        const prevMaskState = prevMask == null ? void 0 : prevMask.state;
        // clone flags to prevent overwriting `_beforeTailState`
        this.currentMask = this.doDispatch(appended, {
            ...flags
        }, tail);
        // restore state after dispatch
        if (this.currentMask) {
            if (this.currentMask !== prevMask) {
                // if mask changed reapply input
                this.currentMask.reset();
                if (insertValue) {
                    this.currentMask.append(insertValue, {
                        raw: true
                    });
                    details.tailShift = this.currentMask.value.length - prevValueBeforeTail.length;
                }
                if (tailValue) details.tailShift += this.currentMask.append(tailValue, {
                    raw: true,
                    tail: true
                }).tailShift;
            } else if (prevMaskState) // Dispatch can do something bad with state, so
            // restore prev mask state
            this.currentMask.state = prevMaskState;
        }
        return details;
    }
    _appendPlaceholder() {
        const details = this._applyDispatch();
        if (this.currentMask) details.aggregate(this.currentMask._appendPlaceholder());
        return details;
    }
    _appendEager() {
        const details = this._applyDispatch();
        if (this.currentMask) details.aggregate(this.currentMask._appendEager());
        return details;
    }
    appendTail(tail) {
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        if (tail) details.aggregate(this._applyDispatch('', {}, tail));
        return details.aggregate(this.currentMask ? this.currentMask.appendTail(tail) : super.appendTail(tail));
    }
    currentMaskFlags(flags) {
        var _flags$_beforeTailSta, _flags$_beforeTailSta2;
        return {
            ...flags,
            _beforeTailState: ((_flags$_beforeTailSta = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta.currentMaskRef) === this.currentMask && ((_flags$_beforeTailSta2 = flags._beforeTailState) == null ? void 0 : _flags$_beforeTailSta2.currentMask) || flags._beforeTailState
        };
    }
    doDispatch(appended, flags, tail) {
        if (flags === void 0) flags = {};
        if (tail === void 0) tail = '';
        return this.dispatch(appended, this, flags, tail);
    }
    doValidate(flags) {
        return super.doValidate(flags) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags)));
    }
    doPrepare(str, flags) {
        if (flags === void 0) flags = {};
        let [s, details] = super.doPrepare(str, flags);
        if (this.currentMask) {
            let currentDetails;
            [s, currentDetails] = super.doPrepare(s, this.currentMaskFlags(flags));
            details = details.aggregate(currentDetails);
        }
        return [
            s,
            details
        ];
    }
    doPrepareChar(str, flags) {
        if (flags === void 0) flags = {};
        let [s, details] = super.doPrepareChar(str, flags);
        if (this.currentMask) {
            let currentDetails;
            [s, currentDetails] = super.doPrepareChar(s, this.currentMaskFlags(flags));
            details = details.aggregate(currentDetails);
        }
        return [
            s,
            details
        ];
    }
    reset() {
        var _this$currentMask;
        (_this$currentMask = this.currentMask) == null || _this$currentMask.reset();
        this.compiledMasks.forEach((m)=>m.reset());
    }
    get value() {
        return this.exposeMask ? this.exposeMask.value : this.currentMask ? this.currentMask.value : '';
    }
    set value(value) {
        if (this.exposeMask) {
            this.exposeMask.value = value;
            this.currentMask = this.exposeMask;
            this._applyDispatch();
        } else super.value = value;
    }
    get unmaskedValue() {
        return this.exposeMask ? this.exposeMask.unmaskedValue : this.currentMask ? this.currentMask.unmaskedValue : '';
    }
    set unmaskedValue(unmaskedValue) {
        if (this.exposeMask) {
            this.exposeMask.unmaskedValue = unmaskedValue;
            this.currentMask = this.exposeMask;
            this._applyDispatch();
        } else super.unmaskedValue = unmaskedValue;
    }
    get typedValue() {
        return this.exposeMask ? this.exposeMask.typedValue : this.currentMask ? this.currentMask.typedValue : '';
    }
    set typedValue(typedValue) {
        if (this.exposeMask) {
            this.exposeMask.typedValue = typedValue;
            this.currentMask = this.exposeMask;
            this._applyDispatch();
            return;
        }
        let unmaskedValue = String(typedValue);
        // double check it
        if (this.currentMask) {
            this.currentMask.typedValue = typedValue;
            unmaskedValue = this.currentMask.unmaskedValue;
        }
        this.unmaskedValue = unmaskedValue;
    }
    get displayValue() {
        return this.currentMask ? this.currentMask.displayValue : '';
    }
    get isComplete() {
        var _this$currentMask2;
        return Boolean((_this$currentMask2 = this.currentMask) == null ? void 0 : _this$currentMask2.isComplete);
    }
    get isFilled() {
        var _this$currentMask3;
        return Boolean((_this$currentMask3 = this.currentMask) == null ? void 0 : _this$currentMask3.isFilled);
    }
    remove(fromPos, toPos) {
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        if (this.currentMask) details.aggregate(this.currentMask.remove(fromPos, toPos))// update with dispatch
        .aggregate(this._applyDispatch());
        return details;
    }
    get state() {
        var _this$currentMask4;
        return {
            ...super.state,
            _rawInputValue: this.rawInputValue,
            compiledMasks: this.compiledMasks.map((m)=>m.state),
            currentMaskRef: this.currentMask,
            currentMask: (_this$currentMask4 = this.currentMask) == null ? void 0 : _this$currentMask4.state
        };
    }
    set state(state) {
        const { compiledMasks: compiledMasks, currentMaskRef: currentMaskRef, currentMask: currentMask, ...maskedState } = state;
        if (compiledMasks) this.compiledMasks.forEach((m, mi)=>m.state = compiledMasks[mi]);
        if (currentMaskRef != null) {
            this.currentMask = currentMaskRef;
            this.currentMask.state = currentMask;
        }
        super.state = maskedState;
    }
    extractInput(fromPos, toPos, flags) {
        return this.currentMask ? this.currentMask.extractInput(fromPos, toPos, flags) : '';
    }
    extractTail(fromPos, toPos) {
        return this.currentMask ? this.currentMask.extractTail(fromPos, toPos) : super.extractTail(fromPos, toPos);
    }
    doCommit() {
        if (this.currentMask) this.currentMask.doCommit();
        super.doCommit();
    }
    nearestInputPos(cursorPos, direction) {
        return this.currentMask ? this.currentMask.nearestInputPos(cursorPos, direction) : super.nearestInputPos(cursorPos, direction);
    }
    get overwrite() {
        return this.currentMask ? this.currentMask.overwrite : this._overwrite;
    }
    set overwrite(overwrite) {
        this._overwrite = overwrite;
    }
    get eager() {
        return this.currentMask ? this.currentMask.eager : this._eager;
    }
    set eager(eager) {
        this._eager = eager;
    }
    get skipInvalid() {
        return this.currentMask ? this.currentMask.skipInvalid : this._skipInvalid;
    }
    set skipInvalid(skipInvalid) {
        this._skipInvalid = skipInvalid;
    }
    get autofix() {
        return this.currentMask ? this.currentMask.autofix : this._autofix;
    }
    set autofix(autofix) {
        this._autofix = autofix;
    }
    maskEquals(mask) {
        return Array.isArray(mask) ? this.compiledMasks.every((m, mi)=>{
            if (!mask[mi]) return;
            const { mask: oldMask, ...restOpts } = mask[mi];
            return (0, $93906f2a377dc74e$export$7aeb68f71172641d)(m, restOpts) && m.maskEquals(oldMask);
        }) : super.maskEquals(mask);
    }
    typedValueEquals(value) {
        var _this$currentMask5;
        return Boolean((_this$currentMask5 = this.currentMask) == null ? void 0 : _this$currentMask5.typedValueEquals(value));
    }
}
/** Currently chosen mask */ /** Currently chosen mask */ /** Compliled {@link Masked} options */ /** Chooses {@link Masked} depending on input value */ $e5831edf0b46fed9$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039).DEFAULTS,
    dispatch: (appended, masked, flags, tail)=>{
        if (!masked.compiledMasks.length) return;
        const inputValue = masked.rawInputValue;
        // simulate input
        const inputs = masked.compiledMasks.map((m, index)=>{
            const isCurrent = masked.currentMask === m;
            const startInputPos = isCurrent ? m.displayValue.length : m.nearestInputPos(m.displayValue.length, (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT);
            if (m.rawInputValue !== inputValue) {
                m.reset();
                m.append(inputValue, {
                    raw: true
                });
            } else if (!isCurrent) m.remove(startInputPos);
            m.append(appended, masked.currentMaskFlags(flags));
            m.appendTail(tail);
            return {
                index: index,
                weight: m.rawInputValue.length,
                totalInputPositions: m.totalInputPositions(0, Math.max(startInputPos, m.nearestInputPos(m.displayValue.length, (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT)))
            };
        });
        // pop masks with longer values first
        inputs.sort((i1, i2)=>i2.weight - i1.weight || i2.totalInputPositions - i1.totalInputPositions);
        return masked.compiledMasks[inputs[0].index];
    }
};
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedDynamic = $e5831edf0b46fed9$export$2e2bcd8739ae039;














/** Pattern which validates enum values */ class $99ea44ae76da8219$export$2e2bcd8739ae039 extends (0, $836f3f1cf9656cb9$export$2e2bcd8739ae039) {
    constructor(opts){
        super({
            ...$99ea44ae76da8219$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        }); // mask will be created in _update
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        const { enum: enum_, ...eopts } = opts;
        if (enum_) {
            const lengths = enum_.map((e)=>e.length);
            const requiredLength = Math.min(...lengths);
            const optionalLength = Math.max(...lengths) - requiredLength;
            eopts.mask = '*'.repeat(requiredLength);
            if (optionalLength) eopts.mask += '[' + '*'.repeat(optionalLength) + ']';
            this.enum = enum_;
        }
        super._update(eopts);
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const matchFrom = Math.min(this.nearestInputPos(0, (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT), this.value.length);
        const matches = this.enum.filter((e)=>this.matchValue(e, this.unmaskedValue + ch, matchFrom));
        if (matches.length) {
            if (matches.length === 1) this._forEachBlocksInRange(0, this.value.length, (b, bi)=>{
                const mch = matches[0][bi];
                if (bi >= this.value.length || mch === b.value) return;
                b.reset();
                b._appendChar(mch, flags);
            });
            const d = super._appendCharRaw(matches[0][this.value.length], flags);
            if (matches.length === 1) matches[0].slice(this.unmaskedValue.length).split('').forEach((mch)=>d.aggregate(super._appendCharRaw(mch)));
            return d;
        }
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)({
            skip: !this.isComplete
        });
    }
    extractTail(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        // just drop tail
        return new (0, $c9d9fedd20e4a1e7$export$2e2bcd8739ae039)('', fromPos);
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        if (fromPos === toPos) return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        const matchFrom = Math.min(super.nearestInputPos(0, (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT), this.value.length);
        let pos;
        for(pos = fromPos; pos >= 0; --pos){
            const matches = this.enum.filter((e)=>this.matchValue(e, this.value.slice(matchFrom, pos), matchFrom));
            if (matches.length > 1) break;
        }
        const details = super.remove(pos, toPos);
        details.tailShift += pos - fromPos;
        return details;
    }
    get isComplete() {
        return this.enum.indexOf(this.value) >= 0;
    }
}
/** Match enum value */ $99ea44ae76da8219$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $836f3f1cf9656cb9$export$2e2bcd8739ae039).DEFAULTS,
    matchValue: (estr, istr, matchFrom)=>estr.indexOf(istr, matchFrom) === matchFrom
};
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedEnum = $99ea44ae76da8219$export$2e2bcd8739ae039;








/** Masking by custom Function */ class $4d81b642b6b84d27$export$2e2bcd8739ae039 extends (0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039) {
    /** */ /** Enable characters overwriting */ /** */ /** */ /** */ updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        super._update({
            ...opts,
            validate: opts.mask
        });
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedFunction = $4d81b642b6b84d27$export$2e2bcd8739ae039;







var $282132fc7196c51f$var$_MaskedNumber;
/** Number mask */ class $282132fc7196c51f$export$2e2bcd8739ae039 extends (0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039) {
    /** Single char */ /** Single char */ /** Array of single chars */ /** */ /** */ /** Digits after point */ /** Flag to remove leading and trailing zeros in the end of editing */ /** Flag to pad trailing zeros after point in the end of editing */ /** Enable characters overwriting */ /** */ /** */ /** */ /** Format typed value to string */ /** Parse string to get typed value */ constructor(opts){
        super({
            ...$282132fc7196c51f$export$2e2bcd8739ae039.DEFAULTS,
            ...opts
        });
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        super._update(opts);
        this._updateRegExps();
    }
    _updateRegExps() {
        const start = '^' + (this.allowNegative ? '[+|\\-]?' : '');
        const mid = '\\d*';
        const end = (this.scale ? "(" + (0, $93906f2a377dc74e$export$7c57da42ce8e346f)(this.radix) + "\\d{0," + this.scale + "})?" : '') + '$';
        this._numberRegExp = new RegExp(start + mid + end);
        this._mapToRadixRegExp = new RegExp("[" + this.mapToRadix.map((0, $93906f2a377dc74e$export$7c57da42ce8e346f)).join('') + "]", 'g');
        this._thousandsSeparatorRegExp = new RegExp((0, $93906f2a377dc74e$export$7c57da42ce8e346f)(this.thousandsSeparator), 'g');
    }
    _removeThousandsSeparators(value) {
        return value.replace(this._thousandsSeparatorRegExp, '');
    }
    _insertThousandsSeparators(value) {
        // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
        const parts = value.split(this.radix);
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
        return parts.join(this.radix);
    }
    doPrepareChar(ch, flags) {
        if (flags === void 0) flags = {};
        const [prepCh, details] = super.doPrepareChar(this._removeThousandsSeparators(this.scale && this.mapToRadix.length && /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */ (flags.input && flags.raw || !flags.input && !flags.raw) ? ch.replace(this._mapToRadixRegExp, this.radix) : ch), flags);
        if (ch && !prepCh) details.skip = true;
        if (prepCh && !this.allowPositive && !this.value && prepCh !== '-') details.aggregate(this._appendChar('-'));
        return [
            prepCh,
            details
        ];
    }
    _separatorsCount(to, extendOnSeparators) {
        if (extendOnSeparators === void 0) extendOnSeparators = false;
        let count = 0;
        for(let pos = 0; pos < to; ++pos)if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
            ++count;
            if (extendOnSeparators) to += this.thousandsSeparator.length;
        }
        return count;
    }
    _separatorsCountFromSlice(slice) {
        if (slice === void 0) slice = this._value;
        return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
    }
    extractInput(fromPos, toPos, flags) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
        return this._removeThousandsSeparators(super.extractInput(fromPos, toPos, flags));
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
        const prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);
        this._value = this._removeThousandsSeparators(this.value);
        const oldValue = this._value;
        this._value += ch;
        const num = this.number;
        let accepted = !isNaN(num);
        let skip = false;
        if (accepted) {
            let fixedNum;
            if (this.min != null && this.min < 0 && this.number < this.min) fixedNum = this.min;
            if (this.max != null && this.max > 0 && this.number > this.max) fixedNum = this.max;
            if (fixedNum != null) {
                if (this.autofix) {
                    this._value = this.format(fixedNum, this).replace($282132fc7196c51f$export$2e2bcd8739ae039.UNMASKED_RADIX, this.radix);
                    skip || (skip = oldValue === this._value && !flags.tail); // if not changed on tail it's still ok to proceed
                } else accepted = false;
            }
            accepted && (accepted = Boolean(this._value.match(this._numberRegExp)));
        }
        let appendDetails;
        if (!accepted) {
            this._value = oldValue;
            appendDetails = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        } else appendDetails = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)({
            inserted: this._value.slice(oldValue.length),
            rawInserted: skip ? '' : ch,
            skip: skip
        });
        this._value = this._insertThousandsSeparators(this._value);
        const beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
        const beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);
        appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
        return appendDetails;
    }
    _findSeparatorAround(pos) {
        if (this.thousandsSeparator) {
            const searchFrom = pos - this.thousandsSeparator.length + 1;
            const separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
            if (separatorPos <= pos) return separatorPos;
        }
        return -1;
    }
    _adjustRangeWithSeparators(from, to) {
        const separatorAroundFromPos = this._findSeparatorAround(from);
        if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;
        const separatorAroundToPos = this._findSeparatorAround(to);
        if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
        return [
            from,
            to
        ];
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
        const valueBeforePos = this.value.slice(0, fromPos);
        const valueAfterPos = this.value.slice(toPos);
        const prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);
        this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));
        const beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);
        return new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)({
            tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
        });
    }
    nearestInputPos(cursorPos, direction) {
        if (!this.thousandsSeparator) return cursorPos;
        switch(direction){
            case (0, $93906f2a377dc74e$export$9106728c49045482).NONE:
            case (0, $93906f2a377dc74e$export$9106728c49045482).LEFT:
            case (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT:
                {
                    const separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);
                    if (separatorAtLeftPos >= 0) {
                        const separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;
                        if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_LEFT) return separatorAtLeftPos;
                    }
                    break;
                }
            case (0, $93906f2a377dc74e$export$9106728c49045482).RIGHT:
            case (0, $93906f2a377dc74e$export$9106728c49045482).FORCE_RIGHT:
                {
                    const separatorAtRightPos = this._findSeparatorAround(cursorPos);
                    if (separatorAtRightPos >= 0) return separatorAtRightPos + this.thousandsSeparator.length;
                }
        }
        return cursorPos;
    }
    doCommit() {
        if (this.value) {
            const number = this.number;
            let validnum = number;
            // check bounds
            if (this.min != null) validnum = Math.max(validnum, this.min);
            if (this.max != null) validnum = Math.min(validnum, this.max);
            if (validnum !== number) this.unmaskedValue = this.format(validnum, this);
            let formatted = this.value;
            if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
            if (this.padFractionalZeros && this.scale > 0) formatted = this._padFractionalZeros(formatted);
            this._value = formatted;
        }
        super.doCommit();
    }
    _normalizeZeros(value) {
        const parts = this._removeThousandsSeparators(value).split(this.radix);
        // remove leading zeros
        parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, (match, sign, zeros, num)=>sign + num);
        // add leading zero
        if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + '0';
        if (parts.length > 1) {
            parts[1] = parts[1].replace(/0*$/, ''); // remove trailing zeros
            if (!parts[1].length) parts.length = 1; // remove fractional
        }
        return this._insertThousandsSeparators(parts.join(this.radix));
    }
    _padFractionalZeros(value) {
        if (!value) return value;
        const parts = value.split(this.radix);
        if (parts.length < 2) parts.push('');
        parts[1] = parts[1].padEnd(this.scale, '0');
        return parts.join(this.radix);
    }
    doSkipInvalid(ch, flags, checkTail) {
        if (flags === void 0) flags = {};
        const dropFractional = this.scale === 0 && ch !== this.thousandsSeparator && (ch === this.radix || ch === $282132fc7196c51f$export$2e2bcd8739ae039.UNMASKED_RADIX || this.mapToRadix.includes(ch));
        return super.doSkipInvalid(ch, flags, checkTail) && !dropFractional;
    }
    get unmaskedValue() {
        return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, $282132fc7196c51f$export$2e2bcd8739ae039.UNMASKED_RADIX);
    }
    set unmaskedValue(unmaskedValue) {
        super.unmaskedValue = unmaskedValue;
    }
    get typedValue() {
        return this.parse(this.unmaskedValue, this);
    }
    set typedValue(n) {
        this.rawInputValue = this.format(n, this).replace($282132fc7196c51f$export$2e2bcd8739ae039.UNMASKED_RADIX, this.radix);
    }
    /** Parsed Number */ get number() {
        return this.typedValue;
    }
    set number(number) {
        this.typedValue = number;
    }
    get allowNegative() {
        return this.min != null && this.min < 0 || this.max != null && this.max < 0;
    }
    get allowPositive() {
        return this.min != null && this.min > 0 || this.max != null && this.max > 0;
    }
    typedValueEquals(value) {
        // handle  0 -> '' case (typed = 0 even if value = '')
        // for details see https://github.com/uNmAnNeR/imaskjs/issues/134
        return (super.typedValueEquals(value) || $282132fc7196c51f$export$2e2bcd8739ae039.EMPTY_VALUES.includes(value) && $282132fc7196c51f$export$2e2bcd8739ae039.EMPTY_VALUES.includes(this.typedValue)) && !(value === 0 && this.value === '');
    }
}
$282132fc7196c51f$var$_MaskedNumber = $282132fc7196c51f$export$2e2bcd8739ae039;
$282132fc7196c51f$export$2e2bcd8739ae039.UNMASKED_RADIX = '.';
$282132fc7196c51f$export$2e2bcd8739ae039.EMPTY_VALUES = [
    ...(0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039).EMPTY_VALUES,
    0
];
$282132fc7196c51f$export$2e2bcd8739ae039.DEFAULTS = {
    ...(0, $e23198c8dcc9cc5a$export$2e2bcd8739ae039).DEFAULTS,
    mask: Number,
    radix: ',',
    thousandsSeparator: '',
    mapToRadix: [
        $282132fc7196c51f$var$_MaskedNumber.UNMASKED_RADIX
    ],
    min: Number.MIN_SAFE_INTEGER,
    max: Number.MAX_SAFE_INTEGER,
    scale: 2,
    normalizeZeros: true,
    padFractionalZeros: false,
    parse: Number,
    format: (n)=>n.toLocaleString('en-US', {
            useGrouping: false,
            maximumFractionDigits: 20
        })
};
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).MaskedNumber = $282132fc7196c51f$export$2e2bcd8739ae039;









/** Mask pipe source and destination types */ const $2226a75bb81f0562$export$90dab59c3d4b6e03 = {
    MASKED: 'value',
    UNMASKED: 'unmaskedValue',
    TYPED: 'typedValue'
};
/** Creates new pipe function depending on mask type, source and destination options */ function $2226a75bb81f0562$export$a504d53a5b99e1b9(arg, from, to) {
    if (from === void 0) from = $2226a75bb81f0562$export$90dab59c3d4b6e03.MASKED;
    if (to === void 0) to = $2226a75bb81f0562$export$90dab59c3d4b6e03.MASKED;
    const masked = (0, $14fa5ae7a370b810$export$2e2bcd8739ae039)(arg);
    return (value)=>masked.runIsolated((m)=>{
            m[from] = value;
            return m[to];
        });
}
/** Pipes value through mask depending on mask type, source and destination options */ function $2226a75bb81f0562$export$a4627e546088548d(value, mask, from, to) {
    return $2226a75bb81f0562$export$a504d53a5b99e1b9(mask, from, to)(value);
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).PIPE_TYPE = $2226a75bb81f0562$export$90dab59c3d4b6e03;
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).createPipe = $2226a75bb81f0562$export$a504d53a5b99e1b9;
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).pipe = $2226a75bb81f0562$export$a4627e546088548d;
















/** Pattern mask */ class $d7a345ba913aa7ee$export$2e2bcd8739ae039 extends (0, $836f3f1cf9656cb9$export$2e2bcd8739ae039) {
    get repeatFrom() {
        var _ref;
        return (_ref = Array.isArray(this.repeat) ? this.repeat[0] : this.repeat === Infinity ? 0 : this.repeat) != null ? _ref : 0;
    }
    get repeatTo() {
        var _ref2;
        return (_ref2 = Array.isArray(this.repeat) ? this.repeat[1] : this.repeat) != null ? _ref2 : Infinity;
    }
    constructor(opts){
        super(opts);
    }
    updateOptions(opts) {
        super.updateOptions(opts);
    }
    _update(opts) {
        var _ref3, _ref4, _this$_blocks;
        const { repeat: repeat, ...blockOpts } = (0, $14fa5ae7a370b810$export$a213ae1c699d7230)(opts); // TODO type
        this._blockOpts = Object.assign({}, this._blockOpts, blockOpts);
        const block = (0, $14fa5ae7a370b810$export$2e2bcd8739ae039)(this._blockOpts);
        this.repeat = (_ref3 = (_ref4 = repeat != null ? repeat : block.repeat) != null ? _ref4 : this.repeat) != null ? _ref3 : Infinity; // TODO type
        super._update({
            mask: 'm'.repeat(Math.max(this.repeatTo === Infinity && ((_this$_blocks = this._blocks) == null ? void 0 : _this$_blocks.length) || 0, this.repeatFrom)),
            blocks: {
                m: block
            },
            eager: block.eager,
            overwrite: block.overwrite,
            skipInvalid: block.skipInvalid,
            lazy: block.lazy,
            placeholderChar: block.placeholderChar,
            displayChar: block.displayChar
        });
    }
    _allocateBlock(bi) {
        if (bi < this._blocks.length) return this._blocks[bi];
        if (this.repeatTo === Infinity || this._blocks.length < this.repeatTo) {
            this._blocks.push((0, $14fa5ae7a370b810$export$2e2bcd8739ae039)(this._blockOpts));
            this.mask += 'm';
            return this._blocks[this._blocks.length - 1];
        }
    }
    _appendCharRaw(ch, flags) {
        if (flags === void 0) flags = {};
        const details = new (0, $ef0ad9fa705f5579$export$2e2bcd8739ae039)();
        for(let bi = (_this$_mapPosToBlock$ = (_this$_mapPosToBlock = this._mapPosToBlock(this.displayValue.length)) == null ? void 0 : _this$_mapPosToBlock.index) != null ? _this$_mapPosToBlock$ : Math.max(this._blocks.length - 1, 0), block, allocated; // try to get a block or
        // try to allocate a new block if not allocated already
        block = (_this$_blocks$bi = this._blocks[bi]) != null ? _this$_blocks$bi : allocated = !allocated && this._allocateBlock(bi); ++bi){
            var _this$_mapPosToBlock$, _this$_mapPosToBlock, _this$_blocks$bi, _flags$_beforeTailSta;
            const blockDetails = block._appendChar(ch, {
                ...flags,
                _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) == null || (_flags$_beforeTailSta = _flags$_beforeTailSta._blocks) == null ? void 0 : _flags$_beforeTailSta[bi]
            });
            if (blockDetails.skip && allocated) {
                // remove the last allocated block and break
                this._blocks.pop();
                this.mask = this.mask.slice(1);
                break;
            }
            details.aggregate(blockDetails);
            if (blockDetails.consumed) break; // go next char
        }
        return details;
    }
    _trimEmptyTail(fromPos, toPos) {
        var _this$_mapPosToBlock2, _this$_mapPosToBlock3;
        if (fromPos === void 0) fromPos = 0;
        const firstBlockIndex = Math.max(((_this$_mapPosToBlock2 = this._mapPosToBlock(fromPos)) == null ? void 0 : _this$_mapPosToBlock2.index) || 0, this.repeatFrom, 0);
        let lastBlockIndex;
        if (toPos != null) lastBlockIndex = (_this$_mapPosToBlock3 = this._mapPosToBlock(toPos)) == null ? void 0 : _this$_mapPosToBlock3.index;
        if (lastBlockIndex == null) lastBlockIndex = this._blocks.length - 1;
        let removeCount = 0;
        for(let blockIndex = lastBlockIndex; firstBlockIndex <= blockIndex; --blockIndex, ++removeCount){
            if (this._blocks[blockIndex].unmaskedValue) break;
        }
        if (removeCount) {
            this._blocks.splice(lastBlockIndex - removeCount + 1, removeCount);
            this.mask = this.mask.slice(removeCount);
        }
    }
    reset() {
        super.reset();
        this._trimEmptyTail();
    }
    remove(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos === void 0) toPos = this.displayValue.length;
        const removeDetails = super.remove(fromPos, toPos);
        this._trimEmptyTail(fromPos, toPos);
        return removeDetails;
    }
    totalInputPositions(fromPos, toPos) {
        if (fromPos === void 0) fromPos = 0;
        if (toPos == null && this.repeatTo === Infinity) return Infinity;
        return super.totalInputPositions(fromPos, toPos);
    }
    get state() {
        return super.state;
    }
    set state(state) {
        this._blocks.length = state._blocks.length;
        this.mask = this.mask.slice(0, this._blocks.length);
        super.state = state;
    }
}
(0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039).RepeatBlock = $d7a345ba913aa7ee$export$2e2bcd8739ae039;






try {
    globalThis.IMask = (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039);
} catch  {}


const $418ef4bb2816ee56$var$masks = [
    {
        selector: '.mask-phone',
        options: {
            mask: '+{7} (000) 000-00-00'
        }
    },
    {
        selector: '.mask-number',
        options: {
            mask: Number
        }
    },
    {
        selector: '.mask-inn',
        options: {
            mask: '0000000000[00]'
        }
    },
    {
        selector: '.mask-currency',
        options: {
            lazy: false,
            mask: 'num',
            blocks: {
                num: {
                    mask: Number,
                    thousandsSeparator: ' ',
                    signed: false,
                    scale: 2,
                    padFractionalZeros: true,
                    radix: ',',
                    mapToRadix: [
                        '.'
                    ]
                }
            }
        }
    },
    {
        selector: '.mask-date',
        options: {
            mask: Date,
            autofix: 'pad'
        }
    }
];
const $418ef4bb2816ee56$export$ffeb8f30de717edd = (targetNode = false)=>{
    $418ef4bb2816ee56$var$masks.forEach((itemMask)=>{
        const node = targetNode || document;
        const fields = node.querySelectorAll(itemMask.selector);
        fields.forEach((itemField)=>{
            (0, $9f3c06206bc5b9fe$export$2e2bcd8739ae039)(itemField, itemMask.options);
        });
    });
};
const $418ef4bb2816ee56$var$maskValidate = {
    'mask-phone': (value)=>{
        const pattern = new RegExp(/^\+7\s?\(\d{3}\)\s?\d{3}-\d{2}-\d{2}$/);
        return pattern.test(value);
    },
    'mask-inn': (value)=>{
        const pattern = new RegExp(/^(\d{10}|\d{12})$/);
        return pattern.test(value);
    }
};
const $418ef4bb2816ee56$export$d9741e8d8bfcaa1b = (maskName)=>{
    if (Object.prototype.hasOwnProperty.call($418ef4bb2816ee56$var$maskValidate, maskName)) return $418ef4bb2816ee56$var$maskValidate[maskName];
    return false;
};


const $f3d73780e5af12a6$var$getMaskClassName = (classList)=>{
    const classes = [
        ...classList
    ];
    let maskClass;
    classes.forEach((className)=>{
        if (className.includes('mask-')) maskClass = className;
    });
    return maskClass;
};
const $f3d73780e5af12a6$var$checkFromMask = (classList, value)=>{
    let result = true;
    const maskClass = $f3d73780e5af12a6$var$getMaskClassName(classList);
    if (maskClass) {
        const validateFunction = (0, $418ef4bb2816ee56$export$d9741e8d8bfcaa1b)(maskClass);
        if (typeof validateFunction === 'function') result = validateFunction(value);
    }
    return result;
};
const $f3d73780e5af12a6$var$fieldCompletionCheck = (fieldElement)=>{
    let isValid = true;
    const errorClassName = `${fieldElement.classList[0]}--error`;
    if (fieldElement.value.length < 1) {
        fieldElement.classList.add(errorClassName);
        isValid = false;
    } else if (fieldElement.classList.value.includes('mask-')) {
        const maskPassed = $f3d73780e5af12a6$var$checkFromMask(fieldElement.classList, fieldElement.value);
        if (!maskPassed) {
            fieldElement.classList.add(errorClassName);
            isValid = false;
        } else fieldElement.classList.remove(errorClassName);
    } else fieldElement.classList.remove(errorClassName);
    return isValid;
};
const $f3d73780e5af12a6$var$fileFieldCompletionCheck = (fieldElement)=>{
    let isValid = true;
    const errorClassName = 'file-field--error';
    const parentFieldElement = fieldElement.closest('.file-field');
    const fileList = fieldElement.files;
    if (fileList.length < 1) {
        parentFieldElement.classList.add(errorClassName);
        isValid = false;
    } else parentFieldElement.classList.remove(errorClassName);
    return isValid;
};
const $f3d73780e5af12a6$export$f7af0404fc1b91d2 = (fieldElements)=>{
    const validResults = [];
    fieldElements.forEach((field)=>{
        const isValid = $f3d73780e5af12a6$var$fieldCompletionCheck(field);
        validResults.push(isValid);
        field.addEventListener('change', ()=>{
            $f3d73780e5af12a6$var$fieldCompletionCheck(field);
        });
    });
    return validResults.every((value)=>value === true);
};
const $f3d73780e5af12a6$export$fe1ad16478351215 = (fileElements)=>{
    const validResults = [];
    fileElements.forEach((element)=>{
        validResults.push($f3d73780e5af12a6$var$fileFieldCompletionCheck(element));
        element.addEventListener('change', ()=>{
            $f3d73780e5af12a6$var$fileFieldCompletionCheck(element);
        });
    });
    return validResults.every((value)=>value === true);
};


const $366106ffbe7c4eae$export$ed692cabb252e59b = (formElement)=>{
    const fieldElements = formElement.querySelectorAll('input[required]:not([type="file"]), select[required], textarea[required]');
    const fileElements = formElement.querySelectorAll('input[type="file"][required]');
    const isValidateFields = (0, $f3d73780e5af12a6$export$f7af0404fc1b91d2)(fieldElements);
    const isValidateFileFields = (0, $f3d73780e5af12a6$export$fe1ad16478351215)(fileElements);
    return isValidateFields && isValidateFileFields;
};
const $366106ffbe7c4eae$export$9f2f414e0766ca84 = (button, isSkipClassChange = false)=>{
    button.disabled = true;
    if (!isSkipClassChange) button.classList.add('btn--loading');
};
const $366106ffbe7c4eae$export$7ae08f9d0817f013 = (button, isSkipClassChange = false)=>{
    button.disabled = false;
    if (!isSkipClassChange) button.classList.remove('btn--loading');
};


/* global BX:writable */ /*! MIT License © Sindre Sorhus */ class $166d9f31c8728179$export$aa9d629c530f62a7 extends Error {
    response;
    request;
    options;
    constructor(response, request, options){
        const code = response.status || response.status === 0 ? response.status : '';
        const title = response.statusText ?? '';
        const status = `${code} ${title}`.trim();
        const reason = status ? `status code ${status}` : 'an unknown error';
        super(`Request failed with ${reason}: ${request.method} ${request.url}`);
        this.name = 'HTTPError';
        this.response = response;
        this.request = request;
        this.options = options;
    }
}


/**
Wrapper for non-Error values that were thrown.

In JavaScript, any value can be thrown (not just Error instances). This class wraps such values to ensure consistent error handling.
*/ class $3df09feb626b8c53$export$5bbe4213615fafb9 extends Error {
    name = 'NonError';
    value;
    constructor(value){
        let message = 'Non-error value was thrown';
        // Intentionally minimal as this error is just an edge-case.
        try {
            if (typeof value === 'string') message = value;
            else if (value && typeof value === 'object' && 'message' in value && typeof value.message === 'string') message = value.message;
        } catch  {
        // Use default message if accessing properties throws
        }
        super(message);
        this.value = value;
    }
}


const $95c77e88185d0a90$export$d8618555562b76b7 = (()=>{
    let duplexAccessed = false;
    let hasContentType = false;
    const supportsReadableStream = typeof globalThis.ReadableStream === 'function';
    const supportsRequest = typeof globalThis.Request === 'function';
    if (supportsReadableStream && supportsRequest) try {
        hasContentType = new globalThis.Request('https://empty.invalid', {
            body: new globalThis.ReadableStream(),
            method: 'POST',
            // @ts-expect-error - Types are outdated.
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
    } catch (error) {
        // QQBrowser on iOS throws "unsupported BodyInit type" error (see issue #581)
        if (error instanceof Error && error.message === 'unsupported BodyInit type') return false;
        throw error;
    }
    return duplexAccessed && !hasContentType;
})();
const $95c77e88185d0a90$export$6c0aacaed85a4966 = typeof globalThis.AbortController === 'function';
const $95c77e88185d0a90$export$f5861fb6f4de6531 = typeof globalThis.AbortSignal === 'function' && typeof globalThis.AbortSignal.any === 'function';
const $95c77e88185d0a90$export$135162ac70ac2b21 = typeof globalThis.ReadableStream === 'function';
const $95c77e88185d0a90$export$f1525fa7979d0aa9 = typeof globalThis.FormData === 'function';
const $95c77e88185d0a90$export$fb003dbd6df95edb = [
    'get',
    'post',
    'put',
    'patch',
    'head',
    'delete'
];
const $95c77e88185d0a90$var$validate = ()=>undefined;
$95c77e88185d0a90$var$validate();
const $95c77e88185d0a90$export$a6f212d4ee888d8c = {
    json: 'application/json',
    text: 'text/*',
    formData: 'multipart/form-data',
    arrayBuffer: '*/*',
    blob: '*/*',
    // Supported in modern Fetch implementations (for example, browsers and recent Node.js/undici).
    // We still feature-check at runtime before exposing the shortcut.
    bytes: '*/*'
};
const $95c77e88185d0a90$export$9b60a72e3f70a1d2 = 2147483647;
const $95c77e88185d0a90$export$23af28b03ba58178 = new TextEncoder().encode('------WebKitFormBoundaryaxpyiPgbbPti10Rw').length;
const $95c77e88185d0a90$export$fa6813432f753b0d = Symbol('stop');
const $95c77e88185d0a90$export$601fffa09f19102d = {
    json: true,
    parseJson: true,
    stringifyJson: true,
    searchParams: true,
    prefixUrl: true,
    retry: true,
    timeout: true,
    hooks: true,
    throwHttpErrors: true,
    onDownloadProgress: true,
    onUploadProgress: true,
    fetch: true,
    context: true
};
const $95c77e88185d0a90$export$f6ff4da7aa12f3ef = {
    next: true
};
const $95c77e88185d0a90$export$b2ec467665ae937d = {
    method: true,
    headers: true,
    body: true,
    mode: true,
    credentials: true,
    cache: true,
    redirect: true,
    referrer: true,
    referrerPolicy: true,
    integrity: true,
    keepalive: true,
    signal: true,
    window: true,
    duplex: true
};


const $b0a405f65ee0c42c$export$cefbc488a81111a3 = (body)=>{
    if (!body) return 0;
    if (body instanceof FormData) {
        // This is an approximation, as FormData size calculation is not straightforward
        let size = 0;
        for (const [key, value] of body){
            size += (0, $95c77e88185d0a90$export$23af28b03ba58178);
            size += new TextEncoder().encode(`Content-Disposition: form-data; name="${key}"`).length;
            size += typeof value === 'string' ? new TextEncoder().encode(value).length : value.size;
        }
        return size;
    }
    if (body instanceof Blob) return body.size;
    if (body instanceof ArrayBuffer) return body.byteLength;
    if (typeof body === 'string') return new TextEncoder().encode(body).length;
    if (body instanceof URLSearchParams) return new TextEncoder().encode(body.toString()).length;
    if ('byteLength' in body) return body.byteLength;
    if (typeof body === 'object' && body !== null) try {
        const jsonString = JSON.stringify(body);
        return new TextEncoder().encode(jsonString).length;
    } catch  {
        return 0;
    }
    return 0; // Default case, unable to determine size
};
const $b0a405f65ee0c42c$var$withProgress = (stream, totalBytes, onProgress)=>{
    let previousChunk;
    let transferredBytes = 0;
    return stream.pipeThrough(new TransformStream({
        transform (currentChunk, controller) {
            controller.enqueue(currentChunk);
            if (previousChunk) {
                transferredBytes += previousChunk.byteLength;
                let percent = totalBytes === 0 ? 0 : transferredBytes / totalBytes;
                // Avoid reporting 100% progress before the stream is actually finished (in case totalBytes is inaccurate)
                if (percent >= 1) // Epsilon is used here to get as close as possible to 100% without reaching it.
                // If we were to use 0.99 here, percent could potentially go backwards.
                percent = 1 - Number.EPSILON;
                onProgress?.({
                    percent: percent,
                    totalBytes: Math.max(totalBytes, transferredBytes),
                    transferredBytes: transferredBytes
                }, previousChunk);
            }
            previousChunk = currentChunk;
        },
        flush () {
            if (previousChunk) {
                transferredBytes += previousChunk.byteLength;
                onProgress?.({
                    percent: 1,
                    totalBytes: Math.max(totalBytes, transferredBytes),
                    transferredBytes: transferredBytes
                }, previousChunk);
            }
        }
    }));
};
const $b0a405f65ee0c42c$export$2e6c793c88b27395 = (response, onDownloadProgress)=>{
    if (!response.body) return response;
    if (response.status === 204) return new Response(null, {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers
    });
    const totalBytes = Math.max(0, Number(response.headers.get('content-length')) || 0);
    return new Response($b0a405f65ee0c42c$var$withProgress(response.body, totalBytes, onDownloadProgress), {
        status: response.status,
        statusText: response.statusText,
        headers: response.headers
    });
};
const $b0a405f65ee0c42c$export$99096e10de875468 = (request, onUploadProgress, originalBody)=>{
    if (!request.body) return request;
    // Use original body for size calculation since request.body is already a stream
    const totalBytes = $b0a405f65ee0c42c$export$cefbc488a81111a3(originalBody ?? request.body);
    return new Request(request, {
        // @ts-expect-error - Types are outdated.
        duplex: 'half',
        body: $b0a405f65ee0c42c$var$withProgress(request.body, totalBytes, onUploadProgress)
    });
};



// eslint-disable-next-line @typescript-eslint/ban-types
const $861998c6908fd708$export$a6cdc56e425d0d0a = (value)=>value !== null && typeof value === 'object';


const $19e1cad4986955d6$export$8886f5ba30bd5e0 = (...sources)=>{
    for (const source of sources){
        if ((!(0, $861998c6908fd708$export$a6cdc56e425d0d0a)(source) || Array.isArray(source)) && source !== undefined) throw new TypeError('The `options` argument must be an object');
    }
    return $19e1cad4986955d6$export$6969335ea1e4e77c({}, ...sources);
};
const $19e1cad4986955d6$export$eee1781d075786ae = (source1 = {}, source2 = {})=>{
    const result = new globalThis.Headers(source1);
    const isHeadersInstance = source2 instanceof globalThis.Headers;
    const source = new globalThis.Headers(source2);
    for (const [key, value] of source.entries())if (isHeadersInstance && value === 'undefined' || value === undefined) result.delete(key);
    else result.set(key, value);
    return result;
};
function $19e1cad4986955d6$var$newHookValue(original, incoming, property) {
    return Object.hasOwn(incoming, property) && incoming[property] === undefined ? [] : $19e1cad4986955d6$export$6969335ea1e4e77c(original[property] ?? [], incoming[property] ?? []);
}
const $19e1cad4986955d6$export$3de1ffbf114b9f2d = (original = {}, incoming = {})=>({
        beforeRequest: $19e1cad4986955d6$var$newHookValue(original, incoming, 'beforeRequest'),
        beforeRetry: $19e1cad4986955d6$var$newHookValue(original, incoming, 'beforeRetry'),
        afterResponse: $19e1cad4986955d6$var$newHookValue(original, incoming, 'afterResponse'),
        beforeError: $19e1cad4986955d6$var$newHookValue(original, incoming, 'beforeError')
    });
const $19e1cad4986955d6$var$appendSearchParameters = (target, source)=>{
    const result = new URLSearchParams();
    for (const input of [
        target,
        source
    ]){
        if (input === undefined) continue;
        if (input instanceof URLSearchParams) for (const [key, value] of input.entries())result.append(key, value);
        else if (Array.isArray(input)) for (const pair of input){
            if (!Array.isArray(pair) || pair.length !== 2) throw new TypeError('Array search parameters must be provided in [[key, value], ...] format');
            result.append(String(pair[0]), String(pair[1]));
        }
        else if ((0, $861998c6908fd708$export$a6cdc56e425d0d0a)(input)) {
            for (const [key, value] of Object.entries(input))if (value !== undefined) result.append(key, String(value));
        } else {
            // String
            const parameters = new URLSearchParams(input);
            for (const [key, value] of parameters.entries())result.append(key, value);
        }
    }
    return result;
};
const $19e1cad4986955d6$export$6969335ea1e4e77c = (...sources)=>{
    let returnValue = {};
    let headers = {};
    let hooks = {};
    let searchParameters;
    const signals = [];
    for (const source of sources){
        if (Array.isArray(source)) {
            if (!Array.isArray(returnValue)) returnValue = [];
            returnValue = [
                ...returnValue,
                ...source
            ];
        } else if ((0, $861998c6908fd708$export$a6cdc56e425d0d0a)(source)) {
            for (let [key, value] of Object.entries(source)){
                // Special handling for AbortSignal instances
                if (key === 'signal' && value instanceof globalThis.AbortSignal) {
                    signals.push(value);
                    continue;
                }
                // Special handling for context - shallow merge only
                if (key === 'context') {
                    if (value !== undefined && value !== null && (!(0, $861998c6908fd708$export$a6cdc56e425d0d0a)(value) || Array.isArray(value))) throw new TypeError('The `context` option must be an object');
                    // Shallow merge: always create a new object to prevent mutation bugs
                    returnValue = {
                        ...returnValue,
                        context: value === undefined || value === null ? {} : {
                            ...returnValue.context,
                            ...value
                        }
                    };
                    continue;
                }
                // Special handling for searchParams
                if (key === 'searchParams') {
                    if (value === undefined || value === null) // Explicit undefined or null removes searchParams
                    searchParameters = undefined;
                    else // First source: keep as-is to preserve type (string/object/URLSearchParams)
                    // Subsequent sources: merge and convert to URLSearchParams
                    searchParameters = searchParameters === undefined ? value : $19e1cad4986955d6$var$appendSearchParameters(searchParameters, value);
                    continue;
                }
                if ((0, $861998c6908fd708$export$a6cdc56e425d0d0a)(value) && key in returnValue) value = $19e1cad4986955d6$export$6969335ea1e4e77c(returnValue[key], value);
                returnValue = {
                    ...returnValue,
                    [key]: value
                };
            }
            if ((0, $861998c6908fd708$export$a6cdc56e425d0d0a)(source.hooks)) {
                hooks = $19e1cad4986955d6$export$3de1ffbf114b9f2d(hooks, source.hooks);
                returnValue.hooks = hooks;
            }
            if ((0, $861998c6908fd708$export$a6cdc56e425d0d0a)(source.headers)) {
                headers = $19e1cad4986955d6$export$eee1781d075786ae(headers, source.headers);
                returnValue.headers = headers;
            }
        }
    }
    if (searchParameters !== undefined) returnValue.searchParams = searchParameters;
    if (signals.length > 0) {
        if (signals.length === 1) returnValue.signal = signals[0];
        else if (0, $95c77e88185d0a90$export$f5861fb6f4de6531) returnValue.signal = AbortSignal.any(signals);
        else // When AbortSignal.any is not available, use the last signal
        // This maintains the previous behavior before signal merging was added
        // This can be remove when the `supportsAbortSignal` check is removed.`
        returnValue.signal = signals.at(-1);
    }
    if (returnValue.context === undefined) returnValue.context = {};
    return returnValue;
};



const $cfb390b29a27f7e5$export$d585027d4667ffce = (input)=>(0, $95c77e88185d0a90$export$fb003dbd6df95edb).includes(input) ? input.toUpperCase() : input;
const $cfb390b29a27f7e5$var$retryMethods = [
    'get',
    'put',
    'head',
    'delete',
    'options',
    'trace'
];
const $cfb390b29a27f7e5$var$retryStatusCodes = [
    408,
    413,
    429,
    500,
    502,
    503,
    504
];
const $cfb390b29a27f7e5$var$retryAfterStatusCodes = [
    413,
    429,
    503
];
const $cfb390b29a27f7e5$var$defaultRetryOptions = {
    limit: 2,
    methods: $cfb390b29a27f7e5$var$retryMethods,
    statusCodes: $cfb390b29a27f7e5$var$retryStatusCodes,
    afterStatusCodes: $cfb390b29a27f7e5$var$retryAfterStatusCodes,
    maxRetryAfter: Number.POSITIVE_INFINITY,
    backoffLimit: Number.POSITIVE_INFINITY,
    delay: (attemptCount)=>0.3 * 2 ** (attemptCount - 1) * 1000,
    jitter: undefined,
    retryOnTimeout: false
};
const $cfb390b29a27f7e5$export$3e5471bb9440c9c1 = (retry = {})=>{
    if (typeof retry === 'number') return {
        ...$cfb390b29a27f7e5$var$defaultRetryOptions,
        limit: retry
    };
    if (retry.methods && !Array.isArray(retry.methods)) throw new Error('retry.methods must be an array');
    if (retry.statusCodes && !Array.isArray(retry.statusCodes)) throw new Error('retry.statusCodes must be an array');
    return {
        ...$cfb390b29a27f7e5$var$defaultRetryOptions,
        ...retry
    };
};


class $ae0e081d12012525$export$66d311bf29d5c89c extends Error {
    request;
    constructor(request){
        super(`Request timed out: ${request.method} ${request.url}`);
        this.name = 'TimeoutError';
        this.request = request;
    }
}


async function $c5d9d222c7ea65ca$export$2e2bcd8739ae039(request, init, abortController, options) {
    return new Promise((resolve, reject)=>{
        const timeoutId = setTimeout(()=>{
            if (abortController) abortController.abort();
            reject(new (0, $ae0e081d12012525$export$66d311bf29d5c89c)(request));
        }, options.timeout);
        options.fetch(request, init).then(resolve).catch(reject).then(()=>{
            clearTimeout(timeoutId);
        });
    });
}


// https://github.com/sindresorhus/delay/tree/ab98ae8dfcb38e1593286c94d934e70d14a4e111
async function $fb6c847a8a710dc0$export$2e2bcd8739ae039(ms, { signal: signal }) {
    return new Promise((resolve, reject)=>{
        if (signal) {
            signal.throwIfAborted();
            signal.addEventListener('abort', abortHandler, {
                once: true
            });
        }
        function abortHandler() {
            clearTimeout(timeoutId);
            reject(signal.reason);
        }
        const timeoutId = setTimeout(()=>{
            signal?.removeEventListener('abort', abortHandler);
            resolve();
        }, ms);
    });
}



const $8f1cde8f0e979cde$export$95d8775889ec941f = (request, options)=>{
    const unknownOptions = {};
    for(const key in options){
        // Skip inherited properties
        if (!Object.hasOwn(options, key)) continue;
        // An option is passed to fetch() if:
        // 1. It's not a standard RequestInit option (not in requestOptionsRegistry)
        // 2. It's not a ky-specific option (not in kyOptionKeys)
        // 3. Either:
        //    a. It's not on the Request object, OR
        //    b. It's a vendor-specific option that should always be passed (in vendorSpecificOptions)
        if (!(key in (0, $95c77e88185d0a90$export$b2ec467665ae937d)) && !(key in (0, $95c77e88185d0a90$export$601fffa09f19102d)) && (!(key in request) || key in (0, $95c77e88185d0a90$export$f6ff4da7aa12f3ef))) unknownOptions[key] = options[key];
    }
    return unknownOptions;
};
const $8f1cde8f0e979cde$export$38f5a1f81179632e = (search)=>{
    if (search === undefined) return false;
    // The `typeof array` still gives "object", so we need different checking for array.
    if (Array.isArray(search)) return search.length > 0;
    if (search instanceof URLSearchParams) return search.size > 0;
    // Record
    if (typeof search === 'object') return Object.keys(search).length > 0;
    if (typeof search === 'string') return search.trim().length > 0;
    return Boolean(search);
};




function $cb46677b8d8c1560$export$190bbe5cae387f63(error) {
    return $cb46677b8d8c1560$export$6b7a49ce9c98a2f(error) || $cb46677b8d8c1560$export$f47339bf28a93789(error);
}
function $cb46677b8d8c1560$export$6b7a49ce9c98a2f(error) {
    return error instanceof (0, $166d9f31c8728179$export$aa9d629c530f62a7) || error?.name === (0, $166d9f31c8728179$export$aa9d629c530f62a7).name;
}
function $cb46677b8d8c1560$export$f47339bf28a93789(error) {
    return error instanceof (0, $ae0e081d12012525$export$66d311bf29d5c89c) || error?.name === (0, $ae0e081d12012525$export$66d311bf29d5c89c).name;
}



class $7cbca30f25e84ae2$export$c482d6f00e170af3 {
    static create(input, options) {
        const ky = new $7cbca30f25e84ae2$export$c482d6f00e170af3(input, options);
        const function_ = async ()=>{
            if (typeof ky.#options.timeout === 'number' && ky.#options.timeout > (0, $95c77e88185d0a90$export$9b60a72e3f70a1d2)) throw new RangeError(`The \`timeout\` option cannot be greater than ${(0, $95c77e88185d0a90$export$9b60a72e3f70a1d2)}`);
            // Delay the fetch so that body method shortcuts can set the Accept header
            await Promise.resolve();
            // Before using ky.request, _fetch clones it and saves the clone for future retries to use.
            // If retry is not needed, close the cloned request's ReadableStream for memory safety.
            let response = await ky.#fetch();
            for (const hook of ky.#options.hooks.afterResponse){
                // eslint-disable-next-line no-await-in-loop
                const modifiedResponse = await hook(ky.request, ky.#getNormalizedOptions(), ky.#decorateResponse(response.clone()), {
                    retryCount: ky.#retryCount
                });
                if (modifiedResponse instanceof globalThis.Response) response = modifiedResponse;
            }
            ky.#decorateResponse(response);
            if (!response.ok && ky.#options.throwHttpErrors) {
                let error = new (0, $166d9f31c8728179$export$aa9d629c530f62a7)(response, ky.request, ky.#getNormalizedOptions());
                for (const hook of ky.#options.hooks.beforeError)// eslint-disable-next-line no-await-in-loop
                error = await hook(error, {
                    retryCount: ky.#retryCount
                });
                throw error;
            }
            // If `onDownloadProgress` is passed, it uses the stream API internally
            if (ky.#options.onDownloadProgress) {
                if (typeof ky.#options.onDownloadProgress !== 'function') throw new TypeError('The `onDownloadProgress` option must be a function');
                if (!(0, $95c77e88185d0a90$export$135162ac70ac2b21)) throw new Error('Streams are not supported in your environment. `ReadableStream` is missing.');
                return (0, $b0a405f65ee0c42c$export$2e6c793c88b27395)(response.clone(), ky.#options.onDownloadProgress);
            }
            return response;
        };
        const isRetriableMethod = ky.#options.retry.methods.includes(ky.request.method.toLowerCase());
        const result = (isRetriableMethod ? ky.#retry(function_) : function_()).finally(async ()=>{
            const originalRequest = ky.#originalRequest;
            const cleanupPromises = [];
            if (originalRequest && !originalRequest.bodyUsed) cleanupPromises.push(originalRequest.body?.cancel());
            if (!ky.request.bodyUsed) cleanupPromises.push(ky.request.body?.cancel());
            await Promise.all(cleanupPromises);
        });
        for (const [type, mimeType] of Object.entries((0, $95c77e88185d0a90$export$a6f212d4ee888d8c))){
            // Only expose `.bytes()` when the environment implements it.
            if (type === 'bytes' && typeof globalThis.Response?.prototype?.bytes !== 'function') continue;
            result[type] = async ()=>{
                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                ky.request.headers.set('accept', ky.request.headers.get('accept') || mimeType);
                const response = await result;
                if (type === 'json') {
                    if (response.status === 204) return '';
                    const text = await response.text();
                    if (text === '') return '';
                    if (options.parseJson) return options.parseJson(text);
                    return JSON.parse(text);
                }
                return response[type]();
            };
        }
        return result;
    }
    // eslint-disable-next-line unicorn/prevent-abbreviations
    static #normalizeSearchParams(searchParams) {
        // Filter out undefined values from plain objects
        if (searchParams && typeof searchParams === 'object' && !Array.isArray(searchParams) && !(searchParams instanceof URLSearchParams)) return Object.fromEntries(Object.entries(searchParams).filter(([, value])=>value !== undefined));
        return searchParams;
    }
    request;
    #abortController;
    #retryCount = 0;
    // eslint-disable-next-line @typescript-eslint/prefer-readonly -- False positive: #input is reassigned on line 202
    #input;
    #options;
    #originalRequest;
    #userProvidedAbortSignal;
    #cachedNormalizedOptions;
    // eslint-disable-next-line complexity
    constructor(input, options = {}){
        this.#input = input;
        this.#options = {
            ...options,
            headers: (0, $19e1cad4986955d6$export$eee1781d075786ae)(this.#input.headers, options.headers),
            hooks: (0, $19e1cad4986955d6$export$3de1ffbf114b9f2d)({
                beforeRequest: [],
                beforeRetry: [],
                beforeError: [],
                afterResponse: []
            }, options.hooks),
            method: (0, $cfb390b29a27f7e5$export$d585027d4667ffce)(options.method ?? this.#input.method ?? 'GET'),
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            prefixUrl: String(options.prefixUrl || ''),
            retry: (0, $cfb390b29a27f7e5$export$3e5471bb9440c9c1)(options.retry),
            throwHttpErrors: options.throwHttpErrors !== false,
            timeout: options.timeout ?? 10000,
            fetch: options.fetch ?? globalThis.fetch.bind(globalThis),
            context: options.context ?? {}
        };
        if (typeof this.#input !== 'string' && !(this.#input instanceof URL || this.#input instanceof globalThis.Request)) throw new TypeError('`input` must be a string, URL, or Request');
        if (this.#options.prefixUrl && typeof this.#input === 'string') {
            if (this.#input.startsWith('/')) throw new Error('`input` must not begin with a slash when using `prefixUrl`');
            if (!this.#options.prefixUrl.endsWith('/')) this.#options.prefixUrl += '/';
            this.#input = this.#options.prefixUrl + this.#input;
        }
        if ((0, $95c77e88185d0a90$export$6c0aacaed85a4966) && (0, $95c77e88185d0a90$export$f5861fb6f4de6531)) {
            this.#userProvidedAbortSignal = this.#options.signal ?? this.#input.signal;
            this.#abortController = new globalThis.AbortController();
            this.#options.signal = this.#userProvidedAbortSignal ? AbortSignal.any([
                this.#userProvidedAbortSignal,
                this.#abortController.signal
            ]) : this.#abortController.signal;
        }
        if (0, $95c77e88185d0a90$export$d8618555562b76b7) // @ts-expect-error - Types are outdated.
        this.#options.duplex = 'half';
        if (this.#options.json !== undefined) {
            this.#options.body = this.#options.stringifyJson?.(this.#options.json) ?? JSON.stringify(this.#options.json);
            this.#options.headers.set('content-type', this.#options.headers.get('content-type') ?? 'application/json');
        }
        // To provide correct form boundary, Content-Type header should be deleted when creating Request from another Request with FormData/URLSearchParams body
        // Only delete if user didn't explicitly provide a custom content-type
        const userProvidedContentType = options.headers && new globalThis.Headers(options.headers).has('content-type');
        if (this.#input instanceof globalThis.Request && ((0, $95c77e88185d0a90$export$f1525fa7979d0aa9) && this.#options.body instanceof globalThis.FormData || this.#options.body instanceof URLSearchParams) && !userProvidedContentType) this.#options.headers.delete('content-type');
        this.request = new globalThis.Request(this.#input, this.#options);
        if ((0, $8f1cde8f0e979cde$export$38f5a1f81179632e)(this.#options.searchParams)) {
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const textSearchParams = typeof this.#options.searchParams === 'string' ? this.#options.searchParams.replace(/^\?/, '') : new URLSearchParams($7cbca30f25e84ae2$export$c482d6f00e170af3.#normalizeSearchParams(this.#options.searchParams)).toString();
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const searchParams = '?' + textSearchParams;
            const url = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, searchParams);
            // The spread of `this.request` is required as otherwise it misses the `duplex` option for some reason and throws.
            this.request = new globalThis.Request(new globalThis.Request(url, {
                ...this.request
            }), this.#options);
        }
        // If `onUploadProgress` is passed, it uses the stream API internally
        if (this.#options.onUploadProgress) {
            if (typeof this.#options.onUploadProgress !== 'function') throw new TypeError('The `onUploadProgress` option must be a function');
            if (!(0, $95c77e88185d0a90$export$d8618555562b76b7)) throw new Error('Request streams are not supported in your environment. The `duplex` option for `Request` is not available.');
            const originalBody = this.request.body;
            if (originalBody) // Pass original body to calculate size correctly (before it becomes a stream)
            this.request = (0, $b0a405f65ee0c42c$export$99096e10de875468)(this.request, this.#options.onUploadProgress, this.#options.body);
        }
    }
    #calculateDelay() {
        const retryDelay = this.#options.retry.delay(this.#retryCount);
        let jitteredDelay = retryDelay;
        if (this.#options.retry.jitter === true) jitteredDelay = Math.random() * retryDelay;
        else if (typeof this.#options.retry.jitter === 'function') {
            jitteredDelay = this.#options.retry.jitter(retryDelay);
            if (!Number.isFinite(jitteredDelay) || jitteredDelay < 0) jitteredDelay = retryDelay;
        }
        return Math.min(this.#options.retry.backoffLimit, jitteredDelay);
    }
    async #calculateRetryDelay(error) {
        this.#retryCount++;
        if (this.#retryCount > this.#options.retry.limit) throw error;
        // Wrap non-Error throws to ensure consistent error handling
        const errorObject = error instanceof Error ? error : new (0, $3df09feb626b8c53$export$5bbe4213615fafb9)(error);
        // User-provided shouldRetry function takes precedence over all other checks
        if (this.#options.retry.shouldRetry !== undefined) {
            const result = await this.#options.retry.shouldRetry({
                error: errorObject,
                retryCount: this.#retryCount
            });
            // Strict boolean checking - only exact true/false are handled specially
            if (result === false) throw error;
            if (result === true) // Force retry - skip all other validation and return delay
            return this.#calculateDelay();
        // If undefined or any other value, fall through to default behavior
        }
        // Default timeout behavior
        if ((0, $cb46677b8d8c1560$export$f47339bf28a93789)(error) && !this.#options.retry.retryOnTimeout) throw error;
        if ((0, $cb46677b8d8c1560$export$6b7a49ce9c98a2f)(error)) {
            if (!this.#options.retry.statusCodes.includes(error.response.status)) throw error;
            const retryAfter = error.response.headers.get('Retry-After') ?? error.response.headers.get('RateLimit-Reset') ?? error.response.headers.get('X-RateLimit-Retry-After') // Symfony-based services
             ?? error.response.headers.get('X-RateLimit-Reset') // GitHub
             ?? error.response.headers.get('X-Rate-Limit-Reset'); // Twitter
            if (retryAfter && this.#options.retry.afterStatusCodes.includes(error.response.status)) {
                let after = Number(retryAfter) * 1000;
                if (Number.isNaN(after)) after = Date.parse(retryAfter) - Date.now();
                else if (after >= Date.parse('2024-01-01')) // A large number is treated as a timestamp (fixed threshold protects against clock skew)
                after -= Date.now();
                const max = this.#options.retry.maxRetryAfter ?? after;
                // Don't apply jitter when server provides explicit retry timing
                return after < max ? after : max;
            }
            if (error.response.status === 413) throw error;
        }
        return this.#calculateDelay();
    }
    #decorateResponse(response) {
        if (this.#options.parseJson) response.json = async ()=>this.#options.parseJson(await response.text());
        return response;
    }
    async #retry(function_) {
        try {
            return await function_();
        } catch (error) {
            const ms = Math.min(await this.#calculateRetryDelay(error), (0, $95c77e88185d0a90$export$9b60a72e3f70a1d2));
            if (this.#retryCount < 1) throw error;
            // Only use user-provided signal for delay, not our internal abortController
            await (0, $fb6c847a8a710dc0$export$2e2bcd8739ae039)(ms, this.#userProvidedAbortSignal ? {
                signal: this.#userProvidedAbortSignal
            } : {});
            for (const hook of this.#options.hooks.beforeRetry){
                // eslint-disable-next-line no-await-in-loop
                const hookResult = await hook({
                    request: this.request,
                    options: this.#getNormalizedOptions(),
                    error: error,
                    retryCount: this.#retryCount
                });
                // If a Request is returned, use it for the retry
                if (hookResult instanceof globalThis.Request) {
                    this.request = hookResult;
                    break;
                }
                // If a Response is returned, use it and skip the retry
                if (hookResult instanceof globalThis.Response) return hookResult;
                // If `stop` is returned from the hook, the retry process is stopped
                if (hookResult === (0, $95c77e88185d0a90$export$fa6813432f753b0d)) return;
            }
            return this.#retry(function_);
        }
    }
    async #fetch() {
        // Reset abortController if it was aborted (happens on timeout retry)
        if (this.#abortController?.signal.aborted) {
            this.#abortController = new globalThis.AbortController();
            this.#options.signal = this.#userProvidedAbortSignal ? AbortSignal.any([
                this.#userProvidedAbortSignal,
                this.#abortController.signal
            ]) : this.#abortController.signal;
            // Recreate request with new signal
            this.request = new globalThis.Request(this.request, {
                signal: this.#options.signal
            });
        }
        for (const hook of this.#options.hooks.beforeRequest){
            // eslint-disable-next-line no-await-in-loop
            const result = await hook(this.request, this.#getNormalizedOptions(), {
                retryCount: this.#retryCount
            });
            if (result instanceof Request) {
                this.request = result;
                break;
            }
            if (result instanceof Response) return result;
        }
        const nonRequestOptions = (0, $8f1cde8f0e979cde$export$95d8775889ec941f)(this.request, this.#options);
        // Cloning is done here to prepare in advance for retries
        this.#originalRequest = this.request;
        this.request = this.#originalRequest.clone();
        if (this.#options.timeout === false) return this.#options.fetch(this.#originalRequest, nonRequestOptions);
        return (0, $c5d9d222c7ea65ca$export$2e2bcd8739ae039)(this.#originalRequest, nonRequestOptions, this.#abortController, this.#options);
    }
    #getNormalizedOptions() {
        if (!this.#cachedNormalizedOptions) {
            const { hooks: hooks, ...normalizedOptions } = this.#options;
            this.#cachedNormalizedOptions = Object.freeze(normalizedOptions);
        }
        return this.#cachedNormalizedOptions;
    }
}







const $59ae15552c3335ec$var$createInstance = (defaults)=>{
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    const ky = (input, options)=>(0, $7cbca30f25e84ae2$export$c482d6f00e170af3).create(input, (0, $19e1cad4986955d6$export$8886f5ba30bd5e0)(defaults, options));
    for (const method of (0, $95c77e88185d0a90$export$fb003dbd6df95edb))// eslint-disable-next-line @typescript-eslint/promise-function-async
    ky[method] = (input, options)=>(0, $7cbca30f25e84ae2$export$c482d6f00e170af3).create(input, (0, $19e1cad4986955d6$export$8886f5ba30bd5e0)(defaults, options, {
            method: method
        }));
    ky.create = (newDefaults)=>$59ae15552c3335ec$var$createInstance((0, $19e1cad4986955d6$export$8886f5ba30bd5e0)(newDefaults));
    ky.extend = (newDefaults)=>{
        if (typeof newDefaults === 'function') newDefaults = newDefaults(defaults ?? {});
        return $59ae15552c3335ec$var$createInstance((0, $19e1cad4986955d6$export$8886f5ba30bd5e0)(defaults, newDefaults));
    };
    ky.stop = (0, $95c77e88185d0a90$export$fa6813432f753b0d);
    return ky;
};
const $59ae15552c3335ec$var$ky = $59ae15552c3335ec$var$createInstance();
var $59ae15552c3335ec$export$2e2bcd8739ae039 = $59ae15552c3335ec$var$ky;
 // Intentionally not exporting this for now as it's just an implementation detail and we don't want to commit to a certain API yet at least.
 // export {NonError} from './errors/NonError.js';


const $fc777e011aeb2fae$var$BASE_PATH = '/api/v1';
const $fc777e011aeb2fae$export$644d8ea042df96a6 = (0, $59ae15552c3335ec$export$2e2bcd8739ae039).create({
    headers: {
        'Session-Id': BX.bitrix_sessid()
    },
    prefixUrl: $fc777e011aeb2fae$var$BASE_PATH
});
const $fc777e011aeb2fae$export$9099264ed9b1c55a = ()=>$fc777e011aeb2fae$var$BASE_PATH;



const $7ede587abac11f86$var$formSubmitHandler = (evt)=>{
    evt.preventDefault();
    const formElement = evt.target;
    if (!(0, $366106ffbe7c4eae$export$ed692cabb252e59b)(formElement)) return;
    const submitButton = formElement.querySelector('button[type="submit"]');
    (0, $366106ffbe7c4eae$export$9f2f414e0766ca84)(submitButton);
    const formData = new FormData(formElement);
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).post('user/registration/', {
        body: formData
    }).json().then((response)=>{
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(formElement, 'beforebegin', response.message, 'success');
        formElement.remove();
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(formElement, 'beforebegin', errorJson.message, 'error');
        (0, $366106ffbe7c4eae$export$7ae08f9d0817f013)(submitButton);
    });
};
const $7ede587abac11f86$var$formSubmitDialogInit = (dialogElement)=>{
    const form = dialogElement.querySelector('form[name="registration"]');
    if (form) form.addEventListener('submit', $7ede587abac11f86$var$formSubmitHandler);
};
const $7ede587abac11f86$var$displaysDialogInit = (dialogElement)=>{
    const triggerElements = document.querySelectorAll('.registration-dialog-trigger');
    if (triggerElements.length > 0) triggerElements.forEach((triggerElement)=>{
        triggerElement.addEventListener('click', (evt)=>{
            (0, $f2d2d5ccac893b6a$export$32562b6fed4c6551)(evt, dialogElement);
        });
    });
};
const $7ede587abac11f86$var$registrationDialogInit = ()=>{
    const dialogElement = document.querySelector('#registrationForm');
    if (dialogElement) {
        $7ede587abac11f86$var$displaysDialogInit(dialogElement);
        $7ede587abac11f86$var$formSubmitDialogInit(dialogElement);
    }
};
document.addEventListener('DOMContentLoaded', ()=>{
    $7ede587abac11f86$var$registrationDialogInit();
});



function $681681aa204bdee0$var$formSubmit(form) {
    const formData = new FormData(form);
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).post('service/', {
        body: formData
    }).json().then((response)=>{
        $681681aa204bdee0$var$showResult(form, response.message);
    });
}
function $681681aa204bdee0$var$showResult(form, message) {
    const result = form.querySelector('.result');
    result.textContent = message;
    result.style.display = 'block';
}
document.addEventListener('DOMContentLoaded', ()=>{
    const dialog = document.getElementById('serviceForm');
    const form = dialog.querySelector('form');
    const select = form.querySelector('.form__select');
    const button = form.querySelector('.bx_filter_parameters_box_title');
    button.addEventListener('click', ()=>{
        select.classList.toggle('active');
    });
    const submitButton = form.querySelector('button[type="submit"]');
    submitButton.addEventListener('click', (e)=>{
        e.preventDefault();
        if (!form.checkValidity()) {
            form.reportValidity();
            return;
        }
        $681681aa204bdee0$var$formSubmit(form);
    });
});






const $3f64a7d5e97c2517$var$formSubmitHandler = (evt)=>{
    evt.preventDefault();
    const formElement = evt.target;
    if (!(0, $366106ffbe7c4eae$export$ed692cabb252e59b)(formElement)) return;
    const submitButton = formElement.querySelector('button[type="submit"]');
    (0, $366106ffbe7c4eae$export$9f2f414e0766ca84)(submitButton);
    const formData = new FormData(formElement);
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).post('user/auth/', {
        body: formData
    }).json().then((response)=>{
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(formElement, 'beforebegin', response.message, 'success');
        formElement.remove();
        setTimeout(()=>{
            document.location.reload();
        }, 500);
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(formElement, 'beforebegin', errorJson.message, 'error');
        (0, $366106ffbe7c4eae$export$7ae08f9d0817f013)(submitButton);
    });
};
const $3f64a7d5e97c2517$var$formSubmitDialogInit = (dialogElement)=>{
    const form = dialogElement.querySelector('form[name="auth"]');
    if (form) form.addEventListener('submit', $3f64a7d5e97c2517$var$formSubmitHandler);
};
const $3f64a7d5e97c2517$var$displaysDialogInit = (dialogElement)=>{
    const triggerElements = document.querySelectorAll('.auth-dialog-trigger');
    if (triggerElements.length > 0) triggerElements.forEach((triggerElement)=>{
        triggerElement.addEventListener('click', (evt)=>{
            (0, $f2d2d5ccac893b6a$export$32562b6fed4c6551)(evt, dialogElement);
        });
    });
};
const $3f64a7d5e97c2517$var$authDialogInit = ()=>{
    const dialogElement = document.querySelector('#authForm');
    if (dialogElement) {
        $3f64a7d5e97c2517$var$displaysDialogInit(dialogElement);
        $3f64a7d5e97c2517$var$formSubmitDialogInit(dialogElement);
    }
};
document.addEventListener('DOMContentLoaded', ()=>{
    $3f64a7d5e97c2517$var$authDialogInit();
});






const $1b71d08988e56714$var$formSubmitHandler = (evt)=>{
    evt.preventDefault();
    const formElement = evt.target;
    if (!(0, $366106ffbe7c4eae$export$ed692cabb252e59b)(formElement)) return;
    const submitButton = formElement.querySelector('button[type="submit"]');
    (0, $366106ffbe7c4eae$export$9f2f414e0766ca84)(submitButton);
    const formData = new FormData(formElement);
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).post('user/recovery/', {
        body: formData
    }).json().then((response)=>{
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(formElement, 'beforebegin', response.message, 'success');
        formElement.remove();
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(formElement, 'beforebegin', errorJson.message, 'error');
        (0, $366106ffbe7c4eae$export$7ae08f9d0817f013)(submitButton);
    });
};
const $1b71d08988e56714$var$formSubmitDialogInit = (dialogElement)=>{
    const form = dialogElement.querySelector('form[name="recovery"]');
    if (form) form.addEventListener('submit', $1b71d08988e56714$var$formSubmitHandler);
};
const $1b71d08988e56714$var$displaysDialogInit = (dialogElement)=>{
    const triggerElements = document.querySelectorAll('.recovery-dialog-trigger');
    if (triggerElements.length > 0) triggerElements.forEach((triggerElement)=>{
        triggerElement.addEventListener('click', (evt)=>{
            (0, $f2d2d5ccac893b6a$export$32562b6fed4c6551)(evt, dialogElement);
        });
    });
};
const $1b71d08988e56714$var$authDialogInit = ()=>{
    const dialogElement = document.querySelector('#recoveryForm');
    if (dialogElement) {
        $1b71d08988e56714$var$displaysDialogInit(dialogElement);
        $1b71d08988e56714$var$formSubmitDialogInit(dialogElement);
    }
};
document.addEventListener('DOMContentLoaded', ()=>{
    $1b71d08988e56714$var$authDialogInit();
});






const $b5b1b8a00baf8427$var$formSubmitHandler = (evt)=>{
    evt.preventDefault();
    const formElement = evt.target;
    if (!(0, $366106ffbe7c4eae$export$ed692cabb252e59b)(formElement)) return;
    const submitButton = formElement.querySelector('button[type="submit"]');
    (0, $366106ffbe7c4eae$export$9f2f414e0766ca84)(submitButton);
    const formData = new FormData(formElement);
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).post('delivery-address/', {
        body: formData
    }).json().then((response)=>{
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(formElement, 'beforebegin', response.message, 'success');
        setTimeout(()=>{
            document.location.reload();
        }, 500);
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(formElement, 'beforebegin', errorJson.message, 'error');
        (0, $366106ffbe7c4eae$export$7ae08f9d0817f013)(submitButton);
    });
};
const $b5b1b8a00baf8427$var$formSubmitDialogInit = (dialogElement)=>{
    const form = dialogElement.querySelector('form[name="add-address"]');
    if (form) form.addEventListener('submit', $b5b1b8a00baf8427$var$formSubmitHandler);
};
const $b5b1b8a00baf8427$var$displaysDialogInit = (dialogElement)=>{
    const triggerElements = document.querySelectorAll('.add-address-dialog-trigger');
    if (triggerElements.length > 0) triggerElements.forEach((triggerElement)=>{
        triggerElement.addEventListener('click', (evt)=>{
            (0, $f2d2d5ccac893b6a$export$32562b6fed4c6551)(evt, dialogElement);
        });
    });
};
const $b5b1b8a00baf8427$var$addAddressDialogInit = ()=>{
    const dialogElement = document.querySelector('#addAddress');
    if (dialogElement) {
        $b5b1b8a00baf8427$var$displaysDialogInit(dialogElement);
        $b5b1b8a00baf8427$var$formSubmitDialogInit(dialogElement);
    }
};
document.addEventListener('DOMContentLoaded', ()=>{
    $b5b1b8a00baf8427$var$addAddressDialogInit();
});






const $5e3c34e96b1f14d4$var$formSubmitHandler = (evt)=>{
    evt.preventDefault();
    const formElement = evt.target;
    if (!(0, $366106ffbe7c4eae$export$ed692cabb252e59b)(formElement)) return;
    const submitButton = formElement.querySelector('button[type="submit"]');
    (0, $366106ffbe7c4eae$export$9f2f414e0766ca84)(submitButton);
    const formData = new FormData(formElement);
    const requestBody = JSON.stringify(Object.fromEntries(formData));
    const addressId = formData.get('id');
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).patch(`delivery-address/${addressId}`, {
        body: requestBody,
        headers: {
            'Content-Type': 'application/json'
        }
    }).json().then((response)=>{
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(formElement, 'beforebegin', response.message, 'success');
        setTimeout(()=>{
            document.location.reload();
        }, 500);
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(formElement, 'beforebegin', errorJson.message, 'error');
        (0, $366106ffbe7c4eae$export$7ae08f9d0817f013)(submitButton);
    });
};
const $5e3c34e96b1f14d4$var$editButtonClickHandler = (triggerElement, dialogElement)=>{
    const addressFields = JSON.parse(triggerElement.dataset.addressJson);
    const formElement = dialogElement.querySelector('form[name="edit-address"]');
    const inputElements = formElement.querySelectorAll('input.filled');
    if (inputElements.length > 0) inputElements.forEach((inputElement)=>{
        inputElement.value = addressFields[inputElement.name];
    });
};
const $5e3c34e96b1f14d4$var$formSubmitDialogInit = (dialogElement)=>{
    const form = dialogElement.querySelector('form[name="edit-address"]');
    if (form) form.addEventListener('submit', $5e3c34e96b1f14d4$var$formSubmitHandler);
};
const $5e3c34e96b1f14d4$var$displaysDialogInit = (dialogElement)=>{
    const triggerElements = document.querySelectorAll('.edit-address-dialog-trigger');
    const addressIdElement = dialogElement.querySelector('input[name="addressId"]');
    if (triggerElements.length > 0) triggerElements.forEach((triggerElement)=>{
        triggerElement.addEventListener('click', (evt)=>{
            if (addressIdElement) addressIdElement.value = triggerElement.dataset.addressId;
            (0, $f2d2d5ccac893b6a$export$32562b6fed4c6551)(evt, dialogElement);
            $5e3c34e96b1f14d4$var$editButtonClickHandler(triggerElement, dialogElement);
        });
    });
};
const $5e3c34e96b1f14d4$var$editAddressDialogInit = ()=>{
    const dialogElement = document.querySelector('#editAddress');
    if (dialogElement) {
        $5e3c34e96b1f14d4$var$displaysDialogInit(dialogElement);
        $5e3c34e96b1f14d4$var$formSubmitDialogInit(dialogElement);
    }
};
document.addEventListener('DOMContentLoaded', ()=>{
    $5e3c34e96b1f14d4$var$editAddressDialogInit();
});




/**
 * Диалоговое модальное окно.
 * Поддерживает автоматическое открытие и открытие по клику на триггер.
 *
 * @class DialogModal
 */ class $d1df9047692a867f$var$DialogModal {
    /**
     * @param {string} props.dialogSelector - селектор элемента dialog.
     * @param {string} props.dialogOpenTrigger - селектор элементов-триггеров для открытия.
     * @param {Object} props.settings - настройки модального окна.
     * @param {boolean} props.settings.autoOpen - Автоматически открывать диалог при загрузке.
     * @param {number} props.settings.timeout - Задержка автооткрытия (мс).
     * @param {string} props.settings.stopAutoOpenSessionKey - Ключ sessionStorage для блокировки повторного автооткрытия.
     * @param {Function} props.settings.callbackByOpen - Callback при открытии диалога.
     */ constructor(props){
        this.dialog = document.querySelector(props.dialogSelector);
        this.triggers = document.querySelectorAll(props.dialogOpenTrigger);
        this.settings = props.settings;
        this.initializeDialog();
    }
    /**
     * Инициализирует диалог: автооткрытие или привязку к триггерам.
     * @returns {void}
     */ initializeDialog() {
        if (!this.dialog) return;
        const isAutoOpenAvailable = !this.checkDialogOpened() && this.settings?.autoOpen;
        !isAutoOpenAvailable ? this.handleDialogOpenByTrigger() : setTimeout(()=>{
            (0, $f2d2d5ccac893b6a$export$32562b6fed4c6551)(null, this.dialog, this.settings?.callbackByOpen);
        }, this.settings.timeout);
    }
    /**
     * Добавляет обработчики клика на элементы-триггеры для открытия диалога.
     * @returns {void}
     */ handleDialogOpenByTrigger() {
        if (!this.triggers) return;
        this.triggers.forEach((trigger)=>{
            trigger.addEventListener('click', (event)=>{
                (0, $f2d2d5ccac893b6a$export$32562b6fed4c6551)(event, this.dialog, this.settings?.callbackByOpen);
            });
        });
    }
    /**
     * Проверяет, был ли диалог уже открыт в текущей сессии (через sessionStorage).
     * @returns {boolean|string|null} Значение из sessionStorage или false, если ключ не задан.
     */ checkDialogOpened() {
        const sessionStopKey = this.settings?.stopAutoOpenSessionKey;
        return sessionStopKey ? sessionStorage.getItem(sessionStopKey) : false;
    }
}
var $d1df9047692a867f$export$2e2bcd8739ae039 = $d1df9047692a867f$var$DialogModal;


document.addEventListener('DOMContentLoaded', ()=>{
    const settingsMaintenanceModal = {
        autoOpen: true,
        stopAutoOpenSessionKey: 'maintenance_stop',
        callbackByOpen: ()=>{
            if (!sessionStorage.getItem('maintenance_stop')) sessionStorage.setItem('maintenance_stop', 'Y');
        }
    };
    new (0, $d1df9047692a867f$export$2e2bcd8739ae039)({
        dialogSelector: '#maintenanceForm',
        settings: settingsMaintenanceModal
    });
    const settingErrorModal = {
        callbackByOpen: ()=>{
            (0, $f2d2d5ccac893b6a$export$59a5ddcbc0f77a29)('requestErrorForm');
        }
    };
    new (0, $d1df9047692a867f$export$2e2bcd8739ae039)({
        dialogSelector: '#requestErrorForm',
        dialogOpenTrigger: '[data-entity="maintenance-trigger"]',
        settings: settingErrorModal
    });
});






const $e21110c95d9c250e$var$deleteSubmitHandler = (evt)=>{
    evt.preventDefault();
    const confirmElement = evt.target.closest('#deleteConfirm');
    const submitButton = confirmElement.querySelector('#deleteAddressBtn');
    (0, $366106ffbe7c4eae$export$9f2f414e0766ca84)(submitButton);
    const addressId = submitButton.dataset.addressId;
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).delete(`delivery-address/${addressId}`).json().then((response)=>{
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(confirmElement, 'beforebegin', response.message, 'success');
        setTimeout(()=>{
            document.location.reload();
        }, 500);
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(confirmElement, 'beforebegin', errorJson.message, 'error');
        (0, $366106ffbe7c4eae$export$7ae08f9d0817f013)(submitButton);
    });
};
const $e21110c95d9c250e$var$deleteSubmitDialogInit = (dialogElement)=>{
    const btn = dialogElement.querySelector('#deleteAddressBtn');
    if (btn) btn.addEventListener('click', $e21110c95d9c250e$var$deleteSubmitHandler);
};
const $e21110c95d9c250e$var$displaysDialogInit = (dialogElement)=>{
    const triggerElements = document.querySelectorAll('.delete-address-dialog-trigger');
    const deleteAddressElement = dialogElement.querySelector('#deleteAddressBtn');
    if (triggerElements.length > 0) triggerElements.forEach((triggerElement)=>{
        triggerElement.addEventListener('click', (evt)=>{
            if (deleteAddressElement) deleteAddressElement.dataset.addressId = triggerElement.dataset.addressId;
            (0, $f2d2d5ccac893b6a$export$32562b6fed4c6551)(evt, dialogElement);
        });
    });
};
const $e21110c95d9c250e$var$deleteAddressDialogInit = ()=>{
    const dialogElement = document.querySelector('#deleteAddress');
    if (dialogElement) {
        $e21110c95d9c250e$var$displaysDialogInit(dialogElement);
        $e21110c95d9c250e$var$deleteSubmitDialogInit(dialogElement);
    }
};
document.addEventListener('DOMContentLoaded', ()=>{
    $e21110c95d9c250e$var$deleteAddressDialogInit();
});






const $45d8d257e161b95f$var$cancelSubmitHandler = (evt)=>{
    const confirmElement = evt.target.closest('#cancelConfirm');
    const submitButton = evt.currentTarget;
    (0, $366106ffbe7c4eae$export$9f2f414e0766ca84)(submitButton);
    const orderId = submitButton.dataset.orderId;
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).patch(`orders/cancel/${orderId}`).json().then((response)=>{
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(confirmElement, 'beforebegin', response.message, 'success');
        setTimeout(()=>{
            document.location.reload();
        }, 500);
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(confirmElement, 'beforebegin', errorJson.message, 'error');
        (0, $366106ffbe7c4eae$export$7ae08f9d0817f013)(submitButton);
    });
};
const $45d8d257e161b95f$var$cancelSubmitDialogInit = (dialogElement)=>{
    const btn = dialogElement.querySelector('#cancelOrderBtn');
    if (btn) btn.addEventListener('click', $45d8d257e161b95f$var$cancelSubmitHandler);
};
const $45d8d257e161b95f$var$displaysDialogInit = (dialogElement)=>{
    const triggerElements = document.querySelectorAll('.cancel-order-dialog-trigger');
    const cancelOrderElement = dialogElement.querySelector('#cancelOrderBtn');
    if (triggerElements.length > 0) triggerElements.forEach((triggerElement)=>{
        triggerElement.addEventListener('click', (evt)=>{
            if (cancelOrderElement) cancelOrderElement.dataset.orderId = triggerElement.dataset.orderId;
            (0, $f2d2d5ccac893b6a$export$32562b6fed4c6551)(evt, dialogElement);
        });
    });
};
const $45d8d257e161b95f$var$cancelOrderDialogInit = ()=>{
    const dialogElement = document.querySelector('#cancelOrderDialog');
    if (dialogElement) {
        $45d8d257e161b95f$var$displaysDialogInit(dialogElement);
        $45d8d257e161b95f$var$cancelSubmitDialogInit(dialogElement);
    }
};
document.addEventListener('DOMContentLoaded', ()=>{
    $45d8d257e161b95f$var$cancelOrderDialogInit();
});






const $76af7e2bd68c4d6a$var$clearSubmitHandler = (evt)=>{
    const confirmElement = evt.target.closest('#clearConfirm');
    const submitButton = evt.currentTarget;
    (0, $366106ffbe7c4eae$export$9f2f414e0766ca84)(submitButton);
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).delete(`favorite/`).json().then((response)=>{
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(confirmElement, 'beforebegin', response.message, 'success');
        setTimeout(()=>{
            document.location.reload();
        }, 500);
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(confirmElement, 'beforebegin', errorJson.message, 'error');
        (0, $366106ffbe7c4eae$export$7ae08f9d0817f013)(submitButton);
    });
};
const $76af7e2bd68c4d6a$var$clearSubmitDialogInit = (dialogElement)=>{
    const btn = dialogElement.querySelector('#clearFavoritesBtn');
    if (btn) btn.addEventListener('click', $76af7e2bd68c4d6a$var$clearSubmitHandler);
};
const $76af7e2bd68c4d6a$var$displaysDialogInit = (dialogElement)=>{
    const triggerElements = document.querySelectorAll('.clear-favorites-dialog-trigger');
    if (triggerElements.length > 0) triggerElements.forEach((triggerElement)=>{
        triggerElement.addEventListener('click', (evt)=>{
            (0, $f2d2d5ccac893b6a$export$32562b6fed4c6551)(evt, dialogElement);
        });
    });
};
const $76af7e2bd68c4d6a$var$clearFavoritesDialogInit = ()=>{
    const dialogElement = document.querySelector('#clearFavorites');
    if (dialogElement) {
        $76af7e2bd68c4d6a$var$displaysDialogInit(dialogElement);
        $76af7e2bd68c4d6a$var$clearSubmitDialogInit(dialogElement);
    }
};
document.addEventListener('DOMContentLoaded', ()=>{
    $76af7e2bd68c4d6a$var$clearFavoritesDialogInit();
});


let $13bfb8db553736ef$var$clickByOutsideHandlerFunction;
const $13bfb8db553736ef$var$clickByOutsideHandler = (evt, dropDownTriggerElement, dropDownElement)=>{
    const parentElement = dropDownElement.parentElement;
    if (!parentElement.contains(evt.target)) $13bfb8db553736ef$var$closeDropDown(dropDownTriggerElement, dropDownElement);
};
const $13bfb8db553736ef$var$isDesktopFlying = (triggerElement)=>{
    return window.innerWidth >= 1024 && triggerElement.parentElement.classList.contains('catalog__drop-down--desktop-flying');
};
const $13bfb8db553736ef$var$openDropDown = (triggerElement, dropDownElement)=>{
    triggerElement.classList.add('catalog__drop-down-trigger--triggered');
    dropDownElement.classList.add('catalog__drop-down-target--open');
    triggerElement.title = "\u0421\u0432\u0435\u0440\u043D\u0443\u0442\u044C";
    if ($13bfb8db553736ef$var$isDesktopFlying(triggerElement)) setTimeout(()=>{
        document.addEventListener('click', $13bfb8db553736ef$var$clickByOutsideHandlerFunction = function(evt) {
            $13bfb8db553736ef$var$clickByOutsideHandler(evt, triggerElement, dropDownElement);
        });
    }, 100);
};
const $13bfb8db553736ef$var$closeDropDown = (triggerElement, dropDownElement)=>{
    triggerElement.classList.remove('catalog__drop-down-trigger--triggered');
    dropDownElement.classList.remove('catalog__drop-down-target--open');
    triggerElement.title = "\u0420\u0430\u0441\u043A\u0440\u044B\u0442\u044C";
    if ($13bfb8db553736ef$var$isDesktopFlying(triggerElement)) document.removeEventListener('click', $13bfb8db553736ef$var$clickByOutsideHandlerFunction);
};
const $13bfb8db553736ef$var$clickDropDownTriggerHandler = (evt)=>{
    const dropDownElement = evt.currentTarget.parentElement.querySelector('.catalog__drop-down-target');
    if (dropDownElement) {
        const isOpen = dropDownElement.classList.contains('catalog__drop-down-target--open');
        if (isOpen) $13bfb8db553736ef$var$closeDropDown(evt.currentTarget, dropDownElement);
        else $13bfb8db553736ef$var$openDropDown(evt.currentTarget, dropDownElement);
    }
};
document.addEventListener('DOMContentLoaded', ()=>{
    const dropDownTriggerElements = document.querySelectorAll('.catalog__drop-down-trigger');
    if (dropDownTriggerElements.length > 0) dropDownTriggerElements.forEach((item)=>{
        item.addEventListener('click', $13bfb8db553736ef$var$clickDropDownTriggerHandler);
    });
});


/* global BX:writable */ 
const $52065533fadfdd15$var$getAmountField = (cardElement)=>{
    return cardElement.querySelector('[data-entity="amount-field"]');
};
const $52065533fadfdd15$var$getProductIdByCard = (cardElement)=>{
    return parseInt(cardElement.dataset.productCardId, 10);
};
const $52065533fadfdd15$var$switchDisplayBuyBlock = (cardElement, isHideAmount = false)=>{
    const buyTriggerElement = cardElement.querySelector('[data-entity="add-to-cart"]');
    const buyTriggerElementMobile = cardElement.querySelector('[data-entity="add-to-cart-mobile"]');
    if (buyTriggerElement) buyTriggerElement.classList.toggle('hidden', !isHideAmount);
    if (buyTriggerElementMobile) buyTriggerElementMobile.classList.toggle('hidden', !isHideAmount);
    const amountWrapperElement = cardElement.querySelector('[data-entity="amount-wrapper"]');
    if (amountWrapperElement) amountWrapperElement.classList.toggle('hidden', isHideAmount);
};
const $52065533fadfdd15$var$deleteFromCart = (cardElement)=>{
    const productId = $52065533fadfdd15$var$getProductIdByCard(cardElement);
    if (!productId) return;
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).delete(`cart/product/${productId}/`).json().then(()=>{
        $52065533fadfdd15$var$switchDisplayBuyBlock(cardElement, true);
        BX.onCustomEvent('OnBasketChange');
    }).catch(async (error)=>{
        const errorJson = error.response && await error.response.json();
        errorJson && console.error(errorJson.message);
    });
};
const $52065533fadfdd15$var$addToCart = (cardElement)=>{
    const fieldElement = $52065533fadfdd15$var$getAmountField(cardElement);
    if (!fieldElement) return;
    $52065533fadfdd15$var$checkAmountBlock(cardElement);
    const productId = $52065533fadfdd15$var$getProductIdByCard(cardElement);
    if (!productId) return;
    let amount = parseInt(fieldElement.value, 10);
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).post(`cart/product/${productId}/`, {
        json: {
            amount: amount
        }
    }).json().then(()=>{
        $52065533fadfdd15$var$switchDisplayBuyBlock(cardElement);
        BX.onCustomEvent('OnBasketChange');
    }).catch(async (error)=>{
        const errorJson = error.response && await error.response.json();
        errorJson && console.error(errorJson.message);
    });
};
const $52065533fadfdd15$var$clickAmountTriggerHandler = (evt, cardElement)=>{
    const triggerValue = evt.currentTarget.value;
    const fieldElement = $52065533fadfdd15$var$getAmountField(cardElement);
    if (!fieldElement) return;
    let amount = parseInt(fieldElement.value, 10);
    switch(triggerValue){
        case 'reduce':
            amount = amount - 1;
            if (amount >= 1) {
                fieldElement.value = amount;
                $52065533fadfdd15$var$addToCart(cardElement);
            } else {
                $52065533fadfdd15$var$switchDisplayBuyBlock(cardElement, true);
                $52065533fadfdd15$var$deleteFromCart(cardElement);
            }
            break;
        case 'increase':
            {
                const maxAmount = fieldElement.max;
                amount = amount + 1;
                if (amount <= maxAmount) {
                    fieldElement.value = amount;
                    $52065533fadfdd15$var$addToCart(cardElement);
                }
                break;
            }
    }
};
const $52065533fadfdd15$var$changeAmountFieldHandler = (cardElement)=>{
    $52065533fadfdd15$var$addToCart(cardElement);
};
const $52065533fadfdd15$export$f8eb9cf9cf77a69a = (cardElement)=>{
    const buyTriggerElement = cardElement.querySelector('[data-entity="add-to-cart"]');
    const buyTriggerElementMobile = cardElement.querySelector('[data-entity="add-to-cart-mobile"]');
    if (buyTriggerElement) buyTriggerElement.addEventListener('click', ()=>{
        $52065533fadfdd15$var$addToCart(cardElement);
        $52065533fadfdd15$var$switchDisplayBuyBlock(cardElement);
    });
    if (buyTriggerElementMobile) buyTriggerElementMobile.addEventListener('click', ()=>{
        $52065533fadfdd15$var$addToCart(cardElement);
        $52065533fadfdd15$var$switchDisplayBuyBlock(cardElement);
    });
    const amountTriggerElements = cardElement.querySelectorAll('[data-entity="amount-trigger"]');
    if (amountTriggerElements.length > 0) amountTriggerElements.forEach((item)=>{
        item.addEventListener('click', (evt)=>{
            $52065533fadfdd15$var$clickAmountTriggerHandler(evt, cardElement);
        });
    });
    const amountFieldElement = cardElement.querySelector('[data-entity="amount-field"]');
    if (amountFieldElement) amountFieldElement.addEventListener('change', ()=>{
        $52065533fadfdd15$var$changeAmountFieldHandler(cardElement);
    });
};
const $52065533fadfdd15$var$switchActiveAmountTrigger = (amountTriggerElement, isDisable = false)=>{
    if (amountTriggerElement) amountTriggerElement.disabled = isDisable;
};
const $52065533fadfdd15$var$checkAmountBlock = (cardElement)=>{
    const fieldElement = $52065533fadfdd15$var$getAmountField(cardElement);
    if (!fieldElement) return;
    let amount = parseInt(fieldElement.value, 10);
    const maxAmount = parseInt(fieldElement.max, 10);
    const increaseTriggerElement = cardElement.querySelector('[data-entity="amount-trigger"][value="increase"]');
    if (amount < 1) fieldElement.value = 1;
    else if (amount >= maxAmount) {
        fieldElement.value = maxAmount;
        $52065533fadfdd15$var$switchActiveAmountTrigger(increaseTriggerElement, true);
    } else $52065533fadfdd15$var$switchActiveAmountTrigger(increaseTriggerElement, false);
};
const $52065533fadfdd15$var$setProductAmount = (productId, amount)=>{
    const cardElement = document.querySelector(`[data-product-card-id="${productId}"]`);
    if (cardElement) {
        const fieldElement = $52065533fadfdd15$var$getAmountField(cardElement);
        if (fieldElement) {
            const maxAmount = parseInt(fieldElement.max, 10);
            fieldElement.value = amount > maxAmount ? maxAmount : amount;
            $52065533fadfdd15$var$switchDisplayBuyBlock(cardElement);
            $52065533fadfdd15$var$checkAmountBlock(cardElement);
        }
    }
};
const $52065533fadfdd15$export$1c3e698ac6e6e94d = ()=>{
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).get('cart/amount/').json().then((response)=>{
        if (response.products.length > 0) response.products.forEach((item)=>{
            $52065533fadfdd15$var$setProductAmount(item.id, item.amount);
        });
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        console.error(errorJson.message);
    });
};







const $7124e6d0afb9d4be$var$getProductId = (triggerElement)=>{
    return parseInt(triggerElement.closest('[data-product-card-id]').dataset.productCardId, 10);
};
const $7124e6d0afb9d4be$var$switchDisplaySubscribeWrapper = (element, isSubscribed)=>{
    if (isSubscribed) element.textContent = "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u043C \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u0435 \u043D\u0430 \u0432\u0430\u0448 email";
};
const $7124e6d0afb9d4be$var$setProductSubscribe = (productId)=>{
    const triggerWrapperElements = document.querySelectorAll(`[data-product-card-id="${productId}"] [data-entity="subscribe-trigger-wrapper"]`);
    if (triggerWrapperElements.length > 0) triggerWrapperElements.forEach((item)=>{
        $7124e6d0afb9d4be$var$switchDisplaySubscribeWrapper(item, true);
    });
};
const $7124e6d0afb9d4be$var$formSubmitHandler = (evt, dialogElement, productId)=>{
    evt.preventDefault();
    const formElement = evt.target;
    if (!(0, $366106ffbe7c4eae$export$ed692cabb252e59b)(formElement)) return;
    const submitButton = formElement.querySelector('button[type="submit"]');
    (0, $366106ffbe7c4eae$export$9f2f414e0766ca84)(submitButton);
    const formData = new FormData(formElement);
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).post(`product-subscribe/product/${productId}/`, {
        body: formData
    }).json().then((response)=>{
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(formElement, 'beforebegin', response.message, 'success');
        (0, $f2d2d5ccac893b6a$export$46cfff9ec9272f81)(dialogElement, true);
        (0, $366106ffbe7c4eae$export$7ae08f9d0817f013)(submitButton);
        $7124e6d0afb9d4be$var$setProductSubscribe(productId);
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        (0, $9a4bfff5dffba651$export$de026b00723010c1)(formElement, 'beforebegin', errorJson.message, 'error');
        (0, $f2d2d5ccac893b6a$export$46cfff9ec9272f81)(dialogElement, true);
        (0, $366106ffbe7c4eae$export$7ae08f9d0817f013)(submitButton);
    });
};
const $7124e6d0afb9d4be$var$formSubmitDialogInit = (dialogElement, productId)=>{
    const form = dialogElement.querySelector('form[name="product-subscribe"]');
    if (form) form.addEventListener('submit', (evt)=>{
        $7124e6d0afb9d4be$var$formSubmitHandler(evt, dialogElement, productId);
    }, {
        once: true
    });
};
const $7124e6d0afb9d4be$var$clickSubscribeTriggerHandler = (evt, triggerElement)=>{
    const productId = $7124e6d0afb9d4be$var$getProductId(triggerElement);
    if (!productId) return;
    const dialogElement = document.querySelector('#productSubscribeForm');
    if (dialogElement) {
        (0, $f2d2d5ccac893b6a$export$32562b6fed4c6551)(evt, dialogElement);
        $7124e6d0afb9d4be$var$formSubmitDialogInit(dialogElement, productId);
    }
};
const $7124e6d0afb9d4be$export$132936eab0c832c = (cardElement)=>{
    const triggerElement = cardElement.querySelector('[data-entity="subscribe-trigger"]');
    if (triggerElement) triggerElement.addEventListener('click', (evt)=>{
        $7124e6d0afb9d4be$var$clickSubscribeTriggerHandler(evt, triggerElement);
    });
};
const $7124e6d0afb9d4be$export$c87fadd8a8ccf4b5 = ()=>{
    const userId = (0, $43829a6f0e34d097$export$5ebc6cb2748e1881)();
    if (userId > 0) (0, $fc777e011aeb2fae$export$644d8ea042df96a6).get(`product-subscribe/user/${userId}/`).json().then((response)=>{
        if (response.products.length > 0) response.products.forEach((item)=>{
            $7124e6d0afb9d4be$var$setProductSubscribe(item);
        });
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        console.error(errorJson.message);
    });
};


document.addEventListener('DOMContentLoaded', ()=>{
    const cardElements = document.querySelectorAll('[data-product-card-id]');
    if (cardElements.length > 0) {
        cardElements.forEach((item)=>{
            (0, $52065533fadfdd15$export$f8eb9cf9cf77a69a)(item);
            (0, $7124e6d0afb9d4be$export$132936eab0c832c)(item);
        });
        (0, $52065533fadfdd15$export$1c3e698ac6e6e94d)();
        setTimeout(()=>(0, $7124e6d0afb9d4be$export$c87fadd8a8ccf4b5)(), 400);
    }
});




const $31f3f793ca07d276$var$showResult = (message)=>{
    const messageElement = document.querySelector('.subscribe__title');
    if (messageElement) messageElement.textContent = message;
};
const $31f3f793ca07d276$var$formSubmitHandler = (evt)=>{
    evt.preventDefault();
    const formElement = evt.target;
    if (!(0, $366106ffbe7c4eae$export$ed692cabb252e59b)(formElement)) return;
    const submitButton = formElement.querySelector('button[type="submit"]');
    (0, $366106ffbe7c4eae$export$9f2f414e0766ca84)(submitButton, true);
    const formData = new FormData(formElement);
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).post('news-subscribe/', {
        body: formData
    }).json().then((response)=>{
        $31f3f793ca07d276$var$showResult(response.message);
        formElement.remove();
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        $31f3f793ca07d276$var$showResult(errorJson.message);
        (0, $366106ffbe7c4eae$export$7ae08f9d0817f013)(submitButton, true);
    });
};
document.addEventListener('DOMContentLoaded', ()=>{
    const form = document.querySelector('form[name="subscribe-news"]');
    if (form) form.addEventListener('submit', $31f3f793ca07d276$var$formSubmitHandler);
});


const $e1efa1f223555c3e$var$openSearch = (searchElement)=>{
    searchElement.classList.add('search--show');
    const autofocusField = searchElement.querySelector('.search__input');
    if (autofocusField && !autofocusField.value) autofocusField.focus();
    document.addEventListener('keydown', $e1efa1f223555c3e$var$keydownHandler);
};
const $e1efa1f223555c3e$var$closeSearch = (searchElement)=>{
    searchElement.classList.remove('search--show');
    document.removeEventListener('keydown', $e1efa1f223555c3e$var$keydownHandler);
};
function $e1efa1f223555c3e$var$keydownHandler(evt) {
    if (evt.code === 'Escape') {
        const searchElement = document.querySelector('.search');
        if (searchElement) $e1efa1f223555c3e$var$closeSearch(searchElement);
    }
}
const $e1efa1f223555c3e$var$clickTriggerHandler = (searchElement)=>{
    $e1efa1f223555c3e$var$openSearch(searchElement);
};
const $e1efa1f223555c3e$var$searchBlockInit = (searchElement)=>{
    const overlayElement = searchElement.querySelector('.search__overlay');
    if (overlayElement) overlayElement.addEventListener('click', ()=>{
        $e1efa1f223555c3e$var$closeSearch(searchElement);
    });
};
document.addEventListener('DOMContentLoaded', ()=>{
    const searchElement = document.querySelector('.search');
    if (!searchElement) return;
    $e1efa1f223555c3e$var$searchBlockInit(searchElement);
    const searchTriggerElements = document.querySelectorAll('.search-trigger');
    if (searchTriggerElements.length > 0) searchTriggerElements.forEach((item)=>{
        item.addEventListener('click', ()=>{
            $e1efa1f223555c3e$var$clickTriggerHandler(searchElement);
        });
    });
});



const $d4d06657c043713f$var$t = (t, e = 1e4)=>(t = parseFloat(t + "") || 0, Math.round((t + Number.EPSILON) * e) / e), $d4d06657c043713f$var$e = function(t) {
    if (!(t && t instanceof Element && t.offsetParent)) return !1;
    const e = t.scrollHeight > t.clientHeight, i = window.getComputedStyle(t).overflowY, n = -1 !== i.indexOf("hidden"), s = -1 !== i.indexOf("visible");
    return e && !n && !s;
}, $d4d06657c043713f$var$i = function(t, n) {
    return !(!t || t === document.body || n && t === n) && ($d4d06657c043713f$var$e(t) ? t : $d4d06657c043713f$var$i(t.parentElement, n));
}, $d4d06657c043713f$var$n = function(t) {
    var e = (new DOMParser).parseFromString(t, "text/html").body;
    if (e.childElementCount > 1) {
        for(var i = document.createElement("div"); e.firstChild;)i.appendChild(e.firstChild);
        return i;
    }
    return e.firstChild;
}, $d4d06657c043713f$var$s = (t)=>`${t || ""}`.split(" ").filter((t)=>!!t), $d4d06657c043713f$var$o = (t, e, i)=>{
    t && $d4d06657c043713f$var$s(e).forEach((e)=>{
        t.classList.toggle(e, i || !1);
    });
};
class $d4d06657c043713f$var$a {
    constructor(t){
        Object.defineProperty(this, "pageX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "pageY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "clientY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "time", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "nativePointer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), this.nativePointer = t, this.pageX = t.pageX, this.pageY = t.pageY, this.clientX = t.clientX, this.clientY = t.clientY, this.id = self.Touch && t instanceof Touch ? t.identifier : -1, this.time = Date.now();
    }
}
const $d4d06657c043713f$var$r = {
    passive: !1
};
class $d4d06657c043713f$var$l {
    constructor(t, { start: e = ()=>!0, move: i = ()=>{}, end: n = ()=>{} }){
        Object.defineProperty(this, "element", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "startCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "moveCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "endCallback", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "currentPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "startPointers", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), this.element = t, this.startCallback = e, this.moveCallback = i, this.endCallback = n;
        for (const t of [
            "onPointerStart",
            "onTouchStart",
            "onMove",
            "onTouchEnd",
            "onPointerEnd",
            "onWindowBlur"
        ])this[t] = this[t].bind(this);
        this.element.addEventListener("mousedown", this.onPointerStart, $d4d06657c043713f$var$r), this.element.addEventListener("touchstart", this.onTouchStart, $d4d06657c043713f$var$r), this.element.addEventListener("touchmove", this.onMove, $d4d06657c043713f$var$r), this.element.addEventListener("touchend", this.onTouchEnd), this.element.addEventListener("touchcancel", this.onTouchEnd);
    }
    onPointerStart(t) {
        if (!t.buttons || 0 !== t.button) return;
        const e = new $d4d06657c043713f$var$a(t);
        this.currentPointers.some((t)=>t.id === e.id) || this.triggerPointerStart(e, t) && (window.addEventListener("mousemove", this.onMove), window.addEventListener("mouseup", this.onPointerEnd), window.addEventListener("blur", this.onWindowBlur));
    }
    onTouchStart(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerStart(new $d4d06657c043713f$var$a(e), t);
        window.addEventListener("blur", this.onWindowBlur);
    }
    onMove(t) {
        const e = this.currentPointers.slice(), i = "changedTouches" in t ? Array.from(t.changedTouches || []).map((t)=>new $d4d06657c043713f$var$a(t)) : [
            new $d4d06657c043713f$var$a(t)
        ], n = [];
        for (const t of i){
            const e = this.currentPointers.findIndex((e)=>e.id === t.id);
            e < 0 || (n.push(t), this.currentPointers[e] = t);
        }
        n.length && this.moveCallback(t, this.currentPointers.slice(), e);
    }
    onPointerEnd(t) {
        t.buttons > 0 && 0 !== t.button || (this.triggerPointerEnd(t, new $d4d06657c043713f$var$a(t)), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur));
    }
    onTouchEnd(t) {
        for (const e of Array.from(t.changedTouches || []))this.triggerPointerEnd(t, new $d4d06657c043713f$var$a(e));
    }
    triggerPointerStart(t, e) {
        return !!this.startCallback(e, t, this.currentPointers.slice()) && (this.currentPointers.push(t), this.startPointers.push(t), !0);
    }
    triggerPointerEnd(t, e) {
        const i = this.currentPointers.findIndex((t)=>t.id === e.id);
        i < 0 || (this.currentPointers.splice(i, 1), this.startPointers.splice(i, 1), this.endCallback(t, e, this.currentPointers.slice()));
    }
    onWindowBlur() {
        this.clear();
    }
    clear() {
        for(; this.currentPointers.length;){
            const t = this.currentPointers[this.currentPointers.length - 1];
            this.currentPointers.splice(this.currentPointers.length - 1, 1), this.startPointers.splice(this.currentPointers.length - 1, 1), this.endCallback(new Event("touchend", {
                bubbles: !0,
                cancelable: !0,
                clientX: t.clientX,
                clientY: t.clientY
            }), t, this.currentPointers.slice());
        }
    }
    stop() {
        this.element.removeEventListener("mousedown", this.onPointerStart, $d4d06657c043713f$var$r), this.element.removeEventListener("touchstart", this.onTouchStart, $d4d06657c043713f$var$r), this.element.removeEventListener("touchmove", this.onMove, $d4d06657c043713f$var$r), this.element.removeEventListener("touchend", this.onTouchEnd), this.element.removeEventListener("touchcancel", this.onTouchEnd), window.removeEventListener("mousemove", this.onMove), window.removeEventListener("mouseup", this.onPointerEnd), window.removeEventListener("blur", this.onWindowBlur);
    }
}
function $d4d06657c043713f$var$c(t, e) {
    return e ? Math.sqrt(Math.pow(e.clientX - t.clientX, 2) + Math.pow(e.clientY - t.clientY, 2)) : 0;
}
function $d4d06657c043713f$var$h(t, e) {
    return e ? {
        clientX: (t.clientX + e.clientX) / 2,
        clientY: (t.clientY + e.clientY) / 2
    } : t;
}
const $d4d06657c043713f$var$d = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t), $d4d06657c043713f$var$u = (t, ...e)=>{
    const i = e.length;
    for(let n = 0; n < i; n++){
        const i = e[n] || {};
        Object.entries(i).forEach(([e, i])=>{
            const n = Array.isArray(i) ? [] : {};
            t[e] || Object.assign(t, {
                [e]: n
            }), $d4d06657c043713f$var$d(i) ? Object.assign(t[e], $d4d06657c043713f$var$u(n, i)) : Array.isArray(i) ? Object.assign(t, {
                [e]: [
                    ...i
                ]
            }) : Object.assign(t, {
                [e]: i
            });
        });
    }
    return t;
}, $d4d06657c043713f$var$p = function(t, e) {
    return t.split(".").reduce((t, e)=>"object" == typeof t ? t[e] : void 0, e);
};
class $d4d06657c043713f$var$f {
    constructor(t = {}){
        Object.defineProperty(this, "options", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        }), Object.defineProperty(this, "events", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Map
        }), this.setOptions(t);
        for (const t of Object.getOwnPropertyNames(Object.getPrototypeOf(this)))t.startsWith("on") && "function" == typeof this[t] && (this[t] = this[t].bind(this));
    }
    setOptions(t) {
        this.options = t ? $d4d06657c043713f$var$u({}, this.constructor.defaults, t) : {};
        for (const [t, e] of Object.entries(this.option("on") || {}))this.on(t, e);
    }
    option(t, ...e) {
        let i = $d4d06657c043713f$var$p(t, this.options);
        return i && "function" == typeof i && (i = i.call(this, this, ...e)), i;
    }
    optionFor(t, e, i, ...n) {
        let s = $d4d06657c043713f$var$p(e, t);
        var o;
        "string" != typeof (o = s) || isNaN(o) || isNaN(parseFloat(o)) || (s = parseFloat(s)), "true" === s && (s = !0), "false" === s && (s = !1), s && "function" == typeof s && (s = s.call(this, this, t, ...n));
        let a = $d4d06657c043713f$var$p(e, this.options);
        return a && "function" == typeof a ? s = a.call(this, this, t, ...n, s) : void 0 === s && (s = a), void 0 === s ? i : s;
    }
    cn(t) {
        const e = this.options.classes;
        return e && e[t] || "";
    }
    localize(t, e = []) {
        t = String(t).replace(/\{\{(\w+).?(\w+)?\}\}/g, (t, e, i)=>{
            let n = "";
            return i ? n = this.option(`${e[0] + e.toLowerCase().substring(1)}.l10n.${i}`) : e && (n = this.option(`l10n.${e}`)), n || (n = t), n;
        });
        for(let i = 0; i < e.length; i++)t = t.split(e[i][0]).join(e[i][1]);
        return t = t.replace(/\{\{(.*?)\}\}/g, (t, e)=>e);
    }
    on(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), this.events || (this.events = new Map), i.forEach((t)=>{
            let i = this.events.get(t);
            i || (this.events.set(t, []), i = []), i.includes(e) || i.push(e), this.events.set(t, i);
        });
    }
    off(t, e) {
        let i = [];
        "string" == typeof t ? i = t.split(" ") : Array.isArray(t) && (i = t), i.forEach((t)=>{
            const i = this.events.get(t);
            if (Array.isArray(i)) {
                const t = i.indexOf(e);
                t > -1 && i.splice(t, 1);
            }
        });
    }
    emit(t, ...e) {
        [
            ...this.events.get(t) || []
        ].forEach((t)=>t(this, ...e)), "*" !== t && this.emit("*", t, ...e);
    }
}
Object.defineProperty($d4d06657c043713f$var$f, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($d4d06657c043713f$var$f, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
class $d4d06657c043713f$var$g extends $d4d06657c043713f$var$f {
    constructor(t = {}){
        super(t), Object.defineProperty(this, "plugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        });
    }
    attachPlugins(t = {}) {
        const e = new Map;
        for (const [i, n] of Object.entries(t)){
            const t = this.option(i), s = this.plugins[i];
            s || !1 === t ? s && !1 === t && (s.detach(), delete this.plugins[i]) : e.set(i, new n(this, t || {}));
        }
        for (const [t, i] of e)this.plugins[t] = i, i.attach();
    }
    detachPlugins(t) {
        t = t || Object.keys(this.plugins);
        for (const e of t){
            const t = this.plugins[e];
            t && t.detach(), delete this.plugins[e];
        }
        return this.emit("detachPlugins"), this;
    }
}
var $d4d06657c043713f$var$m;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Error = 1] = "Error", t[t.Ready = 2] = "Ready", t[t.Panning = 3] = "Panning", t[t.Mousemove = 4] = "Mousemove", t[t.Destroy = 5] = "Destroy";
}($d4d06657c043713f$var$m || ($d4d06657c043713f$var$m = {}));
const $d4d06657c043713f$var$v = [
    "a",
    "b",
    "c",
    "d",
    "e",
    "f"
], $d4d06657c043713f$var$b = {
    PANUP: "Move up",
    PANDOWN: "Move down",
    PANLEFT: "Move left",
    PANRIGHT: "Move right",
    ZOOMIN: "Zoom in",
    ZOOMOUT: "Zoom out",
    TOGGLEZOOM: "Toggle zoom level",
    TOGGLE1TO1: "Toggle zoom level",
    ITERATEZOOM: "Toggle zoom level",
    ROTATECCW: "Rotate counterclockwise",
    ROTATECW: "Rotate clockwise",
    FLIPX: "Flip horizontally",
    FLIPY: "Flip vertically",
    FITX: "Fit horizontally",
    FITY: "Fit vertically",
    RESET: "Reset",
    TOGGLEFS: "Toggle fullscreen"
}, $d4d06657c043713f$var$y = {
    content: null,
    width: "auto",
    height: "auto",
    panMode: "drag",
    touch: !0,
    dragMinThreshold: 3,
    lockAxis: !1,
    mouseMoveFactor: 1,
    mouseMoveFriction: .12,
    zoom: !0,
    pinchToZoom: !0,
    panOnlyZoomed: "auto",
    minScale: 1,
    maxScale: 2,
    friction: .25,
    dragFriction: .35,
    decelFriction: .05,
    click: "toggleZoom",
    dblClick: !1,
    wheel: "zoom",
    wheelLimit: 7,
    spinner: !0,
    bounds: "auto",
    infinite: !1,
    rubberband: !0,
    bounce: !0,
    maxVelocity: 75,
    transformParent: !1,
    classes: {
        content: "f-panzoom__content",
        isLoading: "is-loading",
        canZoomIn: "can-zoom_in",
        canZoomOut: "can-zoom_out",
        isDraggable: "is-draggable",
        isDragging: "is-dragging",
        inFullscreen: "in-fullscreen",
        htmlHasFullscreen: "with-panzoom-in-fullscreen"
    },
    l10n: $d4d06657c043713f$var$b
}, $d4d06657c043713f$var$w = '<circle cx="25" cy="25" r="20"></circle>', $d4d06657c043713f$var$x = '<div class="f-spinner"><svg viewBox="0 0 50 50">' + $d4d06657c043713f$var$w + $d4d06657c043713f$var$w + "</svg></div>", $d4d06657c043713f$var$E = (t)=>t && null !== t && t instanceof Element && "nodeType" in t, $d4d06657c043713f$var$S = (t, e)=>{
    t && $d4d06657c043713f$var$s(e).forEach((e)=>{
        t.classList.remove(e);
    });
}, $d4d06657c043713f$var$P = (t, e)=>{
    t && $d4d06657c043713f$var$s(e).forEach((e)=>{
        t.classList.add(e);
    });
}, $d4d06657c043713f$var$C = {
    a: 1,
    b: 0,
    c: 0,
    d: 1,
    e: 0,
    f: 0
}, $d4d06657c043713f$var$T = 1e5, $d4d06657c043713f$var$M = 1e4, $d4d06657c043713f$var$O = "mousemove", $d4d06657c043713f$var$A = "drag", $d4d06657c043713f$var$L = "content", $d4d06657c043713f$var$z = "auto";
let $d4d06657c043713f$var$R = null, $d4d06657c043713f$var$k = null;
class $d4d06657c043713f$export$b704d075ddd20210 extends $d4d06657c043713f$var$g {
    get fits() {
        return this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1;
    }
    get isTouchDevice() {
        return null === $d4d06657c043713f$var$k && ($d4d06657c043713f$var$k = window.matchMedia("(hover: none)").matches), $d4d06657c043713f$var$k;
    }
    get isMobile() {
        return null === $d4d06657c043713f$var$R && ($d4d06657c043713f$var$R = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)), $d4d06657c043713f$var$R;
    }
    get panMode() {
        return this.options.panMode !== $d4d06657c043713f$var$O || this.isTouchDevice ? $d4d06657c043713f$var$A : $d4d06657c043713f$var$O;
    }
    get panOnlyZoomed() {
        const t = this.options.panOnlyZoomed;
        return t === $d4d06657c043713f$var$z ? this.isTouchDevice : t;
    }
    get isInfinite() {
        return this.option("infinite");
    }
    get angle() {
        return 180 * Math.atan2(this.current.b, this.current.a) / Math.PI || 0;
    }
    get targetAngle() {
        return 180 * Math.atan2(this.target.b, this.target.a) / Math.PI || 0;
    }
    get scale() {
        const { a: t, b: e } = this.current;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get targetScale() {
        const { a: t, b: e } = this.target;
        return Math.sqrt(t * t + e * e) || 1;
    }
    get minScale() {
        return this.option("minScale") || 1;
    }
    get fullScale() {
        const { contentRect: t } = this;
        return t.fullWidth / t.fitWidth || 1;
    }
    get maxScale() {
        return this.fullScale * (this.option("maxScale") || 1) || 1;
    }
    get coverScale() {
        const { containerRect: t, contentRect: e } = this, i = Math.max(t.height / e.fitHeight, t.width / e.fitWidth) || 1;
        return Math.min(this.fullScale, i);
    }
    get isScaling() {
        return Math.abs(this.targetScale - this.scale) > 1e-5 && !this.isResting;
    }
    get isContentLoading() {
        const t = this.content;
        return !!(t && t instanceof HTMLImageElement) && !t.complete;
    }
    get isResting() {
        if (this.isBouncingX || this.isBouncingY) return !1;
        for (const t of $d4d06657c043713f$var$v){
            const e = "e" == t || "f" === t ? 1e-4 : 1e-5;
            if (Math.abs(this.target[t] - this.current[t]) > e) return !1;
        }
        return !(!this.ignoreBounds && !this.checkBounds().inBounds);
    }
    constructor(t, e = {}, i = {}){
        var s;
        if (super(e), Object.defineProperty(this, "pointerTracker", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "resizeObserver", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "updateTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "rAF", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isTicking", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "ignoreBounds", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingX", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "isBouncingY", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "clicks", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "trackingPoints", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "cwd", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "pmme", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "friction", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$m.Init
        }), Object.defineProperty(this, "isDragging", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "content", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "spinner", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "containerRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                width: 0,
                height: 0,
                innerWidth: 0,
                innerHeight: 0
            }
        }), Object.defineProperty(this, "contentRect", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                fullWidth: 0,
                fullHeight: 0,
                fitWidth: 0,
                fitHeight: 0,
                width: 0,
                height: 0
            }
        }), Object.defineProperty(this, "dragStart", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                top: 0,
                left: 0,
                time: 0
            }
        }), Object.defineProperty(this, "dragOffset", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                x: 0,
                y: 0,
                time: 0
            }
        }), Object.defineProperty(this, "current", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $d4d06657c043713f$var$C)
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: Object.assign({}, $d4d06657c043713f$var$C)
        }), Object.defineProperty(this, "velocity", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {
                a: 0,
                b: 0,
                c: 0,
                d: 0,
                e: 0,
                f: 0
            }
        }), Object.defineProperty(this, "lockedAxis", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), !t) throw new Error("Container Element Not Found");
        this.container = t, this.initContent(), this.attachPlugins(Object.assign(Object.assign({}, $d4d06657c043713f$export$b704d075ddd20210.Plugins), i)), this.emit("attachPlugins"), this.emit("init");
        const o = this.content;
        if (o.addEventListener("load", this.onLoad), o.addEventListener("error", this.onError), this.isContentLoading) {
            if (this.option("spinner")) {
                t.classList.add(this.cn("isLoading"));
                const e = $d4d06657c043713f$var$n($d4d06657c043713f$var$x);
                !t.contains(o) || o.parentElement instanceof HTMLPictureElement ? this.spinner = t.appendChild(e) : this.spinner = (null === (s = o.parentElement) || void 0 === s ? void 0 : s.insertBefore(e, o)) || null;
            }
            this.emit("beforeLoad");
        } else queueMicrotask(()=>{
            this.enable();
        });
    }
    initContent() {
        const { container: t } = this, e = this.cn($d4d06657c043713f$var$L);
        let i = this.option($d4d06657c043713f$var$L) || t.querySelector(`.${e}`);
        if (i || (i = t.querySelector("img,picture") || t.firstElementChild, i && $d4d06657c043713f$var$P(i, e)), i instanceof HTMLPictureElement && (i = i.querySelector("img")), !i) throw new Error("No content found");
        this.content = i;
    }
    onLoad() {
        const { spinner: t, container: e, state: i } = this;
        t && (t.remove(), this.spinner = null), this.option("spinner") && e.classList.remove(this.cn("isLoading")), this.emit("afterLoad"), i === $d4d06657c043713f$var$m.Init ? this.enable() : this.updateMetrics();
    }
    onError() {
        this.state !== $d4d06657c043713f$var$m.Destroy && (this.spinner && (this.spinner.remove(), this.spinner = null), this.stop(), this.detachEvents(), this.state = $d4d06657c043713f$var$m.Error, this.emit("error"));
    }
    getNextScale(t) {
        const { fullScale: e, targetScale: i, coverScale: n, maxScale: s, minScale: o } = this;
        let a = o;
        switch(t){
            case "toggleMax":
                a = i - o < .5 * (s - o) ? s : o;
                break;
            case "toggleCover":
                a = i - o < .5 * (n - o) ? n : o;
                break;
            case "toggleZoom":
                a = i - o < .5 * (e - o) ? e : o;
                break;
            case "iterateZoom":
                let t1 = [
                    1,
                    e,
                    s
                ].sort((t, e)=>t - e), r = t1.findIndex((t)=>t > i + 1e-5);
                a = t1[r] || 1;
        }
        return a;
    }
    attachObserver() {
        var t;
        const e = ()=>{
            const { container: t, containerRect: e } = this;
            return Math.abs(e.width - t.getBoundingClientRect().width) > .1 || Math.abs(e.height - t.getBoundingClientRect().height) > .1;
        };
        this.resizeObserver || void 0 === window.ResizeObserver || (this.resizeObserver = new ResizeObserver(()=>{
            this.updateTimer || (e() ? (this.onResize(), this.isMobile && (this.updateTimer = setTimeout(()=>{
                e() && this.onResize(), this.updateTimer = null;
            }, 500))) : this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null));
        })), null === (t = this.resizeObserver) || void 0 === t || t.observe(this.container);
    }
    detachObserver() {
        var t;
        null === (t = this.resizeObserver) || void 0 === t || t.disconnect();
    }
    attachEvents() {
        const { container: t } = this;
        t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("wheel", this.onWheel, {
            passive: !1
        }), this.pointerTracker = new $d4d06657c043713f$var$l(t, {
            start: this.onPointerDown,
            move: this.onPointerMove,
            end: this.onPointerUp
        }), document.addEventListener($d4d06657c043713f$var$O, this.onMouseMove);
    }
    detachEvents() {
        var t;
        const { container: e } = this;
        e.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("wheel", this.onWheel, {
            passive: !1
        }), null === (t = this.pointerTracker) || void 0 === t || t.stop(), this.pointerTracker = null, document.removeEventListener($d4d06657c043713f$var$O, this.onMouseMove), document.removeEventListener("keydown", this.onKeydown, !0), this.clickTimer && (clearTimeout(this.clickTimer), this.clickTimer = null), this.updateTimer && (clearTimeout(this.updateTimer), this.updateTimer = null);
    }
    animate() {
        this.setTargetForce();
        const t = this.friction, e = this.option("maxVelocity");
        for (const i of $d4d06657c043713f$var$v)t ? (this.velocity[i] *= 1 - t, e && !this.isScaling && (this.velocity[i] = Math.max(Math.min(this.velocity[i], e), -1 * e)), this.current[i] += this.velocity[i]) : this.current[i] = this.target[i];
        this.setTransform(), this.setEdgeForce(), !this.isResting || this.isDragging ? this.rAF = requestAnimationFrame(()=>this.animate()) : this.stop("current");
    }
    setTargetForce() {
        for (const t of $d4d06657c043713f$var$v)"e" === t && this.isBouncingX || "f" === t && this.isBouncingY || (this.velocity[t] = (1 / (1 - this.friction) - 1) * (this.target[t] - this.current[t]));
    }
    checkBounds(t = 0, e = 0) {
        const { current: i } = this, n = i.e + t, s = i.f + e, o = this.getBounds(), { x: a, y: r } = o, l = a.min, c = a.max, h = r.min, d = r.max;
        let u = 0, p = 0;
        return l !== 1 / 0 && n < l ? u = l - n : c !== 1 / 0 && n > c && (u = c - n), h !== 1 / 0 && s < h ? p = h - s : d !== 1 / 0 && s > d && (p = d - s), Math.abs(u) < 1e-4 && (u = 0), Math.abs(p) < 1e-4 && (p = 0), Object.assign(Object.assign({}, o), {
            xDiff: u,
            yDiff: p,
            inBounds: !u && !p
        });
    }
    clampTargetBounds() {
        const { target: t } = this, { x: e, y: i } = this.getBounds();
        e.min !== 1 / 0 && (t.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (t.e = Math.min(t.e, e.max)), i.min !== 1 / 0 && (t.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (t.f = Math.min(t.f, i.max));
    }
    calculateContentDim(t = this.current) {
        const { content: e, contentRect: i } = this, { fitWidth: n, fitHeight: s, fullWidth: o, fullHeight: a } = i;
        let r = o, l = a;
        if (this.option("zoom") || 0 !== this.angle) {
            const i = !(e instanceof HTMLImageElement) && ("none" === window.getComputedStyle(e).maxWidth || "none" === window.getComputedStyle(e).maxHeight), c = i ? o : n, h = i ? a : s, d = this.getMatrix(t), u = new DOMPoint(0, 0).matrixTransform(d), p = new DOMPoint(0 + c, 0).matrixTransform(d), f = new DOMPoint(0 + c, 0 + h).matrixTransform(d), g = new DOMPoint(0, 0 + h).matrixTransform(d), m = Math.abs(f.x - u.x), v = Math.abs(f.y - u.y), b = Math.abs(g.x - p.x), y = Math.abs(g.y - p.y);
            r = Math.max(m, b), l = Math.max(v, y);
        }
        return {
            contentWidth: r,
            contentHeight: l
        };
    }
    setEdgeForce() {
        if (this.ignoreBounds || this.isDragging || this.panMode === $d4d06657c043713f$var$O || this.targetScale < this.scale) return this.isBouncingX = !1, void (this.isBouncingY = !1);
        const { target: t } = this, { x: e, y: i, xDiff: n, yDiff: s } = this.checkBounds();
        const o = this.option("maxVelocity");
        let a = this.velocity.e, r = this.velocity.f;
        0 !== n ? (this.isBouncingX = !0, n * a <= 0 ? a += .14 * n : (a = .14 * n, e.min !== 1 / 0 && (this.target.e = Math.max(t.e, e.min)), e.max !== 1 / 0 && (this.target.e = Math.min(t.e, e.max))), o && (a = Math.max(Math.min(a, o), -1 * o))) : this.isBouncingX = !1, 0 !== s ? (this.isBouncingY = !0, s * r <= 0 ? r += .14 * s : (r = .14 * s, i.min !== 1 / 0 && (this.target.f = Math.max(t.f, i.min)), i.max !== 1 / 0 && (this.target.f = Math.min(t.f, i.max))), o && (r = Math.max(Math.min(r, o), -1 * o))) : this.isBouncingY = !1, this.isBouncingX && (this.velocity.e = a), this.isBouncingY && (this.velocity.f = r);
    }
    enable() {
        const { content: t } = this, e = new DOMMatrixReadOnly(window.getComputedStyle(t).transform);
        for (const t of $d4d06657c043713f$var$v)this.current[t] = this.target[t] = e[t];
        this.updateMetrics(), this.attachObserver(), this.attachEvents(), this.state = $d4d06657c043713f$var$m.Ready, this.emit("ready");
    }
    onClick(t) {
        var e;
        "click" === t.type && 0 === t.detail && (this.dragOffset.x = 0, this.dragOffset.y = 0), this.isDragging && (null === (e = this.pointerTracker) || void 0 === e || e.clear(), this.trackingPoints = [], this.startDecelAnim());
        const i = t.target;
        if (!i || t.defaultPrevented) return;
        if (i.hasAttribute("disabled")) return t.preventDefault(), void t.stopPropagation();
        if ((()=>{
            const t = window.getSelection();
            return t && "Range" === t.type;
        })() && !i.closest("button")) return;
        const n = i.closest("[data-panzoom-action]"), s = i.closest("[data-panzoom-change]"), o = n || s, a = o && $d4d06657c043713f$var$E(o) ? o.dataset : null;
        if (a) {
            const e = a.panzoomChange, i = a.panzoomAction;
            if ((e || i) && t.preventDefault(), e) {
                let t = {};
                try {
                    t = JSON.parse(e);
                } catch (t) {
                    console && console.warn("The given data was not valid JSON");
                }
                return void this.applyChange(t);
            }
            if (i) return void (this[i] && this[i]());
        }
        if (Math.abs(this.dragOffset.x) > 3 || Math.abs(this.dragOffset.y) > 3) return t.preventDefault(), void t.stopPropagation();
        if (i.closest("[data-fancybox]")) return;
        const r = this.content.getBoundingClientRect(), l = this.dragStart;
        if (l.time && !this.canZoomOut() && (Math.abs(r.x - l.x) > 2 || Math.abs(r.y - l.y) > 2)) return;
        this.dragStart.time = 0;
        const c = (e)=>{
            this.option("zoom", t) && e && "string" == typeof e && /(iterateZoom)|(toggle(Zoom|Full|Cover|Max)|(zoomTo(Fit|Cover|Max)))/.test(e) && "function" == typeof this[e] && (t.preventDefault(), this[e]({
                event: t
            }));
        }, h = this.option("click", t), d = this.option("dblClick", t);
        d ? (this.clicks++, 1 == this.clicks && (this.clickTimer = setTimeout(()=>{
            1 === this.clicks ? (this.emit("click", t), !t.defaultPrevented && h && c(h)) : (this.emit("dblClick", t), t.defaultPrevented || c(d)), this.clicks = 0, this.clickTimer = null;
        }, 350))) : (this.emit("click", t), !t.defaultPrevented && h && c(h));
    }
    addTrackingPoint(t) {
        const e = this.trackingPoints.filter((t)=>t.time > Date.now() - 100);
        e.push(t), this.trackingPoints = e;
    }
    onPointerDown(t, e, i) {
        var n;
        if (!1 === this.option("touch", t)) return !1;
        this.pwt = 0, this.dragOffset = {
            x: 0,
            y: 0,
            time: 0
        }, this.trackingPoints = [];
        const s = this.content.getBoundingClientRect();
        if (this.dragStart = {
            x: s.x,
            y: s.y,
            top: s.top,
            left: s.left,
            time: Date.now()
        }, this.clickTimer) return !1;
        if (this.panMode === $d4d06657c043713f$var$O && this.targetScale > 1) return t.preventDefault(), t.stopPropagation(), !1;
        const o = t.composedPath()[0];
        if (!i.length) {
            if ([
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO",
                "IFRAME"
            ].includes(o.nodeName) || o.closest("[contenteditable],[data-selectable],[data-draggable],[data-clickable],[data-panzoom-change],[data-panzoom-action]")) return !1;
            null === (n = window.getSelection()) || void 0 === n || n.removeAllRanges();
        }
        if ("mousedown" === t.type) [
            "A",
            "BUTTON"
        ].includes(o.nodeName) || t.preventDefault();
        else if (Math.abs(this.velocity.a) > .3) return !1;
        return this.target.e = this.current.e, this.target.f = this.current.f, this.stop(), this.isDragging || (this.isDragging = !0, this.addTrackingPoint(e), this.emit("touchStart", t)), !0;
    }
    onPointerMove(e, n, s) {
        if (!1 === this.option("touch", e)) return;
        if (!this.isDragging) return;
        if (n.length < 2 && this.panOnlyZoomed && $d4d06657c043713f$var$t(this.targetScale) <= $d4d06657c043713f$var$t(this.minScale)) return;
        if (this.emit("touchMove", e), e.defaultPrevented) return;
        this.addTrackingPoint(n[0]);
        const { content: o } = this, a = $d4d06657c043713f$var$h(s[0], s[1]), r = $d4d06657c043713f$var$h(n[0], n[1]);
        let l = 0, d = 0;
        if (n.length > 1) {
            const t = o.getBoundingClientRect();
            l = a.clientX - t.left - .5 * t.width, d = a.clientY - t.top - .5 * t.height;
        }
        const u = $d4d06657c043713f$var$c(s[0], s[1]), p = $d4d06657c043713f$var$c(n[0], n[1]);
        let f = u ? p / u : 1, g = r.clientX - a.clientX, m = r.clientY - a.clientY;
        this.dragOffset.x += g, this.dragOffset.y += m, this.dragOffset.time = Date.now() - this.dragStart.time;
        let v = $d4d06657c043713f$var$t(this.targetScale) === $d4d06657c043713f$var$t(this.minScale) && this.option("lockAxis");
        if (v && !this.lockedAxis) {
            if ("xy" === v || "y" === v || "touchmove" === e.type) {
                if (Math.abs(this.dragOffset.x) < 6 && Math.abs(this.dragOffset.y) < 6) return void e.preventDefault();
                const t = Math.abs(180 * Math.atan2(this.dragOffset.y, this.dragOffset.x) / Math.PI);
                this.lockedAxis = t > 45 && t < 135 ? "y" : "x", this.dragOffset.x = 0, this.dragOffset.y = 0, g = 0, m = 0;
            } else this.lockedAxis = v;
        }
        if ($d4d06657c043713f$var$i(e.target, this.content) && (v = "x", this.dragOffset.y = 0), v && "xy" !== v && this.lockedAxis !== v && $d4d06657c043713f$var$t(this.targetScale) === $d4d06657c043713f$var$t(this.minScale)) return;
        e.cancelable && e.preventDefault(), this.container.classList.add(this.cn("isDragging"));
        const b = this.checkBounds(g, m);
        this.option("rubberband") ? ("x" !== this.isInfinite && (b.xDiff > 0 && g < 0 || b.xDiff < 0 && g > 0) && (g *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitWidth * b.xDiff))), "y" !== this.isInfinite && (b.yDiff > 0 && m < 0 || b.yDiff < 0 && m > 0) && (m *= Math.max(0, .5 - Math.abs(.75 / this.contentRect.fitHeight * b.yDiff)))) : (b.xDiff && (g = 0), b.yDiff && (m = 0));
        const y = this.targetScale, w = this.minScale, x = this.maxScale;
        y < .5 * w && (f = Math.max(f, w)), y > 1.5 * x && (f = Math.min(f, x)), "y" === this.lockedAxis && $d4d06657c043713f$var$t(y) === $d4d06657c043713f$var$t(w) && (g = 0), "x" === this.lockedAxis && $d4d06657c043713f$var$t(y) === $d4d06657c043713f$var$t(w) && (m = 0), this.applyChange({
            originX: l,
            originY: d,
            panX: g,
            panY: m,
            scale: f,
            friction: this.option("dragFriction"),
            ignoreBounds: !0
        });
    }
    onPointerUp(t, e, n) {
        if (n.length) return this.dragOffset.x = 0, this.dragOffset.y = 0, void (this.trackingPoints = []);
        this.container.classList.remove(this.cn("isDragging")), this.isDragging && (this.addTrackingPoint(e), this.panOnlyZoomed && this.contentRect.width - this.contentRect.fitWidth < 1 && this.contentRect.height - this.contentRect.fitHeight < 1 && (this.trackingPoints = []), $d4d06657c043713f$var$i(t.target, this.content) && "y" === this.lockedAxis && (this.trackingPoints = []), this.emit("touchEnd", t), this.isDragging = !1, this.lockedAxis = !1, this.state !== $d4d06657c043713f$var$m.Destroy && (t.defaultPrevented || this.startDecelAnim()));
    }
    startDecelAnim() {
        var e;
        const i = this.isScaling;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const t of $d4d06657c043713f$var$v)this.velocity[t] = 0;
        this.target.e = this.current.e, this.target.f = this.current.f, $d4d06657c043713f$var$S(this.container, "is-scaling"), $d4d06657c043713f$var$S(this.container, "is-animating"), this.isTicking = !1;
        const { trackingPoints: n } = this, s = n[0], o = n[n.length - 1];
        let a = 0, r = 0, l = 0;
        o && s && (a = o.clientX - s.clientX, r = o.clientY - s.clientY, l = o.time - s.time);
        const c = (null === (e = window.visualViewport) || void 0 === e ? void 0 : e.scale) || 1;
        1 !== c && (a *= c, r *= c);
        let h = 0, d = 0, u = 0, p = 0, f = this.option("decelFriction");
        const g = this.targetScale;
        if (l > 0) {
            u = Math.abs(a) > 3 ? a / (l / 30) : 0, p = Math.abs(r) > 3 ? r / (l / 30) : 0;
            const t = this.option("maxVelocity");
            t && (u = Math.max(Math.min(u, t), -1 * t), p = Math.max(Math.min(p, t), -1 * t));
        }
        u && (h = u / (1 / (1 - f) - 1)), p && (d = p / (1 / (1 - f) - 1)), ("y" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "y" === this.lockedAxis && $d4d06657c043713f$var$t(g) === this.minScale) && (h = u = 0), ("x" === this.option("lockAxis") || "xy" === this.option("lockAxis") && "x" === this.lockedAxis && $d4d06657c043713f$var$t(g) === this.minScale) && (d = p = 0);
        const m = this.dragOffset.x, b = this.dragOffset.y, y = this.option("dragMinThreshold") || 0;
        Math.abs(m) < y && Math.abs(b) < y && (h = d = 0, u = p = 0), (this.option("zoom") && (g < this.minScale - 1e-5 || g > this.maxScale + 1e-5) || i && !h && !d) && (f = .35), this.applyChange({
            panX: h,
            panY: d,
            friction: f
        }), this.emit("decel", u, p, m, b);
    }
    onWheel(t) {
        var e = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const i = Math.max(-1, Math.min(1, e));
        if (this.emit("wheel", t, i), this.panMode === $d4d06657c043713f$var$O) return;
        if (t.defaultPrevented) return;
        const n = this.option("wheel");
        "pan" === n ? (t.preventDefault(), this.panOnlyZoomed && !this.canZoomOut() || this.applyChange({
            panX: 2 * -t.deltaX,
            panY: 2 * -t.deltaY,
            bounce: !1
        })) : "zoom" === n && !1 !== this.option("zoom") && this.zoomWithWheel(t);
    }
    onMouseMove(t) {
        this.panWithMouse(t);
    }
    onKeydown(t) {
        "Escape" === t.key && this.toggleFS();
    }
    onResize() {
        this.updateMetrics(), this.checkBounds().inBounds || this.requestTick();
    }
    setTransform() {
        this.emit("beforeTransform");
        const { current: e, target: i, content: n, contentRect: s } = this, o = Object.assign({}, $d4d06657c043713f$var$C);
        for (const n of $d4d06657c043713f$var$v){
            const s = "e" == n || "f" === n ? $d4d06657c043713f$var$M : $d4d06657c043713f$var$T;
            o[n] = $d4d06657c043713f$var$t(e[n], s), Math.abs(i[n] - e[n]) < ("e" == n || "f" === n ? .51 : .001) && (e[n] = i[n]);
        }
        let { a: a, b: r, c: l, d: c, e: h, f: d } = o, u = `matrix(${a}, ${r}, ${l}, ${c}, ${h}, ${d})`, p = n.parentElement instanceof HTMLPictureElement ? n.parentElement : n;
        if (this.option("transformParent") && (p = p.parentElement || p), p.style.transform === u) return;
        p.style.transform = u;
        const { contentWidth: f, contentHeight: g } = this.calculateContentDim();
        s.width = f, s.height = g, this.emit("afterTransform");
    }
    updateMetrics(e = !1) {
        var i;
        if (!this || this.state === $d4d06657c043713f$var$m.Destroy) return;
        if (this.isContentLoading) return;
        const n = Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1), { container: s, content: o } = this, a = o instanceof HTMLImageElement, r = s.getBoundingClientRect(), l = getComputedStyle(this.container);
        let c = r.width * n, h = r.height * n;
        const d = parseFloat(l.paddingTop) + parseFloat(l.paddingBottom), u = c - (parseFloat(l.paddingLeft) + parseFloat(l.paddingRight)), p = h - d;
        this.containerRect = {
            width: c,
            height: h,
            innerWidth: u,
            innerHeight: p
        };
        const f = parseFloat(o.dataset.width || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalWidth : t instanceof SVGElement ? t.width.baseVal.value : Math.max(t.offsetWidth, t.scrollWidth), e || 0;
        })(o), g = parseFloat(o.dataset.height || "") || ((t)=>{
            let e = 0;
            return e = t instanceof HTMLImageElement ? t.naturalHeight : t instanceof SVGElement ? t.height.baseVal.value : Math.max(t.offsetHeight, t.scrollHeight), e || 0;
        })(o);
        let v = this.option("width", f) || $d4d06657c043713f$var$z, b = this.option("height", g) || $d4d06657c043713f$var$z;
        const y = v === $d4d06657c043713f$var$z, w = b === $d4d06657c043713f$var$z;
        "number" != typeof v && (v = f), "number" != typeof b && (b = g), y && (v = f * (b / g)), w && (b = g / (f / v));
        let x = o.parentElement instanceof HTMLPictureElement ? o.parentElement : o;
        this.option("transformParent") && (x = x.parentElement || x);
        const E = x.getAttribute("style") || "";
        x.style.setProperty("transform", "none", "important"), a && (x.style.width = "", x.style.height = ""), x.offsetHeight;
        const S = o.getBoundingClientRect();
        let P = S.width * n, C = S.height * n, T = P, M = C;
        P = Math.min(P, v), C = Math.min(C, b), a ? { width: P, height: C } = ((t, e, i, n)=>{
            const s = i / t, o = n / e, a = Math.min(s, o);
            return {
                width: t *= a,
                height: e *= a
            };
        })(v, b, P, C) : (P = Math.min(P, v), C = Math.min(C, b));
        let O = .5 * (M - C), A = .5 * (T - P);
        this.contentRect = Object.assign(Object.assign({}, this.contentRect), {
            top: S.top - r.top + O,
            bottom: r.bottom - S.bottom + O,
            left: S.left - r.left + A,
            right: r.right - S.right + A,
            fitWidth: P,
            fitHeight: C,
            width: P,
            height: C,
            fullWidth: v,
            fullHeight: b
        }), x.style.cssText = E, a && (x.style.width = `${P}px`, x.style.height = `${C}px`), this.setTransform(), !0 !== e && this.emit("refresh"), this.ignoreBounds || ($d4d06657c043713f$var$t(this.targetScale) < $d4d06657c043713f$var$t(this.minScale) ? this.zoomTo(this.minScale, {
            friction: 0
        }) : this.targetScale > this.maxScale ? this.zoomTo(this.maxScale, {
            friction: 0
        }) : this.state === $d4d06657c043713f$var$m.Init || this.checkBounds().inBounds || this.requestTick()), this.updateControls();
    }
    calculateBounds() {
        const { contentWidth: e, contentHeight: i } = this.calculateContentDim(this.target), { targetScale: n, lockedAxis: s } = this, { fitWidth: o, fitHeight: a } = this.contentRect;
        let r = 0, l = 0, c = 0, h = 0;
        const d = this.option("infinite");
        if (!0 === d || s && d === s) r = -1 / 0, c = 1 / 0, l = -1 / 0, h = 1 / 0;
        else {
            let { containerRect: s, contentRect: d } = this, u = $d4d06657c043713f$var$t(o * n, $d4d06657c043713f$var$M), p = $d4d06657c043713f$var$t(a * n, $d4d06657c043713f$var$M), { innerWidth: f, innerHeight: g } = s;
            if (s.width === u && (f = s.width), s.width === p && (g = s.height), e > f) {
                c = .5 * (e - f), r = -1 * c;
                let t = .5 * (d.right - d.left);
                r += t, c += t;
            }
            if (o > f && e < f && (r -= .5 * (o - f), c -= .5 * (o - f)), i > g) {
                h = .5 * (i - g), l = -1 * h;
                let t = .5 * (d.bottom - d.top);
                l += t, h += t;
            }
            a > g && i < g && (r -= .5 * (a - g), c -= .5 * (a - g));
        }
        return {
            x: {
                min: r,
                max: c
            },
            y: {
                min: l,
                max: h
            }
        };
    }
    getBounds() {
        const t = this.option("bounds");
        return t !== $d4d06657c043713f$var$z ? t : this.calculateBounds();
    }
    updateControls() {
        const e = this, i = e.container, { panMode: n, contentRect: s, targetScale: a, minScale: r } = e;
        let l = r, c = e.option("click") || !1;
        c && (l = e.getNextScale(c));
        let h = e.canZoomIn(), d = e.canZoomOut(), u = n === $d4d06657c043713f$var$A && !!this.option("touch"), p = d && u;
        if (u && ($d4d06657c043713f$var$t(a) < $d4d06657c043713f$var$t(r) && !this.panOnlyZoomed && (p = !0), ($d4d06657c043713f$var$t(s.width, 1) > $d4d06657c043713f$var$t(s.fitWidth, 1) || $d4d06657c043713f$var$t(s.height, 1) > $d4d06657c043713f$var$t(s.fitHeight, 1)) && (p = !0)), $d4d06657c043713f$var$t(s.width * a, 1) < $d4d06657c043713f$var$t(s.fitWidth, 1) && (p = !1), n === $d4d06657c043713f$var$O && (p = !1), $d4d06657c043713f$var$o(i, this.cn("isDraggable"), p), !this.option("zoom")) return;
        let f = h && $d4d06657c043713f$var$t(l) > $d4d06657c043713f$var$t(a), g = !f && !p && d && $d4d06657c043713f$var$t(l) < $d4d06657c043713f$var$t(a);
        $d4d06657c043713f$var$o(i, this.cn("canZoomIn"), f), $d4d06657c043713f$var$o(i, this.cn("canZoomOut"), g);
        for (const t of i.querySelectorAll("[data-panzoom-action]")){
            let e = !1, i = !1;
            switch(t.dataset.panzoomAction){
                case "zoomIn":
                    h ? e = !0 : i = !0;
                    break;
                case "zoomOut":
                    d ? e = !0 : i = !0;
                    break;
                case "toggleZoom":
                case "iterateZoom":
                    h || d ? e = !0 : i = !0;
                    const n = t.querySelector("g");
                    n && (n.style.display = h ? "" : "none");
            }
            e ? (t.removeAttribute("disabled"), t.removeAttribute("tabindex")) : i && (t.setAttribute("disabled", ""), t.setAttribute("tabindex", "-1"));
        }
    }
    panTo({ x: t = this.target.e, y: e = this.target.f, scale: i = this.targetScale, friction: n = this.option("friction"), angle: s = 0, originX: o = 0, originY: a = 0, flipX: r = !1, flipY: l = !1, ignoreBounds: c = !1 }) {
        this.state !== $d4d06657c043713f$var$m.Destroy && this.applyChange({
            panX: t - this.target.e,
            panY: e - this.target.f,
            scale: i / this.targetScale,
            angle: s,
            originX: o,
            originY: a,
            friction: n,
            flipX: r,
            flipY: l,
            ignoreBounds: c
        });
    }
    applyChange({ panX: e = 0, panY: i = 0, scale: n = 1, angle: s = 0, originX: o = -this.current.e, originY: a = -this.current.f, friction: r = this.option("friction"), flipX: l = !1, flipY: c = !1, ignoreBounds: h = !1, bounce: d = this.option("bounce") }) {
        const u = this.state;
        if (u === $d4d06657c043713f$var$m.Destroy) return;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.friction = r || 0, this.ignoreBounds = h;
        const { current: p } = this, f = p.e, g = p.f, b = this.getMatrix(this.target);
        let y = (new DOMMatrix).translate(f, g).translate(o, a).translate(e, i);
        if (this.option("zoom")) {
            if (!h) {
                const t = this.targetScale, e = this.minScale, i = this.maxScale;
                t * n < e && (n = e / t), t * n > i && (n = i / t);
            }
            y = y.scale(n);
        }
        y = y.translate(-o, -a).translate(-f, -g).multiply(b), s && (y = y.rotate(s)), l && (y = y.scale(-1, 1)), c && (y = y.scale(1, -1));
        for (const e of $d4d06657c043713f$var$v)"e" !== e && "f" !== e && (y[e] > this.minScale + 1e-5 || y[e] < this.minScale - 1e-5) ? this.target[e] = y[e] : this.target[e] = $d4d06657c043713f$var$t(y[e], $d4d06657c043713f$var$M);
        (this.targetScale < this.scale || Math.abs(n - 1) > .1 || this.panMode === $d4d06657c043713f$var$O || !1 === d) && !h && this.clampTargetBounds(), u === $d4d06657c043713f$var$m.Init ? this.animate() : this.isResting || (this.state = $d4d06657c043713f$var$m.Panning, this.requestTick());
    }
    stop(t = !1) {
        if (this.state === $d4d06657c043713f$var$m.Init || this.state === $d4d06657c043713f$var$m.Destroy) return;
        const e = this.isTicking;
        this.rAF && (cancelAnimationFrame(this.rAF), this.rAF = null), this.isBouncingX = !1, this.isBouncingY = !1;
        for (const e of $d4d06657c043713f$var$v)this.velocity[e] = 0, "current" === t ? this.current[e] = this.target[e] : "target" === t && (this.target[e] = this.current[e]);
        this.setTransform(), $d4d06657c043713f$var$S(this.container, "is-scaling"), $d4d06657c043713f$var$S(this.container, "is-animating"), this.isTicking = !1, this.state = $d4d06657c043713f$var$m.Ready, e && (this.emit("endAnimation"), this.updateControls());
    }
    requestTick() {
        this.isTicking || (this.emit("startAnimation"), this.updateControls(), $d4d06657c043713f$var$P(this.container, "is-animating"), this.isScaling && $d4d06657c043713f$var$P(this.container, "is-scaling")), this.isTicking = !0, this.rAF || (this.rAF = requestAnimationFrame(()=>this.animate()));
    }
    panWithMouse(e, i = this.option("mouseMoveFriction")) {
        if (this.pmme = e, this.panMode !== $d4d06657c043713f$var$O || !e) return;
        if ($d4d06657c043713f$var$t(this.targetScale) <= $d4d06657c043713f$var$t(this.minScale)) return;
        this.emit("mouseMove", e);
        const { container: n, containerRect: s, contentRect: o } = this, a = s.width, r = s.height, l = n.getBoundingClientRect(), c = (e.clientX || 0) - l.left, h = (e.clientY || 0) - l.top;
        let { contentWidth: d, contentHeight: u } = this.calculateContentDim(this.target);
        const p = this.option("mouseMoveFactor");
        p > 1 && (d !== a && (d *= p), u !== r && (u *= p));
        let f = .5 * (d - a) - c / a * 100 / 100 * (d - a);
        f += .5 * (o.right - o.left);
        let g = .5 * (u - r) - h / r * 100 / 100 * (u - r);
        g += .5 * (o.bottom - o.top), this.applyChange({
            panX: f - this.target.e,
            panY: g - this.target.f,
            friction: i
        });
    }
    zoomWithWheel(e) {
        if (this.state === $d4d06657c043713f$var$m.Destroy || this.state === $d4d06657c043713f$var$m.Init) return;
        const i = Date.now();
        if (i - this.pwt < 45) return void e.preventDefault();
        this.pwt = i;
        var n = [
            -e.deltaX || 0,
            -e.deltaY || 0,
            -e.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        });
        const s = Math.max(-1, Math.min(1, n)), { targetScale: o, maxScale: a, minScale: r } = this;
        let l = o * (100 + 45 * s) / 100;
        $d4d06657c043713f$var$t(l) < $d4d06657c043713f$var$t(r) && $d4d06657c043713f$var$t(o) <= $d4d06657c043713f$var$t(r) ? (this.cwd += Math.abs(s), l = r) : $d4d06657c043713f$var$t(l) > $d4d06657c043713f$var$t(a) && $d4d06657c043713f$var$t(o) >= $d4d06657c043713f$var$t(a) ? (this.cwd += Math.abs(s), l = a) : (this.cwd = 0, l = Math.max(Math.min(l, a), r)), this.cwd > this.option("wheelLimit") || (e.preventDefault(), $d4d06657c043713f$var$t(l) !== $d4d06657c043713f$var$t(o) && this.zoomTo(l, {
            event: e
        }));
    }
    canZoomIn() {
        return this.option("zoom") && ($d4d06657c043713f$var$t(this.contentRect.width, 1) < $d4d06657c043713f$var$t(this.contentRect.fitWidth, 1) || $d4d06657c043713f$var$t(this.targetScale) < $d4d06657c043713f$var$t(this.maxScale));
    }
    canZoomOut() {
        return this.option("zoom") && $d4d06657c043713f$var$t(this.targetScale) > $d4d06657c043713f$var$t(this.minScale);
    }
    zoomIn(t = 1.25, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomOut(t = .8, e) {
        this.zoomTo(this.targetScale * t, e);
    }
    zoomToFit(t) {
        this.zoomTo("fit", t);
    }
    zoomToCover(t) {
        this.zoomTo("cover", t);
    }
    zoomToFull(t) {
        this.zoomTo("full", t);
    }
    zoomToMax(t) {
        this.zoomTo("max", t);
    }
    toggleZoom(t) {
        this.zoomTo(this.getNextScale("toggleZoom"), t);
    }
    toggleMax(t) {
        this.zoomTo(this.getNextScale("toggleMax"), t);
    }
    toggleCover(t) {
        this.zoomTo(this.getNextScale("toggleCover"), t);
    }
    iterateZoom(t) {
        this.zoomTo("next", t);
    }
    zoomTo(t = 1, { friction: e = $d4d06657c043713f$var$z, originX: i = $d4d06657c043713f$var$z, originY: n = $d4d06657c043713f$var$z, event: s } = {}) {
        if (this.isContentLoading || this.state === $d4d06657c043713f$var$m.Destroy) return;
        const { targetScale: o, fullScale: a, maxScale: r, coverScale: l } = this;
        if (this.stop(), this.panMode === $d4d06657c043713f$var$O && (s = this.pmme || s), s || i === $d4d06657c043713f$var$z || n === $d4d06657c043713f$var$z) {
            const t = this.content.getBoundingClientRect(), e = this.container.getBoundingClientRect(), o = s ? s.clientX : e.left + .5 * e.width, a = s ? s.clientY : e.top + .5 * e.height;
            i = o - t.left - .5 * t.width, n = a - t.top - .5 * t.height;
        }
        let c = 1;
        "number" == typeof t ? c = t : "full" === t ? c = a : "cover" === t ? c = l : "max" === t ? c = r : "fit" === t ? c = 1 : "next" === t && (c = this.getNextScale("iterateZoom")), c = c / o || 1, e = e === $d4d06657c043713f$var$z ? c > 1 ? .15 : .25 : e, this.applyChange({
            scale: c,
            originX: i,
            originY: n,
            friction: e
        }), s && this.panMode === $d4d06657c043713f$var$O && this.panWithMouse(s, e);
    }
    rotateCCW() {
        this.applyChange({
            angle: -90
        });
    }
    rotateCW() {
        this.applyChange({
            angle: 90
        });
    }
    flipX() {
        this.applyChange({
            flipX: !0
        });
    }
    flipY() {
        this.applyChange({
            flipY: !0
        });
    }
    fitX() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.height - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.width / e.fitWidth / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    fitY() {
        this.stop("target");
        const { containerRect: t, contentRect: e, target: i } = this;
        this.applyChange({
            panX: .5 * t.width - (e.left + .5 * e.fitWidth) - i.e,
            panY: .5 * t.innerHeight - (e.top + .5 * e.fitHeight) - i.f,
            scale: t.height / e.fitHeight / this.targetScale,
            originX: 0,
            originY: 0,
            ignoreBounds: !0
        });
    }
    toggleFS() {
        const { container: t } = this, e = this.cn("inFullscreen"), i = this.cn("htmlHasFullscreen");
        t.classList.toggle(e);
        const n = t.classList.contains(e);
        n ? (document.documentElement.classList.add(i), document.addEventListener("keydown", this.onKeydown, !0)) : (document.documentElement.classList.remove(i), document.removeEventListener("keydown", this.onKeydown, !0)), this.updateMetrics(), this.emit(n ? "enterFS" : "exitFS");
    }
    getMatrix(t = this.current) {
        const { a: e, b: i, c: n, d: s, e: o, f: a } = t;
        return new DOMMatrix([
            e,
            i,
            n,
            s,
            o,
            a
        ]);
    }
    reset(t) {
        if (this.state !== $d4d06657c043713f$var$m.Init && this.state !== $d4d06657c043713f$var$m.Destroy) {
            this.stop("current");
            for (const t of $d4d06657c043713f$var$v)this.target[t] = $d4d06657c043713f$var$C[t];
            this.target.a = this.minScale, this.target.d = this.minScale, this.clampTargetBounds(), this.isResting || (this.friction = void 0 === t ? this.option("friction") : t, this.state = $d4d06657c043713f$var$m.Panning, this.requestTick());
        }
    }
    destroy() {
        this.stop(), this.state = $d4d06657c043713f$var$m.Destroy, this.detachEvents(), this.detachObserver();
        const { container: t, content: e } = this, i = this.option("classes") || {};
        for (const e of Object.values(i))t.classList.remove(e + "");
        e && (e.removeEventListener("load", this.onLoad), e.removeEventListener("error", this.onError)), this.detachPlugins();
    }
}
Object.defineProperty($d4d06657c043713f$export$b704d075ddd20210, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$y
}), Object.defineProperty($d4d06657c043713f$export$b704d075ddd20210, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {}
});
const $d4d06657c043713f$var$D = function(t, e) {
    let i = !0;
    return (...n)=>{
        i && (i = !1, t(...n), setTimeout(()=>{
            i = !0;
        }, e));
    };
}, $d4d06657c043713f$var$F = (t, e)=>{
    let i = [];
    return t.childNodes.forEach((t)=>{
        t.nodeType !== Node.ELEMENT_NODE || e && !t.matches(e) || i.push(t);
    }), i;
}, $d4d06657c043713f$var$j = {
    viewport: null,
    track: null,
    enabled: !0,
    slides: [],
    axis: "x",
    transition: "fade",
    preload: 1,
    slidesPerPage: "auto",
    initialPage: 0,
    friction: .12,
    Panzoom: {
        decelFriction: .12
    },
    center: !0,
    infinite: !0,
    fill: !0,
    dragFree: !1,
    adaptiveHeight: !1,
    direction: "ltr",
    classes: {
        container: "f-carousel",
        viewport: "f-carousel__viewport",
        track: "f-carousel__track",
        slide: "f-carousel__slide",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        inTransition: "in-transition",
        isSelected: "is-selected"
    },
    l10n: {
        NEXT: "Next slide",
        PREV: "Previous slide",
        GOTO: "Go to slide #%d"
    }
};
var $d4d06657c043713f$var$B;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Destroy = 2] = "Destroy";
}($d4d06657c043713f$var$B || ($d4d06657c043713f$var$B = {}));
const $d4d06657c043713f$var$H = (t)=>{
    if ("string" == typeof t || t instanceof HTMLElement) t = {
        html: t
    };
    else {
        const e = t.thumb;
        void 0 !== e && ("string" == typeof e && (t.thumbSrc = e), e instanceof HTMLImageElement && (t.thumbEl = e, t.thumbElSrc = e.src, t.thumbSrc = e.src), delete t.thumb);
    }
    return Object.assign({
        html: "",
        el: null,
        isDom: !1,
        class: "",
        customClass: "",
        index: -1,
        dim: 0,
        gap: 0,
        pos: 0,
        transition: !1
    }, t);
}, $d4d06657c043713f$var$N = (t = {})=>Object.assign({
        index: -1,
        slides: [],
        dim: 0,
        pos: -1
    }, t);
class $d4d06657c043713f$var$_ extends $d4d06657c043713f$var$f {
    constructor(t, e){
        super(e), Object.defineProperty(this, "instance", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: t
        });
    }
    attach() {}
    detach() {}
}
const $d4d06657c043713f$var$$ = {
    classes: {
        list: "f-carousel__dots",
        isDynamic: "is-dynamic",
        hasDots: "has-dots",
        dot: "f-carousel__dot",
        isBeforePrev: "is-before-prev",
        isPrev: "is-prev",
        isCurrent: "is-current",
        isNext: "is-next",
        isAfterNext: "is-after-next"
    },
    dotTpl: '<button type="button" data-carousel-page="%i" aria-label="{{GOTO}}"><span class="f-carousel__dot" aria-hidden="true"></span></button>',
    dynamicFrom: 11,
    maxCount: 1 / 0,
    minCount: 2
};
class $d4d06657c043713f$var$W extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "isDynamic", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "list", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onRefresh() {
        this.refresh();
    }
    build() {
        let t = this.list;
        if (!t) {
            t = document.createElement("ul"), $d4d06657c043713f$var$P(t, this.cn("list")), t.setAttribute("role", "tablist");
            const e = this.instance.container;
            e.appendChild(t), $d4d06657c043713f$var$P(e, this.cn("hasDots")), this.list = t;
        }
        return t;
    }
    refresh() {
        var t;
        const e = this.instance.pages.length, i = Math.min(2, this.option("minCount")), n = Math.max(2e3, this.option("maxCount")), s = this.option("dynamicFrom");
        if (e < i || e > n) return void this.cleanup();
        const a = "number" == typeof s && e > 5 && e >= s, r = !this.list || this.isDynamic !== a || this.list.children.length !== e;
        r && this.cleanup();
        const l = this.build();
        if ($d4d06657c043713f$var$o(l, this.cn("isDynamic"), !!a), r) for(let t = 0; t < e; t++)l.append(this.createItem(t));
        let c, h = 0;
        for (const e of [
            ...l.children
        ]){
            const i = h === this.instance.page;
            i && (c = e), $d4d06657c043713f$var$o(e, this.cn("isCurrent"), i), null === (t = e.children[0]) || void 0 === t || t.setAttribute("aria-selected", i ? "true" : "false");
            for (const t of [
                "isBeforePrev",
                "isPrev",
                "isNext",
                "isAfterNext"
            ])$d4d06657c043713f$var$S(e, this.cn(t));
            h++;
        }
        if (c = c || l.firstChild, a && c) {
            const t = c.previousElementSibling, e = t && t.previousElementSibling;
            $d4d06657c043713f$var$P(t, this.cn("isPrev")), $d4d06657c043713f$var$P(e, this.cn("isBeforePrev"));
            const i = c.nextElementSibling, n = i && i.nextElementSibling;
            $d4d06657c043713f$var$P(i, this.cn("isNext")), $d4d06657c043713f$var$P(n, this.cn("isAfterNext"));
        }
        this.isDynamic = a;
    }
    createItem(t = 0) {
        var e;
        const i = document.createElement("li");
        i.setAttribute("role", "presentation");
        const s = $d4d06657c043713f$var$n(this.instance.localize(this.option("dotTpl"), [
            [
                "%d",
                t + 1
            ]
        ]).replace(/\%i/g, t + ""));
        return i.appendChild(s), null === (e = i.children[0]) || void 0 === e || e.setAttribute("role", "tab"), i;
    }
    cleanup() {
        this.list && (this.list.remove(), this.list = null), this.isDynamic = !1, $d4d06657c043713f$var$S(this.instance.container, this.cn("hasDots"));
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($d4d06657c043713f$var$W, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$$
});
const $d4d06657c043713f$var$X = "disabled", $d4d06657c043713f$var$q = "next", $d4d06657c043713f$var$Y = "prev";
class $d4d06657c043713f$var$V extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prev", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "next", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "isDom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    onRefresh() {
        const t = this.instance, e = t.pages.length, i = t.page;
        if (e < 2) return void this.cleanup();
        this.build();
        let n = this.prev, s = this.next;
        n && s && (n.removeAttribute($d4d06657c043713f$var$X), s.removeAttribute($d4d06657c043713f$var$X), t.isInfinite || (i <= 0 && n.setAttribute($d4d06657c043713f$var$X, ""), i >= e - 1 && s.setAttribute($d4d06657c043713f$var$X, "")));
    }
    addBtn(t) {
        var e;
        const i = this.instance, n = document.createElement("button");
        n.setAttribute("tabindex", "0"), n.setAttribute("title", i.localize(`{{${t.toUpperCase()}}}`)), $d4d06657c043713f$var$P(n, this.cn("button") + " " + this.cn(t === $d4d06657c043713f$var$q ? "isNext" : "isPrev"));
        const s = i.isRTL ? t === $d4d06657c043713f$var$q ? $d4d06657c043713f$var$Y : $d4d06657c043713f$var$q : t;
        var o;
        return n.innerHTML = i.localize(this.option(`${s}Tpl`)), n.dataset[`carousel${o = t, o ? o.match("^[a-z]") ? o.charAt(0).toUpperCase() + o.substring(1) : o : ""}`] = "true", null === (e = this.container) || void 0 === e || e.appendChild(n), n;
    }
    build() {
        const t = this.instance.container, e = this.cn("container");
        let { container: i, prev: n, next: s } = this;
        i || (i = t.querySelector("." + e), this.isDom = !!i), i || (i = document.createElement("div"), $d4d06657c043713f$var$P(i, e), t.appendChild(i)), this.container = i, s || (s = i.querySelector("[data-carousel-next]")), s || (s = this.addBtn($d4d06657c043713f$var$q)), this.next = s, n || (n = i.querySelector("[data-carousel-prev]")), n || (n = this.addBtn($d4d06657c043713f$var$Y)), this.prev = n;
    }
    cleanup() {
        this.isDom || (this.prev && this.prev.remove(), this.next && this.next.remove(), this.container && this.container.remove()), this.prev = null, this.next = null, this.container = null, this.isDom = !1;
    }
    attach() {
        this.instance.on([
            "refresh",
            "change"
        ], this.onRefresh);
    }
    detach() {
        this.instance.off([
            "refresh",
            "change"
        ], this.onRefresh), this.cleanup();
    }
}
Object.defineProperty($d4d06657c043713f$var$V, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        classes: {
            container: "f-carousel__nav",
            button: "f-button",
            isNext: "is-next",
            isPrev: "is-prev"
        },
        nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"/></svg>',
        prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"/></svg>'
    }
});
class $d4d06657c043713f$var$Z extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "selectedIndex", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "target", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "nav", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    addAsTargetFor(t) {
        this.target = this.instance, this.nav = t, this.attachEvents();
    }
    addAsNavFor(t) {
        this.nav = this.instance, this.target = t, this.attachEvents();
    }
    attachEvents() {
        const { nav: t, target: e } = this;
        t && e && (t.options.initialSlide = e.options.initialPage, t.state === $d4d06657c043713f$var$B.Ready ? this.onNavReady(t) : t.on("ready", this.onNavReady), e.state === $d4d06657c043713f$var$B.Ready ? this.onTargetReady(e) : e.on("ready", this.onTargetReady));
    }
    onNavReady(t) {
        t.on("createSlide", this.onNavCreateSlide), t.on("Panzoom.click", this.onNavClick), t.on("Panzoom.touchEnd", this.onNavTouch), this.onTargetChange();
    }
    onTargetReady(t) {
        t.on("change", this.onTargetChange), t.on("Panzoom.refresh", this.onTargetChange), this.onTargetChange();
    }
    onNavClick(t, e, i) {
        this.onNavTouch(t, t.panzoom, i);
    }
    onNavTouch(t, e, i) {
        var n, s;
        if (Math.abs(e.dragOffset.x) > 3 || Math.abs(e.dragOffset.y) > 3) return;
        const o = i.target, { nav: a, target: r } = this;
        if (!a || !r || !o) return;
        const l = o.closest("[data-index]");
        if (i.stopPropagation(), i.preventDefault(), !l) return;
        const c = parseInt(l.dataset.index || "", 10) || 0, h = r.getPageForSlide(c), d = a.getPageForSlide(c);
        a.slideTo(d), r.slideTo(h, {
            friction: (null === (s = null === (n = this.nav) || void 0 === n ? void 0 : n.plugins) || void 0 === s ? void 0 : s.Sync.option("friction")) || 0
        }), this.markSelectedSlide(c);
    }
    onNavCreateSlide(t, e) {
        e.index === this.selectedIndex && this.markSelectedSlide(e.index);
    }
    onTargetChange() {
        var t, e;
        const { target: i, nav: n } = this;
        if (!i || !n) return;
        if (n.state !== $d4d06657c043713f$var$B.Ready || i.state !== $d4d06657c043713f$var$B.Ready) return;
        const s = null === (e = null === (t = i.pages[i.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index, o = n.getPageForSlide(s);
        this.markSelectedSlide(s), n.slideTo(o, null === n.prevPage && null === i.prevPage ? {
            friction: 0
        } : void 0);
    }
    markSelectedSlide(t) {
        const e = this.nav;
        e && e.state === $d4d06657c043713f$var$B.Ready && (this.selectedIndex = t, [
            ...e.slides
        ].map((e)=>{
            e.el && e.el.classList[e.index === t ? "add" : "remove"]("is-nav-selected");
        }));
    }
    attach() {
        const t = this;
        let e = t.options.target, i = t.options.nav;
        e ? t.addAsNavFor(e) : i && t.addAsTargetFor(i);
    }
    detach() {
        const t = this, e = t.nav, i = t.target;
        e && (e.off("ready", t.onNavReady), e.off("createSlide", t.onNavCreateSlide), e.off("Panzoom.click", t.onNavClick), e.off("Panzoom.touchEnd", t.onNavTouch)), t.nav = null, i && (i.off("ready", t.onTargetReady), i.off("refresh", t.onTargetChange), i.off("change", t.onTargetChange)), t.target = null;
    }
}
Object.defineProperty($d4d06657c043713f$var$Z, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        friction: .35
    }
});
const $d4d06657c043713f$var$U = {
    Navigation: $d4d06657c043713f$var$V,
    Dots: $d4d06657c043713f$var$W,
    Sync: $d4d06657c043713f$var$Z
}, $d4d06657c043713f$var$G = "animationend", $d4d06657c043713f$var$K = "isSelected", $d4d06657c043713f$var$J = "slide";
class $d4d06657c043713f$export$144901db2ea8e967 extends $d4d06657c043713f$var$g {
    get axis() {
        return this.isHorizontal ? "e" : "f";
    }
    get isEnabled() {
        return this.state === $d4d06657c043713f$var$B.Ready;
    }
    get isInfinite() {
        let t = !1;
        const { contentDim: e, viewportDim: i, pages: n, slides: s } = this, o = s[0];
        return n.length >= 2 && o && e + o.dim >= i && (t = this.option("infinite")), t;
    }
    get isRTL() {
        return "rtl" === this.option("direction");
    }
    get isHorizontal() {
        return "x" === this.option("axis");
    }
    constructor(t, e = {}, i = {}){
        if (super(), Object.defineProperty(this, "bp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: ""
        }), Object.defineProperty(this, "lp", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "userOptions", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$B.Init
        }), Object.defineProperty(this, "page", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "prevPage", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), Object.defineProperty(this, "viewport", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "slides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "pages", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "panzoom", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "inTransition", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: new Set
        }), Object.defineProperty(this, "contentDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "viewportDim", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), "string" == typeof t && (t = document.querySelector(t)), !t || !$d4d06657c043713f$var$E(t)) throw new Error("No Element found");
        this.container = t, this.slideNext = $d4d06657c043713f$var$D(this.slideNext.bind(this), 150), this.slidePrev = $d4d06657c043713f$var$D(this.slidePrev.bind(this), 150), this.userOptions = e, this.userPlugins = i, queueMicrotask(()=>{
            this.processOptions();
        });
    }
    processOptions() {
        var t, e;
        const i = $d4d06657c043713f$var$u({}, $d4d06657c043713f$export$144901db2ea8e967.defaults, this.userOptions);
        let n = "";
        const s = i.breakpoints;
        if (s && $d4d06657c043713f$var$d(s)) for (const [t, e] of Object.entries(s))window.matchMedia(t).matches && $d4d06657c043713f$var$d(e) && (n += t, $d4d06657c043713f$var$u(i, e));
        n === this.bp && this.state !== $d4d06657c043713f$var$B.Init || (this.bp = n, this.state === $d4d06657c043713f$var$B.Ready && (i.initialSlide = (null === (e = null === (t = this.pages[this.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === e ? void 0 : e.index) || 0), this.state !== $d4d06657c043713f$var$B.Init && this.destroy(), super.setOptions(i), !1 === this.option("enabled") ? this.attachEvents() : setTimeout(()=>{
            this.init();
        }, 0));
    }
    init() {
        this.state = $d4d06657c043713f$var$B.Init, this.emit("init"), this.attachPlugins(Object.assign(Object.assign({}, $d4d06657c043713f$export$144901db2ea8e967.Plugins), this.userPlugins)), this.emit("attachPlugins"), this.initLayout(), this.initSlides(), this.updateMetrics(), this.setInitialPosition(), this.initPanzoom(), this.attachEvents(), this.state = $d4d06657c043713f$var$B.Ready, this.emit("ready");
    }
    initLayout() {
        const { container: t } = this, e = this.option("classes");
        $d4d06657c043713f$var$P(t, this.cn("container")), $d4d06657c043713f$var$o(t, e.isLTR, !this.isRTL), $d4d06657c043713f$var$o(t, e.isRTL, this.isRTL), $d4d06657c043713f$var$o(t, e.isVertical, !this.isHorizontal), $d4d06657c043713f$var$o(t, e.isHorizontal, this.isHorizontal);
        let i = this.option("viewport") || t.querySelector(`.${e.viewport}`);
        i || (i = document.createElement("div"), $d4d06657c043713f$var$P(i, e.viewport), i.append(...$d4d06657c043713f$var$F(t, `.${e.slide}`)), t.prepend(i)), i.addEventListener("scroll", this.onScroll);
        let n = this.option("track") || t.querySelector(`.${e.track}`);
        n || (n = document.createElement("div"), $d4d06657c043713f$var$P(n, e.track), n.append(...Array.from(i.childNodes))), n.setAttribute("aria-live", "polite"), i.contains(n) || i.prepend(n), this.viewport = i, this.track = n, this.emit("initLayout");
    }
    initSlides() {
        const { track: t } = this;
        if (!t) return;
        const e = [
            ...this.slides
        ], i = [];
        [
            ...$d4d06657c043713f$var$F(t, `.${this.cn($d4d06657c043713f$var$J)}`)
        ].forEach((t)=>{
            if ($d4d06657c043713f$var$E(t)) {
                const e = $d4d06657c043713f$var$H({
                    el: t,
                    isDom: !0,
                    index: this.slides.length
                });
                i.push(e);
            }
        });
        for (let t of [
            ...this.option("slides", []) || [],
            ...e
        ])i.push($d4d06657c043713f$var$H(t));
        this.slides = i;
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of i)this.emit("beforeInitSlide", t, t.index), this.emit("initSlide", t, t.index);
        this.emit("initSlides");
    }
    setInitialPage() {
        const t = this.option("initialSlide");
        this.page = "number" == typeof t ? this.getPageForSlide(t) : parseInt(this.option("initialPage", 0) + "", 10) || 0;
    }
    setInitialPosition() {
        const { track: t, pages: e, isHorizontal: i } = this;
        if (!t || !e.length) return;
        let n = this.page;
        e[n] || (this.page = n = 0);
        const s = (e[n].pos || 0) * (this.isRTL && i ? 1 : -1), o = i ? `${s}px` : "0", a = i ? "0" : `${s}px`;
        t.style.transform = `translate3d(${o}, ${a}, 0) scale(1)`, this.option("adaptiveHeight") && this.setViewportHeight();
    }
    initPanzoom() {
        this.panzoom && (this.panzoom.destroy(), this.panzoom = null);
        const t = this.option("Panzoom") || {};
        this.panzoom = new $d4d06657c043713f$export$b704d075ddd20210(this.viewport, $d4d06657c043713f$var$u({}, {
            content: this.track,
            zoom: !1,
            panOnlyZoomed: !1,
            lockAxis: this.isHorizontal ? "x" : "y",
            infinite: this.isInfinite,
            click: !1,
            dblClick: !1,
            touch: (t)=>!(this.pages.length < 2 && !t.options.infinite),
            bounds: ()=>this.getBounds(),
            maxVelocity: (t)=>Math.abs(t.target[this.axis] - t.current[this.axis]) < 2 * this.viewportDim ? 100 : 0
        }, t)), this.panzoom.on("*", (t, e, ...i)=>{
            this.emit(`Panzoom.${e}`, t, ...i);
        }), this.panzoom.on("decel", this.onDecel), this.panzoom.on("refresh", this.onRefresh), this.panzoom.on("beforeTransform", this.onBeforeTransform), this.panzoom.on("endAnimation", this.onEndAnimation);
    }
    attachEvents() {
        const t = this.container;
        t && (t.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.addEventListener("slideTo", this.onSlideTo)), window.addEventListener("resize", this.onResize);
    }
    createPages() {
        let t = [];
        const { contentDim: e, viewportDim: i } = this;
        let n = this.option("slidesPerPage");
        n = ("auto" === n || e <= i) && !1 !== this.option("fill") ? 1 / 0 : parseFloat(n + "");
        let s = 0, o = 0, a = 0;
        for (const e of this.slides)(!t.length || o + e.dim - i > .05 || a >= n) && (t.push($d4d06657c043713f$var$N()), s = t.length - 1, o = 0, a = 0), t[s].slides.push(e), o += e.dim + e.gap, a++;
        return t;
    }
    processPages() {
        const e = this.pages, { contentDim: i, viewportDim: n, isInfinite: s } = this, o = this.option("center"), a = this.option("fill"), r = a && o && i > n && !s;
        if (e.forEach((t, e)=>{
            var s;
            t.index = e, t.pos = (null === (s = t.slides[0]) || void 0 === s ? void 0 : s.pos) || 0, t.dim = 0;
            for (const [e, i] of t.slides.entries())t.dim += i.dim, e < t.slides.length - 1 && (t.dim += i.gap);
            r && t.pos + .5 * t.dim < .5 * n ? t.pos = 0 : r && t.pos + .5 * t.dim >= i - .5 * n ? t.pos = i - n : o && (t.pos += -0.5 * (n - t.dim));
        }), e.forEach((e)=>{
            a && !s && i > n && (e.pos = Math.max(e.pos, 0), e.pos = Math.min(e.pos, i - n)), e.pos = $d4d06657c043713f$var$t(e.pos, 1e3), e.dim = $d4d06657c043713f$var$t(e.dim, 1e3), Math.abs(e.pos) <= .1 && (e.pos = 0);
        }), s) return e;
        const l = [];
        let c;
        return e.forEach((t)=>{
            const e = Object.assign({}, t);
            c && e.pos === c.pos ? (c.dim += e.dim, c.slides = [
                ...c.slides,
                ...e.slides
            ]) : (e.index = l.length, c = e, l.push(e));
        }), l;
    }
    getPageFromIndex(t = 0) {
        const e = this.pages.length;
        let i;
        return t = parseInt((t || 0).toString()) || 0, i = this.isInfinite ? (t % e + e) % e : Math.max(Math.min(t, e - 1), 0), i;
    }
    getSlideMetrics(e) {
        var i, n;
        const s = this.isHorizontal ? "width" : "height";
        let o = 0, a = 0, r = e.el;
        const l = !(!r || r.parentNode);
        if (r ? o = parseFloat(r.dataset[s] || "") || 0 : (r = document.createElement("div"), r.style.visibility = "hidden", (this.track || document.body).prepend(r)), $d4d06657c043713f$var$P(r, this.cn($d4d06657c043713f$var$J) + " " + e.class + " " + e.customClass), o) r.style[s] = `${o}px`, r.style["width" === s ? "height" : "width"] = "";
        else {
            l && (this.track || document.body).prepend(r), o = r.getBoundingClientRect()[s] * Math.max(1, (null === (i = window.visualViewport) || void 0 === i ? void 0 : i.scale) || 1);
            let t = r[this.isHorizontal ? "offsetWidth" : "offsetHeight"];
            t - 1 > o && (o = t);
        }
        const c = getComputedStyle(r);
        return "content-box" === c.boxSizing && (this.isHorizontal ? (o += parseFloat(c.paddingLeft) || 0, o += parseFloat(c.paddingRight) || 0) : (o += parseFloat(c.paddingTop) || 0, o += parseFloat(c.paddingBottom) || 0)), a = parseFloat(c[this.isHorizontal ? "marginRight" : "marginBottom"]) || 0, l ? null === (n = r.parentElement) || void 0 === n || n.removeChild(r) : e.el || r.remove(), {
            dim: $d4d06657c043713f$var$t(o, 1e3),
            gap: $d4d06657c043713f$var$t(a, 1e3)
        };
    }
    getBounds() {
        const { isInfinite: t, isRTL: e, isHorizontal: i, pages: n } = this;
        let s = {
            min: 0,
            max: 0
        };
        if (t) s = {
            min: -1 / 0,
            max: 1 / 0
        };
        else if (n.length) {
            const t = n[0].pos, o = n[n.length - 1].pos;
            s = e && i ? {
                min: t,
                max: o
            } : {
                min: -1 * o,
                max: -1 * t
            };
        }
        return {
            x: i ? s : {
                min: 0,
                max: 0
            },
            y: i ? {
                min: 0,
                max: 0
            } : s
        };
    }
    repositionSlides() {
        let e, { isHorizontal: i, isRTL: n, isInfinite: s, viewport: o, viewportDim: a, contentDim: r, page: l, pages: c, slides: h, panzoom: d } = this, u = 0, p = 0, f = 0, g = 0;
        d ? g = -1 * d.current[this.axis] : c[l] && (g = c[l].pos || 0), e = i ? n ? "right" : "left" : "top", n && i && (g *= -1);
        for (const i of h){
            const n = i.el;
            n ? ("top" === e ? (n.style.right = "", n.style.left = "") : n.style.top = "", i.index !== u ? n.style[e] = 0 === p ? "" : `${$d4d06657c043713f$var$t(p, 1e3)}px` : n.style[e] = "", f += i.dim + i.gap, u++) : p += i.dim + i.gap;
        }
        if (s && f && o) {
            let n = getComputedStyle(o), s = "padding", l = i ? "Right" : "Bottom", c = parseFloat(n[s + (i ? "Left" : "Top")]);
            g -= c, a += c, a += parseFloat(n[s + l]);
            for (const i of h)i.el && ($d4d06657c043713f$var$t(i.pos) < $d4d06657c043713f$var$t(a) && $d4d06657c043713f$var$t(i.pos + i.dim + i.gap) < $d4d06657c043713f$var$t(g) && $d4d06657c043713f$var$t(g) > $d4d06657c043713f$var$t(r - a) && (i.el.style[e] = `${$d4d06657c043713f$var$t(p + f, 1e3)}px`), $d4d06657c043713f$var$t(i.pos + i.gap) >= $d4d06657c043713f$var$t(r - a) && $d4d06657c043713f$var$t(i.pos) > $d4d06657c043713f$var$t(g + a) && $d4d06657c043713f$var$t(g) < $d4d06657c043713f$var$t(a) && (i.el.style[e] = `-${$d4d06657c043713f$var$t(f, 1e3)}px`));
        }
        let m, v, b = [
            ...this.inTransition
        ];
        if (b.length > 1 && (m = c[b[0]], v = c[b[1]]), m && v) {
            let i = 0;
            for (const n of h)n.el ? this.inTransition.has(n.index) && m.slides.indexOf(n) < 0 && (n.el.style[e] = `${$d4d06657c043713f$var$t(i + (m.pos - v.pos), 1e3)}px`) : i += n.dim + n.gap;
        }
    }
    createSlideEl(t) {
        const { track: e, slides: i } = this;
        if (!e || !t) return;
        if (t.el && t.el.parentNode) return;
        const n = t.el || document.createElement("div");
        $d4d06657c043713f$var$P(n, this.cn($d4d06657c043713f$var$J)), $d4d06657c043713f$var$P(n, t.class), $d4d06657c043713f$var$P(n, t.customClass);
        const s = t.html;
        s && (s instanceof HTMLElement ? n.appendChild(s) : n.innerHTML = t.html + "");
        const o = [];
        i.forEach((t, e)=>{
            t.el && o.push(e);
        });
        const a = t.index;
        let r = null;
        if (o.length) r = i[o.reduce((t, e)=>Math.abs(e - a) < Math.abs(t - a) ? e : t)];
        const l = r && r.el && r.el.parentNode ? r.index < t.index ? r.el.nextSibling : r.el : null;
        e.insertBefore(n, e.contains(l) ? l : null), t.el = n, this.emit("createSlide", t);
    }
    removeSlideEl(t, e = !1) {
        const i = null == t ? void 0 : t.el;
        if (!i || !i.parentNode) return;
        const n = this.cn($d4d06657c043713f$var$K);
        if (i.classList.contains(n) && ($d4d06657c043713f$var$S(i, n), this.emit("unselectSlide", t)), t.isDom && !e) return i.removeAttribute("aria-hidden"), i.removeAttribute("data-index"), void (i.style.left = "");
        this.emit("removeSlide", t);
        const s = new CustomEvent($d4d06657c043713f$var$G);
        i.dispatchEvent(s), t.el && (t.el.remove(), t.el = null);
    }
    transitionTo(t = 0, e = this.option("transition")) {
        var i, n, s, o;
        if (!e) return !1;
        const a = this.page, { pages: r, panzoom: l } = this;
        t = parseInt((t || 0).toString()) || 0;
        const c = this.getPageFromIndex(t);
        if (!l || !r[c] || r.length < 2 || Math.abs(((null === (n = null === (i = r[a]) || void 0 === i ? void 0 : i.slides[0]) || void 0 === n ? void 0 : n.dim) || 0) - this.viewportDim) > 1) return !1;
        let h = t > a ? 1 : -1;
        this.isInfinite && (0 === a && t === r.length - 1 && (h = -1), a === r.length - 1 && 0 === t && (h = 1));
        const d = r[c].pos * (this.isRTL ? 1 : -1);
        if (a === c && Math.abs(d - l.target[this.axis]) < 1) return !1;
        this.clearTransitions();
        const u = l.isResting;
        $d4d06657c043713f$var$P(this.container, this.cn("inTransition"));
        const p = (null === (s = r[a]) || void 0 === s ? void 0 : s.slides[0]) || null, f = (null === (o = r[c]) || void 0 === o ? void 0 : o.slides[0]) || null;
        this.inTransition.add(f.index), this.createSlideEl(f);
        let g = p.el, m = f.el;
        u || e === $d4d06657c043713f$var$J || (e = "fadeFast", g = null);
        const v = this.isRTL ? "next" : "prev", b = this.isRTL ? "prev" : "next";
        return g && (this.inTransition.add(p.index), p.transition = e, g.addEventListener($d4d06657c043713f$var$G, this.onAnimationEnd), g.classList.add(`f-${e}Out`, `to-${h > 0 ? b : v}`)), m && (f.transition = e, m.addEventListener($d4d06657c043713f$var$G, this.onAnimationEnd), m.classList.add(`f-${e}In`, `from-${h > 0 ? v : b}`)), l.current[this.axis] = d, l.target[this.axis] = d, l.requestTick(), this.onChange(c), !0;
    }
    manageSlideVisiblity() {
        const t = new Set, e = new Set, i = this.getVisibleSlides(parseFloat(this.option("preload", 0) + "") || 0);
        for (const n of this.slides)i.has(n) ? t.add(n) : e.add(n);
        for (const e of this.inTransition)t.add(this.slides[e]);
        for (const e of t)this.createSlideEl(e), this.lazyLoadSlide(e);
        for (const i of e)t.has(i) || this.removeSlideEl(i);
        this.markSelectedSlides(), this.repositionSlides();
    }
    markSelectedSlides() {
        if (!this.pages[this.page] || !this.pages[this.page].slides) return;
        const t = "aria-hidden";
        let e = this.cn($d4d06657c043713f$var$K);
        if (e) for (const i of this.slides){
            const n = i.el;
            n && (n.dataset.index = `${i.index}`, n.classList.contains("f-thumbs__slide") ? this.getVisibleSlides(0).has(i) ? n.removeAttribute(t) : n.setAttribute(t, "true") : this.pages[this.page].slides.includes(i) ? (n.classList.contains(e) || ($d4d06657c043713f$var$P(n, e), this.emit("selectSlide", i)), n.removeAttribute(t)) : (n.classList.contains(e) && ($d4d06657c043713f$var$S(n, e), this.emit("unselectSlide", i)), n.setAttribute(t, "true")));
        }
    }
    flipInfiniteTrack() {
        const { axis: t, isHorizontal: e, isInfinite: i, isRTL: n, viewportDim: s, contentDim: o } = this, a = this.panzoom;
        if (!a || !i) return;
        let r = a.current[t], l = a.target[t] - r, c = 0, h = .5 * s;
        n && e ? (r < -h && (c = -1, r += o), r > o - h && (c = 1, r -= o)) : (r > h && (c = 1, r -= o), r < -o + h && (c = -1, r += o)), c && (a.current[t] = r, a.target[t] = r + l);
    }
    lazyLoadImg(t, e) {
        const i = this, s = "f-fadeIn", o = "is-preloading";
        let a = !1, r = null;
        const l = ()=>{
            a || (a = !0, r && (r.remove(), r = null), $d4d06657c043713f$var$S(e, o), e.complete && ($d4d06657c043713f$var$P(e, s), setTimeout(()=>{
                $d4d06657c043713f$var$S(e, s);
            }, 350)), this.option("adaptiveHeight") && t.el && this.pages[this.page].slides.indexOf(t) > -1 && (i.updateMetrics(), i.setViewportHeight()), this.emit("load", t));
        };
        $d4d06657c043713f$var$P(e, o), e.src = e.dataset.lazySrcset || e.dataset.lazySrc || "", delete e.dataset.lazySrc, delete e.dataset.lazySrcset, e.addEventListener("error", ()=>{
            l();
        }), e.addEventListener("load", ()=>{
            l();
        }), setTimeout(()=>{
            const i = e.parentNode;
            i && t.el && (e.complete ? l() : a || (r = $d4d06657c043713f$var$n($d4d06657c043713f$var$x), i.insertBefore(r, e)));
        }, 300);
    }
    lazyLoadSlide(t) {
        const e = t && t.el;
        if (!e) return;
        const i = new Set;
        let n = Array.from(e.querySelectorAll("[data-lazy-src],[data-lazy-srcset]"));
        e.dataset.lazySrc && n.push(e), n.map((t)=>{
            t instanceof HTMLImageElement ? i.add(t) : t instanceof HTMLElement && t.dataset.lazySrc && (t.style.backgroundImage = `url('${t.dataset.lazySrc}')`, delete t.dataset.lazySrc);
        });
        for (const e of i)this.lazyLoadImg(t, e);
    }
    onAnimationEnd(t) {
        var e;
        const i = t.target, n = i ? parseInt(i.dataset.index || "", 10) || 0 : -1, s = this.slides[n], o = t.animationName;
        if (!i || !s || !o) return;
        const a = !!this.inTransition.has(n) && s.transition;
        a && o.substring(0, a.length + 2) === `f-${a}` && this.inTransition.delete(n), this.inTransition.size || this.clearTransitions(), n === this.page && (null === (e = this.panzoom) || void 0 === e ? void 0 : e.isResting) && this.emit("settle");
    }
    onDecel(t, e = 0, i = 0, n = 0, s = 0) {
        if (this.option("dragFree")) return void this.setPageFromPosition();
        const { isRTL: o, isHorizontal: a, axis: r, pages: l } = this, c = l.length, h = Math.abs(Math.atan2(i, e) / (Math.PI / 180));
        let d = 0;
        if (d = h > 45 && h < 135 ? a ? 0 : i : a ? e : 0, !c) return;
        let u = this.page, p = o && a ? 1 : -1;
        const f = t.current[r] * p;
        let { pageIndex: g } = this.getPageFromPosition(f);
        Math.abs(d) > 5 ? (l[u].dim < document.documentElement["client" + (this.isHorizontal ? "Width" : "Height")] - 1 && (u = g), u = o && a ? d < 0 ? u - 1 : u + 1 : d < 0 ? u + 1 : u - 1) : u = 0 === n && 0 === s ? u : g, this.slideTo(u, {
            transition: !1,
            friction: t.option("decelFriction")
        });
    }
    onClick(t) {
        const e = t.target, i = e && $d4d06657c043713f$var$E(e) ? e.dataset : null;
        let n, s;
        i && (void 0 !== i.carouselPage ? (s = "slideTo", n = i.carouselPage) : void 0 !== i.carouselNext ? s = "slideNext" : void 0 !== i.carouselPrev && (s = "slidePrev")), s ? (t.preventDefault(), t.stopPropagation(), e && !e.hasAttribute("disabled") && this[s](n)) : this.emit("click", t);
    }
    onSlideTo(t) {
        const e = t.detail || 0;
        this.slideTo(this.getPageForSlide(e), {
            friction: 0
        });
    }
    onChange(t, e = 0) {
        const i = this.page;
        this.prevPage = i, this.page = t, this.option("adaptiveHeight") && this.setViewportHeight(), t !== i && (this.markSelectedSlides(), this.emit("change", t, i, e));
    }
    onRefresh() {
        let t = this.contentDim, e = this.viewportDim;
        this.updateMetrics(), this.contentDim === t && this.viewportDim === e || this.slideTo(this.page, {
            friction: 0,
            transition: !1
        });
    }
    onScroll() {
        var t;
        null === (t = this.viewport) || void 0 === t || t.scroll(0, 0);
    }
    onResize() {
        this.option("breakpoints") && this.processOptions();
    }
    onBeforeTransform(t) {
        this.lp !== t.current[this.axis] && (this.flipInfiniteTrack(), this.manageSlideVisiblity()), this.lp = t.current.e;
    }
    onEndAnimation() {
        this.inTransition.size || this.emit("settle");
    }
    reInit(t = null, e = null) {
        this.destroy(), this.state = $d4d06657c043713f$var$B.Init, this.prevPage = null, this.userOptions = t || this.userOptions, this.userPlugins = e || this.userPlugins, this.processOptions();
    }
    slideTo(t = 0, { friction: e = this.option("friction"), transition: i = this.option("transition") } = {}) {
        if (this.state === $d4d06657c043713f$var$B.Destroy) return;
        t = parseInt((t || 0).toString()) || 0;
        const n = this.getPageFromIndex(t), { axis: s, isHorizontal: o, isRTL: a, pages: r, panzoom: l } = this, c = r.length, h = a && o ? 1 : -1;
        if (!l || !c) return;
        if (this.page !== n) {
            const e = new Event("beforeChange", {
                bubbles: !0,
                cancelable: !0
            });
            if (this.emit("beforeChange", e, t), e.defaultPrevented) return;
        }
        if (this.transitionTo(t, i)) return;
        let d = r[n].pos;
        if (this.isInfinite) {
            const e = this.contentDim, i = l.target[s] * h;
            if (2 === c) d += e * Math.floor(parseFloat(t + "") / 2);
            else d = [
                d,
                d - e,
                d + e
            ].reduce(function(t, e) {
                return Math.abs(e - i) < Math.abs(t - i) ? e : t;
            });
        }
        d *= h, Math.abs(l.target[s] - d) < 1 || (l.panTo({
            x: o ? d : 0,
            y: o ? 0 : d,
            friction: e
        }), this.onChange(n));
    }
    slideToClosest(t) {
        if (this.panzoom) {
            const { pageIndex: e } = this.getPageFromPosition();
            this.slideTo(e, t);
        }
    }
    slideNext() {
        this.slideTo(this.page + 1);
    }
    slidePrev() {
        this.slideTo(this.page - 1);
    }
    clearTransitions() {
        this.inTransition.clear(), $d4d06657c043713f$var$S(this.container, this.cn("inTransition"));
        const t = [
            "to-prev",
            "to-next",
            "from-prev",
            "from-next"
        ];
        for (const e of this.slides){
            const i = e.el;
            if (i) {
                i.removeEventListener($d4d06657c043713f$var$G, this.onAnimationEnd), i.classList.remove(...t);
                const n = e.transition;
                n && i.classList.remove(`f-${n}Out`, `f-${n}In`);
            }
        }
        this.manageSlideVisiblity();
    }
    addSlide(t, e) {
        var i, n, s, o;
        const a = this.panzoom, r = (null === (i = this.pages[this.page]) || void 0 === i ? void 0 : i.pos) || 0, l = (null === (n = this.pages[this.page]) || void 0 === n ? void 0 : n.dim) || 0, c = this.contentDim < this.viewportDim;
        let h = Array.isArray(e) ? e : [
            e
        ];
        const d = [];
        for (const t of h)d.push($d4d06657c043713f$var$H(t));
        this.slides.splice(t, 0, ...d);
        for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
        for (const t of d)this.emit("beforeInitSlide", t, t.index);
        if (this.page >= t && (this.page += d.length), this.updateMetrics(), a) {
            const e = (null === (s = this.pages[this.page]) || void 0 === s ? void 0 : s.pos) || 0, i = (null === (o = this.pages[this.page]) || void 0 === o ? void 0 : o.dim) || 0, n = this.pages.length || 1, h = this.isRTL ? l - i : i - l, d = this.isRTL ? r - e : e - r;
            c && 1 === n ? (t <= this.page && (a.current[this.axis] -= h, a.target[this.axis] -= h), a.panTo({
                [this.isHorizontal ? "x" : "y"]: -1 * e
            })) : d && t <= this.page && (a.target[this.axis] -= d, a.current[this.axis] -= d, a.requestTick());
        }
        for (const t of d)this.emit("initSlide", t, t.index);
    }
    prependSlide(t) {
        this.addSlide(0, t);
    }
    appendSlide(t) {
        this.addSlide(this.slides.length, t);
    }
    removeSlide(t) {
        const e = this.slides.length;
        t = (t % e + e) % e;
        const i = this.slides[t];
        if (i) {
            this.removeSlideEl(i, !0), this.slides.splice(t, 1);
            for(let t = 0; t < this.slides.length; t++)this.slides[t].index = t;
            this.updateMetrics(), this.slideTo(this.page, {
                friction: 0,
                transition: !1
            }), this.emit("destroySlide", i);
        }
    }
    updateMetrics() {
        const { panzoom: e, viewport: i, track: n, slides: s, isHorizontal: o, isInfinite: a } = this;
        if (!n) return;
        const r = o ? "width" : "height", l = o ? "offsetWidth" : "offsetHeight";
        if (i) {
            let e = Math.max(i[l], $d4d06657c043713f$var$t(i.getBoundingClientRect()[r], 1e3)), n = getComputedStyle(i), s = "padding", a = o ? "Right" : "Bottom";
            e -= parseFloat(n[s + (o ? "Left" : "Top")]) + parseFloat(n[s + a]), this.viewportDim = e;
        }
        let c, h = 0;
        for (const [e, i] of s.entries()){
            let n = 0, o = 0;
            !i.el && c ? (n = c.dim, o = c.gap) : ({ dim: n, gap: o } = this.getSlideMetrics(i), c = i), n = $d4d06657c043713f$var$t(n, 1e3), o = $d4d06657c043713f$var$t(o, 1e3), i.dim = n, i.gap = o, i.pos = h, h += n, (a || e < s.length - 1) && (h += o);
        }
        h = $d4d06657c043713f$var$t(h, 1e3), this.contentDim = h, e && (e.contentRect[r] = h, e.contentRect[o ? "fullWidth" : "fullHeight"] = h), this.pages = this.createPages(), this.pages = this.processPages(), this.state === $d4d06657c043713f$var$B.Init && this.setInitialPage(), this.page = Math.max(0, Math.min(this.page, this.pages.length - 1)), this.manageSlideVisiblity(), this.emit("refresh");
    }
    getProgress(e, i = !1, n = !1) {
        void 0 === e && (e = this.page);
        const s = this, o = s.panzoom, a = s.contentDim, r = s.pages[e] || 0;
        if (!r || !o) return e > this.page ? -1 : 1;
        let l = -1 * o.current.e, c = $d4d06657c043713f$var$t((l - r.pos) / (1 * r.dim), 1e3), h = c, d = c;
        this.isInfinite && !0 !== n && (h = $d4d06657c043713f$var$t((l - r.pos + a) / (1 * r.dim), 1e3), d = $d4d06657c043713f$var$t((l - r.pos - a) / (1 * r.dim), 1e3));
        let u = [
            c,
            h,
            d
        ].reduce(function(t, e) {
            return Math.abs(e) < Math.abs(t) ? e : t;
        });
        return i ? u : u > 1 ? 1 : u < -1 ? -1 : u;
    }
    setViewportHeight() {
        const { page: t, pages: e, viewport: i, isHorizontal: n } = this;
        if (!i || !e[t]) return;
        let s = 0;
        n && this.track && (this.track.style.height = "auto", e[t].slides.forEach((t)=>{
            t.el && (s = Math.max(s, t.el.offsetHeight));
        })), i.style.height = s ? `${s}px` : "";
    }
    getPageForSlide(t) {
        for (const e of this.pages)for (const i of e.slides)if (i.index === t) return e.index;
        return -1;
    }
    getVisibleSlides(t = 0) {
        var e;
        const i = new Set;
        let { panzoom: n, contentDim: s, viewportDim: o, pages: a, page: r } = this;
        if (o) {
            s = s + (null === (e = this.slides[this.slides.length - 1]) || void 0 === e ? void 0 : e.gap) || 0;
            let l = 0;
            l = n && n.state !== $d4d06657c043713f$var$m.Init && n.state !== $d4d06657c043713f$var$m.Destroy ? -1 * n.current[this.axis] : a[r] && a[r].pos || 0, this.isInfinite && (l -= Math.floor(l / s) * s), this.isRTL && this.isHorizontal && (l *= -1);
            const c = l - o * t, h = l + o * (t + 1), d = this.isInfinite ? [
                -1,
                0,
                1
            ] : [
                0
            ];
            for (const t of this.slides)for (const e of d){
                const n = t.pos + e * s, o = n + t.dim + t.gap;
                n < h && o > c && i.add(t);
            }
        }
        return i;
    }
    getPageFromPosition(t) {
        const { viewportDim: e, contentDim: i, slides: n, pages: s, panzoom: o } = this, a = s.length, r = n.length, l = n[0], c = n[r - 1], h = this.option("center");
        let d = 0, u = 0, p = 0, f = void 0 === t ? -1 * ((null == o ? void 0 : o.target[this.axis]) || 0) : t;
        h && (f += .5 * e), this.isInfinite ? (f < l.pos - .5 * c.gap && (f -= i, p = -1), f > c.pos + c.dim + .5 * c.gap && (f -= i, p = 1)) : f = Math.max(l.pos || 0, Math.min(f, c.pos));
        let g = c, m = n.find((t)=>{
            const e = t.pos - .5 * g.gap, i = t.pos + t.dim + .5 * t.gap;
            return g = t, f >= e && f < i;
        });
        return m || (m = c), u = this.getPageForSlide(m.index), d = u + p * a, {
            page: d,
            pageIndex: u
        };
    }
    setPageFromPosition() {
        const { pageIndex: t } = this.getPageFromPosition();
        this.onChange(t);
    }
    destroy() {
        if ([
            $d4d06657c043713f$var$B.Destroy
        ].includes(this.state)) return;
        this.state = $d4d06657c043713f$var$B.Destroy;
        const { container: t, viewport: e, track: i, slides: n, panzoom: s } = this, o = this.option("classes");
        t.removeEventListener("click", this.onClick, {
            passive: !1,
            capture: !1
        }), t.removeEventListener("slideTo", this.onSlideTo), window.removeEventListener("resize", this.onResize), s && (s.destroy(), this.panzoom = null), n && n.forEach((t)=>{
            this.removeSlideEl(t);
        }), this.detachPlugins(), e && (e.removeEventListener("scroll", this.onScroll), e.offsetParent && i && i.offsetParent && e.replaceWith(...i.childNodes));
        for (const [e, i] of Object.entries(o))"container" !== e && i && t.classList.remove(i);
        this.track = null, this.viewport = null, this.page = 0, this.slides = [];
        const a = this.events.get("ready");
        this.events = new Map, a && this.events.set("ready", a);
    }
}
Object.defineProperty($d4d06657c043713f$export$144901db2ea8e967, "Panzoom", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$export$b704d075ddd20210
}), Object.defineProperty($d4d06657c043713f$export$144901db2ea8e967, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$j
}), Object.defineProperty($d4d06657c043713f$export$144901db2ea8e967, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$U
});
const $d4d06657c043713f$var$tt = function(t) {
    if (!$d4d06657c043713f$var$E(t)) return 0;
    const e = window.scrollY, i = window.innerHeight, n = e + i, s = t.getBoundingClientRect(), o = s.y + e, a = s.height, r = o + a;
    if (e > r || n < o) return 0;
    if (e < o && n > r) return 100;
    if (o < e && r > n) return 100;
    let l = a;
    o < e && (l -= e - o), r > n && (l -= r - n);
    const c = l / i * 100;
    return Math.round(c);
}, $d4d06657c043713f$var$et = !("undefined" == typeof window || !window.document || !window.document.createElement);
let $d4d06657c043713f$var$it;
const $d4d06657c043713f$var$nt = [
    "a[href]",
    "area[href]",
    'input:not([disabled]):not([type="hidden"]):not([aria-hidden])',
    "select:not([disabled]):not([aria-hidden])",
    "textarea:not([disabled]):not([aria-hidden])",
    "button:not([disabled]):not([aria-hidden]):not(.fancybox-focus-guard)",
    "iframe",
    "object",
    "embed",
    "video",
    "audio",
    "[contenteditable]",
    '[tabindex]:not([tabindex^="-"]):not([disabled]):not([aria-hidden])'
].join(","), $d4d06657c043713f$var$st = (t)=>{
    if (t && $d4d06657c043713f$var$et) {
        void 0 === $d4d06657c043713f$var$it && document.createElement("div").focus({
            get preventScroll () {
                return $d4d06657c043713f$var$it = !0, !1;
            }
        });
        try {
            if ($d4d06657c043713f$var$it) t.focus({
                preventScroll: !0
            });
            else {
                const e = window.scrollY || document.body.scrollTop, i = window.scrollX || document.body.scrollLeft;
                t.focus(), document.body.scrollTo({
                    top: e,
                    left: i,
                    behavior: "auto"
                });
            }
        } catch (t) {}
    }
}, $d4d06657c043713f$var$ot = ()=>{
    const t = document;
    let e, i = "", n = "", s = "";
    return t.fullscreenEnabled ? (i = "requestFullscreen", n = "exitFullscreen", s = "fullscreenElement") : t.webkitFullscreenEnabled && (i = "webkitRequestFullscreen", n = "webkitExitFullscreen", s = "webkitFullscreenElement"), i && (e = {
        request: function(e = t.documentElement) {
            return "webkitRequestFullscreen" === i ? e[i](Element.ALLOW_KEYBOARD_INPUT) : e[i]();
        },
        exit: function() {
            return t[s] && t[n]();
        },
        isFullscreen: function() {
            return t[s];
        }
    }), e;
}, $d4d06657c043713f$var$at = {
    animated: !0,
    autoFocus: !0,
    backdropClick: "close",
    Carousel: {
        classes: {
            container: "fancybox__carousel",
            viewport: "fancybox__viewport",
            track: "fancybox__track",
            slide: "fancybox__slide"
        }
    },
    closeButton: "auto",
    closeExisting: !1,
    commonCaption: !1,
    compact: ()=>window.matchMedia("(max-width: 578px), (max-height: 578px)").matches,
    contentClick: "toggleZoom",
    contentDblClick: !1,
    defaultType: "image",
    defaultDisplay: "flex",
    dragToClose: !0,
    Fullscreen: {
        autoStart: !1
    },
    groupAll: !1,
    groupAttr: "data-fancybox",
    hideClass: "f-fadeOut",
    hideScrollbar: !0,
    idle: 3500,
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "prev",
        ArrowDown: "next",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    l10n: Object.assign(Object.assign({}, $d4d06657c043713f$var$b), {
        CLOSE: "Close",
        NEXT: "Next",
        PREV: "Previous",
        MODAL: "You can close this modal content with the ESC key",
        ERROR: "Something Went Wrong, Please Try Again Later",
        IMAGE_ERROR: "Image Not Found",
        ELEMENT_NOT_FOUND: "HTML Element Not Found",
        AJAX_NOT_FOUND: "Error Loading AJAX : Not Found",
        AJAX_FORBIDDEN: "Error Loading AJAX : Forbidden",
        IFRAME_ERROR: "Error Loading Page",
        TOGGLE_ZOOM: "Toggle zoom level",
        TOGGLE_THUMBS: "Toggle thumbnails",
        TOGGLE_SLIDESHOW: "Toggle slideshow",
        TOGGLE_FULLSCREEN: "Toggle full-screen mode",
        DOWNLOAD: "Download"
    }),
    parentEl: null,
    placeFocusBack: !0,
    showClass: "f-zoomInUp",
    startIndex: 0,
    tpl: {
        closeButton: '<button data-fancybox-close class="f-button is-close-btn" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M20 20L4 4m16 0L4 20"/></svg></button>',
        main: '<div class="fancybox__container" role="dialog" aria-modal="true" aria-label="{{MODAL}}" tabindex="-1">\n    <div class="fancybox__backdrop"></div>\n    <div class="fancybox__carousel"></div>\n    <div class="fancybox__footer"></div>\n  </div>'
    },
    trapFocus: !0,
    wheel: "zoom"
};
var $d4d06657c043713f$var$rt, $d4d06657c043713f$var$lt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Closing = 2] = "Closing", t[t.CustomClosing = 3] = "CustomClosing", t[t.Destroy = 4] = "Destroy";
}($d4d06657c043713f$var$rt || ($d4d06657c043713f$var$rt = {})), function(t) {
    t[t.Loading = 0] = "Loading", t[t.Opening = 1] = "Opening", t[t.Ready = 2] = "Ready", t[t.Closing = 3] = "Closing";
}($d4d06657c043713f$var$lt || ($d4d06657c043713f$var$lt = {}));
let $d4d06657c043713f$var$ct = "", $d4d06657c043713f$var$ht = !1, $d4d06657c043713f$var$dt = !1, $d4d06657c043713f$var$ut = null;
const $d4d06657c043713f$var$pt = ()=>{
    let t = "", e = "";
    const i = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
    if (i) {
        const n = i.carousel, s = i.getSlide();
        if (n && s) {
            let o = s.slug || void 0, a = s.triggerEl || void 0;
            e = o || i.option("slug") || "", !e && a && a.dataset && (e = a.dataset.fancybox || ""), e && "true" !== e && (t = "#" + e + (!o && n.slides.length > 1 ? "-" + (s.index + 1) : ""));
        }
    }
    return {
        hash: t,
        slug: e,
        index: 1
    };
}, $d4d06657c043713f$var$ft = ()=>{
    const t = new URL(document.URL).hash, e = t.slice(1).split("-"), i = e[e.length - 1], n = i && /^\+?\d+$/.test(i) && parseInt(e.pop() || "1", 10) || 1;
    return {
        hash: t,
        slug: e.join("-"),
        index: n
    };
}, $d4d06657c043713f$var$gt = ()=>{
    const { slug: t, index: e } = $d4d06657c043713f$var$ft();
    if (!t) return;
    let i = document.querySelector(`[data-slug="${t}"]`);
    if (i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })), $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance()) return;
    const n = document.querySelectorAll(`[data-fancybox="${t}"]`);
    n.length && (i = n[e - 1], i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    })));
}, $d4d06657c043713f$var$mt = ()=>{
    if (!1 === $d4d06657c043713f$export$cb45b08d97cdc4fd.defaults.Hash) return;
    const t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
    if (!1 === (null == t ? void 0 : t.options.Hash)) return;
    const { slug: e, index: i } = $d4d06657c043713f$var$ft(), { slug: n } = $d4d06657c043713f$var$pt();
    t && (e === n ? t.jumpTo(i - 1) : ($d4d06657c043713f$var$ht = !0, t.close())), $d4d06657c043713f$var$gt();
}, $d4d06657c043713f$var$vt = ()=>{
    $d4d06657c043713f$var$ut && clearTimeout($d4d06657c043713f$var$ut), queueMicrotask(()=>{
        $d4d06657c043713f$var$mt();
    });
}, $d4d06657c043713f$var$bt = ()=>{
    window.addEventListener("hashchange", $d4d06657c043713f$var$vt, !1), setTimeout(()=>{
        $d4d06657c043713f$var$mt();
    }, 500);
};
$d4d06657c043713f$var$et && (/complete|interactive|loaded/.test(document.readyState) ? $d4d06657c043713f$var$bt() : document.addEventListener("DOMContentLoaded", $d4d06657c043713f$var$bt));
const $d4d06657c043713f$var$yt = "is-zooming-in";
class $d4d06657c043713f$var$wt extends $d4d06657c043713f$var$_ {
    onCreateSlide(t, e, i) {
        const n = this.instance.optionFor(i, "src") || "";
        i.el && "image" === i.type && "string" == typeof n && this.setImage(i, n);
    }
    onRemoveSlide(t, e, i) {
        i.panzoom && i.panzoom.destroy(), i.panzoom = void 0, i.imageEl = void 0;
    }
    onChange(t, e, i, n) {
        $d4d06657c043713f$var$S(this.instance.container, $d4d06657c043713f$var$yt);
        for (const t of e.slides){
            const e = t.panzoom;
            e && t.index !== i && e.reset(.35);
        }
    }
    onClose() {
        var t;
        const e = this.instance, i = e.container, n = e.getSlide();
        if (!i || !i.parentElement || !n) return;
        const { el: s, contentEl: o, panzoom: a, thumbElSrc: r } = n;
        if (!s || !r || !o || !a || a.isContentLoading || a.state === $d4d06657c043713f$var$m.Init || a.state === $d4d06657c043713f$var$m.Destroy) return;
        a.updateMetrics();
        let l = this.getZoomInfo(n);
        if (!l) return;
        this.instance.state = $d4d06657c043713f$var$rt.CustomClosing, i.classList.remove($d4d06657c043713f$var$yt), i.classList.add("is-zooming-out"), o.style.backgroundImage = `url('${r}')`;
        const c = i.getBoundingClientRect();
        1 === ((null === (t = window.visualViewport) || void 0 === t ? void 0 : t.scale) || 1) && Object.assign(i.style, {
            position: "absolute",
            top: `${i.offsetTop + window.scrollY}px`,
            left: `${i.offsetLeft + window.scrollX}px`,
            bottom: "auto",
            right: "auto",
            width: `${c.width}px`,
            height: `${c.height}px`,
            overflow: "hidden"
        });
        const { x: h, y: d, scale: u, opacity: p } = l;
        if (p) {
            const t = ((t, e, i, n)=>{
                const s = e - t, o = n - i;
                return (e)=>i + ((e - t) / s * o || 0);
            })(a.scale, u, 1, 0);
            a.on("afterTransform", ()=>{
                o.style.opacity = t(a.scale) + "";
            });
        }
        a.on("endAnimation", ()=>{
            e.destroy();
        }), a.target.a = u, a.target.b = 0, a.target.c = 0, a.target.d = u, a.panTo({
            x: h,
            y: d,
            scale: u,
            friction: p ? .2 : .33,
            ignoreBounds: !0
        }), a.isResting && e.destroy();
    }
    setImage(t, e) {
        const i = this.instance;
        t.src = e, this.process(t, e).then((e)=>{
            const { contentEl: n, imageEl: s, thumbElSrc: o, el: a } = t;
            if (i.isClosing() || !n || !s) return;
            n.offsetHeight;
            const r = !!i.isOpeningSlide(t) && this.getZoomInfo(t);
            if (this.option("protected") && a) {
                a.addEventListener("contextmenu", (t)=>{
                    t.preventDefault();
                });
                const t = document.createElement("div");
                $d4d06657c043713f$var$P(t, "fancybox-protected"), n.appendChild(t);
            }
            if (o && r) {
                const s = e.contentRect, a = Math.max(s.fullWidth, s.fullHeight);
                let c = null;
                !r.opacity && a > 1200 && (c = document.createElement("img"), $d4d06657c043713f$var$P(c, "fancybox-ghost"), c.src = o, n.appendChild(c));
                const h = ()=>{
                    c && ($d4d06657c043713f$var$P(c, "f-fadeFastOut"), setTimeout(()=>{
                        c && (c.remove(), c = null);
                    }, 200));
                };
                (l = o, new Promise((t, e)=>{
                    const i = new Image;
                    i.onload = t, i.onerror = e, i.src = l;
                })).then(()=>{
                    i.hideLoading(t), t.state = $d4d06657c043713f$var$lt.Opening, this.instance.emit("reveal", t), this.zoomIn(t).then(()=>{
                        h(), this.instance.done(t);
                    }, ()=>{}), c && setTimeout(()=>{
                        h();
                    }, a > 2500 ? 800 : 200);
                }, ()=>{
                    i.hideLoading(t), i.revealContent(t);
                });
            } else {
                const n = this.optionFor(t, "initialSize"), s = this.optionFor(t, "zoom"), o = {
                    event: i.prevMouseMoveEvent || i.options.event,
                    friction: s ? .12 : 0
                };
                let a = i.optionFor(t, "showClass") || void 0, r = !0;
                i.isOpeningSlide(t) && ("full" === n ? e.zoomToFull(o) : "cover" === n ? e.zoomToCover(o) : "max" === n ? e.zoomToMax(o) : r = !1, e.stop("current")), r && a && (a = e.isDragging ? "f-fadeIn" : ""), i.hideLoading(t), i.revealContent(t, a);
            }
            var l;
        }, ()=>{
            i.setError(t, "{{IMAGE_ERROR}}");
        });
    }
    process(t, e) {
        return new Promise((i, s)=>{
            var o;
            const a = this.instance, r = t.el;
            a.clearContent(t), a.showLoading(t);
            let l = this.optionFor(t, "content");
            if ("string" == typeof l && (l = $d4d06657c043713f$var$n(l)), !l || !$d4d06657c043713f$var$E(l)) {
                if (l = document.createElement("img"), l instanceof HTMLImageElement) {
                    let i = "", n = t.caption;
                    i = "string" == typeof n && n ? n.replace(/<[^>]+>/gi, "").substring(0, 1e3) : `Image ${t.index + 1} of ${(null === (o = a.carousel) || void 0 === o ? void 0 : o.pages.length) || 1}`, l.src = e || "", l.alt = i, l.draggable = !1, t.srcset && l.setAttribute("srcset", t.srcset), this.instance.isOpeningSlide(t) && (l.fetchPriority = "high");
                }
                t.sizes && l.setAttribute("sizes", t.sizes);
            }
            $d4d06657c043713f$var$P(l, "fancybox-image"), t.imageEl = l, a.setContent(t, l, !1);
            t.panzoom = new $d4d06657c043713f$export$b704d075ddd20210(r, $d4d06657c043713f$var$u({
                transformParent: !0
            }, this.option("Panzoom") || {}, {
                content: l,
                width: (e, i)=>a.optionFor(t, "width", "auto", i) || "auto",
                height: (e, i)=>a.optionFor(t, "height", "auto", i) || "auto",
                wheel: ()=>{
                    const t = a.option("wheel");
                    return ("zoom" === t || "pan" == t) && t;
                },
                click: (e, i)=>{
                    var n, s;
                    if (a.isCompact || a.isClosing()) return !1;
                    if (t.index !== (null === (n = a.getSlide()) || void 0 === n ? void 0 : n.index)) return !1;
                    if (i) {
                        const t = i.composedPath()[0];
                        if ([
                            "A",
                            "BUTTON",
                            "TEXTAREA",
                            "OPTION",
                            "INPUT",
                            "SELECT",
                            "VIDEO"
                        ].includes(t.nodeName)) return !1;
                    }
                    let o = !i || i.target && (null === (s = t.contentEl) || void 0 === s ? void 0 : s.contains(i.target));
                    return a.option(o ? "contentClick" : "backdropClick") || !1;
                },
                dblClick: ()=>a.isCompact ? "toggleZoom" : a.option("contentDblClick") || !1,
                spinner: !1,
                panOnlyZoomed: !0,
                wheelLimit: 1 / 0,
                on: {
                    ready: (t)=>{
                        i(t);
                    },
                    error: ()=>{
                        s();
                    },
                    destroy: ()=>{
                        s();
                    }
                }
            }));
        });
    }
    zoomIn(t) {
        return new Promise((e, i)=>{
            const n = this.instance, s = n.container, { panzoom: o, contentEl: a, el: r } = t;
            o && o.updateMetrics();
            const l = this.getZoomInfo(t);
            if (!(l && r && a && o && s)) return void i();
            const { x: c, y: h, scale: d, opacity: u } = l, p = ()=>{
                t.state !== $d4d06657c043713f$var$lt.Closing && (u && (a.style.opacity = Math.max(Math.min(1, 1 - (1 - o.scale) / (1 - d)), 0) + ""), o.scale >= 1 && o.scale > o.targetScale - .1 && e(o));
            }, f = (t)=>{
                (t.scale < .99 || t.scale > 1.01) && !t.isDragging || ($d4d06657c043713f$var$S(s, $d4d06657c043713f$var$yt), a.style.opacity = "", t.off("endAnimation", f), t.off("touchStart", f), t.off("afterTransform", p), e(t));
            };
            o.on("endAnimation", f), o.on("touchStart", f), o.on("afterTransform", p), o.on([
                "error",
                "destroy"
            ], ()=>{
                i();
            }), o.panTo({
                x: c,
                y: h,
                scale: d,
                friction: 0,
                ignoreBounds: !0
            }), o.stop("current");
            const g = {
                event: "mousemove" === o.panMode ? n.prevMouseMoveEvent || n.options.event : void 0
            }, m = this.optionFor(t, "initialSize");
            $d4d06657c043713f$var$P(s, $d4d06657c043713f$var$yt), n.hideLoading(t), "full" === m ? o.zoomToFull(g) : "cover" === m ? o.zoomToCover(g) : "max" === m ? o.zoomToMax(g) : o.reset(.172);
        });
    }
    getZoomInfo(t) {
        const { el: e, imageEl: i, thumbEl: n, panzoom: s } = t, o = this.instance, a = o.container;
        if (!e || !i || !n || !s || $d4d06657c043713f$var$tt(n) < 3 || !this.optionFor(t, "zoom") || !a || o.state === $d4d06657c043713f$var$rt.Destroy) return !1;
        if ("0" === getComputedStyle(a).getPropertyValue("--f-images-zoom")) return !1;
        const r = window.visualViewport || null;
        if (1 !== (r ? r.scale : 1)) return !1;
        let { top: l, left: c, width: h, height: d } = n.getBoundingClientRect(), { top: u, left: p, fitWidth: f, fitHeight: g } = s.contentRect;
        if (!(h && d && f && g)) return !1;
        const m = s.container.getBoundingClientRect();
        p += m.left, u += m.top;
        const v = -1 * (p + .5 * f - (c + .5 * h)), b = -1 * (u + .5 * g - (l + .5 * d)), y = h / f;
        let w = this.option("zoomOpacity") || !1;
        return "auto" === w && (w = Math.abs(h / d - f / g) > .1), {
            x: v,
            y: b,
            scale: y,
            opacity: w
        };
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.change", t.onChange), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.removeSlide", t.onRemoveSlide), e.on("close", t.onClose);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.change", t.onChange), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.removeSlide", t.onRemoveSlide), e.off("close", t.onClose);
    }
}
Object.defineProperty($d4d06657c043713f$var$wt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        initialSize: "fit",
        Panzoom: {
            maxScale: 1
        },
        protected: !1,
        zoom: !0,
        zoomOpacity: "auto"
    }
}), "function" == typeof SuppressedError && SuppressedError;
const $d4d06657c043713f$var$xt = "html", $d4d06657c043713f$var$Et = "image", $d4d06657c043713f$var$St = "map", $d4d06657c043713f$var$Pt = "youtube", $d4d06657c043713f$var$Ct = "vimeo", $d4d06657c043713f$var$Tt = "html5video", $d4d06657c043713f$var$Mt = (t, e = {})=>{
    const i = new URL(t), n = new URLSearchParams(i.search), s = new URLSearchParams;
    for (const [t, i] of [
        ...n,
        ...Object.entries(e)
    ]){
        let e = i + "";
        if ("t" === t) {
            let t = e.match(/((\d*)m)?(\d*)s?/);
            t && s.set("start", 60 * parseInt(t[2] || "0") + parseInt(t[3] || "0") + "");
        } else s.set(t, e);
    }
    let o = s + "", a = t.match(/#t=((.*)?\d+s)/);
    return a && (o += `#t=${a[1]}`), o;
}, $d4d06657c043713f$var$Ot = {
    ajax: null,
    autoSize: !0,
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto"
    },
    preload: !0,
    videoAutoplay: !0,
    videoRatio: 16 / 9,
    videoTpl: '<video class="fancybox__html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n  <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
    videoFormat: "",
    vimeo: {
        byline: 1,
        color: "00adef",
        controls: 1,
        dnt: 1,
        muted: 0
    },
    youtube: {
        controls: 1,
        enablejsapi: 1,
        nocookie: 1,
        rel: 0,
        fs: 1
    }
}, $d4d06657c043713f$var$At = [
    "image",
    "html",
    "ajax",
    "inline",
    "clone",
    "iframe",
    "map",
    "pdf",
    "html5video",
    "youtube",
    "vimeo"
];
class $d4d06657c043713f$var$Lt extends $d4d06657c043713f$var$_ {
    onBeforeInitSlide(t, e, i) {
        this.processType(i);
    }
    onCreateSlide(t, e, i) {
        this.setContent(i);
    }
    onClearContent(t, e) {
        e.xhr && (e.xhr.abort(), e.xhr = null);
        const i = e.iframeEl;
        i && (i.onload = i.onerror = null, i.src = "//about:blank", e.iframeEl = null);
        const n = e.contentEl, s = e.placeholderEl;
        if ("inline" === e.type && n && s) n.classList.remove("fancybox__content"), "none" !== getComputedStyle(n).getPropertyValue("display") && (n.style.display = "none"), setTimeout(()=>{
            s && (n && s.parentNode && s.parentNode.insertBefore(n, s), s.remove());
        }, 0), e.contentEl = void 0, e.placeholderEl = void 0;
        else for(; e.el && e.el.firstChild;)e.el.removeChild(e.el.firstChild);
    }
    onSelectSlide(t, e, i) {
        i.state === $d4d06657c043713f$var$lt.Ready && this.playVideo();
    }
    onUnselectSlide(t, e, i) {
        var n, s;
        if (i.type === $d4d06657c043713f$var$Tt) {
            try {
                null === (s = null === (n = i.el) || void 0 === n ? void 0 : n.querySelector("video")) || void 0 === s || s.pause();
            } catch (t) {}
            return;
        }
        let o;
        i.type === $d4d06657c043713f$var$Ct ? o = {
            method: "pause",
            value: "true"
        } : i.type === $d4d06657c043713f$var$Pt && (o = {
            event: "command",
            func: "pauseVideo"
        }), o && i.iframeEl && i.iframeEl.contentWindow && i.iframeEl.contentWindow.postMessage(JSON.stringify(o), "*"), i.poller && clearTimeout(i.poller);
    }
    onDone(t, e) {
        t.isCurrentSlide(e) && !t.isClosing() && this.playVideo();
    }
    onRefresh(t, e) {
        e.slides.forEach((t)=>{
            t.el && (this.resizeIframe(t), this.setAspectRatio(t));
        });
    }
    onMessage(t) {
        try {
            let e = JSON.parse(t.data);
            if ("https://player.vimeo.com" === t.origin) {
                if ("ready" === e.event) for (let e of Array.from(document.getElementsByClassName("fancybox__iframe")))e instanceof HTMLIFrameElement && e.contentWindow === t.source && (e.dataset.ready = "true");
            } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === e.event) {
                const t = document.getElementById(e.id);
                t && (t.dataset.ready = "true");
            }
        } catch (t) {}
    }
    loadAjaxContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        this.instance.showLoading(t);
        const i = this.instance, n = new XMLHttpRequest;
        i.showLoading(t), n.onreadystatechange = function() {
            n.readyState === XMLHttpRequest.DONE && i.state === $d4d06657c043713f$var$rt.Ready && (i.hideLoading(t), 200 === n.status ? i.setContent(t, n.responseText) : i.setError(t, 404 === n.status ? "{{AJAX_NOT_FOUND}}" : "{{AJAX_FORBIDDEN}}"));
        };
        const s = t.ajax || null;
        n.open(s ? "POST" : "GET", e + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(s), t.xhr = n;
    }
    setInlineContent(t) {
        let e = null;
        if ($d4d06657c043713f$var$E(t.src)) e = t.src;
        else if ("string" == typeof t.src) {
            const i = t.src.split("#", 2).pop();
            e = i ? document.getElementById(i) : null;
        }
        if (e) {
            if ("clone" === t.type || e.closest(".fancybox__slide")) {
                e = e.cloneNode(!0);
                const i = e.dataset.animationName;
                i && (e.classList.remove(i), delete e.dataset.animationName);
                let n = e.getAttribute("id");
                n = n ? `${n}--clone` : `clone-${this.instance.id}-${t.index}`, e.setAttribute("id", n);
            } else if (e.parentNode) {
                const i = document.createElement("div");
                i.classList.add("fancybox-placeholder"), e.parentNode.insertBefore(i, e), t.placeholderEl = i;
            }
            this.instance.setContent(t, e);
        } else this.instance.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    setIframeContent(t) {
        const { src: e, el: i } = t;
        if (!e || "string" != typeof e || !i) return;
        i.classList.add("is-loading");
        const n = this.instance, s = document.createElement("iframe");
        s.className = "fancybox__iframe", s.setAttribute("id", `fancybox__iframe_${n.id}_${t.index}`);
        for (const [e, i] of Object.entries(this.optionFor(t, "iframeAttr") || {}))s.setAttribute(e, i);
        s.onerror = ()=>{
            n.setError(t, "{{IFRAME_ERROR}}");
        }, t.iframeEl = s;
        const o = this.optionFor(t, "preload");
        if ("iframe" !== t.type || !1 === o) return s.setAttribute("src", t.src + ""), n.setContent(t, s, !1), this.resizeIframe(t), void n.revealContent(t);
        n.showLoading(t), s.onload = ()=>{
            if (!s.src.length) return;
            const e = "true" !== s.dataset.ready;
            s.dataset.ready = "true", this.resizeIframe(t), e ? n.revealContent(t) : n.hideLoading(t);
        }, s.setAttribute("src", e), n.setContent(t, s, !1);
    }
    resizeIframe(t) {
        const { type: e, iframeEl: i } = t;
        if (e === $d4d06657c043713f$var$Pt || e === $d4d06657c043713f$var$Ct) return;
        const n = null == i ? void 0 : i.parentElement;
        if (!i || !n) return;
        let s = t.autoSize;
        void 0 === s && (s = this.optionFor(t, "autoSize"));
        let o = t.width || 0, a = t.height || 0;
        o && a && (s = !1);
        const r = n && n.style;
        if (!1 !== t.preload && !1 !== s && r) try {
            const t = window.getComputedStyle(n), e = parseFloat(t.paddingLeft) + parseFloat(t.paddingRight), s = parseFloat(t.paddingTop) + parseFloat(t.paddingBottom), l = i.contentWindow;
            if (l) {
                const t = l.document, i = t.getElementsByTagName($d4d06657c043713f$var$xt)[0], n = t.body;
                r.width = "", n.style.overflow = "hidden", o = o || i.scrollWidth + e, r.width = `${o}px`, n.style.overflow = "", r.flex = "0 0 auto", r.height = `${n.scrollHeight}px`, a = i.scrollHeight + s;
            }
        } catch (t) {}
        if (o || a) {
            const t = {
                flex: "0 1 auto",
                width: "",
                height: ""
            };
            o && "auto" !== o && (t.width = `${o}px`), a && "auto" !== a && (t.height = `${a}px`), Object.assign(r, t);
        }
    }
    playVideo() {
        const t = this.instance.getSlide();
        if (!t) return;
        const { el: e } = t;
        if (!e || !e.offsetParent) return;
        if (!this.optionFor(t, "videoAutoplay")) return;
        if (t.type === $d4d06657c043713f$var$Tt) try {
            const t = e.querySelector("video");
            if (t) {
                const e = t.play();
                void 0 !== e && e.then(()=>{}).catch((e)=>{
                    t.muted = !0, t.play();
                });
            }
        } catch (t) {}
        if (t.type !== $d4d06657c043713f$var$Pt && t.type !== $d4d06657c043713f$var$Ct) return;
        const i = ()=>{
            if (t.iframeEl && t.iframeEl.contentWindow) {
                let e;
                if ("true" === t.iframeEl.dataset.ready) return e = t.type === $d4d06657c043713f$var$Pt ? {
                    event: "command",
                    func: "playVideo"
                } : {
                    method: "play",
                    value: "true"
                }, e && t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"), void (t.poller = void 0);
                t.type === $d4d06657c043713f$var$Pt && (e = {
                    event: "listening",
                    id: t.iframeEl.getAttribute("id")
                }, t.iframeEl.contentWindow.postMessage(JSON.stringify(e), "*"));
            }
            t.poller = setTimeout(i, 250);
        };
        i();
    }
    processType(t) {
        if (t.html) return t.type = $d4d06657c043713f$var$xt, t.src = t.html, void (t.html = "");
        const e = this.instance.optionFor(t, "src", "");
        if (!e || "string" != typeof e) return;
        let i = t.type, n = null;
        if (n = e.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i)) {
            const s = this.optionFor(t, $d4d06657c043713f$var$Pt), { nocookie: o } = s, a = function(t, e) {
                var i = {};
                for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && e.indexOf(n) < 0 && (i[n] = t[n]);
                if (null != t && "function" == typeof Object.getOwnPropertySymbols) {
                    var s = 0;
                    for(n = Object.getOwnPropertySymbols(t); s < n.length; s++)e.indexOf(n[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, n[s]) && (i[n[s]] = t[n[s]]);
                }
                return i;
            }(s, [
                "nocookie"
            ]), r = `www.youtube${o ? "-nocookie" : ""}.com`, l = $d4d06657c043713f$var$Mt(e, a), c = encodeURIComponent(n[2]);
            t.videoId = c, t.src = `https://${r}/embed/${c}?${l}`, t.thumbSrc = t.thumbSrc || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`, i = $d4d06657c043713f$var$Pt;
        } else if (n = e.match(/^.+vimeo.com\/(?:\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/)) {
            const s = $d4d06657c043713f$var$Mt(e, this.optionFor(t, $d4d06657c043713f$var$Ct)), o = encodeURIComponent(n[1]), a = n[4] || "";
            t.videoId = o, t.src = `https://player.vimeo.com/video/${o}?${a ? `h=${a}${s ? "&" : ""}` : ""}${s}`, i = $d4d06657c043713f$var$Ct;
        }
        if (!i && t.triggerEl) {
            const e = t.triggerEl.dataset.type;
            $d4d06657c043713f$var$At.includes(e) && (i = e);
        }
        i || "string" == typeof e && ("#" === e.charAt(0) ? i = "inline" : (n = e.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (i = $d4d06657c043713f$var$Tt, t.videoFormat = t.videoFormat || "video/" + ("ogv" === n[1] ? "ogg" : n[1])) : e.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? i = $d4d06657c043713f$var$Et : e.match(/\.(pdf)((\?|#).*)?$/i) && (i = "pdf")), (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i)) ? (t.src = `https://maps.google.${n[1]}/?ll=${(n[2] ? n[2] + "&z=" + Math.floor(parseFloat(n[3])) + (n[4] ? n[4].replace(/^\//, "&") : "") : n[4] + "").replace(/\?/, "&")}&output=${n[4] && n[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, i = $d4d06657c043713f$var$St) : (n = e.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i)) && (t.src = `https://maps.google.${n[1]}/maps?q=${n[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, i = $d4d06657c043713f$var$St), i = i || this.instance.option("defaultType"), t.type = i, i === $d4d06657c043713f$var$Et && (t.thumbSrc = t.thumbSrc || t.src);
    }
    setContent(t) {
        const e = this.instance.optionFor(t, "src") || "";
        if (t && t.type && e) {
            switch(t.type){
                case $d4d06657c043713f$var$xt:
                    this.instance.setContent(t, e);
                    break;
                case $d4d06657c043713f$var$Tt:
                    const i = this.option("videoTpl");
                    i && this.instance.setContent(t, i.replace(/\{\{src\}\}/gi, e + "").replace(/\{\{format\}\}/gi, this.optionFor(t, "videoFormat") || "").replace(/\{\{poster\}\}/gi, t.poster || t.thumbSrc || ""));
                    break;
                case "inline":
                case "clone":
                    this.setInlineContent(t);
                    break;
                case "ajax":
                    this.loadAjaxContent(t);
                    break;
                case "pdf":
                case $d4d06657c043713f$var$St:
                case $d4d06657c043713f$var$Pt:
                case $d4d06657c043713f$var$Ct:
                    t.preload = !1;
                case "iframe":
                    this.setIframeContent(t);
            }
            this.setAspectRatio(t);
        }
    }
    setAspectRatio(t) {
        const e = t.contentEl;
        if (!(t.el && e && t.type && [
            $d4d06657c043713f$var$Pt,
            $d4d06657c043713f$var$Ct,
            $d4d06657c043713f$var$Tt
        ].includes(t.type))) return;
        let i, n = t.width || "auto", s = t.height || "auto";
        if ("auto" === n || "auto" === s) {
            i = this.optionFor(t, "videoRatio");
            const e = (i + "").match(/(\d+)\s*\/\s?(\d+)/);
            i = e && e.length > 2 ? parseFloat(e[1]) / parseFloat(e[2]) : parseFloat(i + "");
        } else n && s && (i = n / s);
        if (!i) return;
        e.style.aspectRatio = "", e.style.width = "", e.style.height = "", e.offsetHeight;
        const o = e.getBoundingClientRect(), a = o.width || 1, r = o.height || 1;
        e.style.aspectRatio = i + "", i < a / r ? (s = "auto" === s ? r : Math.min(r, s), e.style.width = "auto", e.style.height = `${s}px`) : (n = "auto" === n ? a : Math.min(a, n), e.style.width = `${n}px`, e.style.height = "auto");
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.on("Carousel.createSlide", t.onCreateSlide), e.on("Carousel.selectSlide", t.onSelectSlide), e.on("Carousel.unselectSlide", t.onUnselectSlide), e.on("Carousel.Panzoom.refresh", t.onRefresh), e.on("done", t.onDone), e.on("clearContent", t.onClearContent), window.addEventListener("message", t.onMessage);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.beforeInitSlide", t.onBeforeInitSlide), e.off("Carousel.createSlide", t.onCreateSlide), e.off("Carousel.selectSlide", t.onSelectSlide), e.off("Carousel.unselectSlide", t.onUnselectSlide), e.off("Carousel.Panzoom.refresh", t.onRefresh), e.off("done", t.onDone), e.off("clearContent", t.onClearContent), window.removeEventListener("message", t.onMessage);
    }
}
Object.defineProperty($d4d06657c043713f$var$Lt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$Ot
});
const $d4d06657c043713f$var$zt = "play", $d4d06657c043713f$var$Rt = "pause", $d4d06657c043713f$var$kt = "ready";
class $d4d06657c043713f$var$It extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$kt
        }), Object.defineProperty(this, "inHover", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "timer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "progressBar", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    get isActive() {
        return this.state !== $d4d06657c043713f$var$kt;
    }
    onReady(t) {
        this.option("autoStart") && (t.isInfinite || t.page < t.pages.length - 1) && this.start();
    }
    onChange() {
        this.removeProgressBar(), this.pause();
    }
    onSettle() {
        this.resume();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.resume() : this.pause();
    }
    onMouseEnter() {
        this.inHover = !0, this.pause();
    }
    onMouseLeave() {
        var t;
        this.inHover = !1, (null === (t = this.instance.panzoom) || void 0 === t ? void 0 : t.isResting) && this.resume();
    }
    onTimerEnd() {
        const t = this.instance;
        "play" === this.state && (t.isInfinite || t.page !== t.pages.length - 1 ? t.slideNext() : t.slideTo(0));
    }
    removeProgressBar() {
        this.progressBar && (this.progressBar.remove(), this.progressBar = null);
    }
    createProgressBar() {
        var t;
        if (!this.option("showProgress")) return null;
        this.removeProgressBar();
        const e = this.instance, i = (null === (t = e.pages[e.page]) || void 0 === t ? void 0 : t.slides) || [];
        let n = this.option("progressParentEl");
        if (n || (n = (1 === i.length ? i[0].el : null) || e.viewport), !n) return null;
        const s = document.createElement("div");
        return $d4d06657c043713f$var$P(s, "f-progress"), n.prepend(s), this.progressBar = s, s.offsetHeight, s;
    }
    set() {
        const t = this, e = t.instance;
        if (e.pages.length < 2) return;
        if (t.timer) return;
        const i = t.option("timeout");
        t.state = $d4d06657c043713f$var$zt, $d4d06657c043713f$var$P(e.container, "has-autoplay");
        let n = t.createProgressBar();
        n && (n.style.transitionDuration = `${i}ms`, n.style.transform = "scaleX(1)"), t.timer = setTimeout(()=>{
            t.timer = null, t.inHover || t.onTimerEnd();
        }, i), t.emit("set");
    }
    clear() {
        const t = this;
        t.timer && (clearTimeout(t.timer), t.timer = null), t.removeProgressBar();
    }
    start() {
        const t = this;
        if (t.set(), t.state !== $d4d06657c043713f$var$kt) {
            if (t.option("pauseOnHover")) {
                const e = t.instance.container;
                e.addEventListener("mouseenter", t.onMouseEnter, !1), e.addEventListener("mouseleave", t.onMouseLeave, !1);
            }
            document.addEventListener("visibilitychange", t.onVisibilityChange, !1), t.emit("start");
        }
    }
    stop() {
        const t = this, e = t.state, i = t.instance.container;
        t.clear(), t.state = $d4d06657c043713f$var$kt, i.removeEventListener("mouseenter", t.onMouseEnter, !1), i.removeEventListener("mouseleave", t.onMouseLeave, !1), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), $d4d06657c043713f$var$S(i, "has-autoplay"), e !== $d4d06657c043713f$var$kt && t.emit("stop");
    }
    pause() {
        const t = this;
        t.state === $d4d06657c043713f$var$zt && (t.state = $d4d06657c043713f$var$Rt, t.clear(), t.emit($d4d06657c043713f$var$Rt));
    }
    resume() {
        const t = this, e = t.instance;
        if (e.isInfinite || e.page !== e.pages.length - 1) {
            if (t.state !== $d4d06657c043713f$var$zt) {
                if (t.state === $d4d06657c043713f$var$Rt && !t.inHover) {
                    const e = new Event("resume", {
                        bubbles: !0,
                        cancelable: !0
                    });
                    t.emit("resume", e), e.defaultPrevented || t.set();
                }
            } else t.set();
        } else t.stop();
    }
    toggle() {
        this.state === $d4d06657c043713f$var$zt || this.state === $d4d06657c043713f$var$Rt ? this.stop() : this.start();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("ready", t.onReady), e.on("Panzoom.startAnimation", t.onChange), e.on("Panzoom.endAnimation", t.onSettle), e.on("Panzoom.touchMove", t.onChange);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("ready", t.onReady), e.off("Panzoom.startAnimation", t.onChange), e.off("Panzoom.endAnimation", t.onSettle), e.off("Panzoom.touchMove", t.onChange), t.stop();
    }
}
Object.defineProperty($d4d06657c043713f$var$It, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        autoStart: !0,
        pauseOnHover: !0,
        progressParentEl: null,
        showProgress: !0,
        timeout: 3e3
    }
});
class $d4d06657c043713f$var$Dt extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onPrepare(t) {
        const e = t.carousel;
        if (!e) return;
        const i = t.container;
        i && (e.options.Autoplay = $d4d06657c043713f$var$u({
            autoStart: !1
        }, this.option("Autoplay") || {}, {
            pauseOnHover: !1,
            timeout: this.option("timeout"),
            progressParentEl: ()=>this.option("progressParentEl") || null,
            on: {
                start: ()=>{
                    t.emit("startSlideshow");
                },
                set: (e)=>{
                    var n;
                    i.classList.add("has-slideshow"), (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) !== $d4d06657c043713f$var$lt.Ready && e.pause();
                },
                stop: ()=>{
                    i.classList.remove("has-slideshow"), t.isCompact || t.endIdle(), t.emit("endSlideshow");
                },
                resume: (e, i)=>{
                    var n, s, o;
                    !i || !i.cancelable || (null === (n = t.getSlide()) || void 0 === n ? void 0 : n.state) === $d4d06657c043713f$var$lt.Ready && (null === (o = null === (s = t.carousel) || void 0 === s ? void 0 : s.panzoom) || void 0 === o ? void 0 : o.isResting) || i.preventDefault();
                }
            }
        }), e.attachPlugins({
            Autoplay: $d4d06657c043713f$var$It
        }), this.ref = e.plugins.Autoplay);
    }
    onReady(t) {
        const e = t.carousel, i = this.ref;
        i && e && this.option("playOnStart") && (e.isInfinite || e.page < e.pages.length - 1) && i.start();
    }
    onDone(t, e) {
        const i = this.ref, n = t.carousel;
        if (!i || !n) return;
        const s = e.panzoom;
        s && s.on("startAnimation", ()=>{
            t.isCurrentSlide(e) && i.stop();
        }), t.isCurrentSlide(e) && i.resume();
    }
    onKeydown(t, e) {
        var i;
        const n = this.ref;
        n && e === this.option("key") && "BUTTON" !== (null === (i = document.activeElement) || void 0 === i ? void 0 : i.nodeName) && n.toggle();
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.init", t.onPrepare), e.on("Carousel.ready", t.onReady), e.on("done", t.onDone), e.on("keydown", t.onKeydown);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.init", t.onPrepare), e.off("Carousel.ready", t.onReady), e.off("done", t.onDone), e.off("keydown", t.onKeydown);
    }
}
Object.defineProperty($d4d06657c043713f$var$Dt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: {
        key: " ",
        playOnStart: !1,
        progressParentEl: (t)=>{
            var e;
            return (null === (e = t.instance.container) || void 0 === e ? void 0 : e.querySelector(".fancybox__toolbar [data-fancybox-toggle-slideshow]")) || t.instance.container;
        },
        timeout: 3e3
    }
});
const $d4d06657c043713f$var$Ft = {
    classes: {
        container: "f-thumbs f-carousel__thumbs",
        viewport: "f-thumbs__viewport",
        track: "f-thumbs__track",
        slide: "f-thumbs__slide",
        isResting: "is-resting",
        isSelected: "is-selected",
        isLoading: "is-loading",
        hasThumbs: "has-thumbs"
    },
    minCount: 2,
    parentEl: null,
    thumbTpl: '<button class="f-thumbs__slide__button" tabindex="0" type="button" aria-label="{{GOTO}}" data-carousel-index="%i"><img class="f-thumbs__slide__img" data-lazy-src="{{%s}}" alt="" /></button>',
    type: "modern"
};
var $d4d06657c043713f$var$jt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Hidden = 2] = "Hidden";
}($d4d06657c043713f$var$jt || ($d4d06657c043713f$var$jt = {}));
const $d4d06657c043713f$var$Bt = "isResting", $d4d06657c043713f$var$Ht = "thumbWidth", $d4d06657c043713f$var$Nt = "thumbHeight", $d4d06657c043713f$var$_t = "thumbClipWidth";
let $d4d06657c043713f$var$$t = class extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "type", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: "modern"
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "track", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "thumbWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbClipWidth", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbHeight", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "thumbExtraGap", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$jt.Init
        });
    }
    get isModern() {
        return "modern" === this.type;
    }
    onInitSlide(t, e) {
        const i = e.el ? e.el.dataset : void 0;
        i && (e.thumbSrc = i.thumbSrc || e.thumbSrc || "", e[$d4d06657c043713f$var$_t] = parseFloat(i[$d4d06657c043713f$var$_t] || "") || e[$d4d06657c043713f$var$_t] || 0, e[$d4d06657c043713f$var$Nt] = parseFloat(i.thumbHeight || "") || e[$d4d06657c043713f$var$Nt] || 0), this.addSlide(e);
    }
    onInitSlides() {
        this.build();
    }
    onChange() {
        var t;
        if (!this.isModern) return;
        const e = this.container, i = this.instance, n = i.panzoom, s = this.carousel, a = s ? s.panzoom : null, r = i.page;
        if (n && s && a) {
            if (n.isDragging) {
                $d4d06657c043713f$var$S(e, this.cn($d4d06657c043713f$var$Bt));
                let n = (null === (t = s.pages[r]) || void 0 === t ? void 0 : t.pos) || 0;
                n += i.getProgress(r) * (this[$d4d06657c043713f$var$_t] + this.thumbGap);
                let o = a.getBounds();
                -1 * n > o.x.min && -1 * n < o.x.max && a.panTo({
                    x: -1 * n,
                    friction: .12
                });
            } else $d4d06657c043713f$var$o(e, this.cn($d4d06657c043713f$var$Bt), n.isResting);
            this.shiftModern();
        }
    }
    onRefresh() {
        this.updateProps();
        for (const t of this.instance.slides || [])this.resizeModernSlide(t);
        this.shiftModern();
    }
    isDisabled() {
        const t = this.option("minCount") || 0;
        if (t) {
            const e = this.instance;
            let i = 0;
            for (const t of e.slides || [])t.thumbSrc && i++;
            if (i < t) return !0;
        }
        const e = this.option("type");
        return [
            "modern",
            "classic"
        ].indexOf(e) < 0;
    }
    getThumb(t) {
        const e = this.option("thumbTpl") || "";
        return {
            html: this.instance.localize(e, [
                [
                    "%i",
                    t.index
                ],
                [
                    "%d",
                    t.index + 1
                ],
                [
                    "%s",
                    t.thumbSrc || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
                ]
            ])
        };
    }
    addSlide(t) {
        const e = this.carousel;
        e && e.addSlide(t.index, this.getThumb(t));
    }
    getSlides() {
        const t = [];
        for (const e of this.instance.slides || [])t.push(this.getThumb(e));
        return t;
    }
    resizeModernSlide(t) {
        this.isModern && (t[$d4d06657c043713f$var$Ht] = t[$d4d06657c043713f$var$_t] && t[$d4d06657c043713f$var$Nt] ? Math.round(this[$d4d06657c043713f$var$Nt] * (t[$d4d06657c043713f$var$_t] / t[$d4d06657c043713f$var$Nt])) : this[$d4d06657c043713f$var$Ht]);
    }
    updateProps() {
        const t = this.container;
        if (!t) return;
        const e = (e)=>parseFloat(getComputedStyle(t).getPropertyValue("--f-thumb-" + e)) || 0;
        this.thumbGap = e("gap"), this.thumbExtraGap = e("extra-gap"), this[$d4d06657c043713f$var$Ht] = e("width") || 40, this[$d4d06657c043713f$var$_t] = e("clip-width") || 40, this[$d4d06657c043713f$var$Nt] = e("height") || 40;
    }
    build() {
        const t = this;
        if (t.state !== $d4d06657c043713f$var$jt.Init) return;
        if (t.isDisabled()) return void t.emit("disabled");
        const e = t.instance, i = e.container, n = t.getSlides(), s = t.option("type");
        t.type = s;
        const o = t.option("parentEl"), a = t.cn("container"), r = t.cn("track");
        let l = null == o ? void 0 : o.querySelector("." + a);
        l || (l = document.createElement("div"), $d4d06657c043713f$var$P(l, a), o ? o.appendChild(l) : i.after(l)), $d4d06657c043713f$var$P(l, `is-${s}`), $d4d06657c043713f$var$P(i, t.cn("hasThumbs")), t.container = l, t.updateProps();
        let c = l.querySelector("." + r);
        c || (c = document.createElement("div"), $d4d06657c043713f$var$P(c, t.cn("track")), l.appendChild(c)), t.track = c;
        const h = $d4d06657c043713f$var$u({}, {
            track: c,
            infinite: !1,
            center: !0,
            fill: "classic" === s,
            dragFree: !0,
            slidesPerPage: 1,
            transition: !1,
            preload: .25,
            friction: .12,
            Panzoom: {
                maxVelocity: 0
            },
            Dots: !1,
            Navigation: !1,
            classes: {
                container: "f-thumbs",
                viewport: "f-thumbs__viewport",
                track: "f-thumbs__track",
                slide: "f-thumbs__slide"
            }
        }, t.option("Carousel") || {}, {
            Sync: {
                target: e
            },
            slides: n
        }), d = new e.constructor(l, h);
        d.on("createSlide", (e, i)=>{
            t.setProps(i.index), t.emit("createSlide", i, i.el);
        }), d.on("ready", ()=>{
            t.shiftModern(), t.emit("ready");
        }), d.on("refresh", ()=>{
            t.shiftModern();
        }), d.on("Panzoom.click", (e, i, n)=>{
            t.onClick(n);
        }), t.carousel = d, t.state = $d4d06657c043713f$var$jt.Ready;
    }
    onClick(t) {
        t.preventDefault(), t.stopPropagation();
        const e = this.instance, { pages: i, page: n } = e, s = (t)=>{
            if (t) {
                const e = t.closest("[data-carousel-index]");
                if (e) return [
                    parseInt(e.dataset.carouselIndex || "", 10) || 0,
                    e
                ];
            }
            return [
                -1,
                void 0
            ];
        }, o = (t, e)=>{
            const i = document.elementFromPoint(t, e);
            return i ? s(i) : [
                -1,
                void 0
            ];
        };
        let [a, r] = s(t.target);
        if (a > -1) return;
        const l = this[$d4d06657c043713f$var$_t], c = t.clientX, h = t.clientY;
        let [d, u] = o(c - l, h), [p, f] = o(c + l, h);
        u && f ? (a = Math.abs(c - u.getBoundingClientRect().right) < Math.abs(c - f.getBoundingClientRect().left) ? d : p, a === n && (a = a === d ? p : d)) : u ? a = d : f && (a = p), a > -1 && i[a] && e.slideTo(a);
    }
    getShift(t) {
        var e;
        const i = this, { instance: n } = i, s = i.carousel;
        if (!n || !s) return 0;
        const o = i[$d4d06657c043713f$var$Ht], a = i[$d4d06657c043713f$var$_t], r = i.thumbGap, l = i.thumbExtraGap;
        if (!(null === (e = s.slides[t]) || void 0 === e ? void 0 : e.el)) return 0;
        const c = .5 * (o - a), h = n.pages.length - 1;
        let d = n.getProgress(0), u = n.getProgress(h), p = n.getProgress(t, !1, !0), f = 0, g = c + l + r;
        const m = d < 0 && d > -1, v = u > 0 && u < 1;
        return 0 === t ? (f = g * Math.abs(d), v && 1 === d && (f -= g * Math.abs(u))) : t === h ? (f = g * Math.abs(u) * -1, m && -1 === u && (f += g * Math.abs(d))) : m || v ? (f = -1 * g, f += g * Math.abs(d), f += g * (1 - Math.abs(u))) : f = g * p, f;
    }
    setProps(e) {
        var i;
        const n = this;
        if (!n.isModern) return;
        const { instance: s } = n, o = n.carousel;
        if (s && o) {
            const a = null === (i = o.slides[e]) || void 0 === i ? void 0 : i.el;
            if (a && a.childNodes.length) {
                let i = $d4d06657c043713f$var$t(1 - Math.abs(s.getProgress(e))), o = $d4d06657c043713f$var$t(n.getShift(e));
                a.style.setProperty("--progress", i ? i + "" : ""), a.style.setProperty("--shift", o + "");
            }
        }
    }
    shiftModern() {
        const t = this;
        if (!t.isModern) return;
        const { instance: e, track: i } = t, n = e.panzoom, s = t.carousel;
        if (!(e && i && n && s)) return;
        if (n.state === $d4d06657c043713f$var$m.Init || n.state === $d4d06657c043713f$var$m.Destroy) return;
        for (const i of e.slides)t.setProps(i.index);
        let o = (t[$d4d06657c043713f$var$_t] + t.thumbGap) * (s.slides.length || 0);
        i.style.setProperty("--width", o + "");
    }
    cleanup() {
        const t = this;
        t.carousel && t.carousel.destroy(), t.carousel = null, t.container && t.container.remove(), t.container = null, t.track && t.track.remove(), t.track = null, t.state = $d4d06657c043713f$var$jt.Init, $d4d06657c043713f$var$S(t.instance.container, t.cn("hasThumbs"));
    }
    attach() {
        const t = this, e = t.instance;
        e.on("initSlide", t.onInitSlide), e.state === $d4d06657c043713f$var$B.Init ? e.on("initSlides", t.onInitSlides) : t.onInitSlides(), e.on([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.on("Panzoom.refresh", t.onRefresh);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("initSlide", t.onInitSlide), e.off("initSlides", t.onInitSlides), e.off([
            "change",
            "Panzoom.afterTransform"
        ], t.onChange), e.off("Panzoom.refresh", t.onRefresh), t.cleanup();
    }
};
Object.defineProperty($d4d06657c043713f$var$$t, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$Ft
});
const $d4d06657c043713f$var$Wt = Object.assign(Object.assign({}, $d4d06657c043713f$var$Ft), {
    key: "t",
    showOnStart: !0,
    parentEl: null
}), $d4d06657c043713f$var$Xt = "is-masked", $d4d06657c043713f$var$qt = "aria-hidden";
class $d4d06657c043713f$var$Yt extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "ref", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "hidden", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        });
    }
    get isEnabled() {
        const t = this.ref;
        return t && !t.isDisabled();
    }
    get isHidden() {
        return this.hidden;
    }
    onClick(t, e) {
        e.stopPropagation();
    }
    onCreateSlide(t, e) {
        var i, n, s;
        const o = (null === (s = null === (n = null === (i = this.instance) || void 0 === i ? void 0 : i.carousel) || void 0 === n ? void 0 : n.slides[e.index]) || void 0 === s ? void 0 : s.type) || "", a = e.el;
        if (a && o) {
            let t = `for-${o}`;
            [
                "video",
                "youtube",
                "vimeo",
                "html5video"
            ].includes(o) && (t += " for-video"), $d4d06657c043713f$var$P(a, t);
        }
    }
    onInit() {
        var t;
        const e = this, i = e.instance, n = i.carousel;
        if (e.ref || !n) return;
        const s = e.option("parentEl") || i.footer || i.container;
        if (!s) return;
        const o = $d4d06657c043713f$var$u({}, e.options, {
            parentEl: s,
            classes: {
                container: "f-thumbs fancybox__thumbs"
            },
            Carousel: {
                Sync: {
                    friction: i.option("Carousel.friction") || 0
                }
            },
            on: {
                ready: (t)=>{
                    const i = t.container;
                    i && this.hidden && (e.refresh(), i.style.transition = "none", e.hide(), i.offsetHeight, queueMicrotask(()=>{
                        i.style.transition = "", e.show();
                    }));
                }
            }
        });
        o.Carousel = o.Carousel || {}, o.Carousel.on = $d4d06657c043713f$var$u((null === (t = e.options.Carousel) || void 0 === t ? void 0 : t.on) || {}, {
            click: this.onClick,
            createSlide: this.onCreateSlide
        }), n.options.Thumbs = o, n.attachPlugins({
            Thumbs: $d4d06657c043713f$var$$t
        }), e.ref = n.plugins.Thumbs, e.option("showOnStart") || (e.ref.state = $d4d06657c043713f$var$jt.Hidden, e.hidden = !0);
    }
    onResize() {
        var t;
        const e = null === (t = this.ref) || void 0 === t ? void 0 : t.container;
        e && (e.style.maxHeight = "");
    }
    onKeydown(t, e) {
        const i = this.option("key");
        i && i === e && this.toggle();
    }
    toggle() {
        const t = this.ref;
        if (t && !t.isDisabled()) return t.state === $d4d06657c043713f$var$jt.Hidden ? (t.state = $d4d06657c043713f$var$jt.Init, void t.build()) : void (this.hidden ? this.show() : this.hide());
    }
    show() {
        const t = this.ref;
        if (!t || t.isDisabled()) return;
        const e = t.container;
        e && (this.refresh(), e.offsetHeight, e.removeAttribute($d4d06657c043713f$var$qt), e.classList.remove($d4d06657c043713f$var$Xt), this.hidden = !1);
    }
    hide() {
        const t = this.ref, e = t && t.container;
        e && (this.refresh(), e.offsetHeight, e.classList.add($d4d06657c043713f$var$Xt), e.setAttribute($d4d06657c043713f$var$qt, "true")), this.hidden = !0;
    }
    refresh() {
        const t = this.ref;
        if (!t || !t.state) return;
        const e = t.container, i = (null == e ? void 0 : e.firstChild) || null;
        e && i && i.childNodes.length && (e.style.maxHeight = `${i.getBoundingClientRect().height}px`);
    }
    attach() {
        const t = this, e = t.instance;
        e.state === $d4d06657c043713f$var$rt.Init ? e.on("Carousel.init", t.onInit) : t.onInit(), e.on("resize", t.onResize), e.on("keydown", t.onKeydown);
    }
    detach() {
        var t;
        const e = this, i = e.instance;
        i.off("Carousel.init", e.onInit), i.off("resize", e.onResize), i.off("keydown", e.onKeydown), null === (t = i.carousel) || void 0 === t || t.detachPlugins([
            "Thumbs"
        ]), e.ref = null;
    }
}
Object.defineProperty($d4d06657c043713f$var$Yt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$Wt
});
const $d4d06657c043713f$var$Vt = {
    panLeft: {
        icon: '<svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg>',
        change: {
            panX: -100
        }
    },
    panRight: {
        icon: '<svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg>',
        change: {
            panX: 100
        }
    },
    panUp: {
        icon: '<svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg>',
        change: {
            panY: -100
        }
    },
    panDown: {
        icon: '<svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg>',
        change: {
            panY: 100
        }
    },
    zoomIn: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg>',
        action: "zoomIn"
    },
    zoomOut: {
        icon: '<svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "zoomOut"
    },
    toggle1to1: {
        icon: '<svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg>',
        action: "toggleZoom"
    },
    toggleZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "toggleZoom"
    },
    iterateZoom: {
        icon: '<svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg>',
        action: "iterateZoom"
    },
    rotateCCW: {
        icon: '<svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg>',
        action: "rotateCCW"
    },
    rotateCW: {
        icon: '<svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg>',
        action: "rotateCW"
    },
    flipX: {
        icon: '<svg style="stroke-width: 1.3"><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg>',
        action: "flipX"
    },
    flipY: {
        icon: '<svg style="stroke-width: 1.3"><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg>',
        action: "flipY"
    },
    fitX: {
        icon: '<svg><path d="M4 12V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v6M10 18H3M21 18h-7M6 15l-3 3 3 3M18 15l3 3-3 3"/></svg>',
        action: "fitX"
    },
    fitY: {
        icon: '<svg><path d="M12 20H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h6M18 14v7M18 3v7M15 18l3 3 3-3M15 6l3-3 3 3"/></svg>',
        action: "fitY"
    },
    reset: {
        icon: '<svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg>',
        action: "reset"
    },
    toggleFS: {
        icon: '<svg><g><path d="M14.5 9.5 21 3m0 0h-6m6 0v6M3 21l6.5-6.5M3 21v-6m0 6h6"/></g><g><path d="m14 10 7-7m-7 7h6m-6 0V4M3 21l7-7m0 0v6m0-6H4"/></g></svg>',
        action: "toggleFS"
    }
};
var $d4d06657c043713f$var$Zt;
!function(t) {
    t[t.Init = 0] = "Init", t[t.Ready = 1] = "Ready", t[t.Disabled = 2] = "Disabled";
}($d4d06657c043713f$var$Zt || ($d4d06657c043713f$var$Zt = {}));
const $d4d06657c043713f$var$Ut = {
    absolute: "auto",
    display: {
        left: [
            "infobar"
        ],
        middle: [],
        right: [
            "iterateZoom",
            "slideshow",
            "fullscreen",
            "thumbs",
            "close"
        ]
    },
    enabled: "auto",
    items: {
        infobar: {
            tpl: '<div class="fancybox__infobar" tabindex="-1"><span data-fancybox-current-index></span>/<span data-fancybox-count></span></div>'
        },
        download: {
            tpl: '<a class="f-button" title="{{DOWNLOAD}}" data-fancybox-download href="javasript:;"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></a>'
        },
        prev: {
            tpl: '<button class="f-button" title="{{PREV}}" data-fancybox-prev><svg><path d="m15 6-6 6 6 6"/></svg></button>'
        },
        next: {
            tpl: '<button class="f-button" title="{{NEXT}}" data-fancybox-next><svg><path d="m9 6 6 6-6 6"/></svg></button>'
        },
        slideshow: {
            tpl: '<button class="f-button" title="{{TOGGLE_SLIDESHOW}}" data-fancybox-toggle-slideshow><svg><g><path d="M8 4v16l13 -8z"></path></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
        },
        fullscreen: {
            tpl: '<button class="f-button" title="{{TOGGLE_FULLSCREEN}}" data-fancybox-toggle-fullscreen><svg><g><path d="M4 8V6a2 2 0 0 1 2-2h2M4 16v2a2 2 0 0 0 2 2h2M16 4h2a2 2 0 0 1 2 2v2M16 20h2a2 2 0 0 0 2-2v-2"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>'
        },
        thumbs: {
            tpl: '<button class="f-button" title="{{TOGGLE_THUMBS}}" data-fancybox-toggle-thumbs><svg><circle cx="5.5" cy="5.5" r="1"/><circle cx="12" cy="5.5" r="1"/><circle cx="18.5" cy="5.5" r="1"/><circle cx="5.5" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="18.5" cy="12" r="1"/><circle cx="5.5" cy="18.5" r="1"/><circle cx="12" cy="18.5" r="1"/><circle cx="18.5" cy="18.5" r="1"/></svg></button>'
        },
        close: {
            tpl: '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="m19.5 4.5-15 15M4.5 4.5l15 15"/></svg></button>'
        }
    },
    parentEl: null
}, $d4d06657c043713f$var$Gt = {
    tabindex: "-1",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
}, $d4d06657c043713f$var$Kt = "has-toolbar", $d4d06657c043713f$var$Jt = "fancybox__toolbar";
class $d4d06657c043713f$var$Qt extends $d4d06657c043713f$var$_ {
    constructor(){
        super(...arguments), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$Zt.Init
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        });
    }
    onReady(t) {
        var e;
        if (!t.carousel) return;
        let i = this.option("display"), n = this.option("absolute"), s = this.option("enabled");
        if ("auto" === s) {
            const t = this.instance.carousel;
            let e = 0;
            if (t) for (const i of t.slides)(i.panzoom || "image" === i.type) && e++;
            e || (s = !1);
        }
        s || (i = void 0);
        let o = 0;
        const a = {
            left: [],
            middle: [],
            right: []
        };
        if (i) for (const t of [
            "left",
            "middle",
            "right"
        ])for (const n of i[t]){
            const i = this.createEl(n);
            i && (null === (e = a[t]) || void 0 === e || e.push(i), o++);
        }
        let r = null;
        if (o && (r = this.createContainer()), r) {
            for (const [t, e] of Object.entries(a)){
                const i = document.createElement("div");
                $d4d06657c043713f$var$P(i, $d4d06657c043713f$var$Jt + "__column is-" + t);
                for (const t of e)i.appendChild(t);
                "auto" !== n || "middle" !== t || e.length || (n = !0), r.appendChild(i);
            }
            !0 === n && $d4d06657c043713f$var$P(r, "is-absolute"), this.state = $d4d06657c043713f$var$Zt.Ready, this.onRefresh();
        } else this.state = $d4d06657c043713f$var$Zt.Disabled;
    }
    onClick(t) {
        var e, i;
        const n = this.instance, s = n.getSlide(), o = null == s ? void 0 : s.panzoom, a = t.target, r = a && $d4d06657c043713f$var$E(a) ? a.dataset : null;
        if (!r) return;
        if (void 0 !== r.fancyboxToggleThumbs) return t.preventDefault(), t.stopPropagation(), void (null === (e = n.plugins.Thumbs) || void 0 === e || e.toggle());
        if (void 0 !== r.fancyboxToggleFullscreen) return t.preventDefault(), t.stopPropagation(), void this.instance.toggleFullscreen();
        if (void 0 !== r.fancyboxToggleSlideshow) {
            t.preventDefault(), t.stopPropagation();
            const e = null === (i = n.carousel) || void 0 === i ? void 0 : i.plugins.Autoplay;
            let s = e.isActive;
            return o && "mousemove" === o.panMode && !s && o.reset(), void (s ? e.stop() : e.start());
        }
        const l = r.panzoomAction, c = r.panzoomChange;
        if ((c || l) && (t.preventDefault(), t.stopPropagation()), c) {
            let t = {};
            try {
                t = JSON.parse(c);
            } catch (t) {}
            o && o.applyChange(t);
        } else l && o && o[l] && o[l]();
    }
    onChange() {
        this.onRefresh();
    }
    onRefresh() {
        if (this.instance.isClosing()) return;
        const t = this.container;
        if (!t) return;
        const e = this.instance.getSlide();
        if (!e || e.state !== $d4d06657c043713f$var$lt.Ready) return;
        const i = e && !e.error && e.panzoom;
        for (const e of t.querySelectorAll("[data-panzoom-action]"))i ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        let n = i && i.canZoomIn(), s = i && i.canZoomOut();
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomIn"]'))n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="zoomOut"]'))s ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
        for (const e of t.querySelectorAll('[data-panzoom-action="toggleZoom"],[data-panzoom-action="iterateZoom"]')){
            s || n ? (e.removeAttribute("disabled"), e.removeAttribute("tabindex")) : (e.setAttribute("disabled", ""), e.setAttribute("tabindex", "-1"));
            const t = e.querySelector("g");
            t && (t.style.display = n ? "" : "none");
        }
    }
    onDone(t, e) {
        var i;
        null === (i = e.panzoom) || void 0 === i || i.on("afterTransform", ()=>{
            this.instance.isCurrentSlide(e) && this.onRefresh();
        }), this.instance.isCurrentSlide(e) && this.onRefresh();
    }
    createContainer() {
        const t = this.instance.container;
        if (!t) return null;
        const e = this.option("parentEl") || t;
        let i = e.querySelector("." + $d4d06657c043713f$var$Jt);
        return i || (i = document.createElement("div"), $d4d06657c043713f$var$P(i, $d4d06657c043713f$var$Jt), e.prepend(i)), i.addEventListener("click", this.onClick, {
            passive: !1,
            capture: !0
        }), t && $d4d06657c043713f$var$P(t, $d4d06657c043713f$var$Kt), this.container = i, i;
    }
    createEl(t) {
        const e = this.instance, i = e.carousel;
        if (!i) return null;
        if ("toggleFS" === t) return null;
        if ("fullscreen" === t && !$d4d06657c043713f$var$ot()) return null;
        let s = null;
        const o = i.slides.length || 0;
        let a = 0, r = 0;
        for (const t of i.slides)(t.panzoom || "image" === t.type) && a++, ("image" === t.type || t.downloadSrc) && r++;
        if (o < 2 && [
            "infobar",
            "prev",
            "next"
        ].includes(t)) return s;
        if (void 0 !== $d4d06657c043713f$var$Vt[t] && !a) return null;
        if ("download" === t && !r) return null;
        if ("thumbs" === t) {
            const t = e.plugins.Thumbs;
            if (!t || !t.isEnabled) return null;
        }
        if ("slideshow" === t) {
            if (!i.plugins.Autoplay || o < 2) return null;
        }
        if (void 0 !== $d4d06657c043713f$var$Vt[t]) {
            const e = $d4d06657c043713f$var$Vt[t];
            s = document.createElement("button"), s.setAttribute("title", this.instance.localize(`{{${t.toUpperCase()}}}`)), $d4d06657c043713f$var$P(s, "f-button"), e.action && (s.dataset.panzoomAction = e.action), e.change && (s.dataset.panzoomChange = JSON.stringify(e.change)), s.appendChild($d4d06657c043713f$var$n(this.instance.localize(e.icon)));
        } else {
            const e = (this.option("items") || [])[t];
            e && (s = $d4d06657c043713f$var$n(this.instance.localize(e.tpl)), "function" == typeof e.click && s.addEventListener("click", (t)=>{
                t.preventDefault(), t.stopPropagation(), "function" == typeof e.click && e.click.call(this, this, t);
            }));
        }
        const l = null == s ? void 0 : s.querySelector("svg");
        if (l) for (const [t, e] of Object.entries($d4d06657c043713f$var$Gt))l.getAttribute(t) || l.setAttribute(t, String(e));
        return s;
    }
    removeContainer() {
        const t = this.container;
        t && t.remove(), this.container = null, this.state = $d4d06657c043713f$var$Zt.Disabled;
        const e = this.instance.container;
        e && $d4d06657c043713f$var$S(e, $d4d06657c043713f$var$Kt);
    }
    attach() {
        const t = this, e = t.instance;
        e.on("Carousel.initSlides", t.onReady), e.on("done", t.onDone), e.on([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.onReady(t.instance);
    }
    detach() {
        const t = this, e = t.instance;
        e.off("Carousel.initSlides", t.onReady), e.off("done", t.onDone), e.off([
            "reveal",
            "Carousel.change"
        ], t.onChange), t.removeContainer();
    }
}
Object.defineProperty($d4d06657c043713f$var$Qt, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$Ut
});
const $d4d06657c043713f$var$te = {
    Hash: class extends $d4d06657c043713f$var$_ {
        onReady() {
            $d4d06657c043713f$var$ht = !1;
        }
        onChange(t) {
            $d4d06657c043713f$var$ut && clearTimeout($d4d06657c043713f$var$ut);
            const { hash: e } = $d4d06657c043713f$var$pt(), { hash: i } = $d4d06657c043713f$var$ft(), n = t.isOpeningSlide(t.getSlide());
            n && ($d4d06657c043713f$var$ct = i === e ? "" : i), e && e !== i && ($d4d06657c043713f$var$ut = setTimeout(()=>{
                try {
                    if (t.state === $d4d06657c043713f$var$rt.Ready) {
                        let t = "replaceState";
                        n && !$d4d06657c043713f$var$dt && (t = "pushState", $d4d06657c043713f$var$dt = !0), window.history[t]({}, document.title, window.location.pathname + window.location.search + e);
                    }
                } catch (t) {}
            }, 300));
        }
        onClose(t) {
            if ($d4d06657c043713f$var$ut && clearTimeout($d4d06657c043713f$var$ut), !$d4d06657c043713f$var$ht && $d4d06657c043713f$var$dt) return $d4d06657c043713f$var$dt = !1, $d4d06657c043713f$var$ht = !1, void window.history.back();
            if (!$d4d06657c043713f$var$ht) try {
                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + ($d4d06657c043713f$var$ct || ""));
            } catch (t) {}
        }
        attach() {
            const t = this.instance;
            t.on("ready", this.onReady), t.on([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.on("close", this.onClose);
        }
        detach() {
            const t = this.instance;
            t.off("ready", this.onReady), t.off([
                "Carousel.ready",
                "Carousel.change"
            ], this.onChange), t.off("close", this.onClose);
        }
        static parseURL() {
            return $d4d06657c043713f$var$ft();
        }
        static startFromUrl() {
            $d4d06657c043713f$var$gt();
        }
        static destroy() {
            window.removeEventListener("hashchange", $d4d06657c043713f$var$vt, !1);
        }
    },
    Html: $d4d06657c043713f$var$Lt,
    Images: $d4d06657c043713f$var$wt,
    Slideshow: $d4d06657c043713f$var$Dt,
    Thumbs: $d4d06657c043713f$var$Yt,
    Toolbar: $d4d06657c043713f$var$Qt
}, $d4d06657c043713f$var$ee = "with-fancybox", $d4d06657c043713f$var$ie = "hide-scrollbar", $d4d06657c043713f$var$ne = "--fancybox-scrollbar-compensate", $d4d06657c043713f$var$se = "--fancybox-body-margin", $d4d06657c043713f$var$oe = "aria-hidden", $d4d06657c043713f$var$ae = "is-using-tab", $d4d06657c043713f$var$re = "is-animated", $d4d06657c043713f$var$le = "is-compact", $d4d06657c043713f$var$ce = "is-loading", $d4d06657c043713f$var$he = "is-opening", $d4d06657c043713f$var$de = "has-caption", $d4d06657c043713f$var$ue = "disabled", $d4d06657c043713f$var$pe = "tabindex", $d4d06657c043713f$var$fe = "download", $d4d06657c043713f$var$ge = "href", $d4d06657c043713f$var$me = "src", $d4d06657c043713f$var$ve = (t)=>"string" == typeof t, $d4d06657c043713f$var$be = function() {
    var t = window.getSelection();
    return !!t && "Range" === t.type;
};
let $d4d06657c043713f$var$ye, $d4d06657c043713f$var$we = null, $d4d06657c043713f$var$xe = null, $d4d06657c043713f$var$Ee = 0, $d4d06657c043713f$var$Se = 0, $d4d06657c043713f$var$Pe = 0, $d4d06657c043713f$var$Ce = 0;
const $d4d06657c043713f$var$Te = new Map;
let $d4d06657c043713f$var$Me = 0;
class $d4d06657c043713f$export$cb45b08d97cdc4fd extends $d4d06657c043713f$var$g {
    get isIdle() {
        return this.idle;
    }
    get isCompact() {
        return this.option("compact");
    }
    constructor(t = [], e = {}, i = {}){
        super(e), Object.defineProperty(this, "userSlides", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: []
        }), Object.defineProperty(this, "userPlugins", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: {}
        }), Object.defineProperty(this, "idle", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "idleTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "clickTimer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "pwt", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "ignoreFocusChange", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "startedFs", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: !1
        }), Object.defineProperty(this, "state", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: $d4d06657c043713f$var$rt.Init
        }), Object.defineProperty(this, "id", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: 0
        }), Object.defineProperty(this, "container", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "caption", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "footer", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "carousel", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "lastFocus", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: null
        }), Object.defineProperty(this, "prevMouseMoveEvent", {
            enumerable: !0,
            configurable: !0,
            writable: !0,
            value: void 0
        }), $d4d06657c043713f$var$ye || ($d4d06657c043713f$var$ye = $d4d06657c043713f$var$ot()), this.id = e.id || ++$d4d06657c043713f$var$Me, $d4d06657c043713f$var$Te.set(this.id, this), this.userSlides = t, this.userPlugins = i, queueMicrotask(()=>{
            this.init();
        });
    }
    init() {
        if (this.state === $d4d06657c043713f$var$rt.Destroy) return;
        this.state = $d4d06657c043713f$var$rt.Init, this.attachPlugins(Object.assign(Object.assign({}, $d4d06657c043713f$export$cb45b08d97cdc4fd.Plugins), this.userPlugins)), this.emit("init"), this.emit("attachPlugins"), !0 === this.option("hideScrollbar") && (()=>{
            if (!$d4d06657c043713f$var$et) return;
            const t = document, e = t.body, i = t.documentElement;
            if (e.classList.contains($d4d06657c043713f$var$ie)) return;
            let n = window.innerWidth - i.getBoundingClientRect().width;
            const s = parseFloat(window.getComputedStyle(e).marginRight);
            n < 0 && (n = 0), i.style.setProperty($d4d06657c043713f$var$ne, `${n}px`), s && e.style.setProperty($d4d06657c043713f$var$se, `${s}px`), e.classList.add($d4d06657c043713f$var$ie);
        })(), this.initLayout(), this.scale();
        const t = ()=>{
            this.initCarousel(this.userSlides), this.state = $d4d06657c043713f$var$rt.Ready, this.attachEvents(), this.emit("ready"), setTimeout(()=>{
                this.container && this.container.setAttribute($d4d06657c043713f$var$oe, "false");
            }, 16);
        };
        this.option("Fullscreen.autoStart") && $d4d06657c043713f$var$ye && !$d4d06657c043713f$var$ye.isFullscreen() ? $d4d06657c043713f$var$ye.request().then(()=>{
            this.startedFs = !0, t();
        }).catch(()=>t()) : t();
    }
    initLayout() {
        var t, e;
        const i = this.option("parentEl") || document.body, s = $d4d06657c043713f$var$n(this.localize(this.option("tpl.main") || ""));
        if (s) {
            if (s.setAttribute("id", `fancybox-${this.id}`), s.setAttribute("aria-label", this.localize("{{MODAL}}")), s.classList.toggle($d4d06657c043713f$var$le, this.isCompact), $d4d06657c043713f$var$P(s, this.option("mainClass") || ""), $d4d06657c043713f$var$P(s, $d4d06657c043713f$var$he), this.container = s, this.footer = s.querySelector(".fancybox__footer"), i.appendChild(s), $d4d06657c043713f$var$P(document.documentElement, $d4d06657c043713f$var$ee), $d4d06657c043713f$var$we && $d4d06657c043713f$var$xe || ($d4d06657c043713f$var$we = document.createElement("span"), $d4d06657c043713f$var$P($d4d06657c043713f$var$we, "fancybox-focus-guard"), $d4d06657c043713f$var$we.setAttribute($d4d06657c043713f$var$pe, "0"), $d4d06657c043713f$var$we.setAttribute($d4d06657c043713f$var$oe, "true"), $d4d06657c043713f$var$we.setAttribute("aria-label", "Focus guard"), $d4d06657c043713f$var$xe = $d4d06657c043713f$var$we.cloneNode(), null === (t = s.parentElement) || void 0 === t || t.insertBefore($d4d06657c043713f$var$we, s), null === (e = s.parentElement) || void 0 === e || e.append($d4d06657c043713f$var$xe)), s.addEventListener("mousedown", (t)=>{
                $d4d06657c043713f$var$Ee = t.pageX, $d4d06657c043713f$var$Se = t.pageY, $d4d06657c043713f$var$S(s, $d4d06657c043713f$var$ae);
            }), this.option("closeExisting")) for (const t of $d4d06657c043713f$var$Te.values())t.id !== this.id && t.close();
            else this.option("animated") && ($d4d06657c043713f$var$P(s, $d4d06657c043713f$var$re), setTimeout(()=>{
                this.isClosing() || $d4d06657c043713f$var$S(s, $d4d06657c043713f$var$re);
            }, 350));
            this.emit("initLayout");
        }
    }
    initCarousel(t) {
        const i = this.container;
        if (!i) return;
        const n = i.querySelector(".fancybox__carousel");
        if (!n) return;
        const s = this.carousel = new $d4d06657c043713f$export$144901db2ea8e967(n, $d4d06657c043713f$var$u({}, {
            slides: t,
            transition: "fade",
            Panzoom: {
                lockAxis: this.option("dragToClose") ? "xy" : "x",
                infinite: !!this.option("dragToClose") && "y"
            },
            Dots: !1,
            Navigation: {
                classes: {
                    container: "fancybox__nav",
                    button: "f-button",
                    isNext: "is-next",
                    isPrev: "is-prev"
                }
            },
            initialPage: this.option("startIndex"),
            l10n: this.option("l10n")
        }, this.option("Carousel") || {}));
        s.on("*", (t, e, ...i)=>{
            this.emit(`Carousel.${e}`, t, ...i);
        }), s.on([
            "ready",
            "change"
        ], ()=>{
            this.manageCaption();
        }), this.on("Carousel.removeSlide", (t, e, i)=>{
            this.clearContent(i), i.state = void 0;
        }), s.on("Panzoom.touchStart", ()=>{
            var t, e;
            this.isCompact || this.endIdle(), (null === (t = document.activeElement) || void 0 === t ? void 0 : t.closest(".f-thumbs")) && (null === (e = this.container) || void 0 === e || e.focus());
        }), s.on("settle", ()=>{
            this.idleTimer || this.isCompact || !this.option("idle") || this.setIdle(), this.option("autoFocus") && !this.isClosing && this.checkFocus();
        }), this.option("dragToClose") && (s.on("Panzoom.afterTransform", (t, i)=>{
            const n = this.getSlide();
            if (n && $d4d06657c043713f$var$e(n.el)) return;
            const s = this.container;
            if (s) {
                const t = Math.abs(i.current.f), e = t < 1 ? "" : Math.max(.5, Math.min(1, 1 - t / i.contentRect.fitHeight * 1.5));
                s.style.setProperty("--fancybox-ts", e ? "0s" : ""), s.style.setProperty("--fancybox-opacity", e + "");
            }
        }), s.on("Panzoom.touchEnd", (t, i, n)=>{
            var s;
            const o = this.getSlide();
            if (o && $d4d06657c043713f$var$e(o.el)) return;
            if (i.isMobile && document.activeElement && -1 !== [
                "TEXTAREA",
                "INPUT"
            ].indexOf(null === (s = document.activeElement) || void 0 === s ? void 0 : s.nodeName)) return;
            const a = Math.abs(i.dragOffset.y);
            "y" === i.lockedAxis && (a >= 200 || a >= 50 && i.dragOffset.time < 300) && (n && n.cancelable && n.preventDefault(), this.close(n, "f-throwOut" + (i.current.f < 0 ? "Up" : "Down")));
        })), s.on("change", (t)=>{
            var e;
            let i = null === (e = this.getSlide()) || void 0 === e ? void 0 : e.triggerEl;
            if (i) {
                const e = new CustomEvent("slideTo", {
                    bubbles: !0,
                    cancelable: !0,
                    detail: t.page
                });
                i.dispatchEvent(e);
            }
        }), s.on([
            "refresh",
            "change"
        ], (t)=>{
            const e = this.container;
            if (!e) return;
            for (const i of e.querySelectorAll("[data-fancybox-current-index]"))i.innerHTML = t.page + 1;
            for (const i of e.querySelectorAll("[data-fancybox-count]"))i.innerHTML = t.pages.length;
            if (!t.isInfinite) {
                for (const i of e.querySelectorAll("[data-fancybox-next]"))t.page < t.pages.length - 1 ? (i.removeAttribute($d4d06657c043713f$var$ue), i.removeAttribute($d4d06657c043713f$var$pe)) : (i.setAttribute($d4d06657c043713f$var$ue, ""), i.setAttribute($d4d06657c043713f$var$pe, "-1"));
                for (const i of e.querySelectorAll("[data-fancybox-prev]"))t.page > 0 ? (i.removeAttribute($d4d06657c043713f$var$ue), i.removeAttribute($d4d06657c043713f$var$pe)) : (i.setAttribute($d4d06657c043713f$var$ue, ""), i.setAttribute($d4d06657c043713f$var$pe, "-1"));
            }
            const i = this.getSlide();
            if (!i) return;
            let n = i.downloadSrc || "";
            n || "image" !== i.type || i.error || !$d4d06657c043713f$var$ve(i[$d4d06657c043713f$var$me]) || (n = i[$d4d06657c043713f$var$me]);
            for (const t of e.querySelectorAll("[data-fancybox-download]")){
                const e = i.downloadFilename;
                n ? (t.removeAttribute($d4d06657c043713f$var$ue), t.removeAttribute($d4d06657c043713f$var$pe), t.setAttribute($d4d06657c043713f$var$ge, n), t.setAttribute($d4d06657c043713f$var$fe, e || n), t.setAttribute("target", "_blank")) : (t.setAttribute($d4d06657c043713f$var$ue, ""), t.setAttribute($d4d06657c043713f$var$pe, "-1"), t.removeAttribute($d4d06657c043713f$var$ge), t.removeAttribute($d4d06657c043713f$var$fe));
            }
        }), this.emit("initCarousel");
    }
    attachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        e.addEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), e.addEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), document.addEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), document.addEventListener("visibilitychange", t.onVisibilityChange, !1), document.addEventListener("mousemove", t.onMousemove), t.option("trapFocus") && document.addEventListener("focus", t.onFocus, !0), window.addEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.addEventListener("scroll", t.onResize), i.addEventListener("resize", t.onResize));
    }
    detachEvents() {
        const t = this, e = t.container;
        if (!e) return;
        document.removeEventListener("keydown", t.onKeydown, {
            passive: !1,
            capture: !0
        }), e.removeEventListener("wheel", t.onWheel, {
            passive: !1,
            capture: !1
        }), e.removeEventListener("click", t.onClick, {
            passive: !1,
            capture: !1
        }), document.removeEventListener("mousemove", t.onMousemove), window.removeEventListener("resize", t.onResize);
        const i = window.visualViewport;
        i && (i.removeEventListener("resize", t.onResize), i.removeEventListener("scroll", t.onResize)), document.removeEventListener("visibilitychange", t.onVisibilityChange, !1), document.removeEventListener("focus", t.onFocus, !0);
    }
    scale() {
        const t = this.container;
        if (!t) return;
        const e = window.visualViewport, i = Math.max(1, (null == e ? void 0 : e.scale) || 1);
        let n = "", s = "", o = "";
        if (e && i > 1) {
            let t = `${e.offsetLeft}px`, a = `${e.offsetTop}px`;
            n = e.width * i + "px", s = e.height * i + "px", o = `translate3d(${t}, ${a}, 0) scale(${1 / i})`;
        }
        t.style.transform = o, t.style.width = n, t.style.height = s;
    }
    onClick(t) {
        var e;
        const { container: i, isCompact: n } = this;
        if (!i || this.isClosing()) return;
        !n && this.option("idle") && this.resetIdle();
        const s = t.composedPath()[0];
        if (s.closest(".fancybox-spinner") || s.closest("[data-fancybox-close]")) return t.preventDefault(), void this.close(t);
        if (s.closest("[data-fancybox-prev]")) return t.preventDefault(), void this.prev();
        if (s.closest("[data-fancybox-next]")) return t.preventDefault(), void this.next();
        if ("click" === t.type && 0 === t.detail) return;
        if (Math.abs(t.pageX - $d4d06657c043713f$var$Ee) > 30 || Math.abs(t.pageY - $d4d06657c043713f$var$Se) > 30) return;
        const o = document.activeElement;
        if ($d4d06657c043713f$var$be() && o && i.contains(o)) return;
        if (n && "image" === (null === (e = this.getSlide()) || void 0 === e ? void 0 : e.type)) return void (this.clickTimer ? (clearTimeout(this.clickTimer), this.clickTimer = null) : this.clickTimer = setTimeout(()=>{
            this.toggleIdle(), this.clickTimer = null;
        }, 350));
        if (this.emit("click", t), t.defaultPrevented) return;
        let a = !1;
        if (s.closest(".fancybox__content")) {
            if (o) {
                if (o.closest("[contenteditable]")) return;
                s.matches($d4d06657c043713f$var$nt) || o.blur();
            }
            if ($d4d06657c043713f$var$be()) return;
            a = this.option("contentClick");
        } else s.closest(".fancybox__carousel") && !s.matches($d4d06657c043713f$var$nt) && (a = this.option("backdropClick"));
        "close" === a ? (t.preventDefault(), this.close(t)) : "next" === a ? (t.preventDefault(), this.next()) : "prev" === a && (t.preventDefault(), this.prev());
    }
    onWheel(t) {
        const e = t.target;
        let n = this.option("wheel", t);
        e.closest(".fancybox__thumbs") && (n = "slide");
        const s = "slide" === n, o = [
            -t.deltaX || 0,
            -t.deltaY || 0,
            -t.detail || 0
        ].reduce(function(t, e) {
            return Math.abs(e) > Math.abs(t) ? e : t;
        }), a = Math.max(-1, Math.min(1, o)), r = Date.now();
        this.pwt && r - this.pwt < 300 ? s && t.preventDefault() : (this.pwt = r, this.emit("wheel", t, a), t.defaultPrevented || ("close" === n ? (t.preventDefault(), this.close(t)) : "slide" === n && ($d4d06657c043713f$var$i(e) || (t.preventDefault(), this[a > 0 ? "prev" : "next"]()))));
    }
    onScroll() {
        window.scrollTo($d4d06657c043713f$var$Pe, $d4d06657c043713f$var$Ce);
    }
    onKeydown(t) {
        if (!this.isTopmost()) return;
        this.isCompact || !this.option("idle") || this.isClosing() || this.resetIdle();
        const e = t.key, i = this.option("keyboard");
        if (!i) return;
        const n = t.composedPath()[0], s = document.activeElement && document.activeElement.classList, o = s && s.contains("f-button") || n.dataset.carouselPage || n.dataset.carouselIndex;
        if ("Escape" !== e && !o && $d4d06657c043713f$var$E(n)) {
            if (n.isContentEditable || -1 !== [
                "TEXTAREA",
                "OPTION",
                "INPUT",
                "SELECT",
                "VIDEO"
            ].indexOf(n.nodeName)) return;
        }
        if ("Tab" === t.key ? $d4d06657c043713f$var$P(this.container, $d4d06657c043713f$var$ae) : $d4d06657c043713f$var$S(this.container, $d4d06657c043713f$var$ae), t.ctrlKey || t.altKey || t.shiftKey) return;
        this.emit("keydown", e, t);
        const a = i[e];
        a && "function" == typeof this[a] && (t.preventDefault(), this[a]());
    }
    onResize() {
        const t = this.container;
        if (!t) return;
        const e = this.isCompact;
        t.classList.toggle($d4d06657c043713f$var$le, e), this.manageCaption(this.getSlide()), this.isCompact ? this.clearIdle() : this.endIdle(), this.scale(), this.emit("resize");
    }
    onFocus(t) {
        this.isTopmost() && this.checkFocus(t);
    }
    onMousemove(t) {
        this.prevMouseMoveEvent = t, !this.isCompact && this.option("idle") && this.resetIdle();
    }
    onVisibilityChange() {
        "visible" === document.visibilityState ? this.checkFocus() : this.endIdle();
    }
    manageCloseBtn(t) {
        const e = this.optionFor(t, "closeButton") || !1;
        if ("auto" === e) {
            const t = this.plugins.Toolbar;
            if (t && t.state === $d4d06657c043713f$var$Zt.Ready) return;
        }
        if (!e) return;
        if (!t.contentEl || t.closeBtnEl) return;
        const i = this.option("tpl.closeButton");
        if (i) {
            const e = $d4d06657c043713f$var$n(this.localize(i));
            t.closeBtnEl = t.contentEl.appendChild(e), t.el && $d4d06657c043713f$var$P(t.el, "has-close-btn");
        }
    }
    manageCaption(t) {
        var e, i;
        const n = "fancybox__caption", s = this.container;
        if (!s) return;
        $d4d06657c043713f$var$S(s, $d4d06657c043713f$var$de);
        const o = this.isCompact || this.option("commonCaption"), a = !o;
        if (this.caption && this.stop(this.caption), a && this.caption && (this.caption.remove(), this.caption = null), o && !this.caption) for (const t of (null === (e = this.carousel) || void 0 === e ? void 0 : e.slides) || [])t.captionEl && (t.captionEl.remove(), t.captionEl = void 0, $d4d06657c043713f$var$S(t.el, $d4d06657c043713f$var$de), null === (i = t.el) || void 0 === i || i.removeAttribute("aria-labelledby"));
        if (t || (t = this.getSlide()), !t || o && !this.isCurrentSlide(t)) return;
        const r = t.el;
        let l = this.optionFor(t, "caption", "");
        if (!l) return void (o && this.caption && this.animate(this.caption, "f-fadeOut", ()=>{
            this.caption && (this.caption.innerHTML = "");
        }));
        let c = null;
        if (a) {
            if (c = t.captionEl || null, r && !c) {
                const e = n + `_${this.id}_${t.index}`;
                c = document.createElement("div"), $d4d06657c043713f$var$P(c, n), c.setAttribute("id", e), t.captionEl = r.appendChild(c), $d4d06657c043713f$var$P(r, $d4d06657c043713f$var$de), r.setAttribute("aria-labelledby", e);
            }
        } else {
            if (c = this.caption, c || (c = s.querySelector("." + n)), !c) {
                c = document.createElement("div"), c.dataset.fancyboxCaption = "", $d4d06657c043713f$var$P(c, n);
                (this.footer || s).prepend(c);
            }
            $d4d06657c043713f$var$P(s, $d4d06657c043713f$var$de), this.caption = c;
        }
        c && (c.innerHTML = "", $d4d06657c043713f$var$ve(l) || "number" == typeof l ? c.innerHTML = l + "" : l instanceof HTMLElement && c.appendChild(l));
    }
    checkFocus(t) {
        this.focus(t);
    }
    focus(t) {
        var e;
        if (this.ignoreFocusChange) return;
        const i = document.activeElement || null, n = (null == t ? void 0 : t.target) || null, s = this.container, o = null === (e = this.carousel) || void 0 === e ? void 0 : e.viewport;
        if (!s || !o) return;
        if (!t && i && s.contains(i)) return;
        const a = this.getSlide(), r = a && a.state === $d4d06657c043713f$var$lt.Ready ? a.el : null;
        if (!r || r.contains(i) || s === i) return;
        t && t.cancelable && t.preventDefault(), this.ignoreFocusChange = !0;
        const l = Array.from(s.querySelectorAll($d4d06657c043713f$var$nt));
        let c = [], h = null;
        for (let t of l){
            const e = !t.offsetParent || !!t.closest('[aria-hidden="true"]'), i = r && r.contains(t), n = !o.contains(t);
            if (t === s || (i || n) && !e) {
                c.push(t);
                const e = t.dataset.origTabindex;
                void 0 !== e && e && (t.tabIndex = parseFloat(e)), t.removeAttribute("data-orig-tabindex"), !t.hasAttribute("autoFocus") && h || (h = t);
            } else {
                const e = void 0 === t.dataset.origTabindex ? t.getAttribute("tabindex") || "" : t.dataset.origTabindex;
                e && (t.dataset.origTabindex = e), t.tabIndex = -1;
            }
        }
        let d = null;
        t ? (!n || c.indexOf(n) < 0) && (d = h || s, c.length && (i === $d4d06657c043713f$var$xe ? d = c[0] : this.lastFocus !== s && i !== $d4d06657c043713f$var$we || (d = c[c.length - 1]))) : d = a && "image" === a.type ? s : h || s, d && $d4d06657c043713f$var$st(d), this.lastFocus = document.activeElement, this.ignoreFocusChange = !1;
    }
    next() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slideNext();
    }
    prev() {
        const t = this.carousel;
        t && t.pages.length > 1 && t.slidePrev();
    }
    jumpTo(...t) {
        this.carousel && this.carousel.slideTo(...t);
    }
    isTopmost() {
        var t;
        return (null === (t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.id) == this.id;
    }
    animate(t = null, e = "", i) {
        if (!t || !e) return void (i && i());
        this.stop(t);
        const n = (s)=>{
            s.target === t && t.dataset.animationName && (t.removeEventListener("animationend", n), delete t.dataset.animationName, i && i(), $d4d06657c043713f$var$S(t, e));
        };
        t.dataset.animationName = e, t.addEventListener("animationend", n), $d4d06657c043713f$var$P(t, e);
    }
    stop(t) {
        t && t.dispatchEvent(new CustomEvent("animationend", {
            bubbles: !1,
            cancelable: !0,
            currentTarget: t
        }));
    }
    setContent(t, e = "", i = !0) {
        if (this.isClosing()) return;
        const s = t.el;
        if (!s) return;
        let o = null;
        if ($d4d06657c043713f$var$E(e) ? o = e : (o = $d4d06657c043713f$var$n(e + ""), $d4d06657c043713f$var$E(o) || (o = document.createElement("div"), o.innerHTML = e + "")), [
            "img",
            "picture",
            "iframe",
            "video",
            "audio"
        ].includes(o.nodeName.toLowerCase())) {
            const t = document.createElement("div");
            t.appendChild(o), o = t;
        }
        $d4d06657c043713f$var$E(o) && t.filter && !t.error && (o = o.querySelector(t.filter)), o && $d4d06657c043713f$var$E(o) ? ($d4d06657c043713f$var$P(o, "fancybox__content"), t.id && o.setAttribute("id", t.id), s.classList.add(`has-${t.error ? "error" : t.type || "unknown"}`), s.prepend(o), "none" === o.style.display && (o.style.display = ""), "none" === getComputedStyle(o).getPropertyValue("display") && (o.style.display = t.display || this.option("defaultDisplay") || "flex"), t.contentEl = o, i && this.revealContent(t), this.manageCloseBtn(t), this.manageCaption(t)) : this.setError(t, "{{ELEMENT_NOT_FOUND}}");
    }
    revealContent(t, e) {
        const i = t.el, n = t.contentEl;
        i && n && (this.emit("reveal", t), this.hideLoading(t), t.state = $d4d06657c043713f$var$lt.Opening, (e = this.isOpeningSlide(t) ? void 0 === e ? this.optionFor(t, "showClass") : e : "f-fadeIn") ? this.animate(n, e, ()=>{
            this.done(t);
        }) : this.done(t));
    }
    done(t) {
        this.isClosing() || (t.state = $d4d06657c043713f$var$lt.Ready, this.emit("done", t), $d4d06657c043713f$var$P(t.el, "is-done"), this.isCurrentSlide(t) && this.option("autoFocus") && queueMicrotask(()=>{
            var e;
            null === (e = t.panzoom) || void 0 === e || e.updateControls(), this.option("autoFocus") && this.focus();
        }), this.isOpeningSlide(t) && ($d4d06657c043713f$var$S(this.container, $d4d06657c043713f$var$he), !this.isCompact && this.option("idle") && this.setIdle()));
    }
    isCurrentSlide(t) {
        const e = this.getSlide();
        return !(!t || !e) && e.index === t.index;
    }
    isOpeningSlide(t) {
        var e, i;
        return null === (null === (e = this.carousel) || void 0 === e ? void 0 : e.prevPage) && t && t.index === (null === (i = this.getSlide()) || void 0 === i ? void 0 : i.index);
    }
    showLoading(t) {
        t.state = $d4d06657c043713f$var$lt.Loading;
        const e = t.el;
        if (!e) return;
        $d4d06657c043713f$var$P(e, $d4d06657c043713f$var$ce), this.emit("loading", t), t.spinnerEl || setTimeout(()=>{
            if (!this.isClosing() && !t.spinnerEl && t.state === $d4d06657c043713f$var$lt.Loading) {
                let i = $d4d06657c043713f$var$n($d4d06657c043713f$var$x);
                $d4d06657c043713f$var$P(i, "fancybox-spinner"), t.spinnerEl = i, e.prepend(i), this.animate(i, "f-fadeIn");
            }
        }, 250);
    }
    hideLoading(t) {
        const e = t.el;
        if (!e) return;
        const i = t.spinnerEl;
        this.isClosing() ? null == i || i.remove() : ($d4d06657c043713f$var$S(e, $d4d06657c043713f$var$ce), i && this.animate(i, "f-fadeOut", ()=>{
            i.remove();
        }), t.state === $d4d06657c043713f$var$lt.Loading && (this.emit("loaded", t), t.state = $d4d06657c043713f$var$lt.Ready));
    }
    setError(t, e) {
        if (this.isClosing()) return;
        const i = new Event("error", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("error", i, t), i.defaultPrevented) return;
        t.error = e, this.hideLoading(t), this.clearContent(t);
        const n = document.createElement("div");
        n.classList.add("fancybox-error"), n.innerHTML = this.localize(e || "<p>{{ERROR}}</p>"), this.setContent(t, n);
    }
    clearContent(t) {
        if (void 0 === t.state) return;
        this.emit("clearContent", t), t.contentEl && (t.contentEl.remove(), t.contentEl = void 0);
        const e = t.el;
        e && ($d4d06657c043713f$var$S(e, "has-error"), $d4d06657c043713f$var$S(e, "has-unknown"), $d4d06657c043713f$var$S(e, `has-${t.type || "unknown"}`)), t.closeBtnEl && t.closeBtnEl.remove(), t.closeBtnEl = void 0, t.captionEl && t.captionEl.remove(), t.captionEl = void 0, t.spinnerEl && t.spinnerEl.remove(), t.spinnerEl = void 0;
    }
    getSlide() {
        var t;
        const e = this.carousel;
        return (null === (t = null == e ? void 0 : e.pages[null == e ? void 0 : e.page]) || void 0 === t ? void 0 : t.slides[0]) || void 0;
    }
    close(t, e) {
        if (this.isClosing()) return;
        const i = new Event("shouldClose", {
            bubbles: !0,
            cancelable: !0
        });
        if (this.emit("shouldClose", i, t), i.defaultPrevented) return;
        t && t.cancelable && (t.preventDefault(), t.stopPropagation());
        const n = ()=>{
            this.proceedClose(t, e);
        };
        this.startedFs && $d4d06657c043713f$var$ye && $d4d06657c043713f$var$ye.isFullscreen() ? Promise.resolve($d4d06657c043713f$var$ye.exit()).then(()=>n()) : n();
    }
    clearIdle() {
        this.idleTimer && clearTimeout(this.idleTimer), this.idleTimer = null;
    }
    setIdle(t = !1) {
        const e = ()=>{
            this.clearIdle(), this.idle = !0, $d4d06657c043713f$var$P(this.container, "is-idle"), this.emit("setIdle");
        };
        if (this.clearIdle(), !this.isClosing()) {
            if (t) e();
            else {
                const t = this.option("idle");
                t && (this.idleTimer = setTimeout(e, t));
            }
        }
    }
    endIdle() {
        this.clearIdle(), this.idle && !this.isClosing() && (this.idle = !1, $d4d06657c043713f$var$S(this.container, "is-idle"), this.emit("endIdle"));
    }
    resetIdle() {
        this.endIdle(), this.setIdle();
    }
    toggleIdle() {
        this.idle ? this.endIdle() : this.setIdle(!0);
    }
    toggleFullscreen() {
        $d4d06657c043713f$var$ye && ($d4d06657c043713f$var$ye.isFullscreen() ? $d4d06657c043713f$var$ye.exit() : $d4d06657c043713f$var$ye.request().then(()=>{
            this.startedFs = !0;
        }));
    }
    isClosing() {
        return [
            $d4d06657c043713f$var$rt.Closing,
            $d4d06657c043713f$var$rt.CustomClosing,
            $d4d06657c043713f$var$rt.Destroy
        ].includes(this.state);
    }
    proceedClose(t, e) {
        var i, n;
        this.state = $d4d06657c043713f$var$rt.Closing, this.clearIdle(), this.detachEvents();
        const s = this.container, o = this.carousel, a = this.getSlide(), r = a && this.option("placeFocusBack") ? a.triggerEl || this.option("triggerEl") : null;
        if (r && ($d4d06657c043713f$var$tt(r) ? $d4d06657c043713f$var$st(r) : r.focus()), s && ($d4d06657c043713f$var$S(s, $d4d06657c043713f$var$he), $d4d06657c043713f$var$P(s, "is-closing"), s.setAttribute($d4d06657c043713f$var$oe, "true"), this.option("animated") && $d4d06657c043713f$var$P(s, $d4d06657c043713f$var$re), s.style.pointerEvents = "none"), o) {
            o.clearTransitions(), null === (i = o.panzoom) || void 0 === i || i.destroy(), null === (n = o.plugins.Navigation) || void 0 === n || n.detach();
            for (const t of o.slides){
                t.state = $d4d06657c043713f$var$lt.Closing, this.hideLoading(t);
                const e = t.contentEl;
                e && this.stop(e);
                const i = null == t ? void 0 : t.panzoom;
                i && (i.stop(), i.detachEvents(), i.detachObserver()), this.isCurrentSlide(t) || o.emit("removeSlide", t);
            }
        }
        $d4d06657c043713f$var$Pe = window.scrollX, $d4d06657c043713f$var$Ce = window.scrollY, window.addEventListener("scroll", this.onScroll), this.emit("close", t), this.state !== $d4d06657c043713f$var$rt.CustomClosing ? (void 0 === e && a && (e = this.optionFor(a, "hideClass")), e && a ? (this.animate(a.contentEl, e, ()=>{
            o && o.emit("removeSlide", a);
        }), setTimeout(()=>{
            this.destroy();
        }, 500)) : this.destroy()) : setTimeout(()=>{
            this.destroy();
        }, 500);
    }
    destroy() {
        var t;
        if (this.state === $d4d06657c043713f$var$rt.Destroy) return;
        window.removeEventListener("scroll", this.onScroll), this.state = $d4d06657c043713f$var$rt.Destroy, null === (t = this.carousel) || void 0 === t || t.destroy();
        const e = this.container;
        e && e.remove(), $d4d06657c043713f$var$Te.delete(this.id);
        const i = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
        i ? i.focus() : ($d4d06657c043713f$var$we && ($d4d06657c043713f$var$we.remove(), $d4d06657c043713f$var$we = null), $d4d06657c043713f$var$xe && ($d4d06657c043713f$var$xe.remove(), $d4d06657c043713f$var$xe = null), $d4d06657c043713f$var$S(document.documentElement, $d4d06657c043713f$var$ee), (()=>{
            if (!$d4d06657c043713f$var$et) return;
            const t = document, e = t.body;
            e.classList.remove($d4d06657c043713f$var$ie), e.style.setProperty($d4d06657c043713f$var$se, ""), t.documentElement.style.setProperty($d4d06657c043713f$var$ne, "");
        })(), this.emit("destroy"));
    }
    static bind(t, e, i) {
        if (!$d4d06657c043713f$var$et) return;
        let n, s = "", o = {};
        if (void 0 === t ? n = document.body : $d4d06657c043713f$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : (n = t, $d4d06657c043713f$var$ve(e) && (s = e), "object" == typeof i && (o = i || {})), !n || !$d4d06657c043713f$var$E(n)) return;
        s = s || "[data-fancybox]";
        const a = $d4d06657c043713f$export$cb45b08d97cdc4fd.openers.get(n) || new Map;
        a.set(s, o), $d4d06657c043713f$export$cb45b08d97cdc4fd.openers.set(n, a), 1 === a.size && n.addEventListener("click", $d4d06657c043713f$export$cb45b08d97cdc4fd.fromEvent);
    }
    static unbind(t, e) {
        let i, n = "";
        if ($d4d06657c043713f$var$ve(t) ? (i = document.body, n = t) : (i = t, $d4d06657c043713f$var$ve(e) && (n = e)), !i) return;
        const s = $d4d06657c043713f$export$cb45b08d97cdc4fd.openers.get(i);
        s && n && s.delete(n), n && s || ($d4d06657c043713f$export$cb45b08d97cdc4fd.openers.delete(i), i.removeEventListener("click", $d4d06657c043713f$export$cb45b08d97cdc4fd.fromEvent));
    }
    static destroy() {
        let t;
        for(; t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();)t.destroy();
        for (const t of $d4d06657c043713f$export$cb45b08d97cdc4fd.openers.keys())t.removeEventListener("click", $d4d06657c043713f$export$cb45b08d97cdc4fd.fromEvent);
        $d4d06657c043713f$export$cb45b08d97cdc4fd.openers = new Map;
    }
    static fromEvent(t) {
        if (t.defaultPrevented) return;
        if (t.button && 0 !== t.button) return;
        if (t.ctrlKey || t.metaKey || t.shiftKey) return;
        let e = t.composedPath()[0];
        const i = e.closest("[data-fancybox-trigger]");
        if (i) {
            const t = i.dataset.fancyboxTrigger || "", n = document.querySelectorAll(`[data-fancybox="${t}"]`), s = parseInt(i.dataset.fancyboxIndex || "", 10) || 0;
            e = n[s] || e;
        }
        if (!(e && e instanceof Element)) return;
        let n, s, o, a;
        if ([
            ...$d4d06657c043713f$export$cb45b08d97cdc4fd.openers
        ].reverse().find(([t, i])=>!(!t.contains(e) || ![
                ...i
            ].reverse().find(([i, r])=>{
                let l = e.closest(i);
                return !!l && (n = t, s = i, o = l, a = r, !0);
            }))), !n || !s || !o) return;
        a = a || {}, t.preventDefault(), e = o;
        let r = [], l = $d4d06657c043713f$var$u({}, $d4d06657c043713f$var$at, a);
        l.event = t, l.triggerEl = e, l.delegate = i;
        const c = l.groupAll, h = l.groupAttr, d = h && e ? e.getAttribute(`${h}`) : "";
        if ((!e || d || c) && (r = [].slice.call(n.querySelectorAll(s))), e && !c && (r = d ? r.filter((t)=>t.getAttribute(`${h}`) === d) : [
            e
        ]), !r.length) return;
        const p = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
        return p && p.options.triggerEl && r.indexOf(p.options.triggerEl) > -1 ? void 0 : (e && (l.startIndex = r.indexOf(e)), $d4d06657c043713f$export$cb45b08d97cdc4fd.fromNodes(r, l));
    }
    static fromSelector(t, e, i) {
        let n = null, s = "", o = {};
        if ($d4d06657c043713f$var$ve(t) ? (n = document.body, s = t, "object" == typeof e && (o = e || {})) : t instanceof HTMLElement && $d4d06657c043713f$var$ve(e) && (n = t, s = e, "object" == typeof i && (o = i || {})), !n || !s) return !1;
        const a = $d4d06657c043713f$export$cb45b08d97cdc4fd.openers.get(n);
        return !!a && (o = $d4d06657c043713f$var$u({}, a.get(s) || {}, o), !!o && $d4d06657c043713f$export$cb45b08d97cdc4fd.fromNodes(Array.from(n.querySelectorAll(s)), o));
    }
    static fromNodes(t, e) {
        e = $d4d06657c043713f$var$u({}, $d4d06657c043713f$var$at, e || {});
        const i = [];
        for (const n of t){
            const t = n.dataset || {}, s = t[$d4d06657c043713f$var$me] || n.getAttribute($d4d06657c043713f$var$ge) || n.getAttribute("currentSrc") || n.getAttribute($d4d06657c043713f$var$me) || void 0;
            let o;
            const a = e.delegate;
            let r;
            a && i.length === e.startIndex && (o = a instanceof HTMLImageElement ? a : a.querySelector("img:not([aria-hidden])")), o || (o = n instanceof HTMLImageElement ? n : n.querySelector("img:not([aria-hidden])")), o && (r = o.currentSrc || o[$d4d06657c043713f$var$me] || void 0, !r && o.dataset && (r = o.dataset.lazySrc || o.dataset[$d4d06657c043713f$var$me] || void 0));
            const l = {
                src: s,
                triggerEl: n,
                thumbEl: o,
                thumbElSrc: r,
                thumbSrc: r
            };
            for(const e in t){
                let i = t[e] + "";
                i = "false" !== i && ("true" === i || i), l[e] = i;
            }
            i.push(l);
        }
        return new $d4d06657c043713f$export$cb45b08d97cdc4fd(i, e);
    }
    static getInstance(t) {
        if (t) return $d4d06657c043713f$var$Te.get(t);
        return Array.from($d4d06657c043713f$var$Te.values()).reverse().find((t)=>!t.isClosing() && t) || null;
    }
    static getSlide() {
        var t;
        return (null === (t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance()) || void 0 === t ? void 0 : t.getSlide()) || null;
    }
    static show(t = [], e = {}) {
        return new $d4d06657c043713f$export$cb45b08d97cdc4fd(t, e);
    }
    static next() {
        const t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
        t && t.next();
    }
    static prev() {
        const t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
        t && t.prev();
    }
    static close(t = !0, ...e) {
        if (t) for (const t of $d4d06657c043713f$var$Te.values())t.close(...e);
        else {
            const t = $d4d06657c043713f$export$cb45b08d97cdc4fd.getInstance();
            t && t.close(...e);
        }
    }
}
Object.defineProperty($d4d06657c043713f$export$cb45b08d97cdc4fd, "version", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: "5.0.36"
}), Object.defineProperty($d4d06657c043713f$export$cb45b08d97cdc4fd, "defaults", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$at
}), Object.defineProperty($d4d06657c043713f$export$cb45b08d97cdc4fd, "Plugins", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: $d4d06657c043713f$var$te
}), Object.defineProperty($d4d06657c043713f$export$cb45b08d97cdc4fd, "openers", {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: new Map
});





const $2da9fc5ba000a8d6$var$addImageThumbClickHandlers = (emblaApiMain, emblaApiThumb)=>{
    const slidesThumbs = emblaApiThumb.slideNodes();
    const scrollToIndex = slidesThumbs.map((_, index)=>()=>emblaApiMain.scrollTo(index));
    slidesThumbs.forEach((slideNode, index)=>{
        slideNode.addEventListener('click', scrollToIndex[index], false);
    });
    return ()=>{
        slidesThumbs.forEach((slideNode, index)=>{
            slideNode.removeEventListener('click', scrollToIndex[index], false);
        });
    };
};
const $2da9fc5ba000a8d6$var$addToggleImageThumbActive = (emblaApiMain, emblaApiThumb)=>{
    const slidesThumbs = emblaApiThumb.slideNodes();
    const toggleThumbState = ()=>{
        emblaApiThumb.scrollTo(emblaApiMain.selectedScrollSnap());
        const previous = emblaApiMain.previousScrollSnap();
        const selected = emblaApiMain.selectedScrollSnap();
        slidesThumbs[previous].classList.remove('product-detail__image-thumb--active');
        slidesThumbs[selected].classList.add('product-detail__image-thumb--active');
    };
    emblaApiMain.on('select', toggleThumbState);
    emblaApiThumb.on('init', toggleThumbState);
    return ()=>{
        const selected = emblaApiMain.selectedScrollSnap();
        slidesThumbs[selected].classList.remove('product-detail__image-thumb--active');
    };
};
const $2da9fc5ba000a8d6$var$addDotClickHandlers = (emblaApi, dotsNode)=>{
    let dotNodes = [];
    const addDotWithClickHandlers = ()=>{
        dotsNode.innerHTML = emblaApi.scrollSnapList().map(()=>'<button class="product-detail__image-slider-dot" type="button" title="\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C"><span class="visually-hidden">\u041F\u0435\u0440\u0435\u043A\u043B\u044E\u0447\u0438\u0442\u044C</span></button>').join('');
        dotNodes = Array.from(dotsNode.querySelectorAll('.product-detail__image-slider-dot'));
        dotNodes.forEach((dotNode, index)=>{
            dotNode.addEventListener('click', ()=>emblaApi.scrollTo(index), false);
        });
    };
    const toggleDotActive = ()=>{
        const previous = emblaApi.previousScrollSnap();
        const selected = emblaApi.selectedScrollSnap();
        dotNodes[previous].classList.remove('product-detail__image-slider-dot--active');
        dotNodes[selected].classList.add('product-detail__image-slider-dot--active');
    };
    emblaApi.on('init', addDotWithClickHandlers).on('reInit', addDotWithClickHandlers).on('init', toggleDotActive).on('reInit', toggleDotActive).on('select', toggleDotActive);
    return ()=>{
        dotsNode.innerHTML = '';
    };
};
const $2da9fc5ba000a8d6$var$OPTIONS = {};
const $2da9fc5ba000a8d6$var$OPTIONS_THUMBS = {
    containScroll: false,
    dragFree: false,
    watchDrag: false
};
const $2da9fc5ba000a8d6$var$sliderInit = ()=>{
    const sliderWrapperElement = document.querySelector('.product-detail__image-slider-wrapper');
    if (sliderWrapperElement) {
        const imageThumbsWrapperElement = document.querySelector('.product-detail__image-thumbs-wrapper');
        const emblaApiMain = (0, $ee28a9d8791885a9$export$2e2bcd8739ae039)(sliderWrapperElement, $2da9fc5ba000a8d6$var$OPTIONS);
        const emblaApiThumb = (0, $ee28a9d8791885a9$export$2e2bcd8739ae039)(imageThumbsWrapperElement, $2da9fc5ba000a8d6$var$OPTIONS_THUMBS);
        const removeImageThumbClickHandlers = $2da9fc5ba000a8d6$var$addImageThumbClickHandlers(emblaApiMain, emblaApiThumb);
        const removeToggleImageThumbActive = $2da9fc5ba000a8d6$var$addToggleImageThumbActive(emblaApiMain, emblaApiThumb);
        emblaApiMain.on('destroy', removeImageThumbClickHandlers).on('destroy', removeToggleImageThumbActive);
        emblaApiThumb.on('destroy', removeImageThumbClickHandlers).on('destroy', removeToggleImageThumbActive);
        if (window.innerWidth < 1024) {
            const dotsElement = document.querySelector('.product-detail__image-slider-dots');
            $2da9fc5ba000a8d6$var$addDotClickHandlers(emblaApiMain, dotsElement);
        }
    }
};
const $2da9fc5ba000a8d6$var$fancyboxInit = ()=>{
    (0, $d4d06657c043713f$export$cb45b08d97cdc4fd).bind('[data-fancybox="product-slider"]', {
        l10n: (0, $43829a6f0e34d097$export$a62ef81e9740ca3e),
        Images: {
            zoom: false
        },
        hideScrollbar: false,
        idle: 10000
    });
};
/**
 * @param amount
 * @returns {string}
 */ const $2da9fc5ba000a8d6$var$getIdentificationByAmount = (amount)=>{
    switch(true){
        case amount >= 0 && amount < 100:
            return `${amount}`;
        case amount > 100:
            return "> 100 \u0448\u0442";
        default:
            return '0';
    }
};
/**
 * @param availableStocks
 * @param stocksByOrder
 */ const $2da9fc5ba000a8d6$var$updateStoreAmountIdentifications = ({ availableStocks: availableStocks, stocksByOrder: stocksByOrder })=>{
    const totalAmountElement = document.querySelector('[data-entity="total-amount"]');
    const totalRequestAmountElement = document.querySelector('[data-entity="total-request-amount"]');
    totalAmountElement.textContent = $2da9fc5ba000a8d6$var$getIdentificationByAmount(availableStocks);
    totalRequestAmountElement.textContent = $2da9fc5ba000a8d6$var$getIdentificationByAmount(stocksByOrder);
};
/**
 * @param productId
 * @returns {Promise<void>}
 */ const $2da9fc5ba000a8d6$var$getStoreAmountById = (productId)=>{
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).get(`store/product-amount/${productId}`).then((response)=>response.json()).then((data)=>{
        if (!data.status) return;
        $2da9fc5ba000a8d6$var$updateStoreAmountIdentifications({
            availableStocks: data?.availableStocks,
            stocksByOrder: data?.stocksByOrder
        });
    }).catch(async (error)=>{
        const errorMessage = await error.response.json();
        console.error(errorMessage.message);
    });
};
const $2da9fc5ba000a8d6$var$storeAmountInit = ()=>{
    const wrapperElement = document.querySelector('[data-entity="store-amount-wrapper"]');
    if (wrapperElement) {
        const productId = document.querySelector('[data-product-card-id]').dataset.productCardId;
        $2da9fc5ba000a8d6$var$getStoreAmountById(productId);
    }
};
const $2da9fc5ba000a8d6$var$characteristicsBlockInit = ()=>{
    const characteristicsTriggerElement = document.querySelector('.product-detail__characteristics-trigger');
    const characteristicsListElement = document.querySelector('.product-detail__characteristics-list');
    if (characteristicsTriggerElement && characteristicsListElement) characteristicsTriggerElement.addEventListener('click', ()=>{
        characteristicsTriggerElement.classList.toggle('product-detail__characteristics-trigger--active');
        characteristicsListElement.classList.toggle('product-detail__characteristics-list--active');
    });
};
document.addEventListener('DOMContentLoaded', ()=>{
    $2da9fc5ba000a8d6$var$sliderInit();
    $2da9fc5ba000a8d6$var$fancyboxInit();
    $2da9fc5ba000a8d6$var$characteristicsBlockInit();
    setTimeout(()=>{
        $2da9fc5ba000a8d6$var$storeAmountInit();
    }, 200);
});


const $d5887d36844527e6$var$switchTabsActive = (trigger)=>{
    const tabElements = document.querySelectorAll('.switch-tabs__trigger');
    tabElements.forEach((item)=>{
        if (item === trigger) item.classList.add('switch-tabs__trigger--active');
        else item.classList.remove('switch-tabs__trigger--active');
    });
};
const $d5887d36844527e6$var$switchTabsContentVisibility = (targetId)=>{
    if (targetId.length <= 0) return;
    const targetElement = document.querySelector(`[data-target-id=${targetId}]`);
    if (targetElement) {
        const tabContentElements = document.querySelectorAll('.switch-tabs__target');
        tabContentElements.forEach((item)=>{
            if (item === targetElement) item.classList.add('switch-tabs__target--active');
            else item.classList.remove('switch-tabs__target--active');
        });
    }
};
const $d5887d36844527e6$var$switchTabsInit = ()=>{
    const triggerElements = document.querySelectorAll('.switch-tabs__trigger');
    if (triggerElements.length > 0) triggerElements.forEach((item)=>{
        item.addEventListener('click', (evt)=>{
            const targetBlock = evt.target.dataset.targetFor;
            if (targetBlock.length > 0) {
                $d5887d36844527e6$var$switchTabsActive(item);
                $d5887d36844527e6$var$switchTabsContentVisibility(targetBlock);
            }
        });
    });
};
document.addEventListener('DOMContentLoaded', ()=>{
    $d5887d36844527e6$var$switchTabsInit();
});


/* global BX:writable */ 
const $df8eb5f598e9ef30$var$initCartHandler = (buttonElement)=>{
    const triggerElement = buttonElement.querySelector('[data-entity="clear-cart-trigger"]');
    if (triggerElement) triggerElement.addEventListener('click', ()=>{
        $df8eb5f598e9ef30$var$clickClearCartTriggerHandler();
    });
};
const $df8eb5f598e9ef30$var$clickClearCartTriggerHandler = ()=>{
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).post('cart/clear/').json().then(()=>{
        location.reload();
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        console.error(errorJson.message);
    });
};
document.addEventListener('DOMContentLoaded', ()=>{
    const cartElement = document.querySelector('[data-cart-id]');
    if (cartElement) $df8eb5f598e9ef30$var$initCartHandler(cartElement);
    BX.addCustomEvent('OnBasketChange', function() {
        $df8eb5f598e9ef30$var$initCartHandler(cartElement);
    });
});




const $1d99648c124ffb41$var$formSubmitHandler = (evt)=>{
    evt.preventDefault();
    const formElement = evt.target;
    if (!(0, $366106ffbe7c4eae$export$ed692cabb252e59b)(formElement)) return;
    const submitButton = formElement.querySelector('button[type="submit"]');
    (0, $366106ffbe7c4eae$export$9f2f414e0766ca84)(submitButton);
    const formData = new FormData(formElement);
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).post('feedback/', {
        body: formData
    }).json().then(()=>{
        setTimeout(()=>{
            document.location.reload();
        }, 500);
    }).catch(async ()=>{
        (0, $366106ffbe7c4eae$export$7ae08f9d0817f013)(submitButton);
    });
};
document.addEventListener('DOMContentLoaded', ()=>{
    const form = document.querySelector('form[name="feedback"]');
    if (form) form.addEventListener('submit', $1d99648c124ffb41$var$formSubmitHandler);
});




const $8e9f85720764d722$var$formSubmitHandler = (evt)=>{
    evt.preventDefault();
    const formElement = evt.target;
    if (!(0, $366106ffbe7c4eae$export$ed692cabb252e59b)(formElement)) return;
    const submitButton = formElement.querySelector('button[type="submit"]');
    (0, $366106ffbe7c4eae$export$9f2f414e0766ca84)(submitButton);
    const formData = new FormData(formElement);
    const requestBody = JSON.stringify(Object.fromEntries(formData));
    const userType = formData.get('userType');
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).patch(`user/${userType}/`, {
        body: requestBody,
        headers: {
            'Content-Type': 'application/json'
        }
    }).json().then(()=>{
        setTimeout(()=>{
            document.location.reload();
        }, 500);
    }).catch(async ()=>{
        (0, $366106ffbe7c4eae$export$7ae08f9d0817f013)(submitButton);
    });
};
document.addEventListener('DOMContentLoaded', ()=>{
    const form = document.querySelector('form[name="profile"]');
    if (form) form.addEventListener('submit', $8e9f85720764d722$var$formSubmitHandler);
});



const $4d8a956897d31df5$var$getOrderDetailTriggerData = (evt)=>{
    const triggerElement = evt.currentTarget;
    const orderId = triggerElement.dataset.orderId;
    const idPrefix = triggerElement.dataset.orderPrefix;
    const productsListElement = document.querySelector(`#order-products-${idPrefix}-${orderId}`);
    return {
        triggerElement: triggerElement,
        orderId: orderId,
        idPrefix: idPrefix,
        productsListElement: productsListElement
    };
};
const $4d8a956897d31df5$var$onOrderDetailRequest = (evt)=>{
    const { triggerElement: triggerElement, orderId: orderId, productsListElement: productsListElement } = $4d8a956897d31df5$var$getOrderDetailTriggerData(evt);
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).get(`orders/${orderId}`).text().then((response)=>{
        if (productsListElement) {
            productsListElement.innerHTML = response;
            productsListElement.scrollIntoView();
        }
        triggerElement.classList.toggle('order-table__products-btn--active', true);
        triggerElement.removeEventListener('click', $4d8a956897d31df5$var$onOrderDetailRequest);
        triggerElement.addEventListener('click', $4d8a956897d31df5$var$onOrderDetailClose);
    }).catch(async ()=>{});
};
const $4d8a956897d31df5$var$onOrderDetailOpen = (evt)=>{
    const { triggerElement: triggerElement, productsListElement: productsListElement } = $4d8a956897d31df5$var$getOrderDetailTriggerData(evt);
    if (productsListElement) {
        productsListElement.classList.toggle('order-products__list--hidden', false);
        productsListElement.scrollIntoView();
    }
    triggerElement.classList.toggle('order-table__products-btn--active', true);
    triggerElement.removeEventListener('click', $4d8a956897d31df5$var$onOrderDetailOpen);
    triggerElement.addEventListener('click', $4d8a956897d31df5$var$onOrderDetailClose);
};
const $4d8a956897d31df5$var$onOrderDetailClose = (evt)=>{
    const { triggerElement: triggerElement, productsListElement: productsListElement } = $4d8a956897d31df5$var$getOrderDetailTriggerData(evt);
    if (productsListElement) productsListElement.classList.toggle('order-products__list--hidden', true);
    triggerElement.classList.toggle('order-table__products-btn--active', false);
    triggerElement.removeEventListener('click', $4d8a956897d31df5$var$onOrderDetailClose);
    triggerElement.addEventListener('click', $4d8a956897d31df5$var$onOrderDetailOpen);
};
document.addEventListener('DOMContentLoaded', ()=>{
    const orderDetailTriggers = document.querySelectorAll('[data-order-detail]');
    orderDetailTriggers.forEach((trigger)=>{
        trigger.addEventListener('click', $4d8a956897d31df5$var$onOrderDetailRequest);
    });
});


/* global BX:writable */ 
const $807f0940694c62a9$var$initOrderHandler = (order)=>{
    const savedAddress = order.querySelector('[data-entity="saved_address"]');
    if (savedAddress) $807f0940694c62a9$var$actualizeSavedAddress();
};
const $807f0940694c62a9$var$setSavedAddress = (data)=>{
    const savedAddress = document.querySelector('[data-entity="saved_address"]');
    const select = savedAddress.querySelector('.order__input');
    if (!select.querySelector('[data-entity="option-trigger"]')) data.forEach((element, index)=>{
        const option = document.createElement('option');
        if (index === 0) option.dataset.entity = 'option-trigger';
        option.value = index;
        option.text = element.city + ' ' + element.street + ' ' + element.house + ' ' + element.apartment;
        select.add(option);
    });
    select.addEventListener('change', function(trigger) {
        const selectAddress = data[trigger.target.value];
        const city = document.querySelector('[data-entity="city"]');
        const street = document.querySelector('[data-entity="street"]');
        const house = document.querySelector('[data-entity="house"]');
        const apartment = document.querySelector('[data-entity="apartment"]');
        city.value = selectAddress.code;
        street.value = selectAddress.street;
        house.value = selectAddress.house;
        apartment.value = selectAddress.apartment;
    });
};
const $807f0940694c62a9$var$actualizeSavedAddress = ()=>{
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).get('delivery-address/').json().then((response)=>{
        $807f0940694c62a9$var$setSavedAddress(response.savedAddress);
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        console.error(errorJson.message);
    });
};
document.addEventListener('DOMContentLoaded', ()=>{
    const order = document.querySelector('[data-entity="order"]');
    if (order) $807f0940694c62a9$var$initOrderHandler(order);
    BX.addCustomEvent('onAjaxSuccess', function() {
        if (order) $807f0940694c62a9$var$initOrderHandler(order);
    });
});



const $8707533a5975f9e1$var$actualizeFavoriteCount = (favoriteCount)=>{
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).get('favorite/count/').json().then((response)=>{
        favoriteCount.innerHTML = response.total;
        favoriteCount.style.display = 'block';
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        console.error(errorJson.message);
    });
};
const $8707533a5975f9e1$export$e64ba35d04af36f7 = ()=>{
    const favoriteCount = document.querySelector('[data-entity="favorite-icon-count"]');
    if (favoriteCount) $8707533a5975f9e1$var$actualizeFavoriteCount(favoriteCount);
};
document.addEventListener('DOMContentLoaded', ()=>{
    $8707533a5975f9e1$export$e64ba35d04af36f7();
});


/* global BX:writable */ 

const $d6dceb7da4007043$var$getProductId = (triggerElement)=>{
    return parseInt(triggerElement.closest('[data-product-card-id]').dataset.productCardId, 10);
};
const $d6dceb7da4007043$var$deleteFromFavorite = (triggerElement)=>{
    const productId = $d6dceb7da4007043$var$getProductId(triggerElement);
    if (!productId) return;
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).delete(`favorite/product/${productId}/`).json().then(()=>{
        $d6dceb7da4007043$var$switchDisplayFavorite(triggerElement);
        (0, $8707533a5975f9e1$export$e64ba35d04af36f7)();
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        console.error(errorJson.message);
    });
};
const $d6dceb7da4007043$var$addToFavorite = (triggerElement)=>{
    const productId = $d6dceb7da4007043$var$getProductId(triggerElement);
    if (!productId) return;
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).post(`favorite/product/${productId}/`).json().then(()=>{
        $d6dceb7da4007043$var$switchDisplayFavorite(triggerElement, true);
        (0, $8707533a5975f9e1$export$e64ba35d04af36f7)();
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        console.error(errorJson.message);
    });
};
const $d6dceb7da4007043$var$clickFavoriteTriggerHandler = (triggerElement)=>{
    triggerElement.classList.contains('active') ? $d6dceb7da4007043$var$deleteFromFavorite(triggerElement) : $d6dceb7da4007043$var$addToFavorite(triggerElement);
};
const $d6dceb7da4007043$export$ca6fbf6ef6fcf116 = (cardElement)=>{
    const triggerElement = cardElement.querySelector('[data-entity="favorite-trigger"]');
    if (triggerElement) triggerElement.addEventListener('click', ()=>{
        $d6dceb7da4007043$var$clickFavoriteTriggerHandler(triggerElement);
    });
};
const $d6dceb7da4007043$var$switchDisplayFavorite = (favoriteTriggerElement, isActive = false)=>{
    favoriteTriggerElement.classList.toggle('active', isActive);
    favoriteTriggerElement.title = isActive ? "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0438\u0437 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E" : "\u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0432 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435";
};
const $d6dceb7da4007043$var$setProductFavorite = (productId)=>{
    const favoriteTriggerElement = document.querySelector(`[data-product-card-id="${productId}"] [data-entity="favorite-trigger"]`);
    if (favoriteTriggerElement) $d6dceb7da4007043$var$switchDisplayFavorite(favoriteTriggerElement, true);
};
const $d6dceb7da4007043$export$4f977ab2cc2db53c = ()=>{
    (0, $fc777e011aeb2fae$export$644d8ea042df96a6).get('favorite/').json().then((response)=>{
        if (response.products.length > 0) response.products.forEach((item)=>{
            $d6dceb7da4007043$var$setProductFavorite(item);
        });
    }).catch(async (error)=>{
        const errorJson = await error.response.json();
        console.error(errorJson.message);
    });
};
const $d6dceb7da4007043$var$basketChangeHandler = ()=>{
    const cardElements = document.querySelectorAll('[data-product-card-id]');
    if (cardElements.length > 0) {
        cardElements.forEach((item)=>{
            $d6dceb7da4007043$export$ca6fbf6ef6fcf116(item);
        });
        $d6dceb7da4007043$export$4f977ab2cc2db53c();
    }
};
document.addEventListener('DOMContentLoaded', ()=>{
    const cardElements = document.querySelectorAll('[data-product-card-id]');
    if (cardElements.length > 0) {
        cardElements.forEach((item)=>{
            $d6dceb7da4007043$export$ca6fbf6ef6fcf116(item);
        });
        setTimeout(()=>$d6dceb7da4007043$export$4f977ab2cc2db53c(), 200);
    }
    BX.addCustomEvent('OnBasketChange', function() {
        $d6dceb7da4007043$var$basketChangeHandler();
    });
});



document.addEventListener('DOMContentLoaded', ()=>{
    const settingModal = {
        callbackByOpen: (event)=>{
            let targetButton = event.target;
            const productNameInput = document.querySelector('#product-name');
            const product = targetButton.closest('.product-detail, .product-card');
            const productName = product.querySelector('.product-detail__title, .product-card__name');
            if (productNameInput && productName) productNameInput.value = productName.textContent;
        }
    };
    new (0, $d1df9047692a867f$export$2e2bcd8739ae039)({
        dialogSelector: '#productSubscribeForm',
        dialogOpenTrigger: '[data-entity="subscribe-trigger"]',
        settings: settingModal
    });
});





/**
 * Класс для обработки отправки форм с валидацией и API запросами
 *
 * @class BaseForm
 */ class $62eb2b3f6b0e5cde$var$BaseForm {
    /**
     * @param {string} props.fromSelector - селектор элемента формы
     * @param {string} props.formSubmitSelector - селектор кнопки отправки внутри формы
     * @param {Object} props.settings - настройки формы
     * @param {string} props.settings.api - URL API эндпоинта для отправки данных
     * @param {Function} props.settings.callbackBySend - Callback, вызываемый после успешной отправки
     */ constructor(props){
        this.formSelector = props.fromSelector;
        this.formElement = document.querySelector(props.fromSelector);
        this.formTriggerSubmit = this.formElement?.querySelector(props.formSubmitSelector);
        this.settings = props.settings;
        this.initializeForm();
    }
    /**
     * Инициализирует форму
     */ initializeForm() {
        if (!this.formElement) {
            console.warn(`\u{41D}\u{435} \u{443}\u{434}\u{430}\u{43B}\u{43E}\u{441}\u{44C} \u{43D}\u{430}\u{439}\u{442}\u{438} \u{444}\u{43E}\u{440}\u{43C}\u{443} ${this.formSelector}`);
            return;
        }
        this.handleFormSubmit();
    }
    /**
     * Обрабатывает отправку формы
     */ handleFormSubmit() {
        this.formElement.addEventListener('submit', (event)=>{
            event.preventDefault();
            if (!(0, $366106ffbe7c4eae$export$ed692cabb252e59b)(this.formElement)) return;
            (0, $366106ffbe7c4eae$export$9f2f414e0766ca84)(this.formTriggerSubmit);
            const formData = new FormData(this.formElement);
            this.sendMessage(formData);
        });
    }
    /**
     * Отправляет данные формы на сервер
     */ sendMessage(formData) {
        const apiUrl = this.settings.api.replace(/^\//, '');
        (0, $fc777e011aeb2fae$export$644d8ea042df96a6).post(apiUrl, {
            body: formData
        }).then((response)=>response.json()).then((data)=>{
            if (!data.status) return;
            (0, $9a4bfff5dffba651$export$de026b00723010c1)(this.formElement, 'beforebegin', data.message, 'success');
            this.formElement.reset();
            if (this.settings.callbackBySend) this.settings.callbackBySend();
        }).catch(async (error)=>{
            const errorMessage = await error.response.json();
            (0, $9a4bfff5dffba651$export$de026b00723010c1)(this.formElement, 'beforebegin', errorMessage.message, 'error');
        }).finally(()=>{
            (0, $366106ffbe7c4eae$export$7ae08f9d0817f013)(this.formTriggerSubmit);
        });
    }
}
var $62eb2b3f6b0e5cde$export$2e2bcd8739ae039 = $62eb2b3f6b0e5cde$var$BaseForm;


document.addEventListener('DOMContentLoaded', ()=>{
    new (0, $62eb2b3f6b0e5cde$export$2e2bcd8739ae039)({
        fromSelector: '[name="request-error"]',
        formSubmitSelector: '[type="submit"]',
        settings: {
            api: 'feedback/report'
        }
    });
});



document.addEventListener('DOMContentLoaded', ()=>{
    (0, $418ef4bb2816ee56$export$ffeb8f30de717edd)();
    BX.addCustomEvent('onAjaxSuccess', function() {
        (0, $418ef4bb2816ee56$export$ffeb8f30de717edd)();
    });
});



})();
//# sourceMappingURL=index.js.map
